import { adminFaz8Ar } from './admin.faz8.ar';
/** Panel arayüz metinleri (Arapça; F7-17). Kaynak: TR (asıl) ve EN; terimler docs/I18N_GLOSSARY.md. */
export const adminAr = {
  ...adminFaz8Ar,
  nav: {
    overview: 'نظرة عامة',
    business: 'المنشأة',
    team: 'الفريق',
    connections: 'الاتصالات',
    records: 'السجلات',
    dashboard: 'لوحة المعلومات',
    setup: 'معالج الإعداد',
    organization: 'بيانات المنشأة',
    brands: 'العلامات التجارية',
    stores: 'المتاجر',
    users: 'المستخدمون',
    roles: 'الأدوار',
    apiKeys: 'مفاتيح API',
    webhooks: 'Webhooks',
    integrations: 'التكاملات',
    audit: 'سجل التدقيق',
    system: 'حالة النظام',
    migration: 'حزمة الترحيل',
    privacy: 'طلبات KVKK',
    retention: 'الاحتفاظ والإتلاف',
    ledger: 'حسابات الموزّعين',
    quotes: 'عروض الأسعار',
    salesRegions: 'مناطق المبيعات',
    commissions: 'عمولات المندوبين',
    dealerReports: 'تقارير الموزّعين',
    internationalReport: 'المبيعات حسب الدولة',
    subscriptions: 'الطلبات المتكررة',
    bizimhesap: 'BizimHesap',
    exports: 'التصدير',
    seo: 'مركز SEO',
    attribution: 'الحملات والمصادر',
    tracking: 'القياس',
    google: 'اتصالات Google',
    webVitals: 'سرعة الصفحة',
    keywords: 'الكلمات المفتاحية',
    siteSearch: 'البحث في الموقع',
    attributes: 'خصائص المنتجات',
    collections: 'المجموعات',
    searchConsole: 'أداء البحث',
    merchant: 'Google Shopping',
    helpEditor: 'نصوص المساعدة',
    uiTranslations: 'الترجمات',
    account: 'حسابي',
    menu: 'القائمة',
    skipToContent: 'الانتقال إلى المحتوى',
    stagingBanner:
      'خادم Staging (تجريبي): تُرسل رسائل البريد الإلكتروني فقط إلى العناوين المدرجة في قائمة السماح.',
    stagingBannerLink: 'قائمة السماح',
    organizationSwitch: 'المنشأة',
    sales: 'المبيعات',
    catalog: 'الكتالوج',
    orders: 'الطلبات',
    customers: 'العملاء',
    dealers: 'الموزّعون',
    applications: 'طلبات الانضمام كموزّع',
    products: 'المنتجات',
    categories: 'الفئات',
    stock: 'المخزون',
    pricing: 'الأسعار',
    fx: 'أسعار الصرف',
    discounts: 'رموز الخصم',
    promotions: 'الخصومات التلقائية',
    giftCards: 'بطاقات الهدايا',
    loyalty: 'برنامج الولاء',
    referrals: 'برنامج الإحالة',
    affiliates: 'الشركاء التابعون',
    imports: 'الاستيراد / التصدير',
    payments: 'المدفوعات',
    invoices: 'الفواتير',
    paymentSettings: 'إعدادات الدفع',
    shipping: 'الشحن',
    legal: 'النصوص القانونية',
    redirects: 'عمليات إعادة التوجيه',
    brokenLinks: 'الروابط المعطّلة',
    storefrontGroup: 'واجهة المتجر',
    marketing: 'التسويق',
    marketingAudience: 'المشتركون والموافقات',
    segments: 'الشرائح',
    emailTemplates: 'قوالب البريد الإلكتروني',
    campaigns: 'حملات البريد الإلكتروني',
    automations: 'الأتمتة',
    productAlerts: 'تنبيهات المخزون والأسعار',
    smsWhatsapp: 'الرسائل النصية وWhatsApp',
    smsTemplates: 'قوالب الرسائل النصية',
    push: 'الإشعارات الفورية',
    design: 'التصميم',
    menus: 'القوائم',
    pageDesigns: 'تصاميم الصفحات',
    salesPoints: 'نقاط البيع',
    googleAdsCampaigns: 'حملات Google Ads',
    needsFinder: 'دليل الاحتياجات',
    pages: 'الصفحات',
    banners: 'البانرات',
    blog: 'المدونة',
    contentCalendar: 'تقويم المحتوى',
    contentReport: 'تقرير المحتوى',
    forms: 'النماذج',
    contactMessages: 'رسائل التواصل',
    supportTickets: 'تذاكر الدعم',
    ads: 'مركز الإعلانات',
    googleReports: 'تقارير Google',
    liveChat: 'الدردشة المباشرة',
    questions: 'أسئلة المنتجات',
    reviews: 'تقييمات المنتجات',
  },
  help: {
    whatItDoes: 'ما الغرض منه؟',
    whenToUse: 'متى يُستخدم؟',
    dataChanged: 'ما الذي يغيّره؟',
    requiredPermission: 'الصلاحية المطلوبة',
    reversible: 'هل يمكن التراجع عنه؟',
    commonErrors: 'المشكلات الشائعة وحلولها',
    guide: 'دليل مفصّل',
    open: 'شرح: {{title}}',
  },
  auth: {
    brand: 'لوحة تحكم Zootopia',
    tagline: 'أدِر متجرك وفريقك واتصالاتك من مكان واحد.',
    signInTitle: 'تسجيل الدخول إلى لوحة التحكم',
    signIn: 'تسجيل الدخول',
    forgot: 'نسيت كلمة المرور',
    mfaTitle: 'رمز التحقق',
    mfaLead: 'أدخل الرمز المكوّن من 6 أرقام الظاهر في تطبيق المصادقة على هاتفك.',
    code: 'رمز من 6 أرقام',
    verify: 'تحقّق',
    useBackup: 'استخدام رمز احتياطي',
    backupCode: 'رمز احتياطي',
    useCode: 'التحقق برمز التطبيق',
    enrollTitle: 'إعداد التحقق بخطوتين',
    enrollLead:
      'يؤمّن كل مستخدم لوحة التحكم بتطبيق مصادقة (Google Authenticator أو Microsoft Authenticator وغيرهما). اضغط على «إضافة حساب» في التطبيق وامسح رمز QR هذا.',
    manualKey: 'تعذّر المسح؟ أدخل هذا المفتاح في التطبيق يدويًا:',
    confirmEnroll: 'إنهاء الإعداد',
    backupTitle: 'احفظ رموزك الاحتياطية',
    backupLead:
      'إذا تعذّر عليك الوصول إلى هاتفك، فسجّل الدخول بأحد هذه الرموز. يعمل كل رمز مرة واحدة فقط، ولن تُعرض الرموز مرة أخرى.',
    backupDone: 'حفظت الرموز، متابعة',
    copyCodes: 'نسخ الرموز',
    printCodes: 'طباعة',
    forgotTitle: 'إعادة تعيين كلمة المرور',
    forgotLead: 'أدخل البريد الإلكتروني لحسابك. إذا كان مسجّلًا، فسنرسل رابطًا صالحًا لمدة ساعة واحدة.',
    sendLink: 'إرسال الرابط',
    forgotSent:
      'إذا كان العنوان مسجّلًا، فقد أُرسل بريد إلكتروني. تحقّق من صندوق الوارد ومجلد الرسائل غير المرغوب فيها.',
    forgotUnavailable:
      'لا يمكن إرسال رسائل إعادة تعيين كلمة المرور لأن خدمة البريد الإلكتروني لم تُعدّ بعد. اطلب المساعدة من مسؤول منشأتك؛ إذ يمكن لمسؤول الخادم إنشاء رابط إعادة تعيين لك.',
    backToSignIn: 'العودة إلى تسجيل الدخول',
    resetTitle: 'اختر كلمة مرور جديدة',
    newPassword: 'كلمة المرور الجديدة',
    setPassword: 'حفظ كلمة المرور',
    resetDone: 'تم تغيير كلمة المرور. يمكنك تسجيل الدخول بكلمة المرور الجديدة.',
    passwordHint: '12 حرفًا على الأقل. الجملة الطويلة التي تتذكرها بسهولة خيار جيد.',
    inviteTitle: 'دعاك {{organization}}',
    inviteLead: 'دعوة إلى {{email}}. حدّد اسمك وكلمة المرور، ثم ستُعدّ التحقق بخطوتين.',
    inviteExistingLead: 'لديك حساب بالفعل للعنوان {{email}}. أدخل كلمة المرور الحالية لقبول الدعوة.',
    yourName: 'الاسم الكامل',
    acceptInvite: 'قبول الدعوة',
    stepUpTitle: 'تأكيد هويتك',
    stepUpLead: 'هذا الإجراء حساس. أدخل الرمز من تطبيق المصادقة مرة أخرى.',
    stepUpSubmit: 'تحقّق وتابع',
  },
  dashboard: {
    greeting: 'مرحبًا {{name}}',
    setupHeading: 'الإعداد',
    setupProgress: 'اكتمل {{done}} من أصل {{total}} خطوات متاحة في هذه المرحلة.',
    continueSetup: 'متابعة الإعداد',
    healthHeading: 'النظام',
    attentionHeading: 'يحتاج إلى انتباه',
    salesHeading: 'المبيعات والطلبات',
    nothingToDo: 'لا يوجد ما يحتاج إلى انتباهك حاليًا.',
    salesPending:
      'ستتوفر مخططات المبيعات والطلبات مع وحدة التقارير (المرحلة 8). استخدم حاليًا شاشات الطلبات والمدفوعات والمخزون؛ ولا تُعرض أرقام تقديرية دون بيانات حقيقية.',
    alertReturns: '{{count}} طلبات إرجاع/انسحاب بانتظار الرد.',
    alertPrivacy: '{{count}} طلبات KVKK بانتظار الرد (المهلة القانونية 30 يومًا).',
    alertPrivacyOverdue: 'تجاوزت {{count}} طلبات KVKK مهلة الرد البالغة 30 يومًا.',
    alertLowStock: '{{count}} منتجات مخزونها منخفض (المخزون ← المخزون المنخفض).',
    alertPaymentReview: '{{count}} مدفوعات تحتاج إلى مراجعة (لا يُعدّ الطلب مدفوعًا).',
    alertBalanceReview:
      '{{count}} دفعات بطاقة من الموزّعين تحتاج إلى مراجعة (لم تُقيَّد في حساب الموزّع؛ الحسابات الجارية ← الموزّع ← دفعات الرصيد بالبطاقة).',
    alertIntegration: 'فشل الاتصال بـ {{name}}.',
    alertTls: 'تنتهي صلاحية شهادة SSL لـ {{host}} خلال {{days}} يومًا.',
    alertTlsError: 'تعذّرت قراءة شهادة SSL لـ {{host}}.',
    alertMail: 'خدمة البريد الإلكتروني غير مُعدّة: لا يمكن إرسال الدعوات ورسائل إعادة تعيين كلمة المرور.',
    alertBackup: 'لم تُسجّل أي نسخة احتياطية بعد. تبدأ النسخ الاحتياطية الليلية بعد إعداد الخادم.',
    alertBackupFailed: 'فشلت آخر عملية نسخ احتياطي. التفاصيل: حالة النظام.',
    alertBackupStale: 'آخر نسخة احتياطية ناجحة أقدم من 26 ساعة. قد لا تكون خدمة النسخ الاحتياطي قيد التشغيل.',
    alertRestoreFailed:
      'فشل آخر اختبار للاستعادة: قد يتعذّر استعادة النسخ الاحتياطية. التفاصيل: حالة النظام.',
    alertRedis: 'تعذّر الوصول إلى خادم قائمة الانتظار؛ لا يمكن إرسال رسائل البريد الإلكتروني.',
  },
  setup: {
    go: 'فتح',
    skip: 'تخطي',
    unskip: 'تراجع',
  },
  organization: {
    systemName: 'اسم اللوحة (اسم النظام)',
    systemNameHint:
      'الاسم الظاهر أعلى لوحة الإدارة وفي علامة تبويب المتصفح. اتركه فارغًا لاستخدام «Zootopia Panel».',
    legalSection: 'البيانات القانونية',
    legalLead: 'تستخدم بيانات البائع على الموقع والفواتير وطلب نقطة البيع (POS) هذه البيانات.',
    contactSection: 'التواصل',
    defaultsSection: 'الإعدادات الافتراضية',
    name: 'الاسم المعروض',
    legalName: 'الاسم التجاري الرسمي',
    taxOffice: 'مكتب الضرائب',
    taxNumber: 'الرقم الضريبي / TCKN',
    mersis: 'رقم MERSIS',
    kep: 'عنوان KEP',
    etbis: 'رابط التحقق من ETBİS',
    etbisHint:
      'العنوان الذي يفتحه رمز QR الذي تحصل عليه بعد التسجيل في ETBİS. يظهر مع رمز QR في تذييل واجهة المتجر.',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    address: 'العنوان',
    defaultLocale: 'اللغة الافتراضية',
    defaultCurrency: 'العملة الافتراضية',
  },
  brands: {
    add: 'إضافة علامة تجارية',
    createTitle: 'علامة تجارية جديدة',
    editTitle: 'تعديل العلامة التجارية',
    name: 'اسم العلامة التجارية',
    slug: 'الاسم المختصر',
    description: 'الوصف',
    color: 'اللون الأساسي',
    logo: 'الشعار',
    uploadLogo: 'رفع الشعار',
    replaceLogo: 'استبدال الشعار',
    noLogo: 'لا يوجد شعار',
    archive: 'أرشفة',
    activate: 'تفعيل',
    active: 'نشط',
    archived: 'مؤرشف',
    emptyTitle: 'لا توجد علامات تجارية بعد',
    emptyLead: 'أضف العلامات التجارية التي تبيعها، مثل Zootopia Global وVITATOPIA.',
    logoUploaded: 'تم رفع الشعار',
  },
  stores: {
    customerAuth: {
      title: 'تسجيل دخول العملاء',
      lead: '«المتابعة باستخدام Google» في الدخول والتسجيل والدفع. معطّل افتراضيًا؛ لا تفعّله قبل تحديث إشعار الخصوصية وسجل النقل للخارج بموافقة قانونية.',
      clientReady: 'عميل تسجيل الدخول عبر Google مُعَد',
      clientMissing: 'يتطلب الإعداد: لا يوجد عميل لتسجيل الدخول عبر Google',
      configure: 'أعدّه من التكاملات',
      google: 'تسجيل الدخول عبر Google',
      on: 'مفعّل',
      off: 'معطّل',
      enable: 'فعّل تسجيل الدخول عبر Google',
      disable: 'عطّل تسجيل الدخول عبر Google',
      enableConfirm:
        'سيتمكن العملاء من الدخول والتسجيل بحساب Google في هذا المتجر. تابع إذا حُدّث إشعار الخصوصية وسجل النقل للخارج بموافقة قانونية.',
      disableConfirm:
        'سيُعطَّل تسجيل الدخول عبر Google. يمكن للحسابات المنشأة عبر Google مواصلة الدخول بالبريد وكلمة المرور (عبر «نسيت كلمة المرور» إن لم تكن لديها).',
      ownerOnly: 'يمكن لمالك النشاط فقط تفعيل هذا.',
      redirects: 'عناوين إعادة التوجيه لإدخالها في عميل OAuth في Google Cloud',
      noDomains: 'لا يوجد نطاق واجهة متجر لهذا المتجر.',
    },
    add: 'إضافة متجر',
    createTitle: 'متجر جديد',
    name: 'اسم المتجر',
    code: 'الرمز',
    channel: 'نوع القناة',
    channelB2C: 'B2C — المستهلكون',
    channelB2B: 'B2B — الموزّعون',
    channelHYBRID: 'مختلط — المستهلكون والموزّعون',
    status_draft: 'معاينة',
    status_live: 'مباشر',
    status_maintenance: 'قيد الصيانة',
    status_archived: 'مؤرشف',
    deleteTitle: 'حذف المتجر',
    deleteLead:
      'مخصص لمتجر فُتح عن طريق الخطأ أو غير مستخدم. لا يمكن حذف إلا متجر في المعاينة أو الأرشيف ليس لديه أي طلبات؛ أما المتجر الذي لديه طلبات فأرشِفه.',
    delete: 'حذف المتجر',
    deleted: 'تم حذف المتجر',
    deleteBlocked_store_not_draft:
      'لا يمكن حذف متجر مباشر أو قيد الصيانة؛ أعِده إلى المعاينة أو أرشِفه أولًا.',
    deleteBlocked_store_has_orders: 'لهذا المتجر طلبات ولا يمكن حذفه. أرشِفه إذا لم تعد تستخدمه.',
    deleteDialogTitle: 'حذف «{{name}}»؟',
    deleteDialogLead: 'لا يمكن التراجع عن هذا الإجراء. سيُحذف ما يلي مع المتجر:',
    deleteCodeLabel: 'اكتب رمز المتجر للتأكيد: {{code}}',
    deleteCount_domains: '{{count}} نطاقات',
    deleteCount_markets: '{{count}} أسواق',
    deleteCount_priceLists: '{{count}} قوائم أسعار (مع الأسعار)',
    deleteCount_listings: '{{count}} عروض منتجات (تبقى المنتجات محفوظة)',
    deleteCount_pages: '{{count}} صفحات',
    deleteCount_banners: '{{count}} بانرات',
    deleteCount_menus: '{{count}} قوائم',
    deleteCount_redirects: '{{count}} عمليات إعادة توجيه',
    deleteCount_shippingMethods: '{{count}} طرق شحن',
    brands: 'العلامات التجارية المبيعة',
    domains: 'النطاقات',
    addDomain: 'إضافة نطاق',
    hostname: 'النطاق',
    purpose: 'الاستخدام',
    purpose_storefront: 'واجهة المتجر',
    purpose_admin: 'لوحة التحكم',
    purpose_api: 'API',
    primary: 'أساسي',
    markets: 'الأسواق',
    addMarket: 'إضافة سوق',
    makeDefault: 'تعيين كافتراضي',
    makeDefaultConfirm:
      'هل تريد جعل «{{name}}» السوق الافتراضي؟ ستفتح واجهة المتجر بلغته وعملته ({{currency}})؛ ولا يمكن بيع المنتجات التي ليس لها سعر بهذه العملة.',
    defaultMarketSaved: 'تم تغيير السوق الافتراضي.',
    taxMode: 'وضع الضريبة',
    taxModeOf: 'وضع الضريبة لـ {{name}}',
    taxModeSaved: 'تم حفظ وضع الضريبة.',
    taxModes: {
      domestic: 'ضريبة القيمة المضافة المحلية',
      export_exempt: 'تصدير (معفى من ضريبة القيمة المضافة)',
      destination: 'ضريبة القيمة المضافة لبلد الوجهة',
    },
    returnPolicy: {
      title: 'سياسة الإرجاع (لمحركات البحث)',
      lead: 'معلومات الإرجاع المعروضة في نتائج منتجات Google. يجب أن تتطابق مع شروط الانسحاب والإرجاع في نصوصك القانونية.',
      enabled: 'الإبلاغ لمحركات البحث',
      days: 'مهلة الإرجاع (بالأيام)',
      method: 'طريقة الإرجاع',
      methods: {
        by_mail: 'بالشحن',
        in_store: 'في المتجر',
        by_mail_or_in_store: 'بالشحن أو في المتجر',
      },
      fees: 'رسوم شحن الإرجاع',
      feeOptions: {
        customer_pays: 'يدفعها العميل',
        free: 'مجانًا (ندفعها نحن)',
      },
      save: 'حفظ سياسة الإرجاع',
      saved: 'تم حفظ سياسة الإرجاع.',
    },
    marketName: 'اسم السوق',
    country: 'الدولة',
    language: 'اللغة',
    currency: 'العملة',
    default: 'افتراضي',
    emptyTitle: 'لا توجد متاجر بعد',
    emptyLead: 'ابدأ بإنشاء متجر لـ zootopia.com.tr.',
    dnsNote: 'بعد إضافة النطاق، يجب أن يشير سجل A الخاص به إلى عنوان IP لخادمك في لوحة مسجّل النطاق.',
    noDomains: 'لا توجد نطاقات بعد.',
    noMarkets: 'لا توجد أسواق بعد. تعمل الأسعار والضرائب حسب السوق، لذا أضف سوقًا واحدًا على الأقل.',
    tls: 'SSL',
    remove: 'إزالة',
    open: 'التفاصيل',
    back: 'العودة إلى المتاجر',
  },
  users: {
    invite: 'دعوة مستخدم',
    inviteTitle: 'دعوة مستخدم',
    inviteSent: 'تم إرسال بريد الدعوة',
    manualTitle: 'مشاركة رابط الدعوة',
    manualLead:
      'لم يُرسل بريد إلكتروني إلى {{email}} لأن خدمة البريد الإلكتروني غير مُعدّة. شارك هذا الرابط معه عبر قناة آمنة؛ فهو صالح لمدة 7 أيام ويعمل مرة واحدة.',
    copyLink: 'نسخ الرابط',
    role: 'الدور',
    storeScope: 'تقييد المتجر',
    dealerScope: 'نطاق الموزّعين',
    dealerScopeOf: '{{name}} — نطاق الموزّعين',
    dealerScopes: {
      all: 'جميع الموزّعين',
      assigned: 'الموزّعون المعيّنون فقط',
    },
    allStores: 'جميع المتاجر',
    active: 'نشط',
    suspended: 'موقوف',
    lastLogin: 'آخر تسجيل دخول',
    members: 'الأعضاء',
    pending: 'الدعوات المعلّقة',
    expires: 'صالح حتى',
    revoke: 'إلغاء الدعوة',
    suspend: 'إيقاف',
    activate: 'تفعيل',
    remove: 'إزالة العضو',
    changeRole: 'تغيير الدور',
    you: 'أنت',
    confirmRemove: 'هل تريد إزالة {{name}}؟ تبقى إجراءاته السابقة في سجل التدقيق.',
    noPending: 'لا توجد دعوات معلّقة.',
  },
  roles: {
    system: 'الأدوار الجاهزة',
    custom: 'الأدوار المخصّصة',
    createCustom: 'إنشاء دور مخصّص',
    createTitle: 'دور مخصّص',
    basedOn: 'البدء من دور',
    basedOnNone: 'البدء فارغًا',
    permissions: 'الصلاحيات',
    permissionCount: '{{count}} صلاحيات',
    sensitive: 'حساس',
    phaseNote: 'المرحلة {{phase}}',
    emptyCustom: 'لا توجد أدوار مخصّصة بعد. أنشئ دورًا إذا لم يناسبك أي دور جاهز.',
    name: 'اسم الدور',
    description: 'الوصف',
    delete: 'حذف الدور',
    showPermissions: 'عرض الصلاحيات',
  },
  apiKeys: {
    create: 'إنشاء مفتاح API',
    name: 'اسم المفتاح',
    namePlaceholder: 'مثال: برنامج المحاسبة',
    scopes: 'النطاقات',
    prefix: 'البادئة',
    expiresAt: 'تاريخ الانتهاء',
    noExpiry: 'بلا انتهاء',
    revoked: 'مُلغى',
    expired: 'منتهي الصلاحية',
    revoke: 'إلغاء',
    secretTitle: 'مفتاحك جاهز',
    secretLead: 'انسخ هذا المفتاح إلى البرنامج الخارجي الآن. لن يُعرض مرة أخرى.',
    usage: 'مثال على الاستخدام',
    emptyTitle: 'لا توجد مفاتيح API بعد',
    emptyLead: 'أنشئ مفتاحًا لربط برامج المحاسبة أو ERP أو n8n.',
    confirmRevoke: 'ستفقد البرامج التي تستخدم هذا المفتاح الوصول فورًا. هل تريد إلغاءه؟',
    docs: 'وثائق API',
  },
  webhooks: {
    add: 'إضافة Webhook',
    url: 'عنوان URL',
    description: 'الوصف',
    events: 'الأحداث',
    allEvents: 'جميع الأحداث',
    active: 'نشط',
    disabled: 'معطّل',
    test: 'إرسال حدث تجريبي',
    testSent: 'أُضيف الحدث التجريبي إلى قائمة الانتظار. اطّلع على النتيجة في سجل التسليم.',
    deliveries: 'سجل التسليم',
    rotate: 'تجديد السر',
    secretTitle: 'سر التوقيع',
    secretLead:
      'احفظ هذا السر حتى يتمكن البرنامج المستقبِل من التحقق من أن الطلبات صادرة منا. لن يُعرض مرة أخرى.',
    signatureHelp:
      'يحمل كل طلب ترويسة X-Zootopia-Signature: t=<الوقت>,v1=<HMAC-SHA256(السر, الوقت + "." + المحتوى)>.',
    redeliver: 'إعادة التسليم',
    attempt: 'المحاولة',
    response: 'الاستجابة',
    delivery_pending: 'قيد الانتظار',
    delivery_succeeded: 'نجح',
    delivery_failed: 'فشل',
    delivery_dead: 'توقّف عن المحاولة',
    emptyTitle: 'لا توجد Webhooks بعد',
    emptyLead: 'أضف عنوان URL إذا كان ينبغي لبرنامج ما أن يُبلَّغ بأحداث المتجر فورًا.',
    emptyDeliveries: 'لا توجد عمليات تسليم بعد.',
    delete: 'حذف',
    confirmDelete: 'هل تريد إيقاف الإشعارات إلى عنوان URL هذا وحذفه؟',
    confirmRotate:
      'سيُنشأ سر توقيع جديد ويتوقف القديم عن العمل فورًا. حدّث البرنامج المستقبِل أيضًا. هل تريد المتابعة؟',
    disable: 'تعطيل',
    enable: 'تفعيل',
  },
  integrations: {
    pendingMerged: 'استخدم اتصال iyzico للدفع بالبطاقة',
    pendingDecision: 'يتطلب الإعداد: قرار الاستخدام والحساب لدى المالك',
    log_health_check: 'فحص الاتصال',
    health: {
      title: 'فحص الاتصال',
      lead: 'تُفحص الاتصالات المحفوظة تلقائيًا كل 6 ساعات باختبارات لا ترسل رسائل ولا تُنشئ تكلفة فقط. فشلان متتاليان يُنشئان تنبيهًا في حالة النظام ويُرسلان بريدًا إلى مستلمي التنبيهات. لا يغيّر الفحص حالة الاتصال.',
      verify: 'التحقق من جميع الاتصالات',
      summary: '{{time}}: {{ok}} تعمل، {{failed}} لا تعمل، {{skipped}} يجب اختبارها كلٌّ على حدة.',
      tableCaption: 'نتائج فحص الاتصال',
      colService: 'الخدمة',
      colResult: 'النتيجة',
      colDetail: 'التفاصيل',
      outcome_ok: 'يعمل',
      outcome_failed: 'لا يعمل',
      outcome_skipped: 'اختبره منفردًا',
      lastOk: 'آخر فحص {{time}}: يعمل',
      lastFailed: 'آخر فحص {{time}}: لا يعمل — جرّب «اختبار الاتصال»',
    },
    carrierViaGeliver:
      'يتطلب الربط المباشر عقد تكامل مؤسسيًا وإذن IP من شركة الشحن؛ ويمكنك حاليًا الشحن مع هذه الشركة عبر Geliver.',
    bizimhesapSettings: 'إعدادات الحساب الجاري والصندوق',
    adapterPending: 'غير متصل بعد (يتطلب الإعداد): بانتظار بيانات التكامل من المزوّد',
    configure: 'تهيئة',
    manageOnGoogle: 'من شاشة اتصالات Google',
    manageOnTracking: 'من شاشة القياس',
    test: 'اختبار الاتصال',
    testOk: 'نجح الاتصال',
    testFail: 'فشل الاتصال',
    disconnect: 'قطع الاتصال',
    save: 'حفظ البيانات',
    saved: 'حُفظت البيانات مشفّرة. اختبر الاتصال الآن.',
    environment: 'البيئة',
    env_sandbox: 'Sandbox (تجريبي)',
    env_live: 'مباشر',
    lastTested: 'آخر اختبار',
    notAvailable: 'يُضاف هذا التكامل في المرحلة {{phase}}. لا يمكن إدخال البيانات بعد.',
    docs: 'الوثائق الرسمية',
    logs: 'سجل الاتصال',
    emptyLogs: 'لا توجد سجلات بعد.',
    log_test_connection: 'اختبار الاتصال',
    log_mail_send: 'البريد الإلكتروني',
    log_mail_feedback: 'إشعار ارتداد / شكوى',
    logOutcome_success: 'نجح',
    logOutcome_failure: 'فشل',
    logOutcome_blocked: 'حُظر على Staging',
    reenterSecrets: 'لا تُعرض كلمات المرور المحفوظة أبدًا. أعد إدخال جميع الحقول لتغييرها.',
    confirmDisconnect: 'ستُحذف البيانات المحفوظة وستتوقف هذه الخدمة عن العمل. هل تريد المتابعة؟',
    paymentNote:
      '«Sandbox» / «مباشر» هنا هي نتيجة اختبار اتصال المفاتيح فقط؛ أما ما إذا كان الدفع بالبطاقة في واجهة المتجر معطّلًا أو تجريبيًا أو مباشرًا فيظهر في إعدادات الدفع:',
  },
  audit: {
    when: 'الوقت',
    actor: 'المنفّذ',
    action: 'الإجراء',
    entity: 'السجل',
    filterEntity: 'نوع السجل',
    allEntities: 'الكل',
    apply: 'تصفية',
    clear: 'مسح',
    loadMore: 'عرض المزيد',
    before: 'قبل',
    after: 'بعد',
    actor_system: 'النظام',
    actor_customer: 'العميل',
    actor_api_key: 'مفتاح API',
    actor_user: 'المستخدم',
    empty: 'لا توجد سجلات تطابق هذا الفلتر.',
    details: 'التفاصيل',
    code: 'رمز الإجراء',
    recordId: 'معرّف السجل',
  },
  system: {
    refresh: 'تحديث',
    checkedAt: 'وقت القياس: {{time}}',
    database: 'قاعدة البيانات',
    services: 'الخدمات',
    runStatus: {
      running: 'قيد التشغيل',
      succeeded: 'ناجح',
      failed: 'فاشل',
    },
    redis: 'خادم قائمة الانتظار',
    queues: 'قوائم الانتظار',
    queueName_mail: 'البريد الإلكتروني',
    waiting: 'بالانتظار',
    activeJobs: 'قيد التشغيل',
    failed: 'فاشلة',
    delayed: 'مؤجّلة',
    mail: 'إرسال البريد الإلكتروني',
    mail_organization_smtp: 'اتصال SMTP الخاص بالمنشأة',
    mail_platform_smtp: 'SMTP المنصة',
    mail_not_configured: 'غير مُعدّ',
    backup: 'آخر نسخة احتياطية',
    restoreTest: 'آخر اختبار للاستعادة',
    offsite: 'نسخة احتياطية خارج الموقع',
    offsiteSetup: 'يتطلب الإعداد',
    offsitePending: 'متصل؛ أول رفع بعد النسخ الاحتياطي الليلي التالي',
    offsiteKeep: 'يُحتفظ بها {{days}} يومًا في التخزين',
    none: 'لا يوجد بعد',
    domains: 'النطاقات وSSL',
    ok: 'يعمل',
    error: 'خطأ',
    daysLeft: 'متبقٍ {{days}} يومًا',
    noQueues: 'معلومات قائمة الانتظار غير متاحة.',
    media: 'تخزين الملفات (الصور والمستندات)',
    media_ok: 'قابل للكتابة',
    media_storage_permission_denied: 'لا يوجد إذن بالكتابة',
    media_storage_disk_full: 'القرص ممتلئ',
    media_storage_read_only: 'للقراءة فقط',
    media_storage_write_failed: 'غير قابل للكتابة',
    failedJobs: 'مهام الخلفية الفاشلة',
    environment: 'البيئة',
    env_staging: 'Staging (خادم تجريبي)',
    env_production: 'الإنتاج',
    env_development: 'التطوير',
    mailGuardTitle: 'حماية البريد الإلكتروني على Staging',
    mailGuardLead:
      'لمنع العملاء والموزّعين الحقيقيين من تلقي رسائل بريد إلكتروني من الخادم التجريبي، تُرسل الرسائل فقط إلى العناوين المدرجة في قائمة السماح. أما الرسائل الأخرى فلا تُرسل وتظهر بعبارة «حُظر على Staging» في التكاملات ← بريد SMTP ← سجل الاتصال. لا يوجد هذا القيد في بيئة الإنتاج.',
    mailGuardServer: 'مُعرّف على الخادم (MAIL_ALLOWLIST): {{count}} إدخالات',
    mailGuardList: 'العناوين المسموح بها من لوحة التحكم',
    mailGuardListHint: 'عنوان واحد (name@example.com) أو نطاق واحد (@example.com) في كل سطر؛ بحد أقصى 20.',
    mailGuardEmpty: 'قائمة السماح فارغة: لا يرسل خادم Staging أي بريد إلكتروني.',
    mailGuardPlaceholder: 'name@example.com\n@example.com',
    mailGuardSave: 'حفظ قائمة السماح',
    mailGuardSaved: 'تم حفظ قائمة السماح.',
    alertsTitle: 'التنبيهات الحرجة',
    alertsLead:
      'يُفحص كل 5 دقائق كلٌّ من النسخ الاحتياطية واختبار الاستعادة والقرص وقوائم انتظار المهام وشهادات SSL وإشعارات الدفع وإمكانية الوصول إلى واجهة المتجر ولوحة التحكم. يُرسل بريد إلكتروني عند بدء المشكلة، وكل 24 ساعة ما دامت مستمرة، وعند حلّها (بحد أقصى 10 رسائل في الساعة).',
    alertsNone: 'لا توجد مشكلات قائمة.',
    alertsResolved: 'حُلّت {{count}} تنبيهات خلال آخر 7 أيام',
    alertSince: 'منذ {{time}}',
    alertLastMail: 'آخر بريد: {{time}}',
    alertNotMailed: 'لم يُرسل البريد (حد الساعة أو لا يوجد مستلم)',
    alertResolvedAt: 'حُلّت: {{time}}',
    severity_critical: 'عاجل',
    severity_warning: 'تحذير',
    cspTitle: 'مخالفات أمان المحتوى في المتجر',
    cspLead:
      'عندما تحظر سياسة أمان المحتوى (CSP) في المتجر نصًا برمجيًا أو صورة أو إطارًا أو اتصالًا غير مسموح به، يُبلغ متصفح الزائر عن ذلك. يظهر هنا حظر وسم أو فيديو أو إطار دفع أُضيف حديثًا، أو محاولة لحقن تعليمات برمجية في الصفحة. لا تُحفظ بيانات شخصية ولا بلاغات إضافات المتصفح؛ وتُحذف السجلات التي لم تظهر منذ {{days}} يومًا.',
    cspNone: 'لم يُبلَّغ عن أي مخالفة خلال آخر {{days}} يومًا.',
    cspSummary: '{{rows}} مخالفة مختلفة، {{hits}} بلاغًا إجمالًا · ظهرت خلال آخر 24 ساعة: {{lastDay}}',
    cspDirective: 'القاعدة',
    cspBlocked: 'المورد المحظور',
    cspPage: 'الصفحة',
    cspHits: 'العدد',
    cspLastSeen: 'آخر ظهور',
    cspReportOnly: 'إبلاغ فقط',
    cspSource: 'المصدر: {{file}} (السطر {{line}})',
    cspKeyword_inline: 'تعليمات مضمَّنة (نص برمجي أو معالج حدث داخل الصفحة)',
    cspKeyword_eval: 'تعليمات ديناميكية (eval)',
    'cspKeyword_wasm-eval': 'ترجمة WebAssembly',
    cspKeyword_data: 'عنوان data:',
    cspKeyword_blob: 'عنوان blob:',
    cspKeyword_self: 'عنوان المتجر نفسه',
    alertKinds: {
      login_failures:
        'محاولات دخول فاشلة غير معتادة ({{surface}}): {{count}} محاولة و{{locked}} حسابات مقفلة خلال آخر {{minutes}} دقيقة',
      integration: 'فشل فحص الاتصال مرارًا: {{provider}} ({{result}})',
      backup_missing: 'لا توجد نسخة احتياطية لقاعدة البيانات منذ 26 ساعة',
      backup_failed: 'فشلت آخر نسخة احتياطية لقاعدة البيانات',
      restore_failed: 'فشل اختبار الاستعادة من النسخة الاحتياطية',
      queue_backlog: 'تراكم في قائمة انتظار المهام ({{queue}}: {{waiting}} بالانتظار)',
      queue_failed: 'مهام فاشلة ({{queue}}: {{failed}})',
      disk_space: 'القرص ممتلئ بنسبة {{usedPct}}% ({{freeGb}} GB متاحة)',
      tls: 'شهادة SSL: {{host}} ({{days}} يومًا)',
      payment_hooks: 'رُفضت إشعارات الدفع ({{failures}} خلال الساعة الأخيرة)',
      uptime: 'تعذّر الوصول إلى {{name}} ({{result}})',
      preauth_expiring: 'لدى {{count}} طلبات تفويضات مسبقة أقدم من 20 يومًا (الأقدم: {{oldest}})',
    },
    errorTracking: 'تتبّع الأخطاء الخارجي',
    errorTrackingLive: 'متصل',
    errorTrackingSetup: 'يتطلب الإعداد',
    observability: 'المراقبة (OpenTelemetry)',
    recipients: 'مستلمو التنبيهات',
    recipientsHint:
      'بريد إلكتروني واحد في كل سطر (بحد أقصى 10). إذا تُرك فارغًا، يُبلَّغ المالكون. إذا كان ALERT_EMAILS مُعرّفًا على الخادم، تُرسل تنبيهات المنصة إليه.',
    recipientsSave: 'حفظ المستلمين',
    recipientsSaved: 'تم حفظ مستلمي التنبيهات.',
    mailDnsTitle: 'نطاق البريد الإلكتروني (SPF وDKIM وDMARC)',
    mailDnsLead:
      'توجد هذه السجلات في إعدادات DNS لنطاقك. إذا كانت مفقودة، فقد تذهب رسائل الطلبات وكلمات المرور إلى البريد غير المرغوب فيه أو تُرفض.',
    mailDnsNone: 'لا يوجد نطاق للفحص: يظهر بمجرد تعيين اتصال SMTP أو نطاق واجهة المتجر.',
    mailDnsDomain: '{{domain}} ({{source}}) · تم الفحص: {{time}}',
    mailDnsSource_smtp: 'عنوان مرسل SMTP',
    mailDnsSource_provider: 'عنوان المرسل لدى مزوّد البريد الإلكتروني',
    mailDnsSource_storefront: 'نطاق واجهة المتجر',
    mailDnsSource_query: 'أُدخل يدويًا',
    dns: {
      spf: 'SPF',
      dkim: 'DKIM',
      dmarc: 'DMARC',
      spf_ok: 'موجود',
      spf_missing: 'مفقود — أضف سجل SPF الذي يقدمه مزوّد البريد الإلكتروني',
      spf_multiple: 'سجلات SPF متعددة — ادمجها في سجل واحد (وإلا فهي غير صالحة)',
      spf_unknown: 'تعذّرت قراءة DNS؛ حاول مرة أخرى لاحقًا',
      dkim_ok: 'موجود',
      dkim_not_found: 'غير موجود — أدخل المحدِّد أدناه إذا كنت تعرفه',
      dkim_unknown: 'تعذّرت قراءة DNS؛ حاول مرة أخرى لاحقًا',
      dmarc_ok: 'موجود (الحماية مفعّلة)',
      dmarc_monitoring: 'موجود، مراقبة فقط (p=none)',
      dmarc_missing: 'مفقود — أضف على الأقل «v=DMARC1; p=none»',
      dmarc_unknown: 'تعذّرت قراءة DNS؛ حاول مرة أخرى لاحقًا',
    },
    dkimSelector: 'محدِّد DKIM',
    dkimSelectorHint: 'الاسم الوارد في سجل DKIM لدى مزوّدك (مثل «default»)؛ اتركه فارغًا إذا كان غير معروف.',
    dkimSelectorSave: 'حفظ المحدِّد والفحص',
    mailGuardTooMany: 'بحد أقصى 20 إدخالًا.',
  },
  account: {
    profile: 'الملف الشخصي',
    phone: 'الهاتف',
    language: 'لغة لوحة التحكم',
    uiMode: 'وضع الاستخدام',
    beginner: 'مبتدئ — الشروحات مفتوحة افتراضيًا',
    advanced: 'متقدم — شاشة مبسّطة',
    password: 'كلمة المرور',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    changePassword: 'تغيير كلمة المرور',
    passwordChanged: 'تم تغيير كلمة المرور، وسُجّل الخروج من الجلسات على الأجهزة الأخرى.',
    sessions: 'الجلسات المفتوحة',
    thisDevice: 'هذا الجهاز',
    revoke: 'إنهاء الجلسة',
    organizations: 'منشآتي',
    switchTo: 'التبديل إلى هذه المنشأة',
    current: 'الحالية',
    mobile: 'تطبيق الجوال',
    browser: 'المتصفح',
  },
  privacy: {
    create: 'تسجيل طلب',
    createLead:
      'سجّل طلبًا ورد عبر البريد الإلكتروني أو البريد الإلكتروني المسجّل (KEP) أو البريد العادي أو حضوريًا. مهلة الرد 30 يومًا من تاريخ وصوله إلى المنشأة.',
    created: 'تم تسجيل الطلب',
    save: 'حفظ',
    state: 'عرض',
    states: {
      open: 'الطلبات المفتوحة',
      closed: 'المُنجزة',
    },
    emptyOpen: 'لا توجد طلبات مفتوحة',
    emptyClosed: 'لا توجد طلبات مُنجزة',
    emptyLead:
      'يمكن للعملاء التقديم من حسابي ← بياناتي الشخصية في واجهة المتجر؛ أما الطلبات الواردة بالبريد الإلكتروني فسجّلها عبر «تسجيل طلب».',
    overdue: 'متأخر',
    daysLeft: 'متبقٍ {{count}} يومًا',
    requesterName: 'اسم مقدّم الطلب',
    requesterEmail: 'البريد الإلكتروني لمقدّم الطلب',
    kind: 'نوع الطلب',
    channel: 'ورد عبر',
    receivedAt: 'تاريخ الطلب',
    dueAt: 'الموعد النهائي للرد',
    store: 'المتجر (الاسم المعروض في الرسائل)',
    details: 'نص الطلب / ملخصه',
    statusLabel: 'الحالة',
    customer: 'حساب العميل',
    noCustomer: 'لا يوجد حساب بهذا البريد الإلكتروني (تُطابَق طلبات الزوار حسب البريد الإلكتروني)',
    resolution: 'النتيجة',
    exportedAt: 'آخر تنزيل للبيانات',
    recordsTitle: 'السجلات في النظام',
    records:
      '{{orders}} طلبات، {{addresses}} عناوين، {{favorites}} مفضلات، {{questions}} أسئلة عن المنتجات، {{companies}} عضويات في شركات موزّعين، {{invoices}} فواتير، {{acceptances}} موافقات على عقود/إشعارات، {{messages}} رسائل تواصل، {{tickets}} تذاكر دعم، {{chats}} محادثات مباشرة، {{newsletter}} اشتراكات في النشرة البريدية، {{campaigns}} رسائل حملات، {{automations}} رسائل أتمتة، {{stockAlerts}} طلبات تنبيه بتوفر المخزون، {{smsMessages}} رسائل حملات SMS/WhatsApp؛ {{loyaltyPoints}} نقاط ولاء (تسقط عند المحو).',
    export: 'تنزيل نسخة من البيانات',
    exported: 'تم تنزيل البيانات',
    erasureTitle: 'معاينة إخفاء الهوية',
    erasureDeletes:
      'يُحذف / تُخفى هويته: الحساب (الاسم والبريد الإلكتروني والهاتف وكلمة المرور؛ ويُغلق تسجيل الدخول)، ودفتر العناوين، والجلسات، وسلال التسوق، والمفضلات، وعضوية شركة الموزّع؛ وفي الطلبات: البريد الإلكتروني والهاتف وعنوان التسليم (تبقى المدينة/المنطقة) وملاحظة العميل؛ واسم الكاتب في أسئلة المنتجات. وتُسجّل موافقات الرسائل الممنوحة على أنها مسحوبة.',
    erasureKeeps:
      'يُحتفظ به (التزام قانوني): مبالغ الطلبات وبنودها، وعنوان الفوترة والفواتير، وسجلات الدفع، وسجلات الموافقة على العقود والمعلومات المسبقة، وسجل الموافقات، وسجل التدقيق، وسجل هذا الطلب.',
    note: 'الرد على مقدّم الطلب',
    noteErasure: 'الرد على مقدّم الطلب (اختياري؛ يُرسل نص افتراضي عند إخفاء الهوية)',
    noteHint:
      'يُرسل إلى مقدّم الطلب بالبريد الإلكتروني عند إنجاز الطلب أو رفضه (إذا كان البريد الإلكتروني مُعدًّا). يلزم ذكر سبب للرفض.',
    startReview: 'بدء المراجعة',
    complete: 'إنجاز',
    reject: 'رفض',
    anonymize: 'إخفاء الهوية',
    confirmEmail: 'اكتب البريد الإلكتروني لمقدّم الطلب للتأكيد: {{email}}',
    anonymizeConfirm: 'إخفاء الهوية نهائيًا',
    anonymized: 'تم إخفاء هوية البيانات الشخصية',
    kinds: {
      export: 'نسخة من البيانات',
      erasure: 'المحو (إخفاء الهوية)',
      info: 'طلب معلومات',
      rectification: 'التصحيح',
      objection: 'الاعتراض',
      other: 'أخرى',
    },
    channels: {
      storefront: 'واجهة المتجر (حسابي)',
      email: 'البريد الإلكتروني',
      kep: 'البريد الإلكتروني المسجّل (KEP)',
      post: 'البريد العادي',
      in_person: 'حضوريًا',
      other: 'أخرى',
    },
    statuses: {
      received: 'مستلَم',
      in_progress: 'قيد المراجعة',
      completed: 'مُنجز',
      rejected: 'مرفوض',
    },
  },
  exports: {
    settingsTitle: 'الفترة والملف',
    settingsLead: 'تنطبق هذه الاختيارات على جميع القوائم أدناه.',
    period: 'الفترة',
    periods: {
      this_month: 'هذا الشهر',
      last_month: 'الشهر الماضي',
      last_30: 'آخر 30 يومًا',
      this_year: 'هذا العام',
      last_year: 'العام الماضي',
      custom: 'اختيار التواريخ',
      all: 'كل الفترات',
    },
    from: 'من',
    to: 'إلى',
    range: '{{from}} – {{to}} (بتوقيت تركيا، مع احتساب يوم النهاية)',
    rangeAll: 'جميع السجلات',
    store: 'المتجر',
    allStores: 'جميع المتاجر',
    format: 'صيغة الملف',
    formats: {
      xlsx: 'Excel (XLSX)',
      csv: 'CSV (فاصلة منقوطة)',
    },
    personalData: 'البيانات الشخصية',
    personalDataHint: 'تتطلب الملفات غير المقنّعة التحقق بخطوتين، ويُشار إليها في سجل التدقيق.',
    personalDataModes: {
      masked: 'مقنّعة (موصى به)',
      full: 'غير مقنّعة (بيانات كاملة)',
    },
    listsTitle: 'القوائم',
    listsLead: 'يُسجّل كل تنزيل في سجل التدقيق. يحتوي الملف الواحد على 50,000 صف كحد أقصى.',
    noAccess: 'لا توجد قائمة يمكنك تصديرها. اطلب من المسؤول صلاحية العرض المناسبة.',
    downloaded: 'تم تنزيل {{name}}.',
    stockNote: 'المخزون الحالي؛ لا تنطبق الفترة.',
    customersNote: 'تنطبق الفترة على تاريخ التسجيل.',
    kinds: {
      orders: {
        title: 'الطلبات',
        lead: 'صف واحد لكل طلب مع المبالغ وضريبة القيمة المضافة وبيانات الفوترة.',
        action: 'تنزيل الطلبات',
      },
      order_lines: {
        title: 'بنود الطلبات',
        lead: 'صف واحد لكل صنف مع نسبة ضريبة القيمة المضافة والدفعات.',
        action: 'تنزيل بنود الطلبات',
      },
      customers: {
        title: 'العملاء',
        lead: 'مع النوع والموافقات وعدد الطلبات.',
        action: 'تنزيل العملاء',
      },
      stock: {
        title: 'المخزون',
        lead: 'حسب المستودع والدفعة، مع تواريخ انتهاء الصلاحية.',
        action: 'تنزيل المخزون',
      },
      invoices: {
        title: 'الفواتير',
        lead: 'رقم الفاتورة والنوع والمبلغ الصافي وضريبة القيمة المضافة والإجمالي.',
        action: 'تنزيل الفواتير',
      },
      payments: {
        title: 'المدفوعات والمبالغ المستردة',
        lead: 'التحصيلات والمبالغ المستردة؛ تظهر المبالغ المستردة بقيم سالبة.',
        action: 'تنزيل المدفوعات',
      },
    },
  },
  seo: {
    indexingTitle: 'الفهرسة',
    indexingLead: 'ما إذا كان بإمكان محركات البحث رؤية المتجر.',
    indexOpen: 'مفتوح لمحركات البحث',
    indexClosed: 'مغلق أمام محركات البحث',
    closedStore: 'المتجر غير منشور (معاينة). يُفتح عند نشر المتجر.',
    closedServer: 'المتجر منشور، لكن الفهرسة (SITE_INDEXING) معطّلة على الخادم.',
    checked: 'تم فحص: {{products}} منتجات، {{categories}} فئات، {{pages}} صفحات، {{posts}} مقالات.',
    issuesTitle: 'مشكلات SEO',
    issuesLead: 'نواقص في محتوى واجهة المتجر المنشور. يفتح رابط التعديل الشاشة المناسبة.',
    filter: 'نوع المشكلة',
    filterAll: 'الكل ({{count}} عناصر)',
    noIssues: 'لا توجد مشكلات لهذا الفلتر',
    noIssuesLead: 'لم يُعثر على نواقص من هذا النوع في المحتوى المنشور.',
    colKind: 'النوع',
    colTitle: 'العنوان',
    colIssues: 'المشكلات',
    editItem: 'تعديل {{title}}',
    more: 'يُعرض أول {{shown}} عناصر (من إجمالي {{total}}).',
    kinds: {
      product: 'منتج',
      category: 'فئة',
      page: 'صفحة',
      post: 'مقالة مدونة',
    },
    issueNames: {
      title_long: 'العنوان طويل جدًا',
      title_duplicate: 'عنوان مكرّر',
      description_missing: 'لا يوجد وصف',
      description_long: 'الوصف طويل جدًا',
      description_short: 'الوصف قصير جدًا',
      image_missing: 'لا توجد صورة',
      image_alt_missing: 'النص البديل مفقود',
      image_too_small: 'الصورة الرئيسية صغيرة',
      image_low_resolution: 'الصورة الرئيسية منخفضة الدقة',
      gtin_invalid: 'باركود (GTIN) غير صالح',
      content_thin: 'محتوى ضعيف',
    },
    crawl: {
      title: 'زاحف الموقع',
      lead: 'يتصفح واجهة متجرك كما يفعل الزائر ويكتشف المشكلات التقنية (نطاقك فقط).',
      start: 'بدء الزحف',
      started: 'أُضيف الزحف إلى قائمة الانتظار.',
      none: 'لم يُجرَ أي زحف بعد.',
      clean: 'لم يُعثر على مشكلات في آخر زحف.',
      result: '{{pages}} صفحات، {{issues}} مشكلات',
      truncated: 'تم بلوغ حد الصفحات',
      failed: 'فشل: {{reason}}',
      failReasons: {
        no_domain: 'ليس للمتجر نطاق لواجهة المتجر',
        site_protected: 'واجهة المتجر محمية بكلمة مرور (Staging)؛ لا يستطيع الزاحف قراءة الصفحات',
        home_unreachable: 'تعذّر الوصول إلى الصفحة الرئيسية',
        https_required: 'عنوان واجهة المتجر لا يستخدم https',
        private_address: 'يشير النطاق إلى عنوان شبكة داخلية',
        unknown: 'خطأ غير متوقع',
      },
      showingPrevious: 'النتائج أدناه من آخر زحف مكتمل ({{time}}).',
      filter: 'نوع المشكلة',
      filterAll: 'الكل ({{count}})',
      tableLabel: 'مشكلات الزحف',
      colSeverity: 'الخطورة',
      colType: 'المشكلة',
      colPath: 'العنوان',
      colDetail: 'التفاصيل',
      status: {
        queued: 'في قائمة الانتظار',
        running: 'قيد التشغيل',
        completed: 'مكتمل',
        failed: 'فشل',
      },
      trigger: {
        manual: 'يدوي',
        scheduled: 'أسبوعي',
      },
      severity: {
        error: 'خطأ',
        warning: 'تحذير',
        info: 'معلومة',
      },
      detailStatus: 'الحالة {{status}}',
      detailFrom: 'مرتبط من: {{list}}',
      detailCanonical: 'الرابط الأساسي (canonical): {{url}}',
      detailCount: '{{count}} عناصر',
      detailAlso: 'مطابق لـ: {{list}}',
      types: {
        fetch_failed: 'تعذّر الوصول إلى الصفحة',
        server_error: 'خطأ في الخادم',
        broken_link: 'رابط معطّل',
        sitemap_url_not_ok: 'عنوان خريطة الموقع لا يفتح',
        redirect_chain: 'سلسلة إعادة توجيه',
        redirected_link: 'رابط مُعاد توجيهه',
        title_missing: 'لا يوجد عنوان',
        title_duplicate: 'عنوان مكرّر',
        description_missing: 'لا يوجد وصف',
        description_duplicate: 'وصف مكرّر',
        h1_missing: 'لا يوجد H1',
        h1_multiple: 'عدة عناوين H1',
        img_alt_missing: 'صورة بلا نص بديل',
        canonical_mismatch: 'عدم تطابق canonical',
        noindex_in_sitemap: 'صفحة noindex في خريطة الموقع',
        orphan_page: 'صفحة يتيمة (بلا روابط)',
      },
    },
    historyTitle: 'سجل تغييرات SEO',
    historyLead: 'تغييرات عناوين SEO وأوصافها والأسماء المختصرة (آخر 50).',
    historyEmpty: 'لا توجد تغييرات في حقول SEO بعد.',
    fields: {
      seoTitle: 'عنوان SEO',
      seoDescription: 'وصف SEO',
      slug: 'الاسم المختصر (Slug)',
    },
  },
  merchant: {
    previewTitle: 'الفحص قبل إرسال الخلاصة (Feed)',
    previewLead:
      'تُفحص المنتجات المنشورة في المتجر والمتاحة لعملاء التجزئة؛ ولا تُرسل المنتجات التي بها مشكلات إلى Google أبدًا.',
    counts: {
      items: 'العروض المراد إرسالها',
      inStock: 'متوفر في المخزون',
      excluded: 'المنتجات غير المرسلة',
    },
    excludedTitle: 'المنتجات غير المرسلة',
    warningsTitle: 'التحذيرات (تُرسل)',
    colProduct: 'المنتج',
    colReason: 'السبب',
    reasons: {
      excluded_by_user: 'أُوقف من شاشة المنتج',
      health_not_approved: 'لا توجد موافقة بيطرية أو تغيّر المحتوى',
      health_claim: 'ادعاء بشأن مرض/علاج في النص',
      image_missing: 'لا توجد صورة',
      image_too_small: 'الصور صغيرة جدًا بالنسبة إلى Google (يلزم {{min}}×{{min}} px على الأقل)',
      image_too_large: 'صور أكبر من 64 ميغابكسل',
      price_missing: 'لا يوجد سعر',
      price_not_tax_inclusive: 'السعر لا يشمل ضريبة القيمة المضافة',
      translation_missing: 'لا توجد ترجمة بلغة السوق',
      tax_rate_missing: 'لا توجد نسبة ضريبة القيمة المضافة لبلد السوق',
      no_variants: 'لا يوجد متغيّر نشط',
      country_blocked: 'المنتج غير متاح للبيع في بلد هذا السوق',
    },
    warnings: {
      gtin_missing: 'لا يوجد باركود (GTIN)',
      description_missing: 'لا يوجد وصف',
      google_category_missing: 'لا توجد فئة منتج في Google',
      title_truncated: 'اقتُطع العنوان عند 150 حرفًا',
      image_main_replaced: 'الصورة الأولى صغيرة جدًا بالنسبة إلى Google؛ أُرسلت الصورة التالية كصورة رئيسية',
      image_below_upcoming_minimum: 'لن تُرسل بعد 31 يناير 2027: تشترط Google ألا يقل الحجم عن 500×500 px',
      image_below_recommended: 'الصورة الرئيسية أقل من الحجم الموصى به 1500×1500 px',
      image_size_unknown: 'حجم الصورة الرئيسية غير معروف',
    },
    imageSize: 'الصورة الأولى {{size}} px',
    feedTitle: 'ملف الخلاصة (Feed)',
    feedLead:
      'في Merchant Center، أضف هذا العنوان ضمن «المنتجات ← مصادر البيانات ← ملف ← الجلب المجدول»؛ تجلبه Google يوميًا. لا يلزم اتصال بـ Google.',
    feedEnabled: 'ملف الخلاصة مفعّل',
    feedSaved: 'تم الحفظ.',
    previewMarket: 'السوق',
    marketsTitle: 'الأسواق (الدولة واللغة)',
    marketsLead:
      'يحصل كل سوق يُرسل إلى Google على خلاصة ومصدر بيانات Merchant API خاصين به: السعر بعملة ذلك السوق وقائمة أسعاره، والاسم والوصف بلغة السوق، وطرق الشحن الخاصة بتلك الدولة.',
    marketsSaved: 'تم حفظ الأسواق.',
    defaultMarket: 'افتراضي',
    marketFeedUrl: 'عنوان خلاصة {{market}}',
    marketsNote:
      'أضف كل سوق في Merchant Center كمصدر بيانات منفصل (باختيار الدولة واللغة)؛ تُنشئ مزامنة Merchant API المصادر تلقائيًا. يبقى سوق واحد على الأقل محددًا.',
    feedUrl: 'عنوان الخلاصة',
    lastFetch: 'آخر جلب: {{time}} ({{count}} عروض)',
    neverFetched: 'لم يُجلب بعد.',
    rotate: 'تجديد العنوان',
    rotateConfirm: 'يتوقف العنوان القديم عن العمل فورًا؛ حدّثه في Merchant Center.',
    apiTitle: 'Merchant API',
    apiLead: 'تُرسل المنتجات مباشرةً عبر اتصال Google؛ وتظهر هنا حالة الموافقة وأسباب الرفض.',
    notLinked: 'لم يُختر حساب Merchant Center',
    notLinkedLead: 'اتصل بصلاحية Merchant Center في شاشة اتصالات Google واختر الحساب الخاص بهذا المتجر.',
    lastSync: 'آخر مزامنة: {{time}}',
    neverSynced: 'لم تتم المزامنة بعد',
    status: {
      approved: 'موافق عليه',
      pending: 'قيد المراجعة',
      disapproved: 'مرفوض',
    },
    syncNow: 'إرسال الآن',
    synced: 'أُرسل {{inserted}}، وحُذف {{deleted}}، ولم يتغيّر {{unchanged}}.',
    issuesTitle: 'المشكلات لدى Google',
    issuesLead: 'العروض المرفوضة أو التي تلقت تحذيرات، مع شرح Google ورابط الوثائق.',
    perfTitle: 'أداء المنتجات',
    perfLead:
      'مرات ظهور منتجاتك ونقراتها على Google في القوائم المجانية وإعلانات Shopping. تُقرأ من Merchant Center عند الطلب.',
    perfPeriod: 'الفترة',
    perfLastDays: 'آخر {{n}} يومًا',
    perfTotals: 'إجماليات الفترة',
    perfProduct: 'المنتج',
    perfOrganicClicks: 'النقرات المجانية',
    perfOrganicImpressions: 'مرات الظهور المجانية',
    perfAdsClicks: 'نقرات الإعلانات',
    perfAdsImpressions: 'مرات ظهور الإعلانات',
    perfConversions: 'التحويلات (المجانية)',
    perfEmpty: 'لا توجد مرات ظهور على Google في هذه الفترة.',
    perfNote:
      'حتى يوم أمس. لا تُبلغ Google عن التحويلات إلا للقوائم المجانية؛ أما الإنفاق الإعلاني وإيرادات الطلبات الفعلية ففي مركز الإعلانات.',
    colOffer: 'العرض (SKU)',
    colStatus: 'الحالة',
    colIssue: 'المشكلة',
    docs: 'وثائق Google',
  },
  attribution: {
    builderTitle: 'إنشاء رابط حملة',
    builderLead:
      'يضيف معلومات المصدر (UTM) إلى الرابط الذي تستخدمه في الإعلانات والبريد الإلكتروني ووسائل التواصل الاجتماعي ورموز QR. تُجمّع الطلبات حسبها في التقرير أدناه.',
    url: 'عنوان الصفحة',
    fields: {
      source: 'المصدر (utm_source)',
      medium: 'الوسيط (utm_medium)',
      campaign: 'الحملة (utm_campaign)',
      term: 'الكلمة المفتاحية (utm_term)',
      content: 'المحتوى (utm_content)',
    },
    result: 'رابط الحملة',
    resultEmpty: 'أدخل العنوان والمصدر والوسيط والحملة',
    copy: 'نسخ',
    copied: 'تم نسخ الرابط.',
    builderNote:
      'تُحوّل القيم إلى أحرف صغيرة وتُحوّل الأحرف التركية (مثل «Ekim Bülteni» ← ekim-bulteni) حتى تظهر الحملة في صف واحد في التقرير.',
    reportTitle: 'الطلبات حسب المصدر',
    reportLead:
      'الطلبات الحقيقية (باستثناء المسودات والإلغاءات) حسب المصدر الذي جاءت منه. الإيرادات من الطلبات المدفوعة فقط؛ وتُعرض المبالغ المستردة بشكل منفصل.',
    period: 'الفترة',
    lastDays: 'آخر {{n}} يومًا',
    model: 'نقطة التفاعل',
    models: {
      last: 'آخر تفاعل',
      first: 'أول تفاعل',
    },
    dimension: 'التقسيم',
    dimensions: {
      source_medium: 'المصدر / الوسيط',
      campaign: 'الحملة',
    },
    colSource: 'المصدر',
    colMedium: 'الوسيط',
    colCampaign: 'الحملة',
    colOrders: 'الطلبات',
    colPaid: 'المدفوعة',
    colRevenue: 'الإيرادات (المدفوعة)',
    colRefunded: 'المبالغ المستردة',
    colNet: 'الصافي',
    noConsent: 'غير معروف (لا توجد موافقة على ملفات تعريف الارتباط)',
    direct: 'مباشر / غير معروف',
    noCampaign: 'بلا حملة',
    empty: 'لا توجد طلبات في هذه الفترة.',
    reportNote:
      'لا تُسجّل معلومات المصدر إلا إذا سمح الزائر بملفات تعريف الارتباط التحليلية أو التسويقية؛ وتُحتسب الطلبات الأخرى ضمن «غير معروف».',
  },
  webVitals: {
    statusTitle: 'القياس',
    statusLead:
      'تُقاس الصفحة الرئيسية وفئة واحدة ومنتج واحد ومقالة مدونة واحدة على الجوال وسطح المكتب باستخدام Google PageSpeed Insights. تُقاس المتاجر المنشورة كل يوم اثنين.',
    notConfigured: 'لا يوجد مفتاح PageSpeed Insights',
    notConfiguredLead:
      'أنشئ مفتاح API مجانيًا في Google Cloud، وأدخله في التكاملات ← PageSpeed Insights ثم اختبره.',
    start: 'القياس الآن',
    running: 'جارٍ القياس…',
    started: 'بدأ القياس؛ قد يستغرق بضع دقائق.',
    lastRun: 'آخر قياس: {{time}}',
    neverRun: 'لم يُقس بعد.',
    resultsTitle: 'أحدث النتائج',
    resultsLead:
      'الدرجة: اختبار Lighthouse المعملي (0–100). LCP وINP وCLS: بيانات الزوار الحقيقيين خلال آخر 28 يومًا (Chrome UX Report)، وهي التي تستخدمها Google في الترتيب.',
    colPage: 'الصفحة',
    colDevice: 'الجهاز',
    colScore: 'الدرجة',
    colLcp: 'LCP',
    colInp: 'INP',
    colCls: 'CLS',
    thresholds:
      'جيد: LCP ≤ 2.5 ثانية، INP ≤ 200 مللي ثانية، CLS ≤ 0.1. ضعيف: LCP > 4 ثوانٍ، INP > 500 مللي ثانية، CLS > 0.25. الدرجة: 90+ جيد، 50–89 يحتاج إلى تحسين.',
    templates: {
      home: 'الصفحة الرئيسية',
      category: 'فئة',
      product: 'منتج',
      post: 'مقالة مدونة',
    },
    strategies: {
      mobile: 'الجوال',
      desktop: 'سطح المكتب',
    },
    ratings: {
      good: 'جيد',
      needs_improvement: 'يحتاج إلى تحسين',
      poor: 'ضعيف',
    },
    change: '{{n}} مقارنة بالسابق',
    scopes: {
      url: 'هذه الصفحة',
      origin: 'الموقع بالكامل (لا توجد بيانات كافية لهذه الصفحة)',
      none: 'لا توجد بيانات زوار كافية',
    },
    fieldLine: 'البيانات الميدانية: {{scope}}',
    labLine: 'المختبر: LCP {{lcp}} ثانية، TBT {{tbt}} مللي ثانية، CLS {{cls}}',
    units: {
      s: '{{n}} ثانية',
      ms: '{{n}} مللي ثانية',
    },
    runsTitle: 'أحدث القياسات',
    runStatus: {
      queued: 'في قائمة الانتظار',
      running: 'جارٍ القياس',
      completed: 'مكتمل',
      failed: 'فشل',
    },
    triggers: {
      manual: 'يدوي',
      scheduled: 'أسبوعي',
    },
    errors: {
      psi_page_failed: 'تعذّر فتح الصفحة (قد تكون واجهة المتجر محمية بكلمة مرور)',
      psi_key_invalid: 'لم يُقبل مفتاح API',
      psi_quota: 'استُنفدت الحصة اليومية',
      psi_timeout: 'انتهت مهلة القياس',
      psi_unreachable: 'تعذّر الوصول إلى PageSpeed Insights',
      pagespeed_not_configured: 'لا يوجد مفتاح',
      store_has_no_domain: 'ليس للمتجر نطاق',
      unknown: 'فشل القياس',
    },
  },
  attributes: {
    title: 'خصائص المنتجات',
    lead: 'الخصائص التقنية للمنتجات (مثل الوزن الصافي والمرحلة العمرية والنكهة). تُدخل القيم في شاشة المنتج؛ وتظهر الخصائص المرئية في جدول «المواصفات» بصفحة المنتج.',
    add: 'إضافة خاصية',
    edit: 'تعديل الخاصية',
    editItem: 'تعديل الخاصية {{name}}',
    saved: 'تم حفظ الخاصية',
    deleted: 'تم حذف الخاصية',
    deleteConfirm: 'حذف «{{name}}»؟ ستُحذف قيمتها في {{count}} منتجات أيضًا.',
    emptyTitle: 'لا توجد خصائص بعد',
    emptyLead: 'أضف مثلًا «الوزن الصافي» (رقم، kg) أو «المرحلة العمرية» (خيارات: صغير، بالغ، مسن).',
    name: 'الاسم',
    code: 'الرمز المختصر',
    type: 'النوع',
    types: {
      text: 'نص',
      number: 'رقم',
      select: 'خيار (واحد)',
      multiselect: 'خيارات (متعددة)',
      boolean: 'نعم / لا',
    },
    unit: 'الوحدة',
    options: 'الخيارات',
    optionsPlaceholder: 'خيار واحد في كل سطر',
    where: 'يظهر في',
    onProductPage: 'صفحة المنتج',
    inFilters: 'عوامل التصفية',
    internal: 'لوحة التحكم فقط',
    productCount: 'المنتجات',
    visible: 'العرض في صفحة المنتج',
    filterable: 'العرض في عوامل تصفية واجهة المتجر',
    position: 'الترتيب',
    tagsTitle: 'الوسوم المستخدمة',
    tagsLead: 'الوسوم المعطاة للمنتجات وعدد منتجاتها. تُدخل الوسوم في شاشة المنتج؛ ولا تظهر في واجهة المتجر.',
    noTags: 'لا توجد وسوم بعد.',
  },
  collections: {
    title: 'المجموعات',
    lead: 'مجموعات من منتجات مختارة يدويًا أو منتجات تطابق قاعدة (مثل «منتجات القطط الصغيرة»). تتحدّث المجموعة القائمة على قاعدة تلقائيًا كلما تغيّرت المنتجات.',
    add: 'مجموعة جديدة',
    emptyTitle: 'لا توجد مجموعات بعد',
    emptyLead: 'اختر المنتجات يدويًا أو اكتب قاعدة حسب الفئة والعلامة التجارية والوسم ونوع الحيوان والخصائص.',
    name: 'الاسم',
    kind: 'النوع',
    kinds: {
      manual: 'مختارة يدويًا',
      rule: 'قائمة على قاعدة',
    },
    kindChoice: {
      manual: 'سأختار المنتجات بنفسي',
      rule: 'المنتجات المطابقة لقاعدة',
    },
    status: 'الحالة',
    statuses: {
      active: 'نشطة',
      hidden: 'مخفية',
    },
    productCount: 'المنتجات',
    saved: 'تم حفظ المجموعة',
    deleted: 'تم حذف المجموعة',
    deleteConfirm: 'حذف المجموعة «{{title}}»؟ لن تُحذف المنتجات.',
    backToList: 'العودة إلى المجموعات',
    basics: 'البيانات الأساسية',
    slug: 'الاسم المختصر (Slug)',
    description: 'الوصف',
    seoTitle: 'عنوان SEO',
    seoDescription: 'وصف SEO',
    productsTitle: 'المنتجات',
    pickProducts: 'إضافة منتج',
    matchesTitle: 'المنتجات المطابقة: {{count}}',
    matchesLead: 'المنتجات في المجموعة المحفوظة (بأي حالة؛ لا تعرض واجهة المتجر إلا المنشورة منها).',
    previewLead: 'معاينة: لم تُحفظ القاعدة بعد.',
    noMatches: 'لا توجد منتجات مطابقة.',
    match: 'الشروط',
    matchAll: 'يجب استيفاء جميع الشروط',
    matchAny: 'يكفي استيفاء أي شرط',
    conditions: 'قائمة الشروط',
    field: 'الحقل',
    fields: {
      category: 'الفئة',
      brand: 'العلامة التجارية',
      tag: 'الوسم',
      species: 'نوع الحيوان',
      attribute: 'الخاصية',
    },
    attribute: 'الخاصية',
    op: 'المقارنة',
    ops: {
      is: 'يساوي',
      is_not: 'لا يساوي',
      gte: 'على الأقل',
      lte: 'على الأكثر',
    },
    value: 'القيمة',
    choose: 'اختر',
    addCondition: 'إضافة شرط',
    removeCondition: 'إزالة الشرط',
    preview: 'عرض النتائج المطابقة',
  },
  siteSearch: {
    reportTitle: 'تقرير البحث',
    reportLead:
      'عمليات البحث التي أُجريت في واجهة المتجر (يُحتسب أول عرض لصفحة البحث بحثًا واحدًا). لا تُحفظ أي بيانات شخصية.',
    period: 'الفترة',
    lastDays: 'آخر {{days}} يومًا',
    emptyTitle: 'لا توجد عمليات بحث في هذه الفترة',
    emptyLead: 'تظهر عمليات البحث هنا عندما يستخدم الزوار البحث في واجهة المتجر.',
    totalSearches: 'إجمالي عمليات البحث',
    distinctQueries: 'عمليات البحث المختلفة',
    zeroResultSearches: 'عمليات البحث بلا نتائج',
    topTitle: 'الأكثر بحثًا',
    zeroTitle: 'عمليات البحث بلا نتائج',
    noZero: 'لا توجد عمليات بحث بلا نتائج.',
    noResults: 'لا توجد نتائج',
    colQuery: 'البحث',
    colSearches: 'العدد',
    colResults: 'آخر النتائج',
    synonymsTitle: 'المرادفات',
    synonymsLead:
      'يُبحث عن كلمات المجموعة كبدائل لبعضها (مثل طعام، علف). مفيد لعمليات البحث التي لا تُرجع نتائج.',
    addSynonym: 'إضافة مرادفات',
    editSynonym: 'تعديل المرادفات',
    editSynonymItem: 'تعديل المجموعة {{terms}}',
    deleteSynonymConfirm: 'حذف المجموعة {{terms}}؟',
    synonymSaved: 'تم حفظ المرادفات',
    synonymDeleted: 'تم حذف مجموعة المرادفات',
    noSynonyms: 'لا توجد مجموعات مرادفات بعد.',
    terms: 'الكلمات',
    termsPlaceholder: 'مفصولة بفواصل: طعام, علف',
  },
  keywords: {
    alertsTitle: 'التنبيهات',
    alertsLead:
      'من بيانات Search Console لآخر 28 يومًا: الصفحات المتنافسة على البحث نفسه، والكلمات المفتاحية التي ليس لها صفحة مستهدفة.',
    noAlerts: 'لا توجد تنبيهات.',
    none: 'لا يوجد.',
    cannibalTitle: 'التنافس الذاتي (Cannibalization)',
    gapTitle: 'فجوة المحتوى',
    gapReasons: {
      no_target: 'لا توجد صفحة مستهدفة',
      target_not_found: 'الصفحة المستهدفة غير منشورة',
    },
    inPool: 'في المجمّع',
    target: 'الهدف',
    pageStats: '{{impressions}} مرات ظهور، {{clicks}} نقرات، الترتيب {{position}}',
    poolTitle: 'مجمّع الكلمات المفتاحية',
    poolLead: 'عمليات البحث التي يستهدفها المتجر، مع بيانات Search Console لآخر 28 يومًا.',
    add: 'إضافة كلمة مفتاحية',
    edit: 'تعديل الكلمة المفتاحية',
    editItem: 'تعديل {{keyword}}',
    saved: 'تم الحفظ.',
    deleted: 'تم الحذف.',
    deleteConfirm: 'إزالة «{{keyword}}» من المجمّع؟',
    cluster: 'العنقود',
    allClusters: 'جميع العناقيد',
    language: 'اللغة',
    allLanguages: 'جميع اللغات',
    search: 'بحث',
    emptyTitle: 'لا توجد كلمات مفتاحية بعد',
    emptyLead: 'استخدم «إضافة كلمة مفتاحية» أو اختر من اقتراحات Search Console أدناه.',
    colKeyword: 'الكلمة المفتاحية',
    colTarget: 'الصفحة المستهدفة',
    colClicks: 'النقرات',
    colImpressions: 'مرات الظهور',
    colPosition: 'متوسط الترتيب',
    colTopPage: 'الصفحة الأعلى في مرات الظهور',
    cannibalized: 'التنافس الذاتي',
    targetStatus: {
      ok: 'منشورة',
      missing: 'لا يوجد هدف',
      not_found: 'غير منشورة',
      unverified: 'لم يُفحص',
    },
    intents: {
      informational: 'معلوماتي',
      commercial: 'تجاري',
      transactional: 'معاملاتي',
      navigational: 'تنقّلي',
    },
    metricsNote: 'النقرات ومرات الظهور والترتيب هي بيانات Search Console لآخر 28 يومًا (بتأخير يقارب يومين).',
    keyword: 'الكلمة المفتاحية',
    intent: 'نية البحث',
    intentNone: 'غير محدد',
    targetPath: 'الصفحة المستهدفة',
    notes: 'ملاحظة',
    candidatesTitle: 'اقتراحات Search Console',
    candidatesLead:
      'عمليات بحث غير موجودة في المجمّع حققت أكبر عدد من مرات الظهور خلال آخر 28 يومًا. اخترها وأضفها؛ تُقترح الصفحة المستهدفة بناءً على الصفحة الأعلى ظهورًا.',
    notSynced: 'لا توجد بيانات Search Console بعد. اختر موقعًا (Property) وزامنه من شاشة أداء البحث:',
    noCandidates: 'لا توجد اقتراحات جديدة؛ جميع عمليات البحث موجودة في المجمّع.',
    candidateStats: '{{impressions}} مرات ظهور، {{clicks}} نقرات، الترتيب {{position}}',
    importCluster: 'العنقود',
    importSelected: 'إضافة المحدد ({{n}})',
    imported: 'أُضيفت {{created}} كلمات مفتاحية، و{{skipped}} كانت موجودة بالفعل.',
    rankTitle: 'تتبّع الترتيب',
    rankLead:
      'يتطلب تتبّع ترتيب Google يوميًا مزوّد بيانات مرخّصًا (مدفوعًا)؛ وإلى أن يُختار مزوّد ويُدخل مفتاحه يظهر «يتطلب الإعداد». حاليًا، الترتيب هو متوسط Search Console.',
  },
  scSetup: {
    title: 'الاتصال بـ Google والإعداد',
    lead: 'زر واحد: يتحقق النظام من خصائص Search Console لنطاق المتجر والنطاقات القديمة ويضيفها، ويرسل خريطة الموقع، ويطابق صفحات الموقع القديم الظاهرة في Google بالعناوين الجديدة. ويفحص كل صباح صفحات المنتجات وعينات من العناوين القديمة في Google.',
    connectedAs: 'حساب Google المتصل: {{email}}',
    notConnected: 'لا يوجد حساب Google متصل.',
    missingScope: 'إذن التحقق من الموقع غير موجود: امنحه عبر «الاتصال بـ Google».',
    connect: 'الاتصال بـ Google',
    run: 'تشغيل الإعداد',
    rerun: 'تشغيل الإعداد مجددًا',
    done: 'اكتمل إعداد Search Console',
    siteOk: 'تم التحقق والإضافة إلى Search Console',
    siteVerifiedOnly: 'تم التحقق؛ تعذّرت الإضافة إلى Search Console',
    siteFailed: 'توقف عند {{step}}: {{reason}}',
    enableApi: 'يجب تفعيل "{{api}}" في مشروع Google Cloud (مجانًا)، ثم أعد تشغيل الإعداد.',
    enableApiLink: 'افتح صفحة التفعيل',
    sitePending: 'لم يُعدّ بعد',
    lastRun: 'آخر إعداد: {{date}}',
    sitemapOk: 'أُرسلت خريطة الموقع: {{url}}',
    sitemapFailed: 'تعذّر إرسال خريطة الموقع: {{reason}}',
    sitemapSkipped: 'لم تُرسل خريطة الموقع (تعذّرت إضافة خاصية المتجر).',
    legacyPages:
      '{{found}} صفحة ظاهرة في Google على الخصائص القديمة: {{matched}} مطابقة جديدة، و{{table}} يُعاد توجيهها مسبقًا، و{{fallback}} بلا مقابل (الروابط المعطّلة).',
    publishNote:
      'لكي يدوم الاتصال يجب أن يكون تطبيق OAuth في Google Cloud «قيد الإنتاج»؛ ينتهي إذن التطبيق في وضع «الاختبار» بعد 7 أيام.',
    inspectionsTitle: 'حالة الفهرسة في Google (فحص يومي للعناوين)',
    inspectionsEmpty: 'لا فحوصات بعد. تظهر النتائج الأولى في صباح اليوم التالي للإعداد.',
    colUrl: 'العنوان',
    colKind: 'النوع',
    colState: 'الحالة في Google',
    colCrawl: 'آخر زحف',
    checkedAt: 'فُحص: {{date}}',
    roles: {
      store: 'المتجر',
      legacy: 'نطاق قديم',
    },
    kinds: {
      product: 'صفحة منتج',
      legacy: 'عنوان قديم',
    },
    steps: {
      token: 'ملف التحقق',
      verify: 'التحقق',
      add: 'الإضافة إلى Search Console',
      link: 'الربط',
      sitemap: 'خريطة الموقع',
      pages: 'الصفحات القديمة',
    },
  },
  indexNow: {
    title: 'IndexNow (Bing وYandex)',
    lead: 'تُبلَّغ عناوين المنتجات والفئات والصفحات والمقالات المتغيرة إلى Bing وYandex كل عشر دقائق؛ وتُرسل كل العناوين مرة واحدة في أول تشغيل.',
    notLive: 'المتجر غير منشور: لا يُرسل شيء.',
    indexingOff: 'الفهرسة متوقفة على الخادم: لا يُرسل شيء.',
    key: 'المفتاح: {{key}} (ملفه منشور على الموقع)',
    noKey: 'يُنشأ المفتاح مع أول إرسال.',
    last: 'آخر إرسال: {{date}} · {{count}} عنوانًا',
    never: 'لم يُرسل شيء بعد.',
    failed: 'فشل الإرسال: {{reason}}',
    sent: 'أُرسل {{count}} عنوانًا إلى IndexNow',
    submit: 'إرسال كل العناوين الآن',
    skipped: {
      not_live: 'المتجر غير منشور.',
      indexing_off: 'الفهرسة متوقفة.',
      no_domain: 'لا يوجد نطاق للمتجر.',
      nothing_changed: 'لا عناوين للإرسال.',
    },
  },
  sc: {
    notLinked: 'لم يُختر موقع (Property) في Search Console',
    notLinkedLead:
      'اربط حساب Google واختر موقع Search Console الخاص بهذا المتجر؛ تصل البيانات صباح اليوم التالي (أو عبر «المزامنة الآن»).',
    statusTitle: 'الموقع المرتبط',
    lastSync: 'آخر مزامنة: {{time}}',
    neverSynced: 'لم تتم المزامنة بعد',
    dataRange: 'البيانات: {{from}} – {{to}}',
    syncNow: 'المزامنة الآن',
    synced: 'اكتملت المزامنة ({{rows}} صفوف).',
    noData:
      'لا توجد بيانات بعد. استخدم «المزامنة الآن»؛ تحصل المواقع الجديدة على بيانات Google بعد بضعة أيام.',
    summaryTitle: 'الملخص',
    period: 'الفترة',
    lastDays: 'آخر {{count}} يومًا',
    metrics: {
      clicks: 'النقرات',
      impressions: 'مرات الظهور',
      ctr: 'نسبة النقر إلى الظهور',
      position: 'متوسط الترتيب',
    },
    vsPrevious: '{{change}} مقارنة بالفترة السابقة',
    chartLabel: 'مخطط النقرات اليومية',
    chartCaption: 'النقرات اليومية (تتأخر بيانات Google بنحو يومين).',
    tableTitle: 'التفاصيل',
    dimension: 'عرض',
    dims: {
      query: 'الاستعلامات',
      page: 'الصفحات',
      country: 'الدول',
      device: 'الأجهزة',
    },
    devices: {
      mobile: 'الجوال',
      desktop: 'سطح المكتب',
      tablet: 'الجهاز اللوحي',
    },
    filter: 'بحث',
    noRows: 'لا توجد صفوف في هذه الفترة.',
    moversTitle: 'الصفحات الصاعدة والهابطة',
    moversLead: 'النقرات في الفترة الأخيرة مقارنة بالفترة السابقة المماثلة في المدة.',
    rising: 'صاعدة',
    falling: 'هابطة',
    noMovers: 'لا يوجد تغيير ملحوظ.',
    notComparable: 'لا توجد بيانات للفترة السابقة بعد (تتراكم بيانات Search Console يوميًا).',
    sitemapsTitle: 'خرائط الموقع',
    sitemapsLead: 'خرائط الموقع المرسلة إلى Search Console وحالتها.',
    sitemapsError: 'تعذّرت قراءة خرائط الموقع؛ اختبر اتصال Google.',
    noSitemaps: 'لم تُرسل أي خريطة موقع بعد.',
    colSitemap: 'خريطة الموقع',
    colSubmitted: 'تاريخ الإرسال',
    colStatus: 'الحالة',
    colUrls: 'عناوين URL',
    sitemapPending: 'قيد المعالجة',
    sitemapOk: 'تمت المعالجة',
    sitemapErrors: '{{count}} أخطاء',
    ownSitemap: 'خريطة موقع المتجر:',
    notInProperty: 'لا يشملها الموقع (Property)',
    submitSitemap: 'إرسال خريطة الموقع',
    sitemapSubmitted: 'أُرسلت خريطة الموقع إلى Search Console.',
    inspectTitle: 'فحص عنوان URL',
    inspectLead: 'حالة الصفحة في فهرس Google (فحص عنوان URL في Search Console).',
    inspectUrl: 'عنوان الصفحة',
    inspect: 'فحص',
    quota: 'استُخدمت {{used}} / {{limit}} عمليات فحص اليوم.',
    verdicts: {
      PASS: 'مفهرسة',
      PARTIAL: 'جزئيًا (مع تحذيرات)',
      FAIL: 'غير مفهرسة (خطأ)',
      NEUTRAL: 'غير مفهرسة',
      VERDICT_UNSPECIFIED: 'غير معروف',
    },
    inspectFields: {
      verdict: 'النتيجة',
      coverageState: 'التغطية',
      indexingState: 'الفهرسة مسموح بها',
      robotsTxtState: 'robots.txt',
      pageFetchState: 'جلب الصفحة',
      lastCrawlTime: 'آخر زحف',
      googleCanonical: 'عنوان canonical الذي اختارته Google',
    },
    digestTitle: 'ملخص أسبوعي بالبريد الإلكتروني',
    digestLead:
      'كل يوم اثنين في الساعة 09:00 يتلقى مستلمو التنبيهات ملخص آخر 7 أيام وأهم الاستعلامات والصفحات الصاعدة/الهابطة وآخر زحف للموقع.',
    digestToggle: 'ملخص أسبوعي بالبريد الإلكتروني',
    digestSaved: 'تم الحفظ.',
  },
  google: {
    connected: 'تم ربط حساب Google.',
    clientTitle: 'عميل OAuth',
    clientLead: 'عميل OAuth الذي أنشأته في Google Cloud Console. يُحفظ المعرّف والسر مشفّرين ضمن التكاملات.',
    clientOk: 'تم التحقق',
    clientMissing: 'أدخل أولًا معرّف العميل والسر واختبرهما في التكاملات ← حساب Google (عميل OAuth).',
    toIntegrations: 'الانتقال إلى التكاملات',
    redirectUri: 'عنوان URI المعتمد لإعادة التوجيه',
    copy: 'نسخ',
    copied: 'تم نسخ العنوان.',
    accountTitle: 'حساب Google',
    accountLead:
      'توافق على الخدمات المحددة في شاشة الموافقة الخاصة بـ Google؛ ولا تصل كلمة مرورك إلينا أبدًا.',
    account: 'الحساب المرتبط',
    connectedAt: 'تاريخ الربط',
    lastChecked: 'آخر فحص',
    notConnected: 'لم يُربط أي حساب Google بعد.',
    chooseServices: 'الخدمات المراد ربطها',
    permissionsTitle: 'الأذونات الممنوحة',
    granted: 'ممنوح',
    notGranted: 'غير ممنوح',
    connect: 'الربط عبر Google',
    reconnect: 'إعادة الربط',
    test: 'اختبار الاتصال',
    testOk: 'الاتصال يعمل.',
    testFailed: 'توجد مشكلات في الاتصال؛ راجع السجل.',
    disconnect: 'إزالة الربط',
    disconnectConfirm: 'سيُلغى وصول Google وستُزال المواقع/الحسابات المختارة للمتاجر.',
    disconnected: 'أُزيل الربط وأُلغي الوصول لدى Google.',
    disconnectedLocal: 'أُزيل الربط؛ تعذّر الوصول إلى Google، لذا أزل الوصول من حساب Google الخاص بك أيضًا.',
    status: {
      active: 'نشط',
      error: 'خطأ',
    },
    errors: {
      token_revoked: 'أُزيل الوصول من جهة Google؛ أعد الربط.',
      userinfo_failed: 'تعذّرت قراءة معلومات الحساب.',
      resource_not_accessible: 'لم يعد بالإمكان الوصول إلى هذا المورد.',
      insufficient_scope: 'لم يُمنح الإذن.',
      permission_denied: 'لا يوجد وصول إلى هذا المورد.',
      api_not_enabled: 'واجهة API غير مفعّلة في مشروع Cloud.',
      unauthorized: 'رُفض التفويض.',
      quota_exceeded: 'استُنفدت حصة Google؛ ستُعاد المحاولة لاحقًا.',
      http_error: 'رفضت Google الطلب.',
      network: 'تعذّر الوصول إلى Google.',
      timeout: 'لم يستجب Google في الوقت المحدد.',
    },
    services: {
      search_console: 'Search Console',
      analytics: 'Google Analytics 4',
      merchant_center: 'Merchant Center',
      google_ads: 'Google Ads',
      business_profile: 'Google Business Profile',
    },
    serviceLeads: {
      search_console: 'استعلامات البحث، وأداء الصفحات، وإرسال خريطة الموقع.',
      analytics: 'قائمة الخصائص والتقارير (للقراءة فقط).',
      merchant_center: 'بيانات المنتجات وحالاتها.',
      google_ads:
        'الإنفاق الإعلاني (إلى مركز الإعلانات) ورفع التحويلات اختياريًا. لا يلزم رمز مطوّر؛ يتطلب الحساب الحقيقي وصول Explorer لمشروع Cloud.',
      business_profile: 'بيانات موقع النشاط التجاري ومراجعات Google (للقراءة فقط).',
    },
    resourcesTitle: 'موارد المتجر',
    resourcesLead:
      'أي خاصية Search Console وخاصية GA4 وحساب Merchant Center وحساب عميل Google Ads وموقع Business Profile يستخدمه كل متجر.',
    notLinked: 'لم يتم الاختيار.',
    serviceNotGranted: 'لم تُمنح الصلاحية لهذه الخدمة؛ حدّدها وأعد الاتصال.',
    choose: 'اختيار',
    change: 'تغيير',
    unlink: 'إزالة',
    linked: 'تم حفظ المورد.',
    unlinked: 'تمت إزالة ربط المورد.',
    resourceLabel: 'مورد {{service}}',
    pick: 'تحديد',
    noResources: 'لا يمكن لحساب Google هذا الوصول إلى أي مورد. امنح الوصول في Google ثم أعد تحميل الصفحة.',
    lastSync: 'آخر مزامنة: {{time}}',
    noSyncYet: 'لم تتم المزامنة بعد',
    logsTitle: 'السجل',
    logsLead: 'آخر 50 عملية. لا تُسجَّل الرموز المميزة والبيانات الشخصية أبدًا.',
    noLogs: 'لا توجد إدخالات بعد.',
    colTime: 'الوقت',
    colOperation: 'العملية',
    colOutcome: 'النتيجة',
    colDetail: 'التفاصيل',
    logError: 'خطأ: {{code}}',
    operations: {
      oauth_start: 'بدأ الاتصال',
      oauth_callback: 'استجابة Google',
      token_refresh: 'تحديث الرمز المميز',
      list_resources: 'قائمة الموارد',
      verify_resource: 'التحقق من الوصول إلى الحساب',
      test: 'اختبار الاتصال',
      revoke: 'تم إلغاء الوصول',
    },
    outcomes: {
      success: 'نجحت',
      failure: 'فشلت',
      blocked: 'محظورة',
    },
  },
  tracking: {
    crossDomain: {
      title: 'التتبع عبر النطاقات',
      lead: 'إذا كان للمتجر عدة نطاقات للواجهة، يُقاس الزائر عند التنقل بينها كزائر واحد بالمصدر (الحملة) نفسه.',
      active: 'نشط',
      inactive: 'غير مطلوب',
      activeLead: 'يُنقل رابط GA4 وبيانات المصدر عبر {{count}} نطاقات.',
      reasons: {
        single_domain: 'للمتجر نطاق واجهة واحد؛ يُفعَّل تلقائيًا عند إضافة نطاق ثانٍ.',
        no_google_tag: 'لم يُدخل معرّف قياس GA4 أو حاوية GTM.',
      },
      toDomains: 'الانتقال إلى النطاقات',
      domains: 'النطاقات في التتبع عبر النطاقات',
      stepsTitle: 'المطلوب',
      stepAuto:
        'تضيف الواجهة تلقائيًا معامل رابط GA4 وبيانات المصدر إلى الروابط بين هذه النطاقات؛ ولا يُعد القدوم منها إحالة.',
      stepGa4:
        'في Google Analytics أضف هذه النطاقات ضمن المشرف ← مصادر البيانات ← مصدر الويب ← ضبط إعدادات العلامة ← ضبط النطاقات. مطلوب إذا كنت تستخدم GTM.',
      stepReferrals:
        'لكي لا تظهر هذه التنقلات كإحالات، أضفها عند الحاجة في المكان نفسه ضمن «إدراج الإحالات غير المرغوب فيها».',
      stepConsent:
        'موافقة ملفات تعريف الارتباط لكل نطاق: يُسأل الزائر مجددًا في النطاق الآخر؛ ولا تُكتب بيانات المصدر هناك إلا بموافقته.',
    },
    server: {
      title: 'الأحداث من جانب الخادم',
      lead: 'تُرسَل المبيعات المكتملة وعمليات استرداد المبالغ أيضًا من الخادم بشكل مستقل عن المتصفح: وبذلك تُقاس أيضًا طلبات التحويل البنكي والدفع عند الاستلام ومبيعات الزوار الذين يستخدمون أدوات حظر الإعلانات. ويُراعى إذن ملفات تعريف الارتباط الذي منحه الزائر وقت الطلب.',
      providers: {
        ga4: 'Google Analytics 4 (Measurement Protocol)',
        meta: 'Meta (Conversions API)',
        tiktok: 'TikTok (Events API)',
      },
      short: {
        ga4: 'GA4',
        meta: 'Meta',
        tiktok: 'TikTok',
      },
      status: {
        live: 'مفعّل',
        off: 'متوقف',
        needs_secret: 'يتطلب الإعداد',
        needs_id: 'لا يوجد معرّف',
      },
      needsId: {
        ga4: 'أدخل أولًا معرّف قياس GA4 ضمن «وسوم واجهة المتجر» أعلاه.',
        meta: 'أدخل أولًا معرّف بكسل Meta ضمن «وسوم واجهة المتجر» أعلاه.',
        tiktok: 'أدخل أولًا معرّف بكسل TikTok ضمن «وسوم واجهة المتجر» أعلاه.',
      },
      secret: {
        ga4: 'المفتاح السري لـ API (Measurement Protocol)',
        meta: 'رمز الوصول (Conversions API)',
        tiktok: 'رمز الوصول (Events API)',
      },
      secretSaved: 'تم الحفظ — أدخل قيمة جديدة لاستبدالها',
      testCode: 'رمز حدث الاختبار',
      enabled: 'إرسال أحداث الخادم',
      save: 'حفظ',
      saved: 'تم الحفظ.',
      test: 'إرسال حدث تجريبي',
      testOk: 'وصل الحدث التجريبي إلى المزوّد.',
      testFailed: 'فشل الاختبار: {{reason}}',
      remove: 'إزالة المفتاح السري',
      removeConfirm: 'سيُحذف المفتاح السري ويتوقف إرسال أحداث الخادم إلى هذا المزوّد.',
      last24h:
        'آخر 24 ساعة: {{sent}} مُرسَل، {{failed}} فاشل، {{pending}} قيد الانتظار، {{skipped}} غير مُرسَل.',
      userData: 'مطابقة البيانات الشخصية (تجزئة البريد الإلكتروني والهاتف)',
      userDataLead:
        'عند التفعيل، يُرسَل البريد الإلكتروني ورقم الهاتف الخاصان بالعميل إلى Meta وTikTok على هيئة تجزئة SHA-256. يُعدّ هذا نقلًا للبيانات الشخصية: حدّث أولًا إشعار الخصوصية وسياسة ملفات تعريف الارتباط بالتعاون مع محاميك. متوقف افتراضيًا.',
      logTitle: 'سجل أحداث الخادم',
      logLead: 'آخر 100 حدث: البيانات المُرسَلة والمحاولات ورسالة الخطأ من المزوّد. تُحفظ لمدة 90 يومًا.',
      logEmpty: 'لا توجد أحداث خادم بعد. تظهر عند دفع طلب زائر منح موافقته.',
      filter: 'الحالة',
      all: 'الكل',
      eventStatus: {
        pending: 'قيد الانتظار',
        sent: 'مُرسَل',
        failed: 'فاشل',
        skipped: 'غير مُرسَل',
      },
      events: {
        purchase: 'شراء',
        refund: 'استرداد المبلغ',
      },
      colTime: 'الوقت',
      colProvider: 'المزوّد',
      colEvent: 'الحدث',
      colOrder: 'الطلب',
      colStatus: 'الحالة',
      colDetail: 'التفاصيل',
      attempts: '{{n}} محاولات',
      payload: 'البيانات المُرسَلة',
      retry: 'إعادة المحاولة',
      retried: 'أُعيد إلى قائمة الانتظار.',
      errors: {
        no_client_id: 'لا يوجد ملف تعريف ارتباط GA (طلب الزائر قبل تحميل GA)',
        no_match_keys: 'لا يوجد معرّف مطابق (لا يوجد ملف تعريف ارتباط للبكسل)',
        disabled: 'لم يُرسَل لأن الإرسال كان متوقفًا',
        timeout: 'لم يستجب المزوّد في الوقت المحدد',
        network: 'تعذّر الوصول إلى المزوّد',
        redirect: 'أعاد المزوّد توجيه الطلب (ربما تغيّر عنوان الخدمة)',
      },
    },
    statusTitle: 'حالة واجهة المتجر',
    statusLead:
      'لا تُحمَّل الوسوم في واجهة المتجر إلا ما دامت سياسة ملفات تعريف الارتباط منشورة وبموافقة الزائر.',
    active: 'نشط',
    inactive: 'غير نشط',
    activeLead: 'الوسوم التي تُحمَّل عند موافقة الزائر: {{list}}.',
    reasons: {
      no_tags:
        'لا توجد وسوم بعد. لا تعرض واجهة المتجر شريط ملفات تعريف الارتباط وتستخدم ملفات تعريف الارتباط الضرورية فقط.',
      cookie_policy_missing:
        'لا تُضاف الوسوم إلى واجهة المتجر لعدم نشر سياسة ملفات تعريف الارتباط. انشرها أولًا ضمن «النصوص القانونية».',
    },
    toLegal: 'الانتقال إلى النصوص القانونية',
    tagsTitle: 'الوسوم',
    tagsLead: 'انسخ المعرّفات من الحسابات ذات الصلة. الحقل الفارغ يعني أن هذا الوسم غير مستخدم.',
    fields: {
      gtmContainerId: 'معرّف Google Tag Manager',
      ga4MeasurementId: 'معرّف قياس GA4',
      googleAdsId: 'معرّف Google Ads',
      googleAdsPurchaseLabel: 'تصنيف تحويل الشراء',
      metaPixelId: 'معرّف بكسل Meta',
      tiktokPixelId: 'معرّف بكسل TikTok',
    },
    consentNote:
      'لا يُحمَّل GA4 إلا بموافقة التحليلات، ولا تُحمَّل Google Ads وMeta وTikTok إلا بموافقة التسويق، ويُحمَّل GTM بأيٍّ منهما. لا يعمل أي وسم للزوار الذين يرفضون.',
    save: 'حفظ الوسوم',
    saved: 'تم حفظ الوسوم. تصبح سارية في واجهة المتجر خلال بضع دقائق.',
    providers: {
      site: 'واجهة المتجر (اختيار الموافقة)',
      gtm: 'Google Tag Manager',
      ga4: 'Google Analytics 4',
      googleAds: 'Google Ads',
      meta: 'بكسل Meta',
      tiktok: 'بكسل TikTok',
    },
    legal: {
      title: 'الأثر على النصوص القانونية',
      lead: 'ملفات تعريف الارتباط الخاصة بالوسوم المهيأة ومتلقّو البيانات، وما إذا كانت النصوص المنشورة تذكرها.',
      policyVersion: 'سياسة ملفات تعريف الارتباط المنشورة: الإصدار {{version}}.',
      policyMissing: 'لا توجد سياسة ملفات تعريف ارتباط منشورة.',
      actionNeeded:
        'بعض ملفات تعريف الارتباط أو عمليات النقل غير مذكورة: اطلب من محاميك تحديث النصوص وانشر إصدارًا جديدًا.',
      cookiesTitle: 'ملفات تعريف الارتباط',
      transfersTitle: 'عمليات نقل البيانات (إلى الخارج)',
      colCookie: 'ملف تعريف الارتباط',
      colService: 'الخدمة',
      colDuration: 'المدة',
      colRecipient: 'المتلقّي',
      colCountries: 'الدول',
      colInPolicy: 'في سياسة ملفات تعريف الارتباط',
      colInNotice: 'في إشعار الخصوصية',
      found: 'مذكور',
      missing: 'غير مذكور',
      days: '{{count}} يومًا',
      note: 'لا يكتب النظام النصوص القانونية؛ بل يتحقق فقط من ورود أسماء ملفات تعريف الارتباط والمزوّدين فيها. تتبع أسماء ملفات تعريف الارتباط ومددها وثائق المزوّدين وقد تتغير. عند نشر إصدار جديد من سياسة ملفات تعريف الارتباط، يُطلب من الزوار الاختيار مجددًا.',
    },
    stats: {
      title: 'إحصاءات الموافقة على ملفات تعريف الارتباط',
      lead: 'آخر 30 يومًا؛ يُحتسب آخر اختيار لكل متصفح.',
      none: 'لا توجد اختيارات خلال آخر 30 يومًا.',
      visitors: 'المتصفحات التي اختارت',
      acceptAll: 'قبلت الكل',
      rejectAll: 'رفضت',
      custom: 'اختارت من التفضيلات',
      analytics: 'سمحت بالتحليلات',
      marketing: 'سمحت بالتسويق',
    },
  },
  migration: {
    exportTitle: 'التصدير (Staging)',
    exportLead:
      'يُنزّل إعدادات ومحتوى المتجر المحدد في ملف ZIP واحد. ارفعه باستخدام «استيراد» في لوحة التحكم المباشرة.',
    sourceStore: 'المتجر',
    export: 'تنزيل حزمة الترحيل',
    exported: 'تم تنزيل حزمة الترحيل',
    included:
      'مُضمَّن: المنتجات، والفئات، وقوائم الأسعار والأسعار، وأرصدة المخزون (مع الدفعة/تاريخ انتهاء الصلاحية)، والنصوص القانونية، والصفحات، والمدونة، والقوائم، واللافتات، والسمة، وطرق الشحن، والحسابات البنكية، وبيانات المتجر والنشاط التجاري، وعمليات إعادة التوجيه، والصور.',
    excluded:
      'غير مُضمَّن: العملاء، والموزّعون، والطلبات، والمدفوعات، وسجل التدقيق، والمستخدمون، والنطاقات، والرقم الضريبي للنشاط التجاري، وجميع المفاتيح/كلمات المرور (SMTP، iyzico، PayTR، API).',
    importTitle: 'الاستيراد (مباشر)',
    importLead:
      'تُعرض معاينة أولًا: لا يُكتب أي شيء. تتم المطابقة باستخدام slug وSKU والرمز وIBAN؛ ورفع الحزمة نفسها مجددًا لا يُنشئ تكرارات.',
    targetStore: 'المتجر الهدف',
    targetFromPackage: 'المتجر الموجود في الحزمة (يُطابَق بالرمز، ويُنشأ إن لم يكن موجودًا)',
    includeStock: 'نقل أرصدة المخزون كمخزون افتتاحي',
    overwrite: 'الكتابة فوق السجلات الموجودة المختلفة (عند الإيقاف: تُضاف السجلات المفقودة فقط)',
    legalReviewed: 'أؤكد أن النصوص القانونية قد راجعها محامٍ (النشر مع علامة «تمت المراجعة»)',
    carryApprovals: 'أنقل باسمي موافقات الطبيب البيطري (المختص) الممنوحة في بيئة Staging',
    chooseFile: 'اختيار ملف الحزمة ومعاينته',
    previewOf: 'حزمة من المتجر «{{store}}» التابع لـ {{org}} ({{env}})، صُدِّرت في {{date}}.',
    storeWillCreate: 'المتجر «{{store}}» غير موجود هنا؛ سيُنشأ في وضع المعاينة (أضف النطاق لاحقًا).',
    sectionsCaption: 'الإجراءات حسب القسم',
    section: 'القسم',
    create: 'للإضافة',
    update: 'للتحديث',
    unchanged: 'دون تغيير',
    skipped: 'تم التخطي',
    stockTitle: 'المخزون الافتتاحي (لكل منتج)',
    stockSkipped: 'لن يُنقل المخزون (الخيار متوقف)',
    product: 'المنتج',
    stockStatus: 'الحالة',
    stockStatus_new: 'للكتابة',
    stockStatus_already: 'مكتوب مسبقًا',
    stockStatus_exists: 'يحتوي المستودع على سجلات مخزون بالفعل؛ تم التخطي',
    stockStatus_missing: 'المنتج أو المستودع مفقود',
    approvalsPending:
      'سينتظر {{products}} منتجًا و{{content}} عنصر محتوى موافقة الطبيب البيطري (لم تُنقل الموافقات)، وتبقى مخفية في واجهة المتجر حتى الموافقة.',
    legalWithReview: 'ستُنشر النصوص القانونية مع علامة «راجعها محامٍ»: {{list}}',
    legalWithoutReview: 'ستُنشر النصوص القانونية دون علامة «راجعها محامٍ» (وهي شرط للإطلاق): {{list}}',
    warnings: {
      migration_no_secrets:
        'المفاتيح وكلمات المرور غير موجودة في الحزمة: أدخل مجددًا بيانات SMTP والدفع والشحن في لوحة التحكم المباشرة.',
      migration_card_off: 'يصل الدفع بالبطاقة متوقفًا؛ فعّله في إعدادات الدفع بعد إدخال المفاتيح واختبارها.',
      migration_domains_manual: 'لا تُنقل النطاقات؛ أضف النطاق المباشر ضمن «المتاجر».',
    },
    refresh: 'تحديث المعاينة',
    stale: 'تغيّرت الخيارات؛ حدّث المعاينة',
    apply: 'استيراد',
    applyConfirm:
      'ستُطبَّق الحزمة على هذا النشاط التجاري (في معاملة واحدة). لا تتغير السجلات الموجودة إلا إذا كان خيار «الكتابة فوق» مفعّلًا. هل تريد المتابعة؟',
    applied: 'تم تطبيق حزمة الترحيل',
    resultTitle: 'تم التطبيق على المتجر «{{store}}». النتيجة:',
    sections: {
      store: 'المتجر',
      organization: 'بيانات النشاط التجاري',
      files: 'الصور',
      brands: 'العلامات التجارية',
      taxClasses: 'فئات الضريبة',
      categories: 'الفئات',
      customerGroups: 'مجموعات العملاء',
      warehouses: 'المستودعات',
      products: 'المنتجات',
      productOptions: 'خيارات المنتجات',
      productVariants: 'المتغيرات (SKU)',
      productCategories: 'روابط المنتجات بالفئات',
      productMedia: 'صور المنتجات',
      markets: 'الأسواق',
      storeBrands: 'العلامات التجارية للمتجر',
      priceLists: 'قوائم الأسعار',
      prices: 'الأسعار',
      productStoreListings: 'إدراجات المنتجات',
      shippingMethods: 'طرق الشحن',
      paymentSettings: 'إعدادات الدفع (البطاقة متوقفة)',
      bankAccounts: 'الحسابات البنكية',
      legalDocuments: 'النصوص القانونية',
      legalDocumentVersions: 'إصدارات النصوص القانونية',
      postCategories: 'فئات المدونة',
      posts: 'مقالات المدونة',
      postVersions: 'إصدارات المقالات',
      pages: 'الصفحات',
      pageVersions: 'إصدارات الصفحات',
      banners: 'اللافتات',
      menus: 'القوائم',
      themes: 'السمة',
      themeVersions: 'إصدارات السمة',
      redirects: 'عمليات إعادة التوجيه',
    },
  },
  uiTranslations: {
    coverageTitle: 'حالة الترجمة حسب اللغة',
    coverageLead:
      'تغطية نصوص الواجهة (لوحة التحكم وواجهة المتجر والجوال) ونصوص المساعدة في كل لغة. اللغة المصدر هي التركية؛ ويُعرض النص الناقص بالإنجليزية ثم بالتركية.',
    language: 'اللغة',
    ui: 'نصوص الواجهة',
    help: 'نصوص المساعدة',
    direction: 'اتجاه الكتابة',
    ltr: 'من اليسار إلى اليمين',
    rtl: 'من اليمين إلى اليسار',
    complete: 'مكتملة ({{total}})',
    missing: 'ناقص {{count}} من {{total}}',
    missingKeys: '{{language}}: مفاتيح ناقصة ({{count}})',
    helpNote: 'في اللغات الأخرى تأتي حقول المساعدة التفصيلية من السجل التركي؛ للتعديل حسب اللغة:',
  },
  helpEditor: {
    search: 'البحث بالمفتاح أو العنوان',
    edit: 'تعديل',
    customized: 'معدَّل',
    saved: 'تم حفظ الشرح',
    title: 'العنوان',
    short: 'وصف مختصر',
    history: 'الإصدارات السابقة',
    noHistory: 'لا توجد إصدارات سابقة.',
    locale: 'اللغة',
  },
  confirm: {
    title: 'هل أنت متأكد؟',
    yes: 'نعم، متابعة',
  },
  products: {
    customs: {
      title: 'الجمارك والتصدير',
      lead: 'يُستخدم في الفاتورة المبدئية والبيان الجمركي للشحنات إلى الخارج.',
      hsCode: 'رمز النظام المنسق (HS) (GTİP)',
      hsCodeHint: 'من 6 إلى 12 رقمًا؛ يُسمح بالنقاط والمسافات (مثال: 2309.10.13.00.00).',
      originCountry: 'بلد المنشأ',
      description: 'الوصف الجمركي',
      descriptionHint: 'وصف مختصر للبضاعة في البيان (مثال: طعام قطط جاف).',
    },
    extrasTitle: 'مقاطع الفيديو والمستندات والمنتجات المكمّلة',
    extrasLead:
      'علامتا التبويب «مقاطع الفيديو» و«المستندات» وقسم «يتناسب جيدًا مع» في صفحة المنتج. تُحفظ التغييرات بالضغط على «حفظ».',
    videos: 'مقاطع الفيديو',
    videoUrl: 'رابط الفيديو {{n}}',
    videoTitle: 'عنوان الفيديو {{n}}',
    addVideo: 'إضافة فيديو',
    removeVideo: 'إزالة الفيديو {{n}}',
    documents: 'المستندات',
    noDocuments: 'لا توجد مستندات.',
    documentTitle: 'عنوان المستند {{n}}',
    documentKind: 'نوع المستند {{n}}',
    documentFile: 'الملف: {{name}} ({{size}} KB)',
    documentKinds: {
      analysis_certificate: 'شهادة التحليل',
      leaflet: 'تعليمات الاستخدام',
      safety_data_sheet: 'صحيفة بيانات السلامة',
      registration: 'التسجيل / الترخيص',
      other: 'مستند آخر',
    },
    addDocument: 'رفع مستند PDF',
    openDocument: 'فتح',
    removeDocument: 'إزالة المستند {{n}}',
    documentUploaded: 'تم رفع المستند. يظهر في واجهة المتجر بعد حفظ المنتج.',
    complementary: 'المنتجات المكمّلة («يتناسب جيدًا مع»)',
    create: 'منتج جديد',
    createTitle: 'منتج جديد',
    search: 'بحث',
    searchPlaceholder: 'اسم المنتج أو SKU أو الباركود',
    status: 'الحالة',
    statuses: {
      draft: 'مسودة',
      active: 'نشط',
      archived: 'مؤرشف',
    },
    vetReview: 'المراجعة البيطرية',
    vetStatuses: {
      pending: 'قيد الانتظار',
      approved: 'مُعتمد',
      rejected: 'مرفوض',
      not_required: 'غير مطلوب',
    },
    brand: 'العلامة التجارية',
    empty: 'لا توجد منتجات بعد',
    emptyLead: 'أضف المنتجات واحدًا تلو الآخر أو ارفع ملف Excel/Shopify في صفحة «الاستيراد / التصدير».',
    product: 'المنتج',
    sku: 'SKU',
    stock: 'المخزون',
    variantCount: '{{count}} متغيرات',
    backToList: 'قائمة المنتجات',
    basics: 'البيانات الأساسية',
    title: 'اسم المنتج',
    slug: 'الاسم المختصر (URL)',
    species: 'نوع الحيوان',
    speciesNames: {
      cat: 'قط',
      dog: 'كلب',
      bird: 'طائر',
      rodent: 'قارض صغير (هامستر، خنزير غينيا، إلخ)',
      rabbit: 'أرنب',
      reptile: 'الزواحف والسلاحف',
      exotic: 'حيوانات غريبة أخرى',
    },
    taxClass: 'فئة الضريبة',
    defaultTax: 'فئة الضريبة الافتراضية',
    b2cVisible: 'مرئي لعملاء التجزئة',
    b2bVisible: 'مرئي للموزّعين',
    dealerMinQuantity: 'الحد الأدنى للكمية للموزّعين',
    dealerPackSize: 'حجم الكرتونة للموزّعين (يجب أن تكون الكمية من مضاعفاته)',
    healthContent: 'يحتوي على محتوى صحي (تلزم موافقة الطبيب البيطري)',
    subscribable: 'متاح للتوصيل المنتظم (يمكن للعميل الطلب «كل N أسابيع»)',
    content: 'المحتوى',
    contentLead:
      'لا تدّعِ أن المنتج يقي من الأمراض أو يعالجها. يؤدي تغيير هذه الحقول إلى تجديد المراجعة البيطرية.',
    shortDescription: 'وصف مختصر',
    description: 'الوصف',
    composition: 'التركيب',
    usage: 'طريقة الاستخدام',
    warnings: 'التحذيرات',
    feedRegistrationNo: 'رقم تسجيل العلف',
    categories: 'الفئات',
    noCategories: 'لا توجد فئات بعد؛ أضفها في صفحة «الفئات».',
    tagsAttributes: 'الوسوم والسمات',
    tagsAttributesLead:
      'الوسوم مخصصة لقواعد المجموعات وفلاتر لوحة التحكم؛ أما السمات فتظهر في جدول «المواصفات» في صفحة المنتج.',
    tags: 'الوسوم',
    tagsPlaceholder: 'مفصولة بفواصل: قطط صغيرة، خالٍ من الحبوب',
    tagSuggestions: 'الأكثر استخدامًا:',
    tag: 'وسم',
    noAttributes: 'لم يتم تعريف أي سمات للمنتجات بعد.',
    attributeEmpty: 'فارغ',
    variants: 'الخيارات والمتغيرات',
    variantsLead: 'افصل قيم الخيارات بفواصل. كل صف يمثل متغيرًا.',
    optionName: 'اسم الخيار',
    optionNamePlaceholder: 'مثال: الحجم',
    optionValues: 'قيم الخيار',
    optionValuesPlaceholder: 'مثال: 60 قرصًا، 120 قرصًا',
    removeOption: 'إزالة الخيار',
    addOption: 'إضافة خيار',
    barcode: 'الباركود',
    weight: 'الوزن (غ)',
    cost: 'التكلفة',
    reservedShort: '{{n}} محجوز',
    archiveVariant: 'أرشفة',
    restoreVariant: 'استعادة',
    addVariant: 'إضافة متغير',
    seo: 'محركات البحث (SEO)',
    seoTitle: 'عنوان SEO',
    seoTitleHint: '70 حرفًا كحد أقصى. يُستخدم اسم المنتج إذا كان الحقل فارغًا.',
    seoDescription: 'وصف SEO',
    seoDescriptionHint: '170 حرفًا كحد أقصى.',
    merchant: {
      title: 'Google Shopping',
      lead: 'بيانات المنتج المُرسَلة إلى Merchant Center. يُؤخذ السعر والمخزون والصور والباركود من المنتج نفسه.',
      include: 'إرسال إلى Google Shopping',
      googleCategory: 'فئة منتج Google',
      condition: 'حالة السلعة',
      conditions: {
        new: 'جديد',
        refurbished: 'مُجدَّد',
        used: 'مستعمل',
      },
      identifierExists: 'باركود الشركة المصنّعة',
      identifiers: {
        auto: 'نعم إذا أُدخل باركود (GTIN)',
        no: 'لا يحتوي هذا المنتج على باركود',
      },
      skuIsMpn: 'رمز SKU هو رقم قطعة الشركة المصنّعة (MPN)',
      customLabels: 'التصنيفات المخصصة (تجميع الحملات)',
      customLabel: 'التصنيف {{n}}',
    },
    vetReviewTitle: 'المراجعة البيطرية',
    vetReviewLead: 'لا يمكن نشر المنتجات ذات المحتوى الصحي دون موافقة المراجع البيطري المختص.',
    claimsFound: 'عُثر على صياغات تحتاج إلى مراجعة:',
    noClaims: 'لم يعثر الفحص التلقائي على صياغات خطرة (القرار للمراجع).',
    reviewNote: 'ملاحظة المراجعة',
    reviewNoteHint: 'مطلوبة عند الرفض',
    approveContent: 'اعتماد المحتوى',
    rejectContent: 'رفض',
    reviewSaved: 'تم حفظ المراجعة',
    fields: {
      title: 'اسم المنتج',
      shortDescription: 'وصف مختصر',
      description: 'الوصف',
      composition: 'التركيب',
      usage: 'طريقة الاستخدام',
      warnings: 'التحذيرات',
    },
    media: 'الصور',
    mediaLead: 'الصورة الأولى هي صورة الغلاف.',
    mediaAlt: 'النص البديل للصورة {{n}}',
    mediaMoveLeft: 'تقديم الصورة {{n}}',
    mediaMoveRight: 'تأخير الصورة {{n}}',
    mediaReordered: 'تم حفظ ترتيب الصور',
    mediaOrderLead: 'يعرض معرض واجهة المتجر الصور بهذا الترتيب.',
    mediaStatus: {
      ready: 'جاهزة',
      pending_download: 'بانتظار التنزيل',
      failed: 'فشل التنزيل',
    },
    mediaFailure: {
      invalid_url: 'عنوان غير صالح',
      blocked_address: 'عناوين الشبكة الداخلية غير مسموح بها',
      dns_failed: 'النطاق غير موجود',
      connect_failed: 'تعذّر الاتصال بالخادم',
      tls_failed: 'فشل الاتصال الآمن',
      timeout: 'انتهت المهلة (30 ثانية)',
      not_found: 'لم تعد الصورة موجودة في المصدر',
      forbidden: 'رفض المصدر الوصول',
      http_error: 'خطأ في خادم المصدر',
      too_many_redirects: 'عدد كبير جدًا من عمليات إعادة التوجيه',
      too_large: 'أكبر من 20 MB',
      not_image: 'ليست صورة أو تالفة',
      storage_failed: 'تعذّر الحفظ على الخادم',
      unknown: 'خطأ غير معروف',
    },
    mediaRetry: 'إعادة المحاولة',
    mediaSize: '{{width}}×{{height}} px',
    mediaSmall:
      'صغيرة بالنسبة إلى Google Shopping: يُوصى بحجم 500×500 px على الأقل (إلزامي بعد 31 يناير 2027)',
    mediaRetryQueued: 'سيُعاد تنزيل الصورة (خلال 30 ثانية تقريبًا).',
    confirmRemoveMedia: 'هل تريد إزالة الصورة من المنتج؟',
    imageAdded: 'تمت إضافة الصورة',
    addImage: 'إضافة صورة',
    prices: 'الأسعار',
    pricesLead: 'تُحفظ الأسعار عند مغادرة الحقل. الحقل الفارغ يزيل السعر.',
    noPriceLists: 'أنشئ أولًا قائمة أسعار في صفحة «التسعير».',
    noBaseList_none:
      'لا توجد قائمة أسعار أساسية (للتجزئة) للمتجر «{{store}}»: ليس للمنتج سعر هناك ولا يُدرج. أنشئ قائمة في صفحة «التسعير» مع تحديد المتجر ودون مجموعة.',
    noBaseList_inactive:
      'قائمة الأسعار الأساسية للمتجر «{{store}}» غير نشطة: ليس للمنتج سعر هناك. فعّلها في صفحة «التسعير».',
    noBaseList_currency:
      'يبيع المتجر «{{store}}» بعملة {{currency}} لكن قائمة أسعاره الأساسية تستخدم عملة أخرى. أنشئ قائمة بعملة {{currency}}.',
    noBaseList_dates:
      'قائمة الأسعار الأساسية للمتجر «{{store}}» غير سارية اليوم (تاريخ البدء/الانتهاء). تحقّق من التواريخ في صفحة «التسعير».',
    goPriceLists: 'الانتقال إلى التسعير',
    listInactive: 'غير نشطة',
    listings: 'النشر في المتجر',
    listingsLead: 'يتطلب النشر: منتجًا نشطًا، ومحتوى صحيًا معتمدًا، وسعرًا أساسيًا.',
    published: 'منشور',
    notPublished: 'غير منشور',
    publish: 'نشر',
    unpublish: 'إلغاء النشر',
  },
  categories: {
    name: 'اسم الفئة',
    parent: 'الفئة الرئيسية',
    slug: 'الاسم المختصر (العنوان)',
    slugLead: 'العنوان: {{path}}. عند تغييره، يُعاد توجيه العنوان القديم نهائيًا إلى العنوان الجديد.',
    description: 'الوصف',
    seoTitle: 'العنوان في نتائج البحث',
    seoDescription: 'الوصف في نتائج البحث',
    editTitle: 'تعديل الفئة',
    editHint: 'استخدم «تعديل» لتغيير اسم الفئة وعنوانها ووصفها وطريقة ظهورها في نتائج البحث.',
    topLevel: 'المستوى الأعلى',
    add: 'إضافة فئة',
    productCount: '{{count}} منتجات',
    statuses: {
      active: 'ظاهرة',
      hidden: 'مخفية',
    },
    hide: 'إخفاء',
    show: 'إظهار',
    confirmDelete: 'هل تريد حذف «{{name}}»؟ لن تُحذف المنتجات.',
    empty: 'لا توجد فئات بعد',
    emptyLead: 'ابدأ بفئات المستوى الأعلى مثل «مكمّلات غذائية للقطط».',
  },
  pricing: {
    referencePriceNote:
      '«السعر السابق» في واجهة المتجر هو أدنى سعر طُبّق فعليًا خلال آخر 30 يومًا؛ لا توجد أسعار مشطوبة يدويًا.',
    groups: 'مجموعات العملاء',
    groupsLead: 'مستويات الموزّعين. تُربط شركات الموزّعين المعتمدة بمجموعة.',
    addGroup: 'إضافة مجموعة',
    noGroups: 'لا توجد مجموعات عملاء بعد',
    noGroupsLead: 'أنشئ مجموعة موزّعين واحدة على الأقل لأسعار الموزّعين.',
    minOrderShort: 'الحد الأدنى للطلب: {{amount}}',
    noMinOrder: 'لا يوجد حد أدنى للطلب',
    editMinOrder: 'الحد الأدنى للطلب',
    minOrderTitle: '{{name}} — الحد الأدنى لمبلغ الطلب',
    minOrderLead:
      'لا يمكن لموزّعي هذه المجموعة تقديم طلب ما دام إجمالي السلة (شاملًا المنتجات والخصومات وضريبة القيمة المضافة، وباستثناء الشحن) أقل من هذا المبلغ. يُحدَّد المبلغ الخاص بكل شركة في بطاقة الموزّع.',
    minOrder: 'الحد الأدنى لمبلغ الطلب ({{currency}})',
    minOrderHint: 'فارغ: لا يوجد',
    groupName: 'اسم المجموعة',
    groupCode: 'الرمز',
    groupCodeHint: 'أحرف صغيرة وأرقام و- و_.',
    groupKind: 'النوع',
    kinds: {
      dealer: 'موزّع',
      retail: 'تجزئة',
    },
    lists: 'قوائم الأسعار',
    listsLead: 'القائمة التي لا ترتبط بمجموعة هي القائمة الأساسية التي يراها الجميع.',
    addList: 'إضافة قائمة أسعار',
    noLists: 'لا توجد قوائم أسعار بعد',
    noListsLead: 'أنشئ القائمة الأساسية أولًا، ثم قوائم الموزّعين.',
    taxIncl: 'شامل الضريبة',
    taxExcl: 'غير شامل الضريبة',
    forGroup: 'المجموعة: {{group}}',
    baseList: 'القائمة الأساسية',
    priceCount: '{{count}} أسعار',
    listStatus: {
      active: 'نشطة',
      inactive: 'غير نشطة',
    },
    activate: 'تفعيل',
    deactivate: 'إلغاء التفعيل',
    listName: 'اسم القائمة',
    store: 'المتجر',
    listGroup: 'مجموعة العملاء',
    baseListOption: 'لا شيء — القائمة الأساسية (التجزئة)',
    market: 'السوق',
    allMarkets: 'جميع الأسواق (بهذه العملة)',
    forMarket: 'السوق: {{market}}',
    currency: 'العملة',
    taxInclusive: 'الأسعار شاملة الضريبة',
    priority: 'الأولوية',
    taxes: 'فئات الضريبة',
    taxesLead: 'معدلات الضريبة المخصصة للمنتجات.',
    defaultTax: 'افتراضية',
    noTaxes: 'لا توجد فئات ضريبة بعد',
    taxName: 'الاسم',
    taxNamePlaceholder: 'مثال: ضريبة القيمة المضافة 20%',
    taxRate: 'المعدل',
    addTax: 'إضافة فئة ضريبة',
    countryRates: 'معدلات ضريبة القيمة المضافة حسب الدولة',
    countryRatesLead:
      'في الأسواق التي يكون وضعها الضريبي «ضريبة القيمة المضافة لبلد الوجهة»، يُطبَّق معدل فئة ضريبة المنتج الخاص بتلك الدولة. لا يمكن بيع المنتجات التي ليس لها معدل في ذلك السوق.',
    noCountryRates: 'لا توجد معدلات دول بعد',
    countryRateClass: 'فئة الضريبة',
    countryRateCountry: 'الدولة',
    addCountryRate: 'إضافة معدل دولة',
    countryRateDelete:
      'هل تريد حذف معدل «{{name}}» للدولة {{country}}؟ لن يعود بالإمكان بيع منتجات هذه الفئة في سوق «ضريبة القيمة المضافة لبلد الوجهة» لتلك الدولة.',
    bulk: 'تغيير الأسعار بالجملة',
    bulkLead: 'المعاينة أولًا؛ ويمكن التراجع عن التغييرات المطبّقة.',
    targetList: 'القائمة الهدف',
    operation: 'العملية',
    ops: {
      percent: 'زيادة/تخفيض بنسبة مئوية',
      fixed: 'إضافة/طرح مبلغ',
      from_list: 'الاشتقاق من قائمة أخرى',
      from_cost: 'من التكلفة (هامش الإضافة)',
      target_margin: 'هامش الربح الإجمالي المستهدف',
      fx: 'من عملة أخرى (سعر الصرف)',
    },
    markup: 'هامش الإضافة (%)',
    markupHint:
      'السعر الصافي = التكلفة × (1 + هامش الإضافة). تُضاف ضريبة القيمة المضافة في القوائم الشاملة للضريبة.',
    targetMargin: 'هامش الربح الإجمالي (%)',
    targetMarginHint: 'السعر الصافي = التكلفة ÷ (1 − الهامش). مثال: هامش 40% على تكلفة 100 → 166.67.',
    fxRate: 'سعر الصرف',
    fxRateHint: 'قيمة وحدة واحدة من عملة المصدر في هذه القائمة (مثال: 1 TRY = 0.0291 EUR → 0.0291).',
    fxAdjust: 'تعديل إضافي (%)',
    minMargin: 'الحد الأدنى للهامش (%)',
    minMarginHint:
      'اتركه فارغًا لتخطي الفحص. يُحسب الهامش من السعر الصافي والتكلفة، ولا تُفحص المنتجات التي ليس لها تكلفة.',
    minMarginMode: 'إذا كان أقل',
    minMarginModes: {
      warn: 'تحذير (مع التطبيق)',
      block: 'عدم التطبيق',
    },
    margin: 'الهامش',
    lowMargin: 'هامش منخفض',
    noCost: 'تم تخطي {{count}} متغيرات ليس لها تكلفة (أو تكلفتها بعملة أخرى).',
    blocked: '{{count}} متغيرات أقل من الحد الأدنى للهامش ولن تُطبَّق.',
    lowMarginCount: '{{count}} متغيرات أقل من الحد الأدنى للهامش.',
    campaign: 'الحملة',
    campaignStates: {
      upcoming: 'لم تبدأ',
      live: 'جارية',
      ended: 'انتهت',
    },
    validity: '{{from}} – {{to}}',
    startsAt: 'سارية من',
    endsAt: 'سارية حتى',
    datesHint:
      'اتركه فارغًا لتبقى القائمة سارية دائمًا. لقائمة حملة، حدّد التواريخ وأولوية أعلى من القائمة الأساسية.',
    editDates: 'تعديل التواريخ',
    noLimit: 'مفتوحة المدة',
    amount: 'المبلغ',
    percent: 'النسبة المئوية',
    valueHint: 'استخدم علامة الطرح للتخفيض (مثال: -10).',
    sourceList: 'القائمة المصدر',
    filterBrand: 'العلامة التجارية',
    filterCategory: 'الفئة',
    ending: 'نهاية السعر',
    endings: {
      none: 'إبقاء',
      whole: 'عدد صحيح',
      end_90: '.90',
      end_99: '.99',
    },
    previewBulk: 'معاينة',
    previewSummary: 'سيتغير {{affected}} سعرًا، وسيُتخطى {{skipped}}.',
    before: 'قبل',
    after: 'بعد',
    confirmApply: 'سيتغير {{count}} سعرًا. هل تريد المتابعة؟',
    applyBulk: 'تطبيق',
    bulkApplied: 'تم تطبيق الأسعار بالجملة',
    bulkReverted: 'تم التراجع عن الأسعار بالجملة',
    history: 'السجل',
    affectedCount: '{{count}} أسعار',
    bulkStatus: {
      preview: 'معاينة',
      applied: 'مطبّق',
      reverted: 'تم التراجع',
      expired: 'منتهي الصلاحية',
    },
    confirmRevert: 'هل تريد التراجع عن هذا التغيير بالجملة؟ ستُحفظ الأسعار المعدّلة يدويًا.',
    revert: 'تراجع',
  },
  discounts: {
    create: 'إنشاء رمز خصم',
    empty: 'لا توجد رموز خصم بعد',
    emptyLead: 'أنشئ رمز خصم بنسبة مئوية أو بمبلغ ثابت لحملة.',
    min: 'الحد الأدنى {{amount}}',
    used: 'استُخدم {{used}}/{{limit}}',
    until: 'حتى {{date}}',
    name: 'اسم رمز الخصم (داخلي)',
    code: 'الرمز',
    type: 'النوع',
    types: {
      percentage: 'نسبة مئوية',
      fixed_amount: 'مبلغ ثابت',
    },
    minSubtotal: 'الحد الأدنى لإجمالي السلة',
    usageLimit: 'حد الاستخدام',
    endsAt: 'تاريخ الانتهاء',
    groups: 'مجموعات العملاء المؤهلة',
    groupsHint: 'إذا لم يتم تحديد أي مجموعة، يمكن للجميع استخدامه.',
  },
  stock: {
    ledgerNote: 'لا تُحذف حركات المخزون أبدًا؛ صحّح الأخطاء بتسوية عكسية.',
    warehouses: 'المستودعات',
    warehousesLead: 'المستودع الأول هو الافتراضي، وتحجز الطلبات منه أولًا.',
    default: 'افتراضي',
    noWarehouses: 'لا توجد مستودعات بعد',
    warehouseName: 'اسم المستودع',
    warehouseCode: 'الرمز',
    addWarehouse: 'إضافة مستودع',
    variantStock: 'مخزون المنتج',
    variantStockLead: 'ابحث عن منتج واختر متغيرًا لعرض الأرصدة والحركات الأخيرة.',
    findProduct: 'البحث عن منتج',
    newMovement: 'حركة المخزون',
    transfer: 'نقل',
    warehouse: 'المستودع',
    lot: 'الدفعة',
    expiry: 'تاريخ انتهاء الصلاحية',
    onHand: 'المتوفر',
    reserved: 'محجوز',
    movements: 'الحركات الأخيرة',
    types: {
      receipt: 'استلام',
      sale: 'بيع',
      return: 'إرجاع',
      adjustment: 'تسوية',
      transfer_in: 'نقل وارد',
      transfer_out: 'نقل صادر',
      damage: 'تلف',
      count: 'جرد',
      import: 'استيراد',
      opening: 'المخزون الافتتاحي',
    },
    noResults: 'لا توجد نتائج',
    movementType: 'نوع الحركة',
    lotPick: 'الدفعة',
    chooseLot: 'اختر دفعة',
    lotless: 'مخزون بدون دفعة',
    lotOption: '{{lot}} · انتهاء الصلاحية {{expiry}} · {{onHand}} وحدة',
    countedQuantity: 'الكمية المعدودة (الإجمالي الجديد)',
    quantity: 'الكمية',
    lotNo: 'رقم الدفعة',
    reason: 'السبب',
    fromWarehouseId: 'من المستودع',
    toWarehouseId: 'إلى المستودع',
    noLot: 'بدون دفعة',
    expiryLabel: 'تنتهي في {{date}}',
    availableCount: '{{count}} متاح',
    transferNoStock:
      'لا يوجد لهذا المنتج مخزون قابل للنقل. ينقل التحويل المخزون الموجود بين المستودعات؛ أما أول إدخال للمخزون فهو «استلام».',
    goReceipt: 'إدخال استلام',
    transferNeedsTwo: 'يتطلب النقل مستودعًا نشطًا آخر (أضف واحدًا ضمن «المستودعات»).',
    transferMax: 'يمكن نقل {{count}} كحد أقصى.',
    transferTooMany: 'لا يتوفر في هذا المصدر سوى {{count}}.',
    noStockYet:
      'لا يوجد مخزون لهذا المنتج بعد. أجرِ الإدخال الأول عبر «حركة المخزون» ← «استلام» (مع الدفعة وتاريخ انتهاء الصلاحية).',
    expiring: 'تنتهي صلاحيتها قريبًا',
    expiringLead: 'الدفعات التي لديها مخزون ويقترب تاريخ انتهاء صلاحيتها.',
    withinDays: 'الفترة',
    days: '{{n}} يومًا',
    lotLabel: 'الدفعة {{lot}}',
    noExpiring: 'لا توجد دفعات تنتهي صلاحيتها في هذه الفترة.',
    critical: {
      title: 'مخزون منخفض',
      lead: 'المنتجات التي تكون كميتها القابلة للبيع عند حدها أو أقل منه. الأبعد عن الحد أولًا.',
      none: 'لا توجد منتجات بمخزون منخفض.',
      product: 'المنتج',
      available: 'القابل للبيع',
      threshold: 'الحد',
      rule: 'القاعدة',
      allWarehouses: 'جميع المستودعات',
      sources: {
        warehouse: 'حد المستودع',
        variant: 'حد المنتج',
        default: 'الحد الافتراضي',
      },
      more: 'يتم عرض أول {{shown}} صف (من أصل {{total}}).',
      defaultThreshold: 'الحد الافتراضي',
      defaultThresholdHint: 'للمنتجات التي ليس لها حد خاص بها؛ اتركه فارغًا لتعطيله.',
      saveDefault: 'حفظ الحد الافتراضي',
      defaultSaved: 'تم حفظ الحد الافتراضي.',
      dailyDigest: 'ملخص يومي بالبريد الإلكتروني',
      digestOn: 'الملخص اليومي بالبريد الإلكتروني مفعّل (كل صباح في الساعة 08:00).',
      digestOff: 'الملخص اليومي بالبريد الإلكتروني متوقف.',
      thresholds: 'حدود المخزون المنخفض',
      thresholdsLead:
        'ينضم المنتج إلى قائمة المخزون المنخفض عندما تنخفض كميته القابلة للبيع إلى هذا الرقم أو أقل.',
      saveThresholds: 'حفظ الحدود',
      thresholdsSaved: 'تم حفظ الحدود.',
    },
  },
  customers: {
    create: 'إضافة عميل',
    search: 'بحث',
    searchMaskedHint: 'بدون صلاحية البيانات الشخصية، يقتصر البحث على الأسماء.',
    kind: 'النوع',
    kinds: {
      dealer: 'موزّع',
      retail: 'تجزئة',
    },
    maskedNote: 'البيانات الشخصية مُخفاة.',
    empty: 'لا يوجد عملاء بعد',
    emptyLead: 'يظهر العملاء عند تسجيلهم أو عند استيراد قائمة موزّعين.',
    notActivated: 'غير مُفعّل',
    disabled: 'معطّل',
    createdAndEmailed: 'تم الحفظ، وأُرسل رابط الوصول بالبريد الإلكتروني.',
    name: 'الاسم الكامل',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    sendAccessLink: 'إرسال رابط تعيين كلمة المرور',
    manualLinkTitle: 'إرسال الرابط يدويًا',
    manualLinkLead:
      'البريد الإلكتروني غير مُعدّ، لذا لم يُرسَل شيء. شارك هذا الرابط مع العميل عبر قناة آمنة.',
    linkEmailed: 'أُرسل الرابط بالبريد الإلكتروني.',
    backToList: 'قائمة العملاء',
    profile: 'الملف الشخصي',
    activated: 'الحساب نشط (تم تعيين كلمة المرور)',
    emailVerified: 'تم التحقق من البريد الإلكتروني',
    created: 'تاريخ الإنشاء',
    companies: 'شركات الموزّعين',
    sendReset: 'رابط إعادة تعيين كلمة المرور',
    sendActivation: 'رابط التفعيل',
    unlock: 'إلغاء القفل',
    confirmDisable: 'هل تريد تعطيل حساب العميل؟ ستُغلق الجلسات المفتوحة.',
    confirmEnable: 'هل تريد إعادة تفعيل حساب العميل؟',
    disable: 'تعطيل',
    enable: 'تفعيل',
    consents: 'موافقات التسويق',
    channels: {
      email: 'البريد الإلكتروني',
      sms: 'SMS',
      call: 'اتصال هاتفي',
      whatsapp: 'WhatsApp',
    },
    consentStatus: {
      granted: 'ممنوحة',
      revoked: 'مسحوبة',
      none: 'لا يوجد سجل',
    },
    consentSource: {
      register: 'عند التسجيل',
      account: 'صفحة الحساب',
      checkout: 'عند إتمام الطلب',
      import: 'استيراد',
      admin: 'من لوحة التحكم',
      unsubscribe: 'رابط إلغاء الاشتراك',
    },
    confirmRevoke: 'هل تريد سحب الموافقة؟ يُحتفظ بالسجل.',
    revoke: 'سحب',
    addresses: 'العناوين',
    masked: 'مُخفى',
    noAddresses: 'لا توجد عناوين محفوظة.',
    orders: 'الطلبات الأخيرة',
    noOrders: 'لا توجد طلبات بعد.',
    tags: 'الوسوم',
    tagsLead:
      'لا تظهر في واجهة المتجر؛ تُستخدم كفلتر للقائمة وفي قواعد الشرائح. مُضمَّنة في نُسخ بيانات KVKK.',
    tagsLabel: 'الوسوم (مفصولة بفواصل)',
    tagsPlaceholder: 'مثال: vip، معرض 2026، مالك قطة',
    tagSuggestions: 'الأكثر استخدامًا:',
    saveTags: 'حفظ الوسوم',
    tagsSaved: 'تم حفظ الوسوم.',
    noTags: 'لا توجد وسوم.',
    tagFilter: 'الوسم',
    metricsTitle: 'ملخص الطلبات وRFM',
    metricsLead:
      'يُحسب ليلًا من الطلبات الصالحة (باستثناء الطلبات الملغاة والمسودات والطلبات المستردة بالكامل).',
    noMetrics: 'لا توجد طلبات صالحة بعد، أو لم يُحسب RFM.',
    orderCount: 'الطلبات',
    totalSpent: 'صافي الإنفاق',
    avgOrder: 'متوسط الطلب',
    firstOrder: 'أول طلب',
    lastOrder: 'آخر طلب',
    rfmGroup: 'مجموعة RFM',
    rfmScores: 'R{{r}} · F{{f}} · M{{m}}',
    otherCurrency: '{{count}} طلبات بعملة أخرى (غير مُضمَّنة في الإنفاق)',
    metricsComputed: 'تاريخ الحساب: {{date}}',
    summaryTitle: 'ملخص العميل',
    summaryLead:
      'يُحسب مباشرة من الطلبات (باستثناء الطلبات الملغاة والمسودات وغير المدفوعة والمستردة بالكامل)؛ وتُحدَّث مجموعة RFM ليلًا.',
    lifetimeSpent: 'صافي الإنفاق حتى الآن',
    last12Months: 'آخر 12 شهرًا',
    daysAgo: 'قبل {{count}} يومًا',
    cycle: 'الفاصل بين الطلبات',
    cycleValue: 'كل {{days}} يومًا في المتوسط',
    cycleNone: 'يتطلب طلبين على الأقل',
    nextExpected: 'الطلب التالي المتوقع: {{date}} (تقدير بناءً على الطلبات السابقة)',
    returnsCount: 'طلبات الإرجاع',
    newsletter: 'النشرة البريدية',
    acquisition: 'مصدر الاكتساب',
    acquisitionNoAd: 'غير مطابق لحساب إعلاني',
    cacValue: 'تكلفة الاكتساب {{amount}} ({{month}}، {{count}} عملاء جدد)',
    newsletterNone: 'غير مشترك',
    rfmNotYet: 'لم يُحسب بعد',
    notes: 'ملاحظات داخلية',
    notesLead: 'مرئية لمستخدمي لوحة التحكم فقط؛ مُضمَّنة في نُسخ بيانات KVKK.',
    notesLabel: 'الملاحظة',
    saveNotes: 'حفظ الملاحظة',
    notesSaved: 'تم حفظ الملاحظة.',
    noNotes: 'لا توجد ملاحظات.',
    timelineTitle: 'النشاط',
    timelineLead: 'آخر 40 حدثًا، الأحدث أولًا؛ تظهر فقط الأقسام المسموح لك برؤيتها.',
    timeline: {
      account: 'أنشأ حسابًا',
      order: 'الطلب {{number}} · {{status}} · {{total}}',
      return: 'طلب إرجاع (الطلب {{order}}) · {{resolution}} · {{status}}',
      review: 'تقييم {{rating}}/5 للمنتج {{product}} · {{status}}',
      question: 'سؤال حول {{product}} · {{status}}',
      consent: 'موافقة {{channel}}: {{status}} · {{source}}',
      contact: 'رسالة نموذج التواصل · {{status}}',
      ticket: 'تذكرة دعم #{{number}}: {{subject}} · {{status}}',
      privacy: 'طلب KVKK: {{kind}} · {{status}}',
      newsletter: 'النشرة البريدية: {{status}}',
      campaign: 'بريد الحملة: {{name}}',
      campaignClicked: 'نقر على رابط',
      campaignUnsubscribed: 'ألغى الاشتراك',
      automation: 'بريد الأتمتة: {{name}}',
      message: 'حملة {{channel}}: {{name}} ({{status}})',
    },
  },
  dealers: {
    ledgerTitle: 'الحساب الجاري',
    ledgerOpen: 'حساب آجل',
    ledgerSummary: 'الرصيد {{balance}} · المتأخر {{overdue}}',
    paymentTerm: 'مدة السداد (بالأيام)',
    paymentTermInvalid: 'أدخل عددًا صحيحًا بين 0 و365.',
    paymentTermValue: 'مدة السداد: {{days}} يومًا بعد الطلب.',
    importList: 'استيراد قائمة الموزّعين',
    create: 'إضافة موزّع',
    search: 'بحث',
    searchHint: 'الاسم أو رمز الموزّع أو المدينة أو الرقم الضريبي الكامل.',
    status: 'الحالة',
    statuses: {
      applied: 'مقدَّم الطلب',
      approved: 'مُعتمد',
      suspended: 'موقوف',
      rejected: 'مرفوض',
    },
    empty: 'لا يوجد موزّعون بعد',
    emptyLead: 'استورد قائمة الموزّعين من Excel/CSV أو أضفهم واحدًا تلو الآخر.',
    memberCount: '{{count}} مستخدمين',
    legalName: 'الاسم القانوني للشركة',
    tradeName: 'الاسم التجاري',
    taxOffice: 'مكتب الضرائب',
    taxNumber: 'الرقم الضريبي / TCKN',
    externalCode: 'رمز الموزّع',
    city: 'المدينة',
    district: 'المنطقة',
    email: 'البريد الإلكتروني للشركة',
    phone: 'الهاتف',
    group: 'مجموعة الموزّع',
    createApproved: 'إنشاء كمعتمد (تُتاح أسعار الموزّعين فورًا)',
    backToList: 'قائمة الموزّعين',
    info: 'بيانات الشركة',
    address: 'العنوان',
    source: 'المصدر',
    sources: {
      application: 'طلب عبر واجهة المتجر',
      import: 'استيراد',
      manual: 'من لوحة التحكم',
    },
    approvedAt: 'تاريخ الاعتماد',
    statusActions: 'إجراءات الحالة',
    note: 'ملاحظة',
    noteHint: 'مطلوبة عند الرفض',
    actions: {
      approved: 'اعتماد',
      rejected: 'رفض',
      suspended: 'إيقاف',
    },
    confirm: {
      approved: 'هل تريد اعتماد الموزّع؟ سيبدأ مستخدموه برؤية أسعار الموزّعين.',
      rejected: 'هل تريد رفض الموزّع؟',
      suspended: 'هل تريد إيقاف الموزّع؟ سيرى مستخدموه أسعار التجزئة.',
    },
    members: 'المستخدمون',
    membersLead: 'الأشخاص الذين يسجّلون الدخول إلى واجهة المتجر نيابةً عن هذه الشركة.',
    roles: {
      owner: 'المسؤول المفوّض',
      buyer: 'المشتري',
      viewer: 'عرض فقط',
    },
    rolesLead: 'يحدد الدور ما يمكن للمستخدم فعله نيابةً عن الشركة في واجهة المتجر.',
    roleHelp: {
      owner:
        'يقدّم الطلبات، ويرى طلبات الشركة وكشف الحساب ومستخدمي الشركة، ويدير مواقع الشركة. بلا حد للطلبات.',
      buyer:
        'يقدّم الطلبات ولا يرى إلا طلباته. عند تحديد حد، تحتاج الطلبات التي تتجاوزه إلى موافقة المسؤول المفوّض.',
      viewer: 'يرى أسعار الموزّعين وطلبات الشركة وكشف الحساب، ولا يمكنه تقديم طلبات (مثل موظفي المحاسبة).',
    },
    editMember: 'الدور والحد',
    orderRules: 'قواعد الطلب',
    orderRulesLead:
      'الحد الأدنى لمبلغ الطلب لهذا الموزّع (عند تركه فارغًا يُطبَّق مبلغ مجموعة الموزّع) وما إذا كانت طلبات واجهة المتجر تتطلب أمر شراء (PO).',
    minOrder: 'الحد الأدنى لمبلغ الطلب ({{currency}})',
    minOrderHint: 'فارغ: مبلغ مجموعة الموزّع',
    poRequirement: 'أمر الشراء (PO)',
    poRequirements: {
      none: 'اختياري',
      number: 'رقم PO مطلوب',
      number_and_document: 'رقم PO والمستند مطلوبان',
    },
    editMemberTitle: '{{name}} — الدور وحد الطلب',
    orderLimit: 'حد الطلب ({{currency}})',
    orderLimitHint: 'فارغ: بلا حد',
    orderLimitShort: 'الحد: {{amount}}',
    confirmRemoveMember: 'هل تريد إزالة {{name}} من الشركة؟ لن يُحذف الحساب.',
    noMembers: 'لا يوجد مستخدمون بعد.',
    role: 'الدور',
    addMember: 'إضافة مستخدم',
    applications: 'طلبات الانضمام',
  },
  applications: {
    status: 'الحالة',
    statuses: {
      pending: 'قيد الانتظار',
      approved: 'مقبول',
      rejected: 'مرفوض',
    },
    empty: 'لا توجد طلبات انضمام',
    emptyLead: 'تظهر هنا الطلبات المقدَّمة عبر نموذج واجهة المتجر.',
    documentCount: '{{count}} مستندات',
    businessType: 'نوع النشاط التجاري',
    applicant: 'مقدّم الطلب',
    note: 'ملاحظة الطلب',
    documents: 'المستندات',
    noDocuments: 'لم يتم رفع أي مستندات.',
    decisionNote: 'ملاحظة',
    decisionNoteHint: 'مطلوبة عند الرفض، وتُرسَل إلى مقدّم الطلب بالبريد الإلكتروني.',
    approve: 'قبول',
    reject: 'رفض',
  },
  imports: {
    products: 'المنتجات',
    productsLead:
      'قالبنا (Excel/CSV) أو ملف CSV لمنتجات Shopify أو مستند منتجات بتنسيق JSON/XML. تُضاف المنتجات كمسودات، ويُطبَّق ما يزيد على 50 منتجًا في الخلفية.',
    columnMapping: 'مطابقة الأعمدة',
    columnMappingLead:
      'الحقل الذي يُنقل إليه كل عمود من الملف. اربط العمود غير المعروف بحقل أو تجاهله، ثم أعد المعاينة. تُحفظ المطابقة عند التطبيق وتُستخدم تلقائيًا للملفات اللاحقة ذات العناوين نفسها.',
    unmatchedCount: '{{count}} أعمدة غير معروفة',
    fileColumn: 'العمود في الملف',
    targetField: 'يُستورد إلى',
    columnSource: 'طريقة المطابقة',
    noField: '— لا يُستورد —',
    ignoreColumn: 'تجاهل',
    attributeColumn: 'عمود سمة',
    columnSources: {
      auto: 'تلقائي',
      saved: 'مطابقة محفوظة',
      manual: 'مختار يدويًا',
      attribute: 'سمة',
      ignored: 'متجاهَل',
      unmatched: 'غير معروف',
    },
    remap: 'إعادة المعاينة بالمطابقة',
    fields: {
      handle: 'رمز المنتج (slug)',
      title: 'اسم المنتج',
      brand: 'العلامة التجارية',
      categories: 'الفئة',
      species: 'نوع الحيوان',
      shortDescription: 'وصف مختصر',
      description: 'الوصف',
      composition: 'التركيب',
      usage: 'طريقة الاستخدام',
      warnings: 'التحذيرات',
      feedRegistrationNo: 'رقم تسجيل العلف',
      tax: 'ضريبة القيمة المضافة',
      visibility: 'الظهور',
      option1Name: 'اسم الخيار 1',
      option1Value: 'قيمة الخيار 1',
      option2Name: 'اسم الخيار 2',
      option2Value: 'قيمة الخيار 2',
      option3Name: 'اسم الخيار 3',
      option3Value: 'قيمة الخيار 3',
      sku: 'SKU',
      barcode: 'الباركود',
      weight: 'الوزن (غ)',
      cost: 'التكلفة',
      price: 'السعر',
      stock: 'المخزون',
      images: 'روابط الصور (URL)',
      imageAlt: 'وصف الصورة',
      seoTitle: 'عنوان SEO',
      seoDescription: 'وصف SEO',
      tags: 'الوسوم',
    },
    importQueued: 'جارٍ التطبيق في الخلفية: {{processed}} / {{total}} منتج',
    importQueuedLead: 'يمكنك مغادرة هذه الصفحة؛ يستمر الاستيراد. تظهر النتيجة هنا.',
    importProgress: 'تقدّم الاستيراد',
    retryFailed: 'إعادة محاولة المنتجات الفاشلة',
    exportJson: 'تنزيل JSON',
    exportXml: 'تنزيل XML',
    template: 'تنزيل القالب',
    exportProducts: 'تصدير المنتجات',
    priceList: 'قائمة الأسعار',
    skipPrices: 'عدم استيراد الأسعار',
    warehouse: 'المستودع',
    skipStock: 'عدم استيراد المخزون',
    defaultBrand: 'العلامة التجارية الافتراضية',
    healthContent: 'تحتوي المنتجات على محتوى صحي (تلزم موافقة الطبيب البيطري)',
    chooseFile: 'اختيار ملف ومعاينته',
    formats: {
      zootopia: 'قالب Zootopia',
      shopify: 'Shopify CSV',
    },
    toCreate: '{{count}} جديد',
    toUpdate: '{{count}} تحديثات',
    skipped: '{{count}} تم تخطيها',
    variants: '{{count}} متغيرات',
    images: '{{count}} صور',
    unknownHeaders: 'أعمدة غير معروفة (تم تجاهلها): {{list}}',
    issues: 'عُثر على {{count}} مشكلات؛ لا تُطبَّق الصفوف المتأثرة.',
    row: 'الصف {{row}}',
    downloadIssues: 'تنزيل قائمة المشكلات',
    issueRow: 'الصف',
    issueField: 'الحقل',
    issueProblem: 'المشكلة',
    issueValue: 'القيمة في الملف',
    productsDraftNote: 'لا تُنشر المنتجات؛ راجعها وانشرها بعد موافقة الطبيب البيطري.',
    apply: 'تطبيق',
    applied: 'تم تطبيق الاستيراد',
    stockSkippedLot:
      'يُتتبَّع مخزون {{count}} متغيرات حسب الدفعة/تاريخ انتهاء الصلاحية ولم يُكتب من الملف؛ أدخله في شاشة المخزون حسب الدفعة.',
    productResult: 'تمت إضافة {{created}}، وتحديث {{updated}}، وفشل {{failed}}.',
    categories: 'الفئات',
    categoriesLead:
      'أضف شجرة الفئات أو حدّثها من ملف. ارفع الفئات قبل المنتجات؛ ورفع الملف نفسه مجددًا لا يُنشئ تكرارات.',
    exportCategories: 'تصدير الفئات',
    categoriesPreview: 'معاينة الفئات',
    categoryResult: 'تمت إضافة {{created}} فئة، وتحديث {{updated}}.',
    createMissingCategories: 'إنشاء الفئات المفقودة',
    categoryMode: 'فئات المنتجات الموجودة',
    categoryModes: {
      merge: 'إضافة ما في الملف (مع الإبقاء على الموجود)',
      replace: 'الاستبدال بما في الملف',
    },
    categoriesToCreate: 'سيتم إنشاء {{count}} فئة',
    skuMissing:
      '{{count}} متغيرات لها SKU فارغ، وسيتم تخطي منتجاتها. تظهر رموز SKU المقترحة بين قوسين في قائمة المشكلات (الباركود إن وُجد، وإلا رمز المنتج + الخيار).',
    skuGenerate: 'إعادة المعاينة برموز SKU المقترحة',
    skuGenerated:
      'اقتُرحت رموز SKU لـ {{count}} متغيرات (مدرجة أدناه لكل منتج). يحفظها التطبيق؛ ورفع الملف نفسه مجددًا يُنتج رموز SKU نفسها، فلا تنشأ تكرارات.',
    mediaStatusTitle: 'الصور المستوردة',
    mediaPending: '{{count}} صور بانتظار التنزيل (في الخلفية، كل 30 ثانية).',
    mediaFailed: 'تعذّر تنزيل {{count}} صور.',
    mediaReasons: 'الأسباب: {{list}}',
    mediaRetryAll: 'إعادة محاولة التنزيلات الفاشلة',
    mediaRetryQueued: 'سيُعاد تنزيل {{count}} صور.',
    dealers: 'قائمة الموزّعين',
    dealersLead: 'مطلوب: اسم الشركة ورمز الموزّع أو الرقم الضريبي. إعادة الرفع لا تُنشئ تكرارات.',
    exportDealers: 'تصدير الموزّعين',
    noDealerGroups: 'أنشئ أولًا مجموعة عملاء للموزّعين في صفحة «التسعير».',
    defaultGroup: 'مجموعة الموزّعين الافتراضية',
    defaultStatus: 'الحالة الافتراضية',
    useCompanyEmail: 'استخدام البريد الإلكتروني للشركة لتسجيل الدخول إذا لم يوجد بريد إلكتروني لجهة الاتصال',
    sendLinks: 'إرسال روابط تعيين كلمة المرور إلى المستخدمين بالبريد الإلكتروني',
    unchanged: '{{count}} دون تغيير',
    errorRows: '{{count}} صفوف بها أخطاء',
    members: '{{count}} مستخدمين',
    action: 'الإجراء',
    actions: {
      create: 'جديد',
      update: 'تحديث',
      unchanged: 'دون تغيير',
      error: 'خطأ',
    },
    dealerResult: 'تمت إضافة {{created}} موزّعًا، وتحديث {{updated}}، وربط {{members}} مستخدمًا.',
    linksEmailed: 'أُرسلت رسائل تعيين كلمة المرور إلى {{count}} مستخدمين.',
    needActivation:
      'لم يتلقَّ {{count}} مستخدمين رابطًا (البريد الإلكتروني غير مُعدّ أو لم يُحدَّد الخيار). أنشئ الروابط من صفحة الموزّع، أو يمكن للموزّعين استخدام «نسيت كلمة المرور» بعد إعداد البريد الإلكتروني.',
  },
  orders: {
    geliver: {
      ship: 'الشحن عبر Geliver',
      lead: 'أدخل أبعاد الطرد ووزنه، واحصل على عروض شركات الشحن، واختر أحدها واشترِ الملصق.',
      testBadge: 'بيئة الاختبار',
      weight: 'الوزن (غ)',
      weightMissing: 'لا يوجد وزن لـ {{count}} منتج؛ أُضيف الوزن الافتراضي. زِن الطرد وصحّح القيمة.',
      getOffers: 'احصل على العروض',
      offersPending: 'العروض تصل ({{percent}}٪)',
      refresh: 'تحديث',
      noOffers: 'لم تصل عروض. تحقّق من الأبعاد والعنوان وحاول مرة أخرى.',
      offers: 'عروض الشحن',
      cheapest: 'الأرخص',
      fastest: 'الأسرع',
      buy: 'اشترِ الملصق ({{amount}})',
      confirm:
        'ستُخصم رسوم الملصق {{amount}} من رصيدك في Geliver؛ وتُسجّل الشحنة وتخرج المنتجات المعبأة من المخزون.',
      confirmTest: 'سيُشترى ملصق لشحنة اختبار؛ وتُسجّل الشحنة وتخرج المنتجات المعبأة من المخزون.',
      confirmYes: 'أكّد واشترِ',
      back: 'رجوع',
      bought: 'تم شراء الملصق وتسجيل الشحنة.',
      codNote: 'لا تُشحن طلبات الدفع عند الاستلام عبر Geliver حاليًا.',
      notReady: 'اختر عنوان المرسل في صفحة الشحن للشحن عبر Geliver.',
      badge: 'Geliver',
      label: 'افتح الملصق',
      sync: 'حدّث الحالة',
      synced: 'تم تحديث الحالة',
      cancel: 'الإلغاء في Geliver',
      cancelConfirm:
        'ستُلغى الشحنة في Geliver؛ وتعود المنتجات المعبأة إلى المخزون ويمكن شحن الطلب مجددًا. تُسترد رسوم الملصق وفق قواعد Geliver.',
      cancelled: 'أُلغيت الشحنة',
      price: 'الملصق {{amount}}',
      awaitingTracking: 'يصل رقم التتبع عندما تستلم شركة الشحن الطرد؛ ويُرسل البريد إلى العميل حينها.',
    },
    createManual: 'إنشاء طلب',
    paymentNote:
      'تصبح طلبات البطاقة «مدفوعة» تلقائيًا بعد تحقق المزوّد. في التحويلات البنكية استخدم «تم استلام الدفعة» في الطلب بعد وصول المبلغ؛ أما طلبات الدفع عند الاستلام والحساب الآجل للموزّعين فتصل بحالة «قيد المعالجة».',
    search: 'بحث (رقم الطلب، العميل، الشركة، رقم PO)',
    po: {
      title: 'أمر الشراء وموافقة الشركة',
      lead: 'رقم أمر الشراء (PO) ومستنده الخاصان بالموزّع؛ وموافقة المسؤول المفوّض في الشركة عندما يتجاوز طلب المشتري حده.',
      number: 'رقم PO',
      save: 'حفظ رقم PO',
      document: 'مستند PO:',
      download: 'تنزيل {{name}} ({{kb}} KB)',
      noDocument: 'غير مرفق',
      attach: 'إرفاق مستند',
      replace: 'استبدال المستند',
      attached: 'تم إرفاق مستند PO.',
      approval: 'موافقة الشركة',
      requestedBy: 'طلبه',
      approvedBy: 'وافق عليه (المسؤول المفوّض في الشركة)',
      approvedAmount: 'إجمالي البضائع المعتمد',
      approvalNote: 'ملاحظة الموافقة',
      listLabel: 'PO: {{number}}',
    },
    status: 'الحالة',
    statuses: {
      draft: 'مسودة',
      awaiting_payment: 'بانتظار الدفع',
      paid: 'مدفوع',
      processing: 'قيد المعالجة',
      shipped: 'تم الشحن',
      delivered: 'تم التسليم',
      completed: 'مكتمل',
      cancelled: 'ملغى',
    },
    empty: 'لا توجد طلبات بعد',
    emptyLead: 'تظهر هنا طلبات واجهة المتجر والموزّعين ولوحة التحكم.',
    number: 'رقم الطلب',
    customer: 'العميل',
    channel: 'القناة',
    channels: {
      web: 'واجهة المتجر',
      b2b: 'موزّع',
      manual: 'لوحة التحكم',
      api: 'API',
    },
    total: 'الإجمالي',
    detailTitle: 'الطلب {{number}}',
    backToList: 'قائمة الطلبات',
    payment: {
      unpaid: 'غير مدفوع',
      pending: 'الدفع قيد الانتظار',
      paid: 'مدفوع',
      authorized: 'تفويض مسبق',
      partially_refunded: 'مسترد جزئيًا',
      refunded: 'مسترد',
    },
    lines: 'العناصر',
    qty: 'الكمية',
    unitPrice: 'سعر الوحدة',
    lineTotal: 'المبلغ',
    lotAllocated: 'مخصّص حسب الدفعة / تاريخ انتهاء الصلاحية',
    subtotal: 'المجموع الفرعي',
    discount: 'الخصم {{code}}',
    promotion: 'العرض: {{label}}',
    loyaltyTier: 'خصم المستوى: {{tier}} ({{percent}})',
    loyaltyPoints: '{{points}} نقطة',
    shippingPromotion: 'مجاني ({{label}})',
    tax: 'الضريبة',
    shipping: 'الشحن',
    customerInfo: 'العميل والعنوان',
    shippingAddress: 'عنوان الشحن',
    billingAddress: 'عنوان الفوترة',
    customerNote: 'ملاحظة الطلب',
    changeStatus: 'إجراءات الحالة',
    actions: {
      awaiting_payment: 'تأكيد الطلب (حجز المخزون)',
      processing: 'وضع علامة «قيد المعالجة»',
      shipped: 'وضع علامة «تم الشحن»',
      delivered: 'وضع علامة «تم التسليم»',
      completed: 'إكمال',
      cancelled: 'إلغاء',
    },
    actionHints: {
      awaiting_payment: 'تُؤكَّد المسودة، ويُحجز المخزون ويُحتسب استخدام رمز الخصم.',
      processing: 'يبدأ التجهيز. عند الجاهزية، استخدم «شحن» لإدخال رقم التتبع.',
      shipped: 'يُخصم المخزون المحجوز كعملية بيع. لم يعد بالإمكان إلغاء الطلب.',
      delivered: 'يتم وضع علامة «تم التسليم» على الطلب.',
      completed: 'يُغلق الطلب.',
      cancelled: 'يُحرَّر المخزون المحجوز واستخدام رمز الخصم.',
    },
    statusNote: 'ملاحظة',
    timeline: 'المخطط الزمني',
    noteEvent: 'ملاحظة داخلية',
    internalNote: 'إضافة ملاحظة داخلية',
    addNote: 'إضافة ملاحظة',
    manualLead: 'تتبع الأسعار مجموعة العميل (سعر الموزّع للموزّعين).',
    createButton: 'إنشاء طلب',
    created: 'تم إنشاء الطلب',
    changeCustomer: 'تغيير',
    customerHint: 'ابحث بالاسم (أو بالبريد الإلكتروني إذا كانت لديك صلاحية البيانات الشخصية).',
    addProduct: 'إضافة منتج',
    manualPrice: 'سعر الوحدة اليدوي',
    manualPricePlaceholder: 'سعر القائمة',
    fullName: 'اسم المستلم',
    addressLine: 'العنوان',
    discountCode: 'رمز الخصم',
    initialStatus: 'الحالة الأولية',
    codFee: 'رسوم الدفع عند الاستلام',
    paymentMethod: 'طريقة الدفع',
    paymentMethods: {
      card: 'بطاقة',
      paypal: 'PayPal',
      bank_transfer: 'تحويل بنكي',
      cash_on_delivery: 'الدفع عند الاستلام',
      open_account: 'حساب آجل',
      manual: 'يدوي (تحويل/نقدًا وغير ذلك)',
      gift_card: 'بطاقة هدية',
      store_credit: 'رصيد المتجر',
      loyalty_points: 'نقاط الولاء',
    },
    shippingMethod: 'طريقة الشحن',
    initialStatuses: {
      confirmed: 'تأكيد (حجز المخزون)',
      draft: 'مسودة (بدون حجز)',
    },
    paymentsTitle: 'الدفع',
    capture: 'تم استلام الدفعة',
    refund: 'استرداد المبلغ',
    noPayments: 'لا توجد سجلات دفع.',
    installments: '{{count}} أقساط',
    refundedAmount: 'المبلغ المسترد: {{amount}}',
    refunds: 'عمليات الاسترداد',
    refundReasons: {
      customer_request: 'طلب العميل',
      withdrawal: 'حق الانسحاب',
      damaged: 'تالف/معيب',
      out_of_stock: 'نفد من المخزون',
      duplicate: 'دفعة مكررة',
      other: 'أخرى',
    },
    restocked: 'أُعيد إلى المخزون',
    testPaymentWarning:
      'دُفع هذا الطلب في بيئة الاختبار، ولم يتم تحصيل أي أموال حقيقية. لا تشحنه، وألغِ الطلب عند انتهاء الاختبار.',
    resolveRefund: 'تحديد النتيجة',
    resolveRefundTitle: 'تحديد نتيجة الاسترداد',
    resolveRefundLead:
      'توقفت عملية الاسترداد هذه ونتيجتها غير معروفة. تحقّق في لوحة تحكم مزوّد الدفع مما إذا كان الاسترداد قد تم، ثم اختر النتيجة. لن يُرسَل طلب استرداد جديد إلى المزوّد.',
    resolveRefundOutcome: 'حالة عملية الاسترداد هذه في لوحة تحكم المزوّد',
    resolveRefundSucceeded: 'تمت (أُعيد المبلغ)',
    resolveRefundFailed: 'لم تتم',
    resolveRefundNote: 'ملاحظة',
    resolveRefundSave: 'حفظ النتيجة',
    resolveRefundDone: 'تم حفظ نتيجة الاسترداد',
    eventTypes: {
      preauth_captured: 'تم تحصيل التفويض المسبق',
      preauth_released: 'تم تحرير التفويض المسبق، وأُلغي الطلب',
      preauth_capture_failed: 'فشل تحصيل التفويض المسبق',
      edited: 'تم تعديل الطلب',
      return_requested: 'تم فتح طلب إرجاع/انسحاب',
      return_approved: 'تمت الموافقة على طلب الإرجاع',
      return_rejected: 'تم رفض طلب الإرجاع',
      return_completed: 'اكتمل طلب الإرجاع',
      return_cancelled: 'أُلغي طلب الإرجاع',
      created: 'تم إنشاء الطلب',
      status_changed: 'تغيّرت الحالة',
      payment_failed: 'فشل الدفع',
      payment_review: 'الدفعة تحتاج إلى مراجعة',
      payment_after_cancel: 'وصلت دفعة لطلب ملغى (يلزم استرداد المبلغ)',
      payment_captured: 'تم استلام الدفعة',
      payment_amount_mismatch: 'عدم تطابق مبلغ الدفعة',
      refund: 'تم استرداد المبلغ',
      refund_failed: 'فشل الاسترداد',
      partially_shipped: 'تم شحن طرد (شحن جزئي)',
      exchange_shipped: 'تم شحن المنتج البديل',
      items_cancelled: 'تم إلغاء عناصر (إلغاء جزئي)',
      shipment_cancelled: 'أُلغيت الشحنة، وأُعيدت العناصر إلى المخزون',
    },
    eventMessages: {
      draft_updated: 'تم تحديث المسودة (العناصر أو العميل أو الشحن أو الخصم).',
      lines_changed: 'تغيّرت العناصر/الكميات، وأُعيد حساب المبالغ وحجز المخزون.',
      address_changed: 'تغيّر عنوان التسليم.',
      billing_changed: 'تغيّر عنوان الفوترة.',
      note_changed: 'تغيّرت ملاحظة الطلب.',
      po_number_changed: 'تغيّر رقم أمر الشراء (PO).',
      po_document_attached: 'تم إرفاق مستند أمر الشراء (PO).',
      payment_timeout: 'انتهت مهلة الدفع، وأُلغي الطلب تلقائيًا.',
      bank_transfer_timeout: 'لم يصل التحويل البنكي في الوقت المحدد، وأُلغي الطلب تلقائيًا.',
    },
    refundStatuses: {
      pending: 'قيد التنفيذ',
      succeeded: 'نجح',
      failed: 'فشل',
    },
    captured: 'تم تسجيل الدفعة',
    captureTitle: 'تم استلام الدفعة · {{amount}}',
    captureLead:
      'سجّل الدفعة بعد التحقق من وصول المبلغ. يتلقى العميل رسالة بريد إلكتروني «تم استلام الدفعة».',
    captureNote: 'ملاحظة الدفع',
    refundDone: 'اكتمل الاسترداد',
    refundFailed: 'فشل استرداد المبلغ؛ راجع قسم الدفع',
    refundTitle: 'استرداد المبلغ',
    refundCardLead:
      'يتم الاسترداد عبر مزوّد الخدمة الذي استُلم من خلاله الدفع (iyzico أو PayTR أو Sipay أو Stripe أو PayPal)؛ وقد يستغرق ظهور المبلغ في البطاقة أو حساب PayPal بضعة أيام عمل.',
    refundManualLead: 'تُجري أنت استرداد التحويل البنكي أو الدفع عند الاستلام عبر بنكك؛ وتسجّله هنا.',
    refundConfirm: 'استرداد',
    refundable: 'قابل للاسترداد: {{amount}}',
    refundAmount: 'مبلغ الاسترداد (₺)',
    refundReason: 'السبب',
    refundNote: 'ملاحظة',
    refundNoteHint: 'مثال: رقم IBAN الذي تم الاسترداد إليه والتاريخ.',
    refundPayment: 'الدفعة المراد استردادها',
    refundPaymentOption: '{{provider}} · قابل للاسترداد {{amount}}',
    refundAsCredit: 'الاسترداد كرصيد في المتجر بدلًا من المال',
    refundCreditConsent: 'وافق العميل صراحةً على استلام المبلغ المسترد كرصيد في المتجر',
    refundCreditLead:
      'يُضاف المبلغ إلى رصيد المتجر الخاص بالعميل؛ ولا يُسترد أي مبلغ إلى البطاقة أو الحساب البنكي. استخدمه فقط بموافقة صريحة من العميل، ولا تستخدمه أبدًا في حالات الاسترداد الناتجة عن الانسحاب.',
    refundTenderLead: 'يُعاد المبلغ إلى بطاقة الهدية أو رصيد المتجر؛ ولا يتم أي استرداد عبر مزوّد الدفع.',
    refundToStoreCredit: 'كرصيد في المتجر',
    restock: 'إعادة المنتجات المُرجعة إلى المخزون',
    restockQty: '{{title}} – الكمية المُرجعة',
    shipmentsTitle: 'الشحن',
    ship: 'شحن',
    shipAfterPayment: 'لا يمكن الشحن قبل استلام الدفع.',
    noShipments: 'لا توجد شحنات بعد.',
    trackingLink: 'تتبّع',
    shipmentStatuses: {
      created: 'تم الإنشاء',
      in_transit: 'قيد النقل',
      out_for_delivery: 'قيد التوصيل',
      delivered: 'تم التسليم',
      returned: 'مُرتجع',
      exception: 'توجد مشكلة',
      cancelled: 'ملغى',
    },
    updateShipment: 'تحديث الحالة',
    shipped: 'تم شحن الطلب',
    shipTitle: 'شحن الطلب',
    shipLead:
      'اختر المنتجات والكميات الموجودة في هذا الطرد. تُخصم الكميات المعبأة من المخزون ويتلقى العميل رسالة بريد إلكتروني برقم التتبع. إذا لم يتبقَّ شيء للشحن تصبح حالة الطلب «تم الشحن»، وإلا يبقى قيد التجهيز.',
    shipItems: 'المنتجات في هذا الطرد',
    shipQty: '{{title}} – الكمية المراد شحنها',
    shipProgress: 'تم شحن {{shipped}}/{{ordered}}',
    shipCodNote: 'لا يمكن تقسيم طلب الدفع عند الاستلام؛ تُشحن جميع المنتجات المتبقية في هذا الطرد.',
    shipPartialNote: 'هذا الطرد جزء من الطلب؛ وتُشحن المنتجات المتبقية لاحقًا.',
    shipNothing: 'أضف منتجًا واحدًا على الأقل إلى الطرد.',
    shippedPartial: 'تم شحن الطرد؛ والمنتجات المتبقية بانتظار الشحن',
    partiallyShipped: 'تم الشحن جزئيًا',
    ledgerSettled: 'تمت التسوية عبر الحساب الجاري',
    exportExempt: 'تصدير — معفى من ضريبة القيمة المضافة',
    waitingToShip: 'بانتظار الشحن: {{items}}',
    shipmentItem: '{{quantity}} × {{title}}',
    chooseProvince: 'اختر المحافظة',
    chooseDistrict: 'اختر المنطقة',
    chooseProvinceFirst: 'اختر المحافظة أولًا',
    legacyPlace: '{{value}} (غير موجود في القائمة)',
    cancelledQty: '{{count}} ملغاة',
    cancelledItems: 'المنتجات الملغاة',
    refundDue:
      'لم يُسترد بعد مبلغ {{amount}} الخاص بالمنتجات التي أُلغيت لتعذّر شحنها. استرده عبر «استرداد» (يُقترح المبلغ تلقائيًا).',
    cancelItems: 'إلغاء المنتجات المتبقية',
    cancelItemsLead:
      'تُلغى من الطلب المنتجات التي يتعذّر شحنها: يُحرَّر المخزون المحجوز ويتلقى العميل رسالة بريد إلكتروني. لا يتغيّر إجمالي الطلب؛ وإذا كان مدفوعًا فاسترد مبلغ المنتجات الملغاة عبر «استرداد». إذا لم يتبقَّ شيء للشحن تصبح حالة الطلب «تم الشحن».',
    cancelQty: '{{title}} – الكمية المراد إلغاؤها',
    cancelItemsNote: 'ملاحظة للعميل',
    cancelItemsNoteHint: 'تظهر للعميل في البريد الإلكتروني (مثال: «نفد المنتج لدى المورّد»).',
    itemsCancelled: 'تم إلغاء المنتجات؛ المبلغ {{amount}}',
    trackingNumber: 'رقم التتبع',
    trackingUrl: 'رابط التتبع',
    trackingUrlHint: 'إذا تُرك فارغًا، تُستخدم صفحة التتبع الخاصة بشركة الشحن (لم يتم التحقق من التنسيق).',
    packageCount: 'عدد الطرود',
    updateShipmentLead: 'عند اختيار «تم التسليم» يُعلَّم الطلب أيضًا كمُسلَّم بمجرد تسليم جميع طروده.',
    shipmentCancelNote:
      'تعود منتجات الطرد الملغى إلى المخزون وتُحجز للطلب مرة أخرى؛ وتعود حالة الطلب إلى «قيد التجهيز» ويمكن شحن المنتجات مجددًا. لا تُلغِ إلا إذا لم يغادر الطرد إطلاقًا.',
    shipmentStatus: 'الحالة',
    shipmentNote: 'ملاحظة',
    invoicesTitle: 'الفاتورة',
    createInvoice: 'إنشاء فاتورة',
    noInvoices: 'لا توجد فاتورة.',
    contractsTitle: 'النصوص المقبولة',
    contractsLead: 'النصوص التي اطّلع عليها العميل ووافق عليها عند إتمام الطلب، مع الإصدار والوقت.',
    contractHash: 'بصمة النص: {{hash}}…',
  },
  orderTools: {
    manualPriceHint:
      'سعر الوحدة يدويًا ({{currency}}، المعاملة الضريبية كما في قائمة الأسعار)؛ اتركه فارغًا لاستخدام سعر القائمة الخاص بالعميل.',
    editDraftTitle: 'مسودة الطلب {{number}}',
    saveDraft: 'حفظ المسودة',
    customerKind: 'نوع العميل',
    customerKinds: {
      customer: 'عميل مسجّل',
      guest: 'زائر',
    },
    guestEmail: 'البريد الإلكتروني',
    guestEmailHint: 'تُرسل تفاصيل الطلب والدفع إلى هذا العنوان.',
    maskedKeep: 'القيمة المحفوظة مخفية؛ اتركها فارغة للإبقاء عليها.',
    guestPhone: 'هاتف العميل',
    noShippingMethod: 'بدون طريقة شحن (مجاني أو يُحدَّد لاحقًا)',
    audience: {
      retail: 'للبيع بالتجزئة فقط',
      dealers: 'للموزّعين فقط',
    },
    shippingFee: 'رسوم الشحن ({{currency}}، شاملة ضريبة القيمة المضافة)',
    shippingFeeHint: 'اتركه فارغًا لحساب الرسوم من الطريقة المختارة (شرائح الوزن، حدّ الشحن المجاني).',
    discountKind: 'الخصم',
    discountKinds: {
      none: 'بدون خصم',
      code: 'رمز الخصم',
      manual: 'مبلغ يدوي',
    },
    manualDiscount: 'مبلغ الخصم ({{currency}}، شامل ضريبة القيمة المضافة)',
    manualDiscountHint: 'يُوزَّع على المنتجات بنسبة مبالغها؛ ولا يمكن أن يتجاوز المجموع الفرعي.',
    addressMasked:
      'العنوان مخفي (ليست لديك صلاحية عرض البيانات الشخصية). لتغييره أدخل العنوان كاملًا؛ واتركه فارغًا للإبقاء على العنوان المحفوظ.',
    editLinesTitle: 'تعديل المنتجات',
    editLinesLead:
      'تحتفظ المنتجات الموجودة بسعر الوحدة الخاص بها؛ وتُضاف المنتجات الجديدة بالسعر الحالي. تبقى رسوم الشحن كما هي، ويُحجز المخزون من جديد.',
    editAddressTitle: 'تعديل العنوان والملاحظة',
    editAddressLead:
      'يمكن تغيير عنوان التسليم وملاحظة الطلب حتى إنشاء شحنة. ولا يمكن تغيير عنوان الفاتورة بعد إصدار الفاتورة.',
    editDraft: 'تعديل المسودة',
    editLines: 'تعديل المنتجات',
    editAddress: 'تعديل العنوان والملاحظة',
    bulkRegion: 'الطلبات المحددة',
    selected: 'الطلبات المحددة: {{count}}',
    printOrders: 'طباعة ملخص الطلب',
    printPacking: 'طباعة قائمة التعبئة',
    exportSelected: 'تنزيل بصيغة Excel',
    bulkStatus: 'تغيير الحالة',
    bulkDone: 'تم تغيير حالة {{count}} من الطلبات.',
    bulkStatusTitle: 'تغيير حالة {{count}} من الطلبات',
    bulkStatusLead:
      'يتغيّر كل طلب وفق قواعده الخاصة (المخزون، رمز الخصم، إشعار العميل)؛ وتُدرج الطلبات التي يتعذّر تغييرها مع السبب.',
    bulkApply: 'تطبيق',
    bulkSummary: 'تم تغيير {{ok}} من الطلبات، ولم يتغيّر {{failed}}.',
    bulkTarget: 'الحالة الجديدة',
    bulkCancelWarning:
      'يتلقى عملاء الطلبات الملغاة رسالة إلغاء بالبريد الإلكتروني؛ ويُحرَّر المخزون المحجوز ويُعاد حق استخدام رمز الخصم. لا تُلغى الطلبات المدفوعة دون استرداد المبلغ.',
    selectAllPage: 'تحديد جميع الطلبات في هذه الصفحة',
    selectRow: 'تحديد الطلب {{number}}',
  },
  preauth: {
    held: 'يوجد حجز بمبلغ {{amount}} على البطاقة (تفويض مسبق)؛ ولم يُخصم بعد.',
    deadline: 'آخر موعد للتحصيل: {{date}} (الأيام المتبقية: {{days}}).',
    expiringSoon: 'على وشك الانتهاء: اشحن الطلب أو حصّل المبلغ الآن.',
    partial: 'إجمالي الطلب {{amount}}: يُخصم هذا المبلغ عند التحصيل، ويُحرِّر البنك المبلغ المتبقي {{rest}}.',
    capture: 'تحصيل',
    captureTitle: 'تحصيل التفويض المسبق',
    captureLead: 'سيُخصم {{amount}} من المبلغ المحجوز {{held}}. ويتم ذلك تلقائيًا أيضًا عند الشحن.',
    captured: 'تم تحصيل المبلغ',
    release: 'تحرير التفويض المسبق',
    releaseTitle: 'تحرير التفويض المسبق',
    releaseLead:
      'يُرفع الحجز عن البطاقة ويُلغى الطلب؛ ويُعاد المخزون وحق استخدام رمز الخصم، ويتلقى العميل رسالة إلغاء بالبريد الإلكتروني. لا يمكن التراجع عن هذا الإجراء.',
    releaseNote: 'السبب',
    released: 'تم تحرير التفويض المسبق؛ وأُلغي الطلب',
  },
  paymentLinks: {
    title: 'رابط الدفع',
    create: 'إنشاء رابط دفع',
    renew: 'إنشاء رابط جديد',
    empty: 'لا يوجد رابط دفع لهذا الطلب.',
    createdAt: 'تاريخ الإنشاء: {{date}}',
    expiresAt: 'صالح حتى: {{date}}',
    paidAt: 'تاريخ الدفع: {{date}}',
    openedAt: 'فتحه العميل: {{date}}',
    notOpened: 'لم يُفتح بعد',
    states: {
      active: 'صالح',
      paid: 'مدفوع',
      expired: 'منتهي الصلاحية',
      cancelled: 'ملغى',
      closed: 'مغلق',
      amount_changed: 'تغيّر المبلغ',
    },
    cancel: 'إلغاء',
    cancelConfirm: 'هل تريد إلغاء هذا الرابط؟ لن يتمكن العميل من الدفع من خلاله.',
    cancelledToast: 'تم إلغاء الرابط',
    createTitle: 'إنشاء رابط دفع',
    createLead: 'يطّلع العميل على الطلب ونصوص العقد ويوافق عليها ثم يدفع {{amount}} بالبطاقة.',
    draftNote: 'الطلب مسودة: إنشاء الرابط يؤكد الطلب ويحجز المخزون ويحتسب استخدام رمز الخصم.',
    renewNote: 'سيُلغى الرابط الحالي؛ أرسل الرابط الجديد إلى العميل.',
    hours: 'مدة الصلاحية',
    hourOptions: {
      h24: '24 ساعة',
      h72: '3 أيام',
      h168: '7 أيام',
      h720: '30 يومًا',
    },
    sendEmail: 'إرسال الرابط إلى البريد الإلكتروني للعميل ({{email}})',
    noEmail: 'لا يحتوي الطلب على عنوان بريد إلكتروني؛ انسخ الرابط وأرسله بنفسك.',
    createButton: 'إنشاء',
    createdTitle: 'رابط الدفع جاهز',
    createdLead:
      'يُعرض الرابط الآن فقط؛ انسخه وأرسله إلى العميل (WhatsApp أو SMS أو البريد الإلكتروني). إذا فُقد، أنشئ رابطًا جديدًا.',
    url: 'الرابط',
    copy: 'نسخ',
    copied: 'تم نسخ الرابط',
    copyFailed: 'تعذّر النسخ؛ حدّد الرابط وانسخه يدويًا.',
    emailed: 'تم إرسال الرابط إلى البريد الإلكتروني للعميل.',
    notEmailed: 'لم يتم إرسال أي بريد إلكتروني.',
  },
  proforma: {
    title: 'فاتورة مبدئية',
    open: 'فاتورة مبدئية',
    back: 'العودة إلى الطلب',
    documentLabel: 'فاتورة مبدئية {{number}}',
    notInvoice: 'هذه فاتورة مبدئية؛ ولا تحلّ محل الفاتورة التجارية (e-Fatura / e-Arşiv).',
    currency: 'العملة: {{currency}}',
    sellerTax: 'مكتب الضرائب / الرقم الضريبي: {{office}} / {{number}}',
    mersis: 'رقم MERSİS: {{no}}',
    buyer: 'المشتري',
    consignee: 'المستلم',
    totalWeight: 'إجمالي وزن المنتجات',
    kg: '{{value}} كغ',
    description: 'وصف البضاعة',
    hsCode: 'رمز النظام المنسق (HS)',
    origin: 'المنشأ',
    weight: 'الوزن',
    discount: 'الخصم',
    exportExemption:
      'تسليم للتصدير: لم تُحتسب ضريبة القيمة المضافة (قانون ضريبة القيمة المضافة التركي رقم 3065، المادة 11/1-a).',
    exemptionVerify: 'ينبغي أن يؤكد محاسبك أساس الإعفاء والصياغة الواردة في هذا المستند.',
    fxLine: 'سعر الصرف: {{pair}} (سعر شراء العملات الأجنبية لدى TCMB، {{date}})',
    pricesInclusive: 'الأسعار شاملة ضريبة القيمة المضافة.',
    pricesExclusive: 'الأسعار غير شاملة ضريبة القيمة المضافة.',
    missingCustoms:
      'منتجات ينقصها رمز النظام المنسق (HS) أو بلد المنشأ: {{skus}}. أكمِلها من قسم «الجمارك والتصدير» في صفحة تعديل المنتج.',
  },
  catalogTranslations: {
    title: 'الترجمات',
    productLead:
      'اللغة الأساسية للمنتج هي {{base}}. الاسم والأوصاف وحقول SEO بلغات أخرى؛ وتُتاح اللغة المترجمة لمحركات البحث على عنوانها المسبوق برمز اللغة (مثل /en/…).',
    missing: 'لا توجد ترجمة',
    findings: 'ادعاءات صحية محتملة: {{count}}؛ راجعها قبل الاعتماد',
    vet: {
      approved: 'معتمد',
      pending: 'بانتظار موافقة الطبيب البيطري',
    },
    approve: 'اعتماد',
    approveConfirm: 'هل تريد اعتماد ترجمة {{language}}؟ يُنشر النص المعتمد في واجهة المتجر.',
    approved: 'تم اعتماد الترجمة.',
    add: 'إضافة ترجمة',
    deleteConfirm: 'هل تريد حذف ترجمة {{language}}؟',
    dialogTitle: 'ترجمة {{language}}',
    dialogLead: 'لا تُعرض حقول الوصف الفارغة. وتبقى التركيبة وطريقة الاستخدام والتحذيرات باللغة الأساسية.',
    productTitle: 'اسم المنتج',
    shortDescription: 'وصف مختصر',
    description: 'الوصف',
    seoTitle: 'عنوان SEO',
    seoDescription: 'وصف SEO',
    categoryTitle: '{{name}} — الترجمات',
    categoryLead: 'اسم الفئة ووصفها وحقول SEO؛ وتُتاح الفئة المترجمة لمحركات البحث بتلك اللغة.',
    noLanguages: 'لا تحتوي متاجرك على أي لغة غير اللغة الأساسية. أضف سوقًا بلغة أخرى لتتمكن من الترجمة.',
    language: 'اللغة',
    done: 'مترجَم',
    categoryName: 'اسم الفئة',
    saveLanguage: 'حفظ {{language}}',
  },
  orderPrint: {
    orderTitle: 'ملخص الطلب',
    packingTitle: 'قائمة التعبئة',
    print: 'طباعة / حفظ بصيغة PDF',
    nothing: 'لا توجد طلبات للطباعة.',
    lead: 'عدد الطلبات: {{count}}. يُطبع كل طلب في صفحة مستقلة؛ وللحصول على ملف PDF اختر «حفظ بصيغة PDF» في نافذة الطباعة.',
    maskedNote: 'العناوين وبيانات الاتصال مخفية لأنه ليست لديك صلاحية عرض البيانات الشخصية.',
    documentLabel: '{{title}} {{number}}',
    packingNote: 'قائمة الانتقاء والتعبئة داخل المستودع؛ وليست بديلًا عن إشعار الإرسال الإلكتروني.',
    lots: 'الدفعة / تاريخ انتهاء الصلاحية',
    check: 'تحقق',
    lotLine: '{{lot}} (تنتهي {{expiry}}) × {{qty}}',
    preparedBy: 'أعدّه',
    checkedBy: 'دقّقه',
  },
  payments: {
    store: 'المتجر',
    noStore: 'أنشئ متجرًا أولًا',
    noStoreLead: 'إعدادات الدفع والشحن خاصة بكل متجر. أضف متجرًا من شاشة «المتاجر».',
    cardTitle: 'الدفع بالبطاقة (نقطة بيع افتراضية)',
    cardLead:
      'iyzico أو PayTR. لا تصل بيانات البطاقة إلى المتجر أبدًا؛ إذ تُدخل في الصفحة الآمنة لمزوّد الدفع.',
    envSandbox: 'تجريبي',
    envLive: 'مباشر',
    keysHint: 'تُحفظ المفاتيح مشفّرة في شاشة التكاملات، حيث تُجري أيضًا اختبار الاتصال:',
    cardProvider: 'مزوّد الدفع بالبطاقة',
    cardOff: 'متوقف',
    cardStatus: 'الدفع بالبطاقة في واجهة المتجر:',
    cardState_off: 'متوقف',
    cardState_test: 'تجريبي (دون أموال حقيقية)',
    cardState_live: 'مباشر',
    cardNext_off_none:
      'الخطوة التالية: أدخل مفاتيح الاختبار (Sandbox) الخاصة بـ iyzico أو PayTR في التكاملات واختبر الاتصال؛ ثم اختر المزوّد أدناه واحفظ.',
    cardNext_off_live_only:
      'المفاتيح المباشرة مرتبطة لكن الدفع بالبطاقة متوقف. لصاحب النشاط: اختر المزوّد أو اضغط «الانتقال إلى الوضع المباشر»؛ وفي حال عدم وجود دفعة تجريبية يمكنك تأكيد التحذير والانتقال مباشرةً إلى الوضع المباشر عبر التحقق بخطوتين، ثم تنفيذ أول طلب مباشر بمبلغ صغير واسترداده. أما الأدوار الأخرى فتحتاج أولًا إلى دفعة ناجحة في البيئة التجريبية.',
    cardNext_off_ready: 'الخطوة التالية: اختر المزوّد أدناه واحفظ؛ يبدأ الدفع بالبطاقة في الوضع التجريبي.',
    cardNext_test:
      'يمكن للعملاء الدفع ببطاقات الاختبار؛ ولا تُخصم أموال حقيقية. ادفع طلبًا تجريبيًا وتحقق منه في المدفوعات؛ وإذا نجح، انتقل إلى المدفوعات الحقيقية عبر «الانتقال إلى الوضع المباشر» (يوم الإطلاق).',
    cardNext_live: 'يتم قبول مدفوعات حقيقية بالبطاقة.',
    environment: 'البيئة',
    goLive: 'الانتقال إلى الوضع المباشر',
    backToSandbox: 'العودة إلى الوضع التجريبي',
    backToSandboxConfirm: 'سيتم إيقاف الدفع بالبطاقة وإعادة البيئة إلى الوضع التجريبي. هل تريد المتابعة؟',
    sandboxNote:
      'لا تُخصم أموال حقيقية في الوضع التجريبي؛ نفّذ طلبًا تجريبيًا باستخدام بطاقات الاختبار الخاصة بالمزوّد.',
    maxInstallments: 'التقسيط',
    singlePayment: 'دفعة واحدة',
    upTo: 'عدد الأقساط حتى {{count}}',
    cardTimeout: 'مهلة الدفع بالبطاقة (بالدقائق)',
    cardCapture: 'توقيت الخصم',
    cardCaptures: {
      immediate: 'الخصم عند الدفع',
      preauth: 'تفويض مسبق، والخصم عند الشحن',
    },
    cardCapturePreauthHint:
      'يُحجز المبلغ على البطاقة عند إتمام الطلب ويُخصم عند شحن الطلب (أو عبر «تحصيل» في تفاصيل الطلب). يُحرِّر البنك الحجوزات التي لا تُحصَّل خلال 25 يومًا. دفعة واحدة فقط؛ ولا يمكن إجراء تفويض مسبق لبطاقات الخصم المباشر (Debit).',
    preauthPaytr:
      'التفويض المسبق غير متاح مع PayTR: فالمستند الفني الخاص به غير منشور للعموم؛ ويمكن إضافته بعد أن توفّره PayTR.',
    preauthSipay: 'لا يُستخدم التفويض المسبق مع Sipay: يُحصَّل المبلغ فور الدفع.',
    cardCurrencies: 'الدفع بالبطاقة بالعملات الأجنبية',
    cardCurrenciesHint: {
      iyzico:
        'في المتجر المسعَّر بعملة غير TRY، تُعرض البطاقات فقط بالعملات المحددة هنا. حدّدها إذا كان لديك اتفاق مع iyzico لتحصيل العملات الأجنبية.',
      paytr:
        'في المتجر المسعَّر بعملة غير TRY، تُعرض البطاقات فقط بالعملات المحددة هنا. يتطلب PayTR اتفاقًا مع فريق الشركات لديه لعملات EUR/USD/GBP.',
      sipay:
        'في المتجر الذي عملته غير الليرة التركية، يُعرض الدفع بالبطاقة بالعملات المحددة هنا فقط. يقبل Sipay اليورو والدولار؛ ويتطلب التحصيل بالعملة الأجنبية اتفاقًا مع Sipay.',
      stripe:
        'بطاقات العملات الأجنبية عبر Stripe: في الأسواق المسعَّرة بعملة محددة هنا، يتم الدفع بالبطاقة عبر صفحة الدفع الخاصة بـ Stripe.',
    },
    cardCurrencyLabel: 'الدفع بالبطاقة بعملة {{currency}}',
    notifyUrls: 'روابط الإشعارات',
    iyzicoNotify: 'رابط إشعارات iyzico (Webhook)',
    paytrNotify: 'رابط إشعارات PayTR',
    sipayNotify: 'رابط إشعارات Sipay (webhook)',
    intlTitle: 'المدفوعات الخارجية (Stripe، PayPal)',
    intlLead:
      'استقبل الدفع بالبطاقة في أسواق العملات الأجنبية عبر صفحة Stripe، ومدفوعات PayPal عبر صفحة PayPal. وتستمر مدفوعات TRY عبر مزوّد البطاقة أعلاه.',
    intlEntityTitle: 'يلزم وجود شركة مسجّلة خارج تركيا',
    intlEntityLead:
      'لا تفتح Stripe وPayPal حسابات للشركات المسجّلة في تركيا. يُفتح الحساب باسم شركتك في دولة مدعومة وتذهب الأموال إلى تلك الشركة. اتفق مع محاسبك على الفوترة والمحاسبة قبل الانتقال إلى الوضع المباشر.',
    intlCardProvider: 'الدفع بالبطاقة بالعملات الأجنبية',
    intlCardHint: 'عند اختيار Stripe، تتم مدفوعات البطاقة بغير TRY عبر Stripe؛ دون تقسيط أو تفويض مسبق.',
    intlCardOff: 'مزوّد البطاقة المحلي (إذا كان لديه اتفاق للعملات الأجنبية)',
    intlCardEnvironment: 'بيئة بطاقات العملات الأجنبية',
    paypal: 'الدفع عبر PayPal',
    paypalHint:
      'خيار PayPal في خطوة إتمام الطلب؛ يظهر فقط في أسواق EUR وUSD وGBP. اربط أولًا التكاملات ← PayPal.',
    paypalEnvironment: 'بيئة PayPal',
    stripeNotify: 'رابط Webhook الخاص بـ Stripe',
    paypalNotify: 'رابط Webhook الخاص بـ PayPal',
    otherTitle: 'طرق الدفع الأخرى',
    otherLead: 'في الطرق الأخرى غير البطاقة، علِّم الطلب بـ «تم استلام الدفع» عند وصول المال.',
    bankTransfer: 'تحويل بنكي',
    bankTransferHold: 'مهلة الدفع بالتحويل البنكي (بالساعات)',
    bankTransferHint:
      'يرى العميل البيانات البنكية بعد الطلب؛ وتؤكد أنت عند استلام الدفع. تُلغى الطلبات غير المدفوعة في الوقت المحدد تلقائيًا.',
    cod: 'الدفع عند الاستلام',
    codHint: 'يُعرض فقط مع طرق الشحن التي تدعمه.',
    codFee: 'رسوم الدفع عند الاستلام (₺)',
    codMax: 'الحد الأقصى للدفع عند الاستلام (₺)',
    dealerOpenAccount: 'الحساب الآجل للموزّعين',
    dealerOpenAccountHint: 'يطلب الموزّعون المعتمدون دون دفع؛ ويُقيَّد المبلغ في حسابهم الجاري.',
    guestCheckout: 'الطلب كزائر',
    guestCheckoutHint: 'إذا كان متوقفًا، يجب على العملاء إنشاء حساب لتقديم الطلب.',
    summaryTitle: 'الطرق المعروضة في واجهة المتجر',
    summaryCard: 'البطاقة: {{provider}} ({{env}})',
    summaryNoCard: 'الدفع بالبطاقة متوقف',
    summaryIntl: 'بطاقات العملات الأجنبية: {{provider}} ({{env}})',
    summaryPaypal: 'PayPal ({{env}})',
    goLiveTitle: 'الانتقال إلى الوضع المباشر مع {{provider}}',
    goLiveLead: 'من الآن فصاعدًا ستُخصم أموال حقيقية من بطاقات العملاء. يجب استكمال البنود أدناه.',
    goLiveConfirm: 'الانتقال إلى الوضع المباشر',
    checkLiveConnection: 'نجح اختبار الاتصال بالمفاتيح المباشرة',
    checkSandboxPayment: 'دفعة ناجحة واحدة على الأقل في الوضع التجريبي',
    noSandboxTitle: 'لم تُنفَّذ دفعة تجريبية',
    noSandboxLead:
      'لا توجد دفعة ناجحة في البيئة التجريبية. إذا انتقلت إلى الوضع المباشر، فنفّذ أول طلب مباشر بنفسك بمبلغ صغير واسترده للتأكد من أن الدفع والاسترداد يعملان.',
    noSandboxAck:
      'أنتقل إلى الوضع المباشر دون دفعة تجريبية؛ وسأنفّذ أول طلب مباشر بنفسي بمبلغ صغير ثم أسترده (موافقة صاحب النشاط).',
    noSandboxOwnerOnly: 'لا يمكن إلا لصاحب النشاط الموافقة على الانتقال إلى الوضع المباشر دون دفعة تجريبية.',
    firstLiveOrderTitle: 'نفّذ أول طلب مباشر بنفسك واسترده',
    firstLiveOrderLead:
      'تم تفعيل الدفع بالبطاقة في الوضع المباشر دون دفعة تجريبية. نفّذ طلبًا صغيرًا ببطاقتك الخاصة، وتحقق من أنه مدفوع، ثم استرده من تفاصيل الطلب. يختفي هذا التنبيه بعد اكتمال الاسترداد.',
    goLiveAck: 'أدرك أنه ستُخصم مبالغ من بطاقات حقيقية وأن اتفاقية مزوّد الدفع معتمدة.',
    bankAccounts: 'الحسابات البنكية',
    bankAccountsLead: 'تُعرض للعملاء الذين يختارون التحويل البنكي.',
    addBankAccount: 'إضافة حساب بنكي',
    editBankAccount: 'تعديل الحساب البنكي',
    noBankAccounts: 'لا توجد حسابات بنكية',
    noBankAccountsLead:
      'أضف حسابًا واحدًا على الأقل إذا كان التحويل البنكي مفعّلًا؛ وإلا فستُخفى هذه الطريقة.',
    accountStatus: {
      active: 'نشط',
      inactive: 'غير نشط',
    },
    deleteBankAccountConfirm: 'هل تريد حذف هذا الحساب البنكي؟ لن تتأثر الطلبات السابقة.',
    bankAccountDialogLead:
      'يتم التحقق من صحة رقم IBAN. تتطلب التغييرات التحقق بخطوتين وتُسجَّل في سجل التدقيق.',
    bankName: 'البنك',
    accountHolder: 'صاحب الحساب',
    iban: 'IBAN',
    accountStatusLabel: 'الحالة',
    accountCurrency: 'العملة',
    status: 'الحالة',
    provider: 'الطريقة',
    statuses: {
      pending: 'قيد الانتظار',
      requires_action: 'تحتاج إلى مراجعة',
      authorized: 'مفوَّض (محجوز)',
      captured: 'محصَّل',
      failed: 'فشل',
      cancelled: 'ملغى',
      expired: 'منتهي الصلاحية',
    },
    providers: {
      iyzico: 'iyzico',
      paytr: 'PayTR',
      stripe: 'Stripe',
      paypal: 'PayPal',
      sipay: 'Sipay',
      bank_transfer: 'تحويل بنكي',
      cash_on_delivery: 'الدفع عند الاستلام',
      open_account: 'حساب آجل',
      manual: 'يدوي',
      gift_card: 'بطاقة هدية',
      store_credit: 'رصيد المتجر',
      loyalty_points: 'نقاط الولاء',
    },
    empty: 'لا توجد مدفوعات بعد',
    emptyLead: 'تظهر هنا المدفوعات الواردة من واجهة المتجر أو لوحة التحكم.',
    amount: 'المبلغ',
    refunded: 'مُسترد',
    events: 'الإشعارات',
    eventsTitle: 'سجلات الدفع · {{number}}',
    eventsLead: 'إشعارات المزوّد والاستعلامات. لا تُعالَج الإشعارات ذات التوقيع غير الصالح.',
    noEvents: 'لا توجد سجلات.',
    eventKinds: {
      webhook: 'إشعار',
      callback: 'إشعار (PayTR)',
      return: 'العودة من المتصفح',
      status_query: 'استعلام عن الحالة',
      reconcile: 'مطابقة',
      manual: 'يدوي',
    },
    outcomes: {
      applied: 'تمت المعالجة',
      duplicate: 'مكرر (تم تجاهله)',
      ignored: 'تم التجاهل',
      rejected: 'مرفوض',
      error: 'خطأ',
    },
    signatureOk: 'التوقيع صالح',
    signatureBad: 'التوقيع غير صالح',
  },
  returns: {
    title: 'طلبات الإرجاع / الانسحاب',
    customerNote: 'ملاحظة العميل',
    decisionNote: 'ملاحظة المتجر',
    kinds: {
      withdrawal: 'حق الانسحاب',
      defective: 'منتج تالف / معيب',
      wrong_item: 'منتج خاطئ',
      other: 'أخرى',
    },
    statuses: {
      requested: 'بانتظار الرد',
      approved: 'تمت الموافقة',
      rejected: 'مرفوض',
      completed: 'مكتمل',
      cancelled: 'ملغى',
    },
    actions: {
      approved: 'موافقة',
      rejected: 'رفض',
      completed: 'إكمال',
      cancelled: 'إلغاء',
    },
    leads: {
      approved:
        'تُرسل إلى العميل رسالة موافقة بالبريد الإلكتروني. اكتب طريقة إرسال المنتج (شركة الشحن، رمز الاتفاق، العنوان). يتم استرداد المبلغ من قسم الدفع عند وصول المنتج.',
      rejected: 'تُرسل إلى العميل رسالة بريد إلكتروني تتضمن السبب. السبب إلزامي.',
      completed:
        'أغلق طلب الإرجاع بعد وصول المنتج وإتمام الاسترداد من قسم الدفع. هذا الإجراء لا يُجري أي استرداد للمبلغ.',
      cancelled: 'أغلقه إذا تراجع العميل عن طلبه. الملاحظة إلزامية.',
    },
    noteLabels: {
      approved: 'تعليمات الإرسال',
      rejected: 'السبب',
      completed: 'ملاحظة',
      cancelled: 'ملاحظة',
    },
    done: {
      approved: 'تمت الموافقة على طلب الإرجاع',
      rejected: 'تم رفض طلب الإرجاع',
      completed: 'تم إكمال طلب الإرجاع',
      cancelled: 'تم إلغاء طلب الإرجاع',
    },
    resolutions: {
      refund: 'استرداد المبلغ',
      exchange: 'استبدال',
    },
    exchangeTo: 'يُرسل بدلًا منه: {{items}}',
    exchangeShipped: 'تم شحن منتج الاستبدال: {{carrier}} · {{tracking}}',
    restockedYes: 'أُعيد المنتج المُرجع إلى المخزون.',
    restockedNo: 'لم يُعَد المنتج المُرجع إلى المخزون.',
    shipExchange: 'شحن منتج الاستبدال',
    shipExchangeLead:
      'بعد وصول المنتج المُرجع، اشحن المنتج الجديد. يُخصم المنتج المحجوز من المخزون، ويكتمل طلب الإرجاع، ويتلقى العميل رسالة بريد إلكتروني برقم التتبع. لا تتم أي حركة مالية.',
    restock: 'إعادة المنتج المُرجع إلى المخزون القابل للبيع',
    restockHint: 'لا تُعِد المنتج المعيب أو المفتوح إلى المخزون.',
    exchangeShippedDone: 'تم شحن منتج الاستبدال',
    exchangeLeads: {
      approved:
        'عند الموافقة يُحجز المنتج المطلوب للعميل وتُرسل إليه رسالة موافقة بالبريد الإلكتروني. اكتب طريقة إعادة إرسال المنتج. وعند وصول المنتج المُرجع، اشحن المنتج الجديد عبر «شحن منتج الاستبدال».',
      rejected: 'يتلقى العميل رسالة بريد إلكتروني تتضمن السبب. السبب إلزامي.',
      cancelled: 'أغلقه إذا غيّر العميل رأيه؛ ويعود المنتج المحجوز متاحًا للبيع. الملاحظة إلزامية.',
    },
  },
  launch: {
    title: 'حالة النشر',
    lead_draft:
      'المتجر في وضع المعاينة: واجهة المتجر مفتوحة مع تنبيه «معاينة» ومخفية عن محركات البحث. يمكن نشره بعد استكمال البنود الإلزامية أدناه.',
    lead_live: 'المتجر منشور: واجهة المتجر مفتوحة للعملاء الحقيقيين.',
    lead_maintenance: 'المتجر في وضع الصيانة: يرى الزوار صفحة صيانة. وتستمر لوحة التحكم والطلبات في العمل.',
    lead_archived:
      'المتجر مؤرشف: واجهة المتجر مغلقة ويظهر المتجر في آخر القائمة. عند إلغاء الأرشفة يعود إلى وضع المعاينة.',
    toArchive: 'أرشفة',
    unarchive: 'إلغاء الأرشفة',
    dialogTitle_archived: 'أرشفة المتجر',
    dialogLead_archived:
      'تُغلق واجهة المتجر؛ ويُحتفظ بالطلبات والمنتجات والإعدادات. يمكنك إلغاء الأرشفة في أي وقت.',
    confirm_archived: 'أرشفة',
    done_archived: 'تمت أرشفة المتجر',
    goLive: 'نشر المتجر',
    toMaintenance: 'صيانة',
    toDraft: 'العودة إلى المعاينة',
    blocked: 'بنود إلزامية ناقصة قبل النشر: {{count}}.',
    noPermission: 'لا يمكن تغيير حالة النشر إلا لصاحب النشاط والمسؤولين.',
    dialogTitle_live: 'نشر المتجر',
    dialogLead_live: 'يتطلب هذا الإجراء التحقق بخطوتين ويُسجَّل في سجل التدقيق.',
    dialogTitle_maintenance: 'وضع المتجر في الصيانة',
    dialogLead_maintenance:
      'يرى الزوار صفحة صيانة (خلال دقيقة). وتتلقى محركات البحث استجابة «غير متاح مؤقتًا».',
    dialogTitle_draft: 'العودة إلى المعاينة',
    dialogLead_draft: 'يتوقف نشر المتجر: تُفتح واجهة المتجر مع تنبيه «معاينة» وتُخفى عن محركات البحث.',
    liveEffect1: 'يختفي تنبيه «معاينة»؛ والطلبات المقدَّمة طلبات حقيقية.',
    liveEffect2: 'لا يُعرض الدفع بالبطاقة في البيئة التجريبية؛ إذ يتطلب الدفع بالبطاقة البيئة المباشرة.',
    liveEffect3: 'إتاحة المتجر لمحركات البحث إعداد منفصل على الخادم (SITE_INDEXING=on)؛ راجع دليل الترحيل.',
    confirmText: 'راجعتُ الأسعار وطرق الدفع والنصوص القانونية؛ وسيُفتح المتجر للعملاء الحقيقيين.',
    note: 'ملاحظة',
    confirm_live: 'نشر',
    confirm_maintenance: 'بدء الصيانة',
    confirm_draft: 'العودة إلى المعاينة',
    done_live: 'المتجر منشور',
    done_maintenance: 'المتجر في وضع الصيانة',
    done_draft: 'عاد المتجر إلى وضع المعاينة',
  },
  readiness: {
    title: 'قائمة التحقق قبل الإطلاق',
    lead: 'ما يحتاجه المتجر قبل بدء البيع. يتم التحقق من كل بند استنادًا إلى بيانات حقيقية.',
    progress: 'تم إنجاز {{done}} من {{total}}',
    ok: 'مكتمل',
    missing: 'ناقص',
    fix: 'إصلاح',
    goLiveLocked:
      'بعد استكمال البنود الإلزامية، يُنشر المتجر من المتاجر ← المتجر ← حالة النشر بتأكيد صريح والتحقق بخطوتين.',
    items: {
      seller_info: 'بيانات البائع (الاسم القانوني، العنوان، الهاتف، البريد الإلكتروني)',
      domain: 'نطاق المتجر',
      products: 'منتج منشور واحد على الأقل',
      shipping: 'طريقة شحن واحدة على الأقل',
      payment_methods: 'طريقة دفع واحدة على الأقل',
      card_live: 'الدفع بالبطاقة في الوضع المباشر',
      etbis: 'التسجيل في ETBİS (موصى به)',
      legal_published: 'نشر النصوص القانونية الإلزامية',
      legal_reviewed: 'مراجعة النصوص القانونية من قِبل محامٍ',
      legal_languages: 'النصوص القانونية بلغات الأسواق',
    },
    hints: {
      seller_info: 'املأ الحقول الناقصة في شاشة بيانات النشاط التجاري.',
      domain: 'أضف نطاقًا لواجهة المتجر من شاشة المتاجر.',
      products: 'انشر منتجًا واحدًا على الأقل.',
      shipping: 'أضف طريقة شحن.',
      payment_methods: 'فعّل الدفع بالبطاقة أو التحويل البنكي أو الدفع عند الاستلام.',
      card_live: 'انتقل إلى الوضع المباشر بعد نجاح دفعة تجريبية.',
      etbis: 'سجّل في نظام ETBİS التابع لوزارة التجارة وأدخل رابط التحقق في بيانات النشاط التجاري.',
      legal_published: 'انشر النصوص القانونية الناقصة.',
      legal_reviewed: 'اطلب من محامٍ مراجعة النصوص ثم أعد نشرها مع تعليمها كنصوص تمت مراجعتها.',
      legal_languages:
        'بعض النصوص غير منشورة بلغات أسواقك؛ يرى الزائر بتلك اللغة النص التركي. أضفها من تبويب اللغة في شاشة النصوص القانونية (اختياري).',
    },
    sellerFields: {
      legalName: 'الاسم القانوني',
      address: 'العنوان',
      phone: 'الهاتف',
      email: 'البريد الإلكتروني',
    },
  },
  reconcile: {
    title: 'المطابقة',
    lead: 'يُقارَن تقرير معاملات المزوّد بمدفوعاتك. ومع الاتصال المباشر يتم التحقق من اليوم السابق تلقائيًا كل يوم.',
    done: 'اكتملت المطابقة',
    date: 'اليوم',
    run: 'مقارنة',
    empty: 'لم تُجرَ أي مطابقة بعد.',
    issues: 'الفروقات: {{count}}',
    statuses: {
      running: 'قيد التشغيل',
      ok: 'لا توجد فروقات',
      mismatch: 'توجد فروقات',
      error: 'خطأ',
    },
    view: 'التفاصيل',
    detailTitle: 'تفاصيل المطابقة',
    summary: 'المدفوعات هنا: {{local}}، ولدى المزوّد: {{remote}}؛ الفروقات: {{issues}}.',
    kinds: {
      missing_local: 'موجود لدى المزوّد، ومفقود هنا',
      missing_provider: 'موجود هنا، ومفقود لدى المزوّد',
      amount_mismatch: 'فرق في المبلغ',
      status_mismatch: 'فرق في الحالة',
    },
    amounts: 'هنا: {{ours}} · لدى المزوّد: {{theirs}}',
    resolvedNote: 'مغلق',
    resolveNote: 'ملاحظة',
    resolve: 'إغلاق الفرق',
  },
  shipping: {
    currency: 'عملة الرسوم',
    currencyMismatch:
      'عملة المتجر هي {{currency}}؛ ولا تُعرض الطريقة إلا في الطلبات بعملتها الخاصة، لذا لن تظهر.',
    otherCurrency: '{{currency}} (لا تظهر في المتجر)',
    countries: 'دول الوجهة',
    countriesHint: 'إذا لم تُحدَّد أي دولة تُعرض الطريقة في جميع الأسواق؛ وإلا ففي أسواق هذه الدول فقط.',
    countriesShort: 'الدول: {{list}}',
    add: 'إضافة طريقة شحن',
    edit: 'تعديل طريقة الشحن',
    empty: 'لا توجد طرق شحن',
    emptyLead: 'أضف طريقة شحن واحدة على الأقل لإتمام الطلب.',
    carriers: {
      yurtici: 'Yurtiçi Kargo',
      aras: 'Aras Kargo',
      mng: 'MNG Kargo (DHL eCommerce)',
      ptt: 'PTT Kargo',
      surat: 'Sürat Kargo',
      hepsijet: 'HepsiJET',
      kolaygelsin: 'Kolay Gelsin',
      ups: 'UPS',
      other: 'أخرى',
    },
    freeAlways: 'مجاني',
    byWeight: 'حسب الوزن (عدد الشرائح: {{count}})',
    freeOverShort: 'مجاني فوق {{amount}}',
    codShort: 'الدفع عند الاستلام',
    audiences: {
      all: 'الجميع',
      retail: 'عملاء التجزئة',
      dealers: 'الموزّعون',
    },
    daysShort: '{{days}} أيام عمل',
    statuses: {
      active: 'نشط',
      inactive: 'غير نشط',
    },
    deleteConfirm: 'هل تريد حذف طريقة الشحن هذه؟ لن تتأثر الطلبات الحالية.',
    trackingTitle: 'تتبّع الشحنات',
    trackingLead: 'أدخل رقم التتبع عند الشحن؛ ويراه العميل في البريد الإلكتروني وفي صفحة الطلب.',
    carrierApiNote:
      'عند ربط Geliver، يجلب زر «الشحن عبر Geliver» في صفحة الطلب العروض ويشتري الملصق ويجلب رقم التتبع تلقائيًا. يتطلب الربط المباشر مع Yurtiçi وAras وMNG بيانات التكامل المؤسسي وإذن IP من الشركات (يتطلب الإعداد)؛ وحتى ذلك الحين اشحن معها عبر Geliver أو أدخل رقم التتبع يدويًا.',
    geliver: {
      title: 'الشحن عبر Geliver',
      lead: 'بحساب Geliver تُنشأ الشحنات من الطلبات وتُقارن أسعار شركات الشحن ويُشترى الملصق من اللوحة؛ وتصل الحالة ورقم التتبع من Geliver تلقائيًا.',
      notConnected: 'Geliver غير متصلة (يتطلب الإعداد).',
      connect: 'اربط من التكاملات',
      test: 'بيئة الاختبار',
      live: 'مباشر',
      testNote: 'في بيئة الاختبار تُنشأ الشحنات في Geliver كشحنات اختبار.',
      liveNote: 'في البيئة الحية تُخصم رسوم الملصق من رصيدك في Geliver.',
      sender: 'عنوان المرسل',
      senderHint: 'اختر من العناوين المعرّفة في Geliver.',
      senderNone: 'لم يُختر',
      sendersEmpty: 'لا يوجد عنوان مرسل في حساب Geliver. أضف عنوانًا في لوحة Geliver ثم أعد تحميل الصفحة.',
      senderDefault: '{{name}} (الافتراضي في Geliver)',
      length: 'الطول (سم)',
      width: 'العرض (سم)',
      height: 'الارتفاع (سم)',
      parcel: 'أبعاد الطرد الافتراضية',
      defaultWeight: 'الوزن الافتراضي (غ)',
      defaultWeightHint: 'يُستخدم للبنود التي لا يوجد لمنتجها وزن.',
    },
    name: 'الاسم',
    nameHint: 'يظهر للعملاء (مثل: الشحن العادي).',
    carrier: 'شركة الشحن',
    audience: 'الفئة المستهدفة',
    rateType: 'نوع التسعير',
    rateTypes: {
      flat: 'سعر ثابت',
      weight: 'حسب الوزن',
    },
    price: 'السعر (₺، شامل الضريبة)',
    priceHint: 'أدخل 0 للشحن المجاني.',
    tiers: 'شرائح الوزن',
    tiersHint: 'كل صف: سعر سلال التسوق حتى ذلك الوزن (بالغرام). رتّبها تصاعديًا.',
    upToGrams: 'حتى (غرام)',
    addTier: 'إضافة شريحة',
    freeOver: 'شحن مجاني فوق (₺)',
    estimatedDays: 'مدة التسليم المتوقعة (أيام عمل)',
    estimatedDaysHint: 'مثال: 1-3',
    handlingDays: 'مدة التجهيز (أيام عمل)',
    transitDays: 'مدة النقل (أيام عمل)',
    daysMin: 'الحد الأدنى',
    daysMax: 'الحد الأقصى',
    status: 'الحالة',
    codAvailable: 'الدفع عند الاستلام متاح',
    codAvailableHint: 'يُعرض مع هذه الطريقة (إذا كان الدفع عند الاستلام مفعّلًا).',
  },
  brokenLinks: {
    collect: 'جمع العناوين القديمة من الأرشيف',
    collected:
      'عُثر على {{found}} عنوانًا في الأرشيف: {{matched}} مطابقة جديدة، و{{table}} موجودة في القائمة، و{{fallback}} بلا مقابل (تُرسل إلى صفحة آمنة).',
    collectFailed: 'تعذّر الوصول إلى الأرشيف: {{hosts}}. حاول مرة أخرى لاحقًا.',
    storeHost: 'نطاق المتجر',
    foundVia: 'المصدر',
    emptyLead: 'تظهر هنا العناوين التي تُرجع 404 والعناوين القديمة التي لا مقابل لها.',
    fallback: 'لم يُعثر على مقابل؛ يُرسَل الزائر بـ 301 إلى: {{to}}',
    shown404: 'يعرض المتجر «الصفحة غير موجودة» (404)',
    notVisited: 'لا زيارات بعد · أُضيف: {{date}}',
    via: {
      request: 'زيارة',
      archive: 'الأرشيف',
      search_console: 'Search Console',
    },
    kinds: {
      product: 'منتج',
      category: 'فئة',
      shop: 'المتجر',
      blog: 'المقالات',
      post: 'مقالة',
      page: 'صفحة',
      asset: 'ملف',
      home: 'الصفحة الرئيسية',
    },
  },
  redirects: {
    goneTarget: 'أُزيل نهائيًا (دون إعادة توجيه)',
    gone: 'أُزيل نهائيًا (410)',
    goneLead:
      'لا تتم أي إعادة توجيه؛ يرى الزوار صفحة «تمت إزالة الصفحة» وتتلقى محركات البحث الرمز 410، فيُزال العنوان من الفهرس. يُفضَّل استخدام 301 إذا وُجدت صفحة مشابهة.',
    goneSaved: 'تم تعليم العنوان كمُزال نهائيًا',
    goneConfirm: 'هل تريد إرجاع 410 (أُزيل نهائيًا) للعنوان «{{path}}»؟ ستُسقط محركات البحث هذا العنوان.',
    notFoundTitle: 'العناوين غير الموجودة',
    notFoundLead:
      'عناوين واجهة المتجر التي تُرجع 404 والعناوين القديمة التي أُرسلت إلى صفحة آمنة لعدم وجود مقابل لها، الأكثر ظهورًا أولًا. أضف إعادة التوجيه الصحيحة أو أرجِع 410 أو تجاهلها. يُحفظ النطاق والمسار فقط (دون IP أو سلسلة الاستعلام).',
    notFoundFilter: 'عرض',
    notFoundOpen: 'قيد الانتظار',
    notFoundIgnored: 'المتجاهَلة',
    notFoundEmpty: 'لا توجد عناوين غير موجودة.',
    notFoundIgnoredEmpty: 'لا توجد عناوين متجاهَلة.',
    notFoundHits: 'عدد مرات الظهور: {{count}} · آخرها: {{date}}',
    notFoundRedirect: 'إعادة توجيه',
    notFoundGone: 'إرجاع 410',
    notFoundIgnore: 'تجاهل',
    notFoundReopen: 'استعادة',
    notFoundMore: 'يتم عرض {{shown}} من العناوين الأكثر ظهورًا (الإجمالي {{total}}).',
    add: 'إضافة إعادة توجيه',
    edit: 'تعديل إعادة التوجيه',
    import: 'استيراد من ملف',
    search: 'البحث في العناوين',
    empty: 'لا توجد عمليات إعادة توجيه بعد',
    emptyLead:
      'وجّه عناوين الموقع القديم إلى العناوين الجديدة للحفاظ على ترتيب Google والروابط المحفوظة. تُضاف إعادة توجيه تلقائيًا عند تغيّر عنوان منتج أو فئة.',
    noMatch: 'لا توجد إعادة توجيه تطابق البحث',
    from: 'العنوان القديم',
    to: 'العنوان الجديد',
    code: 'نوع إعادة التوجيه',
    permanent: '301 — دائم (موصى به)',
    temporary: '302 — مؤقت',
    note: 'ملاحظة',
    saved: 'تم حفظ إعادة التوجيه',
    dialogLead:
      'يجب أن يكون العنوان القديم مسارًا يبدأ بـ «/» (يُختصر الرابط الكامل إلى مساره). ويمكن أن يكون العنوان الجديد مسارًا في هذا الموقع أو عنوانًا كاملًا يبدأ بـ https://.',
    deleteConfirm:
      'هل تريد حذف إعادة التوجيه الخاصة بـ {{path}}؟ سيرى زوار هذا العنوان صفحة «الصفحة غير موجودة».',
    hits: 'عدد مرات الاستخدام: {{count}} · آخرها {{date}}',
    noHits: 'لم تُستخدم بعد',
    range: '{{from}}–{{to}} من {{total}}',
    sources: {
      manual: 'يدوي',
      import: 'استيراد',
      auto: 'تلقائي',
      match: 'مطابقة',
    },
    importTitle: 'استيراد قائمة إعادة التوجيه',
    importLead:
      'ملف CSV أو Excel: أعمدة العنوان القديم والعنوان الجديد والرمز (301/302) اختياريًا والملاحظة. تُعرض معاينة أولًا؛ وإذا احتوى أي صف على خطأ فلن يُحفظ شيء. تُحدَّث العناوين القديمة الموجودة. عمود «النطاق» الاختياري يجعل القاعدة خاصة بنطاق قديم واحد.',
    chooseFile: 'اختيار ملف ومعاينته',
    apply: 'استيراد',
    previewSummary:
      'الصفوف: {{total}} — جديدة: {{create}}، للتحديث: {{update}}، دون تغيير: {{unchanged}}، بها أخطاء: {{errors}}.',
    errorLine: 'الصف {{line}}',
    imported: 'تمت إضافة {{created}} من عمليات إعادة التوجيه، وتحديث {{updated}}',
    howTitle: 'كيف يعمل',
    howLead: 'تتحقق واجهة المتجر من هذه القائمة مع كل طلب صفحة (تسري التغييرات خلال دقيقة).',
    how1: 'تتجاهل المطابقة حالة الأحرف والشرطة المائلة «/» في النهاية؛ فـ «/uyeol/» و«/uyeol» متطابقان. ويتم تجاهل سلاسل الاستعلام (?...).',
    how2: 'تُختصر السلاسل (A→B وB→C يوجّهان A مباشرةً إلى C)؛ ولا يُطبَّق السجل الذي يُنشئ حلقة.',
    how3: 'يُظهر عدد مرات الاستخدام ما إذا كان العنوان القديم لا يزال يتلقى زيارات؛ ويمكن حذف السجلات غير المستخدمة منذ أشهر.',
    allHosts: 'كل النطاقات',
    host: 'نطاق المصدر',
    filterSource: 'المصدر',
    filterHost: 'النطاق',
    anySource: 'الكل',
    anyHost: 'الكل',
    matchScore: 'التشابه {{score}}٪',
    shadowTitle: '{{count}} قاعدة تحجب صفحات المتجر نفسه',
    shadowLead:
      'هذه العناوين صفحات حقيقية في المتجر (مثل نقاط البيع والمقالات ومكتشف الاحتياجات أو منتج أو فئة منشورة). بسبب القاعدة يُعاد توجيه الزائر بدلًا من رؤية الصفحة. احذف القاعدة لتظهر الصفحة.',
    shadowDelete: 'حذف القاعدة',
    how4: 'كل طلب إلى نطاق قديم (مثل zootopiaglobal.com) — عبر http أو https، مع www أو بدونها — يذهب إلى عنوانه النهائي بخطوة 301 واحدة وفق هذه القائمة.',
    how5: 'للعنوان القديم غير الموجود في القائمة يبحث النظام عن مقابله: تُضاف المطابقة المؤكدة باسم «مطابقة»، وإلا يُرسَل الزائر إلى فئة النوع أو كل المنتجات أو الصفحة الرئيسية ويُدرج العنوان في:',
    matchKinds: {
      product: 'منتج',
      category: 'فئة',
      category_species: 'فئة النوع',
      shop: 'كل المنتجات',
      blog: 'المقالات',
      post: 'مقالة',
      page: 'صفحة',
    },
  },
  legal: {
    lawyerNote: 'تكتب هذه النصوص أنت أو محاميك؛ ولا يُنشئ النظام محتوى قانونيًا. اطلب مراجعتها قبل النشر.',
    kinds: {
      kvkk_notice: 'إشعار الخصوصية (KVKK)',
      membership_terms: 'شروط العضوية',
      pre_information: 'نموذج المعلومات المسبقة',
      distance_sales: 'عقد البيع عن بُعد',
      return_policy: 'الإرجاع والانسحاب',
      privacy_policy: 'سياسة الخصوصية',
      cookie_policy: 'سياسة ملفات تعريف الارتباط',
    },
    required: '(إلزامي للنشر)',
    publishedVersion: 'الإصدار {{version}} · نُشر في {{date}}',
    notPublished: 'غير منشور',
    templated: 'يُملأ عند إتمام الطلب',
    reviewed: 'تمت مراجعته قانونيًا',
    notReviewed: 'لم يُصرَّح بالمراجعة',
    hasDraft: 'مسودة',
    write: 'كتابة',
    draftSaved: 'تم حفظ المسودة',
    published: 'تم نشر إصدار جديد',
    templatedLead:
      'يُملأ هذا النص ببيانات البائع والمشتري والمنتجات والإجمالي عند إتمام الطلب. المتغيرات الإلزامية: اسم البائع، اسم المشتري، المنتجات، الإجمالي.',
    plainLead: 'يُنشر هذا النص في صفحة مستقلة في واجهة المتجر؛ وتُملأ متغيرات البائع.',
    discardConfirm: 'هل تريد حذف المسودة؟ لن يتأثر الإصدار المنشور.',
    discard: 'حذف المسودة',
    saveDraft: 'حفظ المسودة',
    publish: 'نشر',
    title: 'العنوان',
    variables: 'المتغيرات',
    insertVariable: 'إدراج عند موضع المؤشر',
    body: 'النص',
    bodyHint: 'نص عادي؛ افصل بين الفقرات بسطر فارغ.',
    reviewedAck: 'تمت مراجعة هذا النص من قِبل محاميّ/مستشاري القانوني.',
    saveBeforePublish: 'احفظ المسودة قبل النشر.',
    history: 'سجل الإصدارات',
    versionLabel: 'الإصدار {{version}}',
    statuses: {
      published: 'منشور',
      retired: 'مؤرشف',
      draft: 'مسودة',
    },
    view: 'عرض',
    languages: 'النسخ اللغوية',
    languageGaps:
      'هناك نصوص إلزامية غير منشورة بلغات أسواقك المفتوحة (يرى الزائر بتلك اللغة النص التركي؛ ولا يمنع ذلك الإطلاق):',
    langPublished: 'منشور، الإصدار {{version}}',
    language: 'اللغة',
    primaryLanguage: 'الأساس',
    marketLanguage: 'لغة السوق',
    copyTurkish: 'البدء من النص التركي',
    translationNote:
      'نسخة {{language}} ترجمة للنص التركي. اطلب من محاميك مراجعة الترجمة أيضًا؛ ويُقدَّم إقرار المراجعة القانونية لهذه اللغة على حدة. وإلى أن تُنشر نسخة بهذه اللغة، يرى الزائر النص التركي.',
    switchLanguageConfirm: 'ستفقد التغييرات غير المحفوظة. هل تريد تغيير اللغة؟',
  },
  invoices: {
    providerCancelStates: {
      required: 'يجب الإلغاء في BizimHesap',
      failed: 'فشل الإلغاء في BizimHesap',
      uncertain: 'الإلغاء في BizimHesap غير مؤكد',
      return_required: 'صدر مستند إلكتروني: يلزم إصدار فاتورة إرجاع',
      done: 'تم الإلغاء في BizimHesap',
    },
    providerCancelResult: {
      done: 'تم إلغاء الفاتورة في BizimHesap.',
      failed: 'رفض BizimHesap الإلغاء؛ والخطأ مسجّل على الفاتورة.',
      uncertain: 'لم يستجب BizimHesap: ربما تم الإلغاء. تحقق في لوحة تحكم BizimHesap وعلِّم النتيجة.',
    },
    cancelAtProvider: 'الإلغاء في BizimHesap',
    resolveProviderCancel: 'تعليم الإلغاء',
    returnDone: 'تم إصدار فاتورة الإرجاع',
    returnLead:
      'حصلت الفاتورة على رقم مستند إلكتروني رسمي: لذلك لا تُلغى في BizimHesap، بل تُصدر فاتورة إرجاع بدلًا من ذلك (بانتظار تأكيد المحاسب). علِّمها هنا بعد إصدار فاتورة الإرجاع.',
    providerResolveLead: 'تحقق في لوحة تحكم BizimHesap مما إذا كانت الفاتورة قد أُلغيت.',
    providerOutcomes: {
      done: 'ملغاة',
      not_done: 'غير ملغاة (يمكن إعادة المحاولة)',
    },
    sendResult: {
      sent: 'تم إرسال الفاتورة إلى BizimHesap',
      failed: 'تعذّر إرسال الفاتورة',
      uncertain: 'انقطع الاتصال: حالة الفاتورة غير مؤكدة',
      draft: 'تم الحفظ',
      sending: 'جارٍ الإرسال',
      cancelled: 'ملغاة',
    },
    bhTarget: 'حساب BizimHesap {{code}} · الصندوق {{cash}}',
    bhNoCash: 'لا يوجد (ذمم مدينة)',
    resend: 'إعادة الإرسال',
    send: 'إرسال',
    resolve: 'تم التحقق',
    markCancelled: 'تعليم كملغاة',
    resolveTitle: 'تسجيل الفاتورة غير المؤكدة',
    cancelTitle: 'تعليم الفاتورة كملغاة',
    resolveLead: 'تحقق في BizimHesap مما إذا كانت فاتورة هذا الطلب قد أُنشئت.',
    cancelLead: 'يُلغي هذا الإجراء السجل هنا فقط. ألغِ الفاتورة/مستند e-Arşiv في BizimHesap.',
    outcome: 'النتيجة',
    outcomes: {
      sent: 'تم إنشاء الفاتورة',
      not_sent: 'لم يتم إنشاء الفاتورة',
    },
    number: 'رقم الفاتورة',
    note: 'ملاحظة',
    status: 'الحالة',
    statuses: {
      draft: 'مسودة',
      sending: 'جارٍ الإرسال',
      sent: 'مُرسلة',
      failed: 'فشلت',
      uncertain: 'غير مؤكدة',
      cancelled: 'ملغاة',
    },
    empty: 'لا توجد فواتير بعد',
    emptyLead: 'تُنشأ الفواتير من تفاصيل الطلب.',
    providers: {
      bizimhesap: 'BizimHesap',
      manual: 'يدوي (صدرت في مكان آخر)',
    },
    kinds: {
      e_arsiv: 'الأرشيف الإلكتروني (e-Arşiv)',
      e_fatura: 'الفاتورة الإلكترونية (e-Fatura)',
      unknown: 'غير محدد',
    },
    open: 'فتح الفاتورة',
    bizimhesapNote:
      'تُنشئ واجهة BizimHesap البرمجية (API) الفاتورة كسجل؛ ويتم التحويل إلى e-Arşiv/e-Fatura في BizimHesap.',
    bizimhesapLead:
      'تطابق البنود والإجماليات الطلب تمامًا؛ والإرسال خطوة منفصلة. اربط BizimHesap من شاشة التكاملات.',
    manualLead: 'إذا أصدرت الفاتورة في برنامج آخر، فسجّل رقمها.',
    provider: 'المصدر',
    kind: 'النوع',
  },
  pageDesigns: {
    published: '{{experience}}: التصميم {{variant}} منشور.',
    option: '{{letter}} — {{name}}',
    live: 'منشور',
    preview: 'معاينة',
    previewOf: 'معاينة {{name}}',
    publish: 'نشر',
    publishOf: 'نشر {{name}}',
    shotDesktop: '{{name}}: عرض سطح المكتب',
    shotMobile: '{{name}}: عرض الجوال',
    history: 'سجل التغييرات',
    historyLead: 'من غيّر أي خيار إلى أي خيار ومتى (من سجل التدقيق).',
    noHistory: 'لا توجد تغييرات بعد؛ كل الأقسام على الخيار A.',
    colWhen: 'التاريخ',
    colWho: 'الشخص',
    colWhat: 'القسم',
    colChange: 'التغيير',
    change: 'من {{from}} إلى {{to}}',
    experiences: {
      header: {
        title: 'القائمة العلوية',
        lead: 'رأس كل صفحة في المتجر: الشعار وعناصر القائمة (القوائم) والبحث وتسجيل الدخول والسلة؛ قائمة جانبية على الجوال.',
      },
      articles: {
        title: 'المقالات',
        lead: 'قائمة المدونة وصفحات الفئات والأرشيف: المقالة المميزة والفئات ووقت القراءة والبحث. صفحة المقالة واحدة في كل الخيارات.',
      },
      store_locator: {
        title: 'نقاط البيع',
        lead: 'صفحة المتجر التي تعرض الوكلاء المعتمدين: التصفية حسب الولاية والمنطقة والحي، «استخدم موقعي»، الخريطة وصفحات الولايات والمناطق.',
      },
      needs_finder: {
        title: 'احتياجات حيواني الأليف',
        lead: 'تدفق الأسئلة وروتين العناية المقترح لحيوان الزائر (/ihtiyac-bulucu). الأسئلة والقواعد والنتيجة واحدة في الخيارات الثلاثة.',
      },
    },
    variants: {
      header: {
        a: {
          name: 'أفقي كلاسيكي',
          character: 'الشعار والبحث والسلة في الأعلى، وعناصر القائمة أفقية؛ مألوف وأسرع للتصفح.',
        },
        b: {
          name: 'شعار في الوسط',
          character: 'اسم العلامة كبير في الوسط والقائمة أسفله؛ استقبال هادئ بطابع متجر صغير.',
        },
        c: {
          name: 'مدمج ومصوّر',
          character: 'سطر واحد رفيع؛ تفتح المنتجات ببلاطات مرسومة لأنواع الحيوانات، ومساحة أكبر للمحتوى.',
        },
      },
      articles: {
        a: {
          name: 'مجلة',
          character: 'مقالة مميزة كبيرة وشرائط للفئات؛ يُعرض المحتوى كواجهة متجر.',
        },
        b: {
          name: 'شبكة بطاقات',
          character: 'بطاقات متساوية ورقائق تصفية؛ اختيار سريع بين مقالات كثيرة.',
        },
        c: {
          name: 'قائمة قراءة',
          character: 'قائمة بسيطة تعتمد على الخط مع صور صغيرة؛ تركّز على القراءة.',
        },
      },
      store_locator: {
        a: {
          name: 'الخريطة أولًا',
          character: 'عوامل التصفية والقائمة في جانب وخريطة الولايات في الجانب الآخر؛ تصفّحهما معًا.',
        },
        b: {
          name: 'القائمة أولًا',
          character: 'صف تصفية واحد فوق شبكة بطاقات؛ الخريطة اختيارية.',
        },
        c: {
          name: 'دليل المناطق',
          character: 'دليل للولايات والمناطق مع صفحة لكل منطقة؛ مناسب لزوار محركات البحث.',
        },
      },
      needs_finder: {
        a: {
          name: 'بطاقات',
          character:
            'كل خطوة في شاشة مستقلة ببطاقات كبيرة؛ التقدم في الأعلى ورجوع / متابعة في الأسفل. الأسهل على الهاتف.',
        },
        b: {
          name: 'محادثة',
          character:
            'تأتي الأسئلة تباعًا في فقاعات محادثة وتُجاب بأزرار؛ ويمكن تغيير كل إجابة. الأسئلة ثابتة ولا ذكاء اصطناعي.',
        },
        c: {
          name: 'صفحة واحدة + ملخّص مباشر',
          character:
            'كل الأسئلة في صفحة واحدة؛ ويتحدّث ملخّص الروتين بجانبها مع الإجابة. مناسب للمقارنة على الشاشات العريضة.',
        },
      },
    },
  },
  needsFinder: {
    editor: 'محرّر دليل الاحتياجات',
    startTitle: 'لم يُعدّ «احتياجات حيواني الأليف» بعد',
    startLead:
      'يختار الزائر النوع والمعلومات الأساسية ومجالات الدعم؛ وتقترح قواعد ثابتة روتين عناية من المنتجات المناسبة. يمكنك إنشاء المسودة الأولى من بيانات منتجاتك أو البدء بمسودة فارغة. لا تُنشر المسودة دون موافقة خبير بيطري.',
    generate: 'إنشاء المسودة الأولى من بيانات المنتجات',
    startEmpty: 'البدء بمسودة فارغة',
    generated: 'أُنشئت المسودة من بيانات المنتجات. راجع النصوص والقواعد.',
    noDraft: 'لا توجد مسودة بعد. يمكن لمن لديه صلاحية تحرير المحتوى إنشاؤها.',
    save: 'حفظ المسودة',
    saved: 'تم حفظ المسودة.',
    unsaved: 'توجد تغييرات غير محفوظة.',
    discard: 'تجاهل التغييرات',
    saveErrors: 'تعذّر حفظ المسودة؛ صحّح ما يلي:',
    saveFirst: 'احفظ المسودة أولًا.',
    statusTitle: 'الحالة والنشر',
    statusLead:
      'مسودة ← إرسال للمراجعة ← موافقة الخبير البيطري ← نشر. إذا تغيّرت المسودة بعد الموافقة تسقط الموافقة؛ ويستمر المتجر في عرض النسخة المعتمدة المنشورة.',
    review: {
      not_submitted: 'لم تُرسل للمراجعة',
      pending: 'قيد مراجعة الخبير',
      approved: 'وافق الخبير',
      rejected: 'رفض الخبير',
    },
    live: 'منشور في المتجر',
    notLive: 'غير منشور في المتجر',
    liveDiffers: 'المسودة تختلف عن النسخة المنشورة',
    publishedAt: 'آخر نشر: {{date}}',
    generatedNote:
      'أُنشئت هذه المسودة تلقائيًا من بيانات المنتجات: المجالات من الفئات والقواعد من المنتجات. راجع نصوص الأسباب وسؤال الطوارئ والاستثناءات مع الخبير.',
    reviewNote: 'ملاحظة الخبير: {{note}}',
    problemsTitle: 'قائمة التحقق',
    problems: {
      no_areas: 'لا توجد مجالات دعم (يمنع النشر).',
      no_rules: 'لا توجد قواعد توصية (يمنع النشر).',
      no_emergency_option: 'لا يوجد خيار طوارئ في أي سؤال (يمنع النشر).',
      area_without_rules: 'لا قواعد في مجال «{{ref}}»؛ من يختاره لا تظهر له منتجات.',
      product_hidden:
        '{{product}} غير ظاهر في المتجر (مسودة أو مخفي أو غير منشور في المتجر أو دون موافقة بيطرية)؛ لن يُقترح.',
      product_species_mismatch: '{{product}} لا يطابق أنواع القاعدة؛ لن يُقترح أبدًا.',
      product_no_species: 'لم يُحدَّد نوع مستهدف لـ {{product}}؛ لن يُقترح أبدًا.',
      bundle_promotion_not_running: 'حملة الحزمة المرتبطة لا تعمل حاليًا؛ لا تظهر في المتجر.',
    },
    submit: 'إرسال للمراجعة',
    submitted: 'أُرسلت المسودة لمراجعة الخبير.',
    publish: 'نشر',
    publishedToast: '«احتياجات حيواني الأليف» منشور في المتجر.',
    unpublish: 'إلغاء النشر',
    unpublishedToast: 'أُزيل من المتجر.',
    unpublishTitle: 'إلغاء النشر؟',
    unpublishLead:
      'تُغلق صفحة المتجر ويُزال الرابط الافتراضي من القائمة العلوية. تبقى المسودة والموافقة؛ ويمكنك النشر مجددًا.',
    regenerate: 'إعادة إنشاء المسودة',
    regenerateTitle: 'إعادة إنشاء المسودة؟',
    regenerateLead:
      'تحل مسودة جديدة من بيانات المنتجات محل الحالية؛ وتضيع تعديلاتك وموافقة الخبير. لا تتغير النسخة المنشورة.',
    petProfiles: 'احفظ حيواني (للأعضاء)',
    petProfilesLead:
      'عند التفعيل يمكن للعضو حفظ المعلومات الأساسية لحيوانه في حسابه بموافقة صريحة. لا تفعّله قبل مراجعة نص الموافقة قانونيًا. لا تُحفظ إجابات الأسئلة الصحية.',
    reviewTitle: 'مراجعة الخبير البيطري',
    reviewLead:
      'يراجع الخبير الأسئلة ونصوص الأسباب والقائمة الكاملة للمنتجات التي قد تُقترح. يُتخذ القرار على المحتوى المعروض.',
    findings: 'وجد فحص الادعاءات الصحية {{count}} عبارة',
    productsTitle: 'المنتجات التي قد تُقترح',
    colProduct: 'المنتج',
    colSpecies: 'النوع',
    colReasons: 'السبب',
    colState: 'الحالة',
    visible: 'ظاهر في المتجر',
    hidden: 'غير ظاهر في المتجر',
    noUsage: 'لا يوجد نص استخدام',
    reviewNoteLabel: 'ملاحظة الخبير',
    approve: 'موافقة',
    reject: 'رفض',
    decided: 'تم حفظ القرار.',
    waitingExpert: 'بانتظار قرار المراجِع البيطري.',
    otherLanguages: 'لغات أخرى',
    lang: {
      en: 'الإنجليزية',
      de: 'الألمانية',
      ar: 'العربية',
    },
    condition: 'الشرط',
    conditionLead:
      'يجب أن يتحقق كل قسم تملؤه؛ ويكفي داخل القسم أحد الخيارات المحددة. إن لم تختر شيئًا فهو ساري دائمًا.',
    cond: {
      species: 'النوع',
      ages: 'العمر',
      weights: 'الوزن',
      neutered: 'التعقيم',
      any: 'لا يهم',
      reproductive: 'حامل / مرضع',
      areas: 'مجال الدعم',
      answer: 'إجابة سؤال',
      noAnswer: 'لا يُنظر إلى إجابة',
      answerOptions: 'إحدى هذه الإجابات',
    },
    always: 'دائمًا',
    moveUp: '{{name}}: نقل للأعلى',
    moveDown: '{{name}}: نقل للأسفل',
    edit: '{{name}}: تعديل',
    delete: '{{name}}: حذف',
    deleteTitle: 'حذف؟',
    deleteLead: 'يُزال العنصر من المسودة؛ ويمكنك التراجع قبل الحفظ عبر «تجاهل التغييرات».',
    apply: 'تطبيق',
    tabs: {
      areas: 'مجالات الدعم',
      questions: 'الأسئلة',
      rules: 'قواعد التوصية',
      exclusions: 'الاستثناءات',
      texts: 'النصوص',
      preview: 'معاينة',
      report: 'التقرير',
    },
    areasLead: 'الموضوعات التي يختارها الزائر (مثل المفاصل، الجلد والفراء). تظهر للأنواع المحددة فقط.',
    rulesCount: '{{count}} قواعد',
    addArea: 'إضافة مجال',
    noAreas: 'لا توجد مجالات دعم بعد.',
    areaDialog: 'مجال الدعم',
    areaLabel: 'اسم المجال',
    areaDescription: 'وصف قصير',
    areaSpecies: 'يظهر للأنواع',
    areaCategories: 'الفئات المرتبطة',
    id: 'المعرّف',
    idLead: 'اسم قصير يُستخدم في القواعد (حروف لاتينية صغيرة وأرقام وشرطات). لا تغيّره بعد الحفظ.',
    questionsLead:
      'تُطرح الأسئلة بهذا الترتيب. السؤال المرتبط بمجال يُطرح عند اختياره فقط؛ والسؤال المشروط عند تحقق شرطه (تفرّع).',
    general: 'عام (لكل زائر)',
    optionsCount: '{{count}} خيارات',
    hasEmergency: 'يحتوي خيار طوارئ',
    askedWhen: 'يُطرح عندما: {{condition}}',
    defaultYes: 'نعم',
    defaultNo: 'لا',
    addQuestion: 'إضافة سؤال',
    noQuestions: 'لا توجد أسئلة بعد. يجب أن يحتوي سؤال واحد على الأقل على خيار طوارئ.',
    questionDialog: 'سؤال',
    questionText: 'نص السؤال',
    questionHelp: 'نص المساعدة',
    questionArea: 'المجال المرتبط',
    questionMultiple: 'يمكن اختيار أكثر من خيار',
    askWhen: 'متى يُطرح؟ (تفرّع)',
    options: 'الخيارات',
    optionLabel: 'الخيار {{n}}',
    optionEmergency: 'طوارئ (لا منتجات، إحالة إلى طبيب بيطري)',
    optionExclusive: 'يُختار وحده («لا شيء مما سبق»)',
    addOption: 'إضافة خيار',
    rulesLead:
      'إذا تحقق الشرط يُقترح المنتج مع سببه المعتمد. لا يُقترح أبدًا منتج لا يناسب النوع المختار. وإن نفد المخزون يظهر البديل التالي.',
    unsavedProduct: 'منتج (يظهر اسمه بعد الحفظ)',
    priorityValue: 'الأولوية {{n}}',
    alternativesCount: '{{count}} بدائل',
    addRule: 'إضافة قاعدة',
    noRules: 'لا توجد قواعد بعد.',
    ruleDialog: 'قاعدة توصية',
    ruleProduct: 'المنتج المقترح',
    ruleReason: 'سبب الاقتراح (يظهر في المتجر)',
    rulePriority: 'الأولوية (0–100)',
    rulePriorityLead: 'الاقتراحات ذات الأولوية الأعلى تأتي أولًا.',
    ruleAlternatives: 'بدائل عند نفاد المخزون (بالترتيب، 5 كحد أقصى)',
    exclusionsLead:
      'إذا تحقق الشرط فلا تُقترح المنتجات المدرجة من أي قاعدة (مثل غير المناسبة أثناء الحمل). للاستثناءات الأولوية دائمًا.',
    addExclusion: 'إضافة استثناء',
    noExclusions: 'لا توجد استثناءات بعد.',
    exclusionDialog: 'استثناء',
    exclusionProducts: 'منتجات لا تُقترح',
    exclusionNote: 'ملاحظة (في اللوحة)',
    textsLead: 'نص المقدمة ونص الطوارئ وحملة الحزمة الاختيارية.',
    intro: 'نص المقدمة',
    emergencyText: 'نص الطوارئ',
    bundle: 'حملة حزمة الاحتياجات',
    bundleLead:
      'اختيارية؛ معطّلة افتراضيًا. إذا كانت الحملة التلقائية المرتبطة تعمل يظهر اسمها وشرطها في النتيجة؛ وتحسب السلة الخصم.',
    bundleOff: 'بلا حملة',
    bundleLinked: 'حملة مرتبطة',
    previewLead:
      'الحساب نفسه لمحرك القواعد في المتجر. اختر إجابات زائر لترى المنتجات التي تظهر وأسبابها والمنتجات المستبعدة ولماذا.',
    previewResult: 'النتيجة',
    removedTitle: 'المنتجات المستبعدة',
    removed: {
      excluded: 'قاعدة استثناء',
      species: 'لا يناسب النوع المختار',
      unavailable: 'غير ظاهر في المتجر',
    },
    previewNote:
      'تستخدم المعاينة بيانات المنتجات المحفوظة ولا تراعي المخزون؛ تظهر المنتجات المضافة بعد حفظ المسودة.',
    emergencyShort: 'طوارئ',
    reportLead:
      'إجماليات فقط: كم زائرًا بدأ وأكمل واختار حالة طوارئ وأضاف الكل إلى السلة. لا تُحفظ هوية الزائر أو إجاباته.',
    reportDays: 'المدة',
    lastDays: 'آخر {{n}} يومًا',
    reportEmpty: 'لا سجلات في هذه المدة.',
    metrics: {
      starts: 'بدأ',
      completes: 'أكمل',
      emergencies: 'طوارئ',
      addAll: 'أضاف الكل إلى السلة',
      rate: 'نسبة الإكمال',
    },
    bySpecies: 'حسب النوع',
    reportPrivacy:
      'لا تحتوي العدادات على بيانات شخصية؛ ولا تتلقى وسوم القياس (GA4/GTM) أحداثًا إلا بموافقة ملفات تعريف الارتباط.',
  },
  salesPoints: {
    sectionTitle: 'نقطة البيع',
    sectionLead:
      'بيانات النشاط التجاري الظاهرة في صفحة «نقاط البيع» بالمتجر. لا يُعرض اسم المسؤول ولا رقم جواله تلقائيًا أبدًا.',
    add: 'إضافة نقطة بيع',
    edit: 'تعديل نقطة البيع',
    saved: 'حُفظت نقطة البيع.',
    deleted: 'حُذفت نقطة البيع.',
    confirmDelete: 'هل تريد حذف نقطة البيع «{{name}}»؟ لا يتغير سجل الوكيل.',
    empty: 'لا توجد نقطة بيع لهذا الوكيل',
    emptyLead: 'بعد الإضافة تظهر في صفحة «نقاط البيع» (إذا كان الوكيل معتمدًا).',
    fromLocation: 'إضافة من موقع:',
    addFromLocation: '{{label}}',
    personNameNote:
      'قد يكون الاسم التجاري لهذا الوكيل اسم شخص. اكتب اسم المتجر أو النشاط كاسم ظاهر أو أخفِ النقطة (قانون حماية البيانات).',
    notApprovedNote: 'الوكيل غير معتمد، لذا لا تظهر نقاط بيعه؛ وتظهر تلقائيًا عند اعتماده.',
    shown: 'ظاهرة',
    hidden: 'مخفية',
    visible: 'إظهار في المتجر',
    name: 'الاسم الظاهر',
    nameLead: 'اسم المتجر أو النشاط. لا تكتب اسم شخص.',
    neighbourhood: 'الحي',
    chooseNeighbourhood: 'اختر الحي',
    addressLine: 'الشارع والرقم',
    pin: 'الموقع (دبوس الخريطة)',
    pinLead:
      'ابحث عن المكان في خرائط Google، وانسخ الإحداثيات بالنقر بزر الفأرة الأيمن، ثم الصقها هنا (يصلح الرابط أيضًا). بدون دبوس لا تُرتَّب النقطة حسب المسافة.',
    pinRead: 'الموقع المقروء: {{lat}}, {{lng}}',
    pinInvalid: 'تعذّرت قراءة الموقع. الصق إحداثيات مثل «41.0082, 28.9784» أو رابط خرائط Google.',
    findOnMaps: 'فتح العنوان في خرائط Google',
    phone: 'هاتف المتجر',
    phoneLead: 'رقم النشاط الذي يتصل به الزوار. لا تكتب جوال المسؤول إلا بموافقته.',
    hours: 'ساعات العمل',
    days: {
      mon: 'الاثنين',
      tue: 'الثلاثاء',
      wed: 'الأربعاء',
      thu: 'الخميس',
      fri: 'الجمعة',
      sat: 'السبت',
      sun: 'الأحد',
    },
    dayMode: '{{day}}: الحالة',
    dayUnknown: 'غير محدد',
    dayOpen: 'مفتوح',
    dayClosed: 'مغلق',
    opens: '{{day}}: الفتح',
    closes: '{{day}}: الإغلاق',
    note: 'ملاحظة (تظهر في المتجر)',
    warnings: {
      no_pin: 'بدون دبوس',
      no_phone: 'بدون هاتف',
      person_name: 'قد يكون اسم شخص',
      company_not_approved: 'الوكيل غير معتمد',
      address_missing: 'العنوان ناقص',
      geocode_not_found: 'لم يُعثر على العنوان في الخريطة',
      geocode_mismatch: 'العنوان يشير إلى مكان آخر',
      geocode_approximate: 'موقع تقريبي',
    },
    settings: 'الإضافة التلقائية',
    autoAdd: 'إضافة الوكلاء المعتمدين حديثًا كنقاط بيع',
    autoAddLead:
      'عند اعتماد الوكيل تُنشأ نقاط بيع من مواقعه (دون اسم المسؤول أو هاتفه). يُضاف أيضًا الوكيل الذي قد يكون اسمه التجاري اسم شخص ظاهرًا مع تنبيه؛ تحقّق من الاسم المعروض. تُخفى نقاط الوكيل المعلّق تلقائيًا.',
    autoAddOn: 'سيُضاف الوكلاء المعتمدون حديثًا كنقاط بيع.',
    autoAddOff: 'لن يُضاف الوكلاء المعتمدون حديثًا كنقاط بيع.',
    geocode: 'تحديد الموقع من العنوان (OpenStreetMap)',
    geocodeLead:
      'تُحدَّد مواقع النقاط التي ليس لها دبوس يدوي من عناوينها؛ وفي المتجر يرتّب «استخدام موقعي» أقرب النقاط وفق هذا الموقع. إذا أشار العنوان إلى مكان آخر أو لم يُعثر عليه يظهر تنبيه في بطاقة الوكيل. يُرسَل عنوان النشاط التجاري فقط.',
    geocodeOn: 'ستُحدَّد المواقع من العناوين.',
    geocodeOff: 'لن تُحدَّد المواقع من العناوين؛ تُستخدم الدبابيس اليدوية فقط.',
    backfill: 'إنشاء من الوكلاء المعتمدين',
    backfillDone: 'أُضيفت {{created}} نقطة بيع ({{companies}} وكيل). وكلاء بعنوان غير معروف: {{skipped}}.',
    backfillSkipped: 'تعذّر إنشاء نقطة بيع لهؤلاء الوكلاء لأن الولاية/المنطقة غير معروفة:',
    geocodeNow: 'تحديد المواقع الآن',
    geocodeNowRunning: 'جارٍ البحث عن العناوين…',
    geocodeNowDone: 'تم البحث عن {{checked}} عنوان: عُثر على {{found}}، وفي {{problems}} مشكلة.',
    geocodeNowNone: 'لا توجد نقطة بانتظار الموقع.',
    geocodeOne: 'تحديد الموقع من العنوان',
    geocodeResult: {
      ok: 'عُثر على الموقع وحُفظ الدبوس.',
      approximate: 'عُثر على موقع تقريبي (على مستوى الحي)؛ حُفظ الدبوس.',
      not_found: 'لم يُعثر على العنوان في الخريطة؛ تحقّق من العنوان أو أدخل الدبوس يدويًا.',
      mismatch: 'العنوان يشير إلى مكان آخر ({{place}})؛ لم يُحفظ الدبوس.',
      error: 'تعذّر الوصول إلى خدمة المواقع؛ ستُعاد المحاولة قريبًا.',
    },
    pinSource: {
      manual: 'الموقع: أُدخل يدويًا',
      geocoded: 'الموقع: من العنوان (OpenStreetMap)',
      none: 'الموقع: لا يوجد',
    },
    mismatchFound: 'المكان المعثور عليه: {{place}}',
    missing: {
      no_address: 'لا يوجد عنوان لهذا الوكيل؛ تعذّر إنشاء نقطة بيع. أضف موقعًا أو عنوان الشركة.',
      address_unknown:
        'الولاية/المنطقة في عنوان هذا الوكيل غير موجودة في القائمة الرسمية؛ تعذّر إنشاء نقطة بيع. صحّح العنوان أو أضف النقطة يدويًا.',
    },
    listTitle: 'نقاط البيع',
    listLead:
      'تُعدَّل البيانات من صفحة الوكيل. لا يظهر في المتجر إلا النقاط المعلَّمة «ظاهرة» لوكلاء معتمدين.',
    allCities: 'كل الولايات',
    visibility: 'الحالة في المتجر',
    bulkShow: 'إظهار المحدد ({{count}})',
    bulkHide: 'إخفاء المحدد ({{count}})',
    bulkDone: 'حُدّثت {{count}} نقطة بيع.',
    selectAll: 'تحديد الكل',
    selectOne: 'تحديد نقطة البيع {{name}}',
    none: 'لا توجد نقاط بيع',
    noneLead: 'أضفها من صفحة الوكيل؛ وعند تفعيل الإضافة التلقائية يُضاف الوكلاء المعتمدون حديثًا تلقائيًا.',
    colName: 'الاسم الظاهر',
    colPlace: 'المنطقة/الولاية',
    colDealer: 'الوكيل',
    colStatus: 'الحالة',
  },
  design: {
    saved: 'تم حفظ مسودة السمة.',
    published: 'تم نشر السمة. تظهر في واجهة المتجر خلال دقيقة.',
    discarded: 'تم تجاهل التغييرات غير المنشورة.',
    rolledBack: 'تم نشر الإصدار المحدد مرة أخرى.',
    preview: 'معاينة في واجهة المتجر',
    previewBlocked: 'حظر المتصفح علامة التبويب الجديدة. انسخ الرابط وافتحه:',
    save: 'حفظ المسودة',
    publish: 'نشر',
    unsaved: 'لديك تغييرات غير محفوظة.',
    revertLocal: 'تجاهل تغييراتي',
    discard: 'العودة إلى السمة المنشورة',
    discardConfirm:
      'ستُحذف تغييرات المسودة غير المنشورة وتعود المسودة إلى الإصدار المنشور ({{version}}). هل تريد المتابعة؟',
    editor: 'إعدادات السمة',
    liveVersion: 'المنشور: الإصدار {{version}} · {{date}}',
    noLiveTheme: 'لا توجد سمة منشورة (المظهر الافتراضي)',
    unpublished: 'توجد تغييرات غير منشورة',
    issuesCount: 'مشكلات في سهولة القراءة: {{count}}',
    templates: 'القوالب',
    templatesLead: 'يغيّر الألوان والخطوط والتخطيط معًا. لا يظهر القالب المختار إلا في المعاينة حتى تحفظه.',
    templatePick: 'اختر قالبًا',
    templateNames: {
      clinic: 'عيادة',
      natural: 'طبيعي',
      modern: 'عصري',
      classic: 'كلاسيكي',
    },
    colors: 'الألوان',
    colorsLead:
      'ابدأ من لوحة ألوان جاهزة وعدّل الألوان واحدًا تلو الآخر. تُدرج أزواج الألوان غير المقروءة أسفل المعاينة.',
    palettes: 'لوحات ألوان جاهزة',
    paletteNames: {
      pine: 'صنوبر',
      ocean: 'محيط',
      forest: 'غابة',
      amber: 'كهرماني',
      plum: 'برقوقي',
      ink: 'حبر',
    },
    lightColors: 'ألوان المظهر الفاتح',
    darkColors: 'ألوان المظهر الداكن',
    darkMode: 'استخدام الألوان الداكنة عندما يكون الجهاز في الوضع الداكن',
    colorNames: {
      background: 'الخلفية',
      surface: 'خلفية البطاقات والحقول',
      text: 'النص',
      mutedText: 'النص الثانوي',
      border: 'الفواصل والحدود',
      primary: 'اللون الأساسي (الروابط)',
      secondary: 'اللون الثانوي',
      accent: 'لون التمييز',
      button: 'الزر',
      buttonText: 'نص الزر',
      buttonHover: 'الزر (عند التمرير فوقه)',
    },
    typography: 'الخطوط',
    typographyLead: 'تُقدَّم الخطوط مع واجهة المتجر؛ ولا يحتاج الزوار إلى تثبيتها.',
    bodyFont: 'خط النص الأساسي',
    headingFont: 'خط العناوين',
    fontKinds: {
      sans: 'بدون زوائد (sans-serif)',
      serif: 'بزوائد (serif)',
    },
    baseSize: 'حجم النص الأساسي',
    px: '{{value}} px',
    headingScale: 'أحجام العناوين',
    headingScales: {
      compact: 'صغير',
      normal: 'متوسط',
      large: 'كبير',
    },
    headingWeight: 'سُمك العناوين',
    weights: {
      w500: 'متوسط',
      w600: 'شبه عريض',
      w700: 'عريض',
    },
    shape: 'الشكل',
    shapeLead: 'يُطبَّق تدوير الزوايا والظل على البطاقات والحقول والأزرار.',
    radius: 'تدوير الزوايا',
    buttonShape: 'شكل الأزرار',
    buttonShapes: {
      square: 'مربّع',
      rounded: 'مستدير الزوايا',
      pill: 'كبسولة',
    },
    shadow: 'الظل',
    shadows: {
      none: 'بدون',
      soft: 'خفيف',
      strong: 'قوي',
    },
    layout: 'التخطيط',
    layoutLead: 'بطاقات المنتجات، والترويسة والتذييل، وصفحة المنتج، وحقول النماذج.',
    cardStyle: 'بطاقة المنتج',
    cardStyles: {
      bordered: 'بإطار',
      flat: 'مسطّح',
      raised: 'بارز',
    },
    imageRatio: 'نسبة صورة المنتج',
    imageRatios: {
      square: 'مربّعة (1:1)',
      portrait: 'عمودية (4:5)',
      landscape: 'أفقية (4:3)',
    },
    gridDesktop: 'الأعمدة على الحاسوب',
    gridMobile: 'الأعمدة على الهواتف',
    columns: 'الأعمدة: {{count}}',
    headerLayout: 'موضع الشعار',
    headerLayoutMoved: 'يُختار الآن تخطيط القائمة العلوية والشعار من',
    headerLayouts: {
      start: 'في البداية',
      center: 'في الوسط',
    },
    headerStyle: 'خلفية الترويسة',
    headerStyles: {
      surface: 'فاتح',
      brand: 'اللون الأساسي',
    },
    headerSticky: 'تثبيت الترويسة في الأعلى أثناء التمرير',
    footerStyle: 'خلفية التذييل',
    footerStyles: {
      surface: 'فاتح',
      dark: 'داكن',
      brand: 'اللون الأساسي',
    },
    gallery: 'صورة صفحة المنتج',
    galleryPositions: {
      start: 'في البداية',
      end: 'في النهاية',
    },
    blogLayout: 'صفحة المدونة',
    blogLayouts: {
      grid: 'شبكة',
      list: 'قائمة',
    },
    inputStyle: 'حقول النماذج',
    inputStyles: {
      outline: 'بإطار',
      filled: 'معبّأة',
    },
    livePreview: 'معاينة مباشرة',
    device: 'الجهاز',
    devices: {
      phone: 'هاتف',
      tablet: 'جهاز لوحي',
      desktop: 'حاسوب مكتبي',
    },
    scheme: 'المظهر',
    schemes: {
      light: 'فاتح',
      dark: 'داكن',
    },
    mock: {
      store: 'اسم المتجر',
      search: 'البحث عن المنتجات',
      account: 'حسابي',
      cart: 'سلة التسوق',
      heading: 'عنوان تجريبي',
      lead: 'تستخدم فقرة المقدمة لون النص الثانوي.',
      body: 'يستخدم النص الأساسي الخط والحجم المختارين؛',
      link: 'وتستخدم الروابط اللون الأساسي.',
      primaryButton: 'الزر الأساسي',
      secondaryButton: 'الزر الثانوي',
      secondaryTag: 'ثانوي',
      accentTag: 'تمييز',
      products: 'المنتجات',
      product: 'اسم المنتج',
      price: 'السعر',
      field: 'حقل نموذج',
      placeholder: 'إدخال تجريبي',
      fieldHelp: 'يستخدم نص مساعدة الحقل لون النص الثانوي.',
      footer: 'التذييل',
    },
    contrastOk: 'جميع أزواج الألوان مقروءة (WCAG AA).',
    contrastTitle: 'أزواج الألوان هذه غير مقروءة بما يكفي؛ ولا يمكن نشر السمة قبل إصلاحها:',
    contrastIssue: 'المظهر {{palette}}: {{fg}} / {{bg}} — {{ratio}}:1 (على الأقل {{min}}:1)',
    versions: 'سجل الإصدارات',
    versionsLead:
      'يُحفظ كل نشر كإصدار غير قابل للتعديل. والعودة إلى إصدار سابق تنشر إصدارًا جديدًا أيضًا؛ ولا يُحذف السجل أبدًا.',
    noVersions: 'لا توجد إصدارات منشورة بعد.',
    versionNo: 'الإصدار {{version}}',
    restoredFrom: 'تمت استعادة الإصدار {{version}}',
    current: 'منشور',
    rollback: 'العودة إلى هذا الإصدار',
    rollbackConfirm:
      'سيُنشر الإصدار {{version}} مرة أخرى وتُضبط المسودة عليه. وستُحذف تغييرات المسودة غير المحفوظة. هل تريد المتابعة؟',
    publishTitle: 'نشر السمة',
    publishLead: 'يرى الزوار المظهر الجديد خلال دقيقة. ويمكنك العودة إلى إصدار سابق في أي وقت.',
    publishConfirm: 'نشر',
    publishSavesFirst: 'ستُحفظ التغييرات غير المحفوظة أولًا.',
    note: 'ملاحظة الإصدار',
  },
  menus: {
    save: 'حفظ القائمة',
    startFrom: 'البدء من لغة أخرى',
    loadDraft: 'تحميل المسودة',
    draftLoaded: 'تم تحميل مسودة القائمة؛ ترجم التسميات ثم احفظ.',
    draftDropped: 'أُزيلت الروابط التي ليس لها مقابل بهذه اللغة: {{labels}}',
    draftEmpty: 'قائمة {{lang}} فارغة؛ لا يوجد ما يمكن تحميله.',
    saved: 'تم حفظ القائمة. تظهر في واجهة المتجر خلال دقيقة.',
    unsaved: 'توجد تغييرات غير محفوظة',
    location: 'موضع القائمة',
    locations: {
      header: 'قائمة الترويسة',
      footer: 'قائمة التذييل',
    },
    locationLead: {
      header:
        'تظهر قائمة الترويسة أسفل ترويسة واجهة المتجر. العنصر الذي يحتوي على عناصر فرعية يفتح قائمة موسّعة (Mega menu): المستوى الثاني عناوين أعمدة، والمستوى الثالث روابط.',
      footer:
        'في قائمة التذييل، المستوى الأول عنوان عمود والمستوى الثاني روابطه. وتُجمع الروابط التي ليس لها عناصر فرعية تحت «روابط».',
    },
    empty: 'لا تحتوي هذه القائمة على عناصر بعد',
    emptyLead: {
      header: 'ما دامت فارغة، تعرض ترويسة واجهة المتجر روابط «المنتجات» و«نقاط البيع» و«المقالات».',
      footer: 'ما دامت فارغة، يعرض التذييل بيانات البائع وخدمة العملاء والنصوص القانونية.',
    },
    add: 'إضافة عنصر',
    addChild: 'إضافة عنصر فرعي',
    newItem: 'عنصر جديد',
    label: 'الاسم الظاهر في القائمة',
    link: 'الرابط',
    linkTypes: {
      none: 'عنوان بدون رابط',
      category: 'فئة',
      product: 'منتج',
      products: 'جميع المنتجات',
      page: 'صفحة',
      blog: 'المقالات (المدونة)',
      post: 'مقالة في المدونة',
      url: 'عنوان URL',
    },
    category: 'الفئة',
    chooseCategory: 'اختر فئة',
    page: 'الصفحة',
    choosePage: 'اختر صفحة',
    post: 'المقالة',
    choosePost: 'اختر مقالة',
    blogLead: 'ينتقل إلى صفحة المقالات في واجهة المتجر (/blog).',
    notLivePage: '{{name}} (غير منشور)',
    hiddenCategory: '{{name}} (مخفي)',
    product: 'المنتج',
    productSearch: 'اسم المنتج أو SKU أو الباركود',
    productPicked: 'المنتج المحدد: {{title}}',
    productNone: 'لم يتم تحديد منتج بعد.',
    url: 'عنوان URL',
    newTab: 'فتح في علامة تبويب جديدة',
    noneLead: 'العنوان بدون رابط يجمع عناصره الفرعية فقط.',
    productsLead: 'ينتقل إلى صفحة جميع المنتجات.',
    unavailable: 'الوجهة غير ظاهرة في واجهة المتجر',
    moveUp: 'نقل {{label}} إلى الأعلى',
    moveDown: 'نقل {{label}} إلى الأسفل',
  },
  editor: {
    toolbar: 'تنسيق النص',
    paragraph: 'فقرة',
    heading2: 'عنوان',
    heading3: 'عنوان فرعي',
    bold: 'عريض',
    italic: 'مائل',
    bulletList: 'قائمة نقطية',
    orderedList: 'قائمة مرقّمة',
    blockquote: 'اقتباس',
    rule: 'خط فاصل',
    link: 'إضافة رابط',
    unlink: 'إزالة الرابط',
    image: 'إضافة صورة',
    undo: 'تراجع',
    redo: 'إعادة',
    moveUp: 'نقل الكتلة المحددة إلى الأعلى',
    moveDown: 'نقل الكتلة المحددة إلى الأسفل',
    linkTitle: 'الرابط',
    linkApply: 'تطبيق الرابط',
    linkUrl: 'عنوان URL',
    linkUrlLead: 'مسار داخل الموقع (مثل /urunler)، أو عنوان يبدأ بـ https://، أو mailto: أو tel:.',
    linkNewTab: 'فتح في علامة تبويب جديدة',
    imageTitle: 'إضافة صورة',
    imageInsert: 'إدراج الصورة',
    imageAlt: 'النص البديل',
    imageAltLead: 'صِف باختصار ما تعرضه الصورة؛ إذ تقرأ برامج قراءة الشاشة هذا النص.',
    imageCaption: 'التعليق',
    table: 'إدراج جدول',
    tableToolbar: 'إجراءات الجدول',
    addRow: 'إضافة صف',
    addColumn: 'إضافة عمود',
    deleteRow: 'حذف الصف',
    deleteColumn: 'حذف العمود',
    deleteTable: 'حذف الجدول',
    video: 'إدراج فيديو',
    videoTitle: 'إدراج فيديو',
    videoLead:
      'الصق عنوان YouTube أو Vimeo. لا يُرسَل أي طلب إلى خدمة الفيديو في واجهة المتجر حتى يضغط الزائر على زر التشغيل.',
    videoUrl: 'رابط الفيديو',
    videoName: 'عنوان الفيديو',
    videoInsert: 'إدراج الفيديو',
    import: 'استيراد Markdown أو HTML',
    importTitle: 'استيراد Markdown أو HTML',
    importLead:
      'الصق نصًا كتبته في مكان آخر؛ سيُدرج في موضع المؤشر. تُحفظ العناوين والقوائم والجداول والاقتباسات والخط العريض/المائل والروابط، أما النصوص البرمجية والأنماط والصور الخارجية فلا تُستورد.',
    importFormat: 'التنسيق',
    importText: 'النص',
    importRun: 'تحويل وإدراج',
    importEmpty: 'لا يوجد محتوى للتحويل.',
    imported: 'تم إدراج المحتوى.',
    importSkippedImages: 'تم تخطي {{count}} من الصور الخارجية (ارفع الصور عبر «إدراج صورة»).',
    importSkippedScripts: 'تمت إزالة {{count}} من كتل النصوص البرمجية/الأنماط.',
    importSkippedEmbeds: 'تمت إزالة {{count}} من العناصر المضمّنة (يُحتفظ بمقاطع فيديو YouTube/Vimeo فقط).',
  },
  pages: {
    create: 'صفحة جديدة',
    createConfirm: 'إنشاء وتحرير',
    empty: 'لا توجد صفحات بعد',
    emptyLead:
      'إلى أن يُنشر تخطيط للصفحة الرئيسية، تعرض واجهة المتجر الصفحة الرئيسية الافتراضية. استخدم «صفحة جديدة» لإنشاء تخطيط للصفحة الرئيسية أو صفحة مؤسسية أو صفحة حملة.',
    updated: 'آخر تعديل {{date}}',
    kind: 'نوع الصفحة',
    kinds: {
      home: 'تخطيط الصفحة الرئيسية',
      page: 'صفحة مؤسسية',
      landing: 'صفحة حملة',
    },
    states: {
      draft: 'مسودة',
      scheduled: 'مجدول',
      live: 'منشور',
      expired: 'انتهى',
      unpublished: 'تم إلغاء النشر',
    },
    reviews: {
      not_required: 'لا يلزم اعتماد',
      pending: 'بانتظار اعتماد المختص',
      approved: 'اعتمده المختص',
      rejected: 'رفضه المختص',
    },
    title: 'عنوان الصفحة',
    newHeading: 'عنوان جديد',
    back: 'جميع الصفحات',
    saved: 'تم حفظ المسودة',
    publishedToast: 'تم نشر الصفحة',
    unpublishedToast: 'تم إلغاء نشر الصفحة',
    reviewedToast: 'تم حفظ قرار المراجعة',
    preview: 'معاينة',
    save: 'حفظ المسودة',
    publish: 'نشر',
    liveVersion: 'الإصدار المنشور: {{version}}',
    unpublished: 'توجد تغييرات غير منشورة',
    publishAtInfo: 'البدء: {{date}}',
    unpublishAtInfo: 'الانتهاء: {{date}}',
    basics: 'بيانات الصفحة',
    slug: 'الاسم المختصر',
    slugLead: 'العنوان: {{path}}',
    seoTitle: 'عنوان SEO',
    seoDescription: 'وصف SEO',
    chars: '{{count}}/{{max}} حرفًا',
    healthContent: 'محتوى صحي (يتطلب اعتماد المختص)',
    sections: 'الأقسام',
    sectionsLead: 'تظهر في واجهة المتجر من الأعلى إلى الأسفل بهذا الترتيب. تبقى الأقسام المخفية في المسودة.',
    noSections: 'لا توجد أقسام بعد. اختر نوع قسم أدناه وأضفه.',
    sectionType: 'نوع القسم',
    sectionTypes: {
      hero: 'عنوان رئيسي كبير',
      richText: 'نص',
      imageText: 'صورة ونص',
      productGrid: 'شبكة المنتجات',
      categoryTiles: 'مربعات الفئات',
      faq: 'الأسئلة الشائعة',
      banners: 'البانرات',
      postList: 'مقالات المدونة',
    },
    addSection: 'إضافة قسم',
    hidden: 'مخفي',
    hide: 'إخفاء',
    moveUp: 'نقل القسم {{n}} إلى الأعلى',
    moveDown: 'نقل القسم {{n}} إلى الأسفل',
    sectionUnavailable: 'نوع القسم هذا غير مدعوم بعد.',
    heading: 'العنوان',
    heroText: 'نص قصير',
    ctaLabel: 'نص الزر',
    ctaHref: 'رابط الزر',
    body: 'النص',
    imagePosition: 'موضع الصورة',
    gridSource: 'مصدر المنتجات',
    gridSources: {
      newest: 'أحدث المنتجات',
      category: 'منتجات فئة معيّنة',
      products: 'منتجات أختارها',
      bestsellers: 'الأكثر مبيعًا (آخر 30 يومًا)',
      discounted: 'المنتجات المخفّضة',
      collection: 'منتجات مجموعة معيّنة',
      brand: 'منتجات علامة تجارية معيّنة',
    },
    gridCollection: 'المجموعة',
    gridBrand: 'العلامة التجارية',
    chooseRef: 'اختر',
    refInactive: '{{name}} (لا يظهر في واجهة المتجر)',
    gridLimit: 'عدد المنتجات',
    products: 'إضافة منتجات',
    unknownProduct: 'المنتج غير موجود (ربما حُذف)',
    tileCategories: 'الفئات المعروضة',
    question: 'السؤال {{n}}',
    answer: 'الإجابة {{n}}',
    addQuestion: 'إضافة سؤال',
    removeQuestion: 'إزالة هذا السؤال',
    noImage: 'لا توجد صورة',
    uploadImage: 'رفع صورة',
    replaceImage: 'استبدال الصورة',
    imageAlt: 'النص البديل',
    review: 'مراجعة المختص',
    reviewLead:
      'تُنشر الصفحات التي تتضمن محتوى صحيًا أو ادعاءات صحية بعد اعتماد المراجع البيطري المختص. ويسقط الاعتماد عند تغيير المحتوى.',
    reviewNote: 'ملاحظة المراجع: {{note}}',
    reviewNoteLabel: 'ملاحظة المراجعة',
    reviewSaveFirst: 'احفظ المسودة أولًا؛ يسري القرار على المحتوى المحفوظ.',
    findings: 'ادعاءات صحية محتملة: {{count}}',
    approve: 'اعتماد',
    reject: 'رفض',
    versions: 'الإصدارات المنشورة',
    versionsLead: 'تُحفظ كل عملية نشر كإصدار غير قابل للتعديل.',
    noVersions: 'لم تُنشر هذه الصفحة بعد.',
    unpublish: 'إلغاء النشر',
    unpublishConfirm: 'ستُزال الصفحة من واجهة المتجر فورًا. تُحفظ المسودات والإصدارات. هل تريد المتابعة؟',
    deleteConfirm: 'ستُحذف صفحة المسودة هذه نهائيًا. هل تريد المتابعة؟',
    publishTitle: 'نشر الصفحة',
    publishLead: 'تُنشر المسودة كإصدار جديد. إذا لم تحدد تواريخ فستُنشر فورًا.',
    publishConfirm: 'نشر',
    publishAt: 'تاريخ البدء',
    bannerPlacement: 'منطقة البانر',
    bannersLead: 'يعرض هذا القسم البانرات النشطة المضافة إلى المنطقة المختارة.',
    manageBanners: 'إدارة البانرات',
    allPostCategories: 'جميع الفئات',
    postLimit: 'عدد المقالات',
    unpublishAt: 'تاريخ الانتهاء',
  },
  banners: {
    create: 'بانر جديد',
    createConfirm: 'حفظ كمسودة',
    save: 'حفظ',
    saved: 'تم حفظ البانر',
    activate: 'تفعيل',
    activated: 'تم تفعيل البانر',
    deactivate: 'إيقاف',
    deactivated: 'تم إيقاف البانر',
    reordered: 'تم حفظ الترتيب',
    back: 'جميع البانرات',
    unsaved: 'توجد تغييرات غير محفوظة',
    saveBeforeActivate: 'احفظ قبل التفعيل.',
    activeLocked: 'هذا البانر نشط؛ يتطلب تعديله صلاحية «نشر المحتوى».',
    emptyPlacement: 'لا توجد بانرات في هذه المنطقة.',
    noText: 'لا يوجد نص',
    startsInfo: 'البدء: {{date}}',
    endsInfo: 'الانتهاء: {{date}}',
    updated: 'آخر تعديل {{date}}',
    moveUp: 'نقل {{name}} إلى الأعلى',
    moveDown: 'نقل {{name}} إلى الأسفل',
    placements: {
      home_hero: 'شريط العرض في الصفحة الرئيسية',
      home_secondary: 'المنطقة الثانوية في الصفحة الرئيسية',
      category_top: 'أعلى صفحة الفئة',
      announcement: 'شريط الإعلانات',
      popup: 'نافذة منبثقة',
    },
    placementLead: {
      home_hero: 'يتناوب في أعلى الصفحة الرئيسية (8 كحد أقصى). يمكن للزوار إيقافه مؤقتًا.',
      home_secondary: 'مربعات في الصفحة الرئيسية (6 كحد أقصى).',
      category_top: 'فوق قائمة المنتجات في الفئات المختارة (الأول في الترتيب).',
      announcement: 'سطر واحد في أعلى الموقع (الأول في الترتيب).',
      popup:
        'يظهر مرة واحدة عند تحميل الصفحة، ولا يظهر أبدًا في سلة التسوق أو أثناء إتمام الطلب (الأول في الترتيب).',
    },
    states: {
      draft: 'مسودة',
      scheduled: 'مجدول',
      live: 'منشور',
      expired: 'انتهى',
      inactive: 'متوقف',
    },
    audiences: {
      all: 'الجميع',
      retail: 'غير الموزّعين',
      dealer: 'الموزّعون فقط',
    },
    basics: 'بيانات البانر',
    placement: 'الموضع',
    name: 'الاسم الداخلي',
    nameLead: 'يظهر في لوحة التحكم فقط.',
    title: 'العنوان',
    text: 'النص',
    announcementText: 'نص الإعلان',
    ctaLabel: 'نص الزر',
    href: 'عنوان الرابط',
    images: 'الصور',
    imagesLead: 'لا يُكتب النص فوق الصورة أبدًا؛ تُستخدم الصورة كصورة فقط.',
    desktopImage: 'صورة سطح المكتب',
    uploadDesktop: 'رفع صورة سطح المكتب',
    replaceDesktop: 'استبدال صورة سطح المكتب',
    mobileImage: 'صورة الجوال',
    uploadMobile: 'رفع صورة الجوال',
    replaceMobile: 'استبدال صورة الجوال',
    targeting: 'الجمهور والتوقيت',
    targetingLead: 'من يراه ومتى.',
    audience: 'الجمهور المستهدف',
    startsAt: 'البدء',
    endsAt: 'الانتهاء',
    dismissDays: 'عدد أيام الإخفاء بعد الإغلاق',
    categories: 'الفئات',
    categoriesLead: 'إذا لم تُختر أي فئة، يظهر في جميع صفحات الفئات.',
    dangerZone: 'الحذف',
    deleteConfirm: 'سيُحذف هذا البانر نهائيًا. هل تريد المتابعة؟',
  },
  blog: {
    create: 'مقال جديد',
    posts: 'المقالات',
    filter: 'عرض',
    filters: {
      all: 'جميع المقالات',
      review: 'بانتظار اعتماد المختص',
      live: 'المنشورة',
      draft: 'المسودات',
    },
    pendingCount: 'مقالات بانتظار اعتماد المختص: {{count}}',
    empty: 'لا توجد مقالات',
    emptyLead: 'استخدم «مقال جديد» لكتابة مقالك الأول؛ لن يظهر حتى يُنشر.',
    publishedInfo: 'نُشر في {{date}}',
    states: {
      draft: 'مسودة',
      scheduled: 'مجدول',
      live: 'منشور',
      unpublished: 'تم إلغاء النشر',
    },
    title: 'عنوان المقال',
    back: 'جميع المقالات',
    feature: 'تمييز',
    unfeature: 'إزالة التمييز',
    featuredBadge: 'مميز',
    featuredToast: 'أصبحت المقالة مميزة في صفحة المقالات.',
    unfeaturedToast: 'لم تعد المقالة مميزة.',
    readingTime: 'مدة القراءة: {{n}} دقيقة',
    article: 'المقال',
    excerpt: 'المقتطف',
    category: 'الفئة',
    noCategory: 'بدون فئة',
    tags: 'الوسوم',
    tagsLead: 'افصل بينها بفواصل.',
    authorName: 'اسم الكاتب',
    authorTitle: 'لقب الكاتب',
    authorTitlePlaceholder: 'طبيب بيطري',
    cover: 'صورة الغلاف',
    uploadCover: 'رفع صورة الغلاف',
    replaceCover: 'استبدال صورة الغلاف',
    body: 'نص المقال',
    references: 'المراجع',
    referencesLead: 'المصادر العلمية والروابط التي يستند إليها المقال.',
    referenceTitle: 'المرجع {{n}}',
    referenceUrl: 'رابط المرجع {{n}}',
    referenceRemove: 'إزالة المرجع {{n}}',
    referenceAdd: 'إضافة مرجع',
    related: 'منتجات ذات صلة',
    relatedLead: 'تُعرض في نهاية المقال.',
    relatedSearch: 'إضافة منتج',
    seo: 'محركات البحث',
    noVersions: 'لم يُنشر هذا المقال بعد.',
    publishedToast: 'تم نشر المقال',
    unpublishedToast: 'تم إلغاء نشر المقال',
    unpublishConfirm: 'سيُزال المقال من واجهة المتجر فورًا. تُحفظ المسودات والإصدارات. هل تريد المتابعة؟',
    deleteConfirm: 'ستُحذف مسودة المقال هذه نهائيًا. هل تريد المتابعة؟',
    publishTitle: 'نشر المقال',
    publishLead: 'تُنشر المسودة كإصدار جديد. إذا لم تحدد تاريخًا فستُنشر فورًا.',
    categories: 'فئات المدونة',
    categoriesLead: 'تظهر الفئة في واجهة المتجر بمجرد احتوائها على مقال منشور.',
    categoryName: 'اسم الفئة',
    categoryAdd: 'إضافة فئة',
    categoryEdit: 'تعديل الفئة',
    categorySlugLead: 'عند تغييره، يُعاد توجيه العنوان القديم إلى العنوان الجديد.',
    categoryDescription: 'الوصف',
    categorySaved: 'تم حفظ الفئة',
    categoryDelete: 'حذف الفئة {{name}}',
    categoryDeleteConfirm: 'سيتم حذف «{{name}}» وتصبح مقالاتها بدون فئة. هل تريد المتابعة؟',
    postCount: '{{count}} مقال',
  },
  contentPlan: {
    kind: 'النوع',
    allKinds: 'جميع المحتويات',
    kinds: {
      post: 'مقال مدونة',
      page: 'صفحة',
      banner: 'بانر',
    },
    monthNav: 'اختيار الشهر',
    prevMonth: 'الشهر السابق',
    nextMonth: 'الشهر التالي',
    thisMonth: 'هذا الشهر',
    summary: 'مخطط: {{planned}}، منفّذ: {{done}}',
    agenda: 'تقويم المحتوى لشهر {{month}}',
    today: 'اليوم',
    planned: 'مخطط',
    empty: 'لا توجد أحداث نشر هذا الشهر',
    emptyLead:
      'تظهر هنا المقالات والصفحات المجدولة للنشر في تاريخ لاحق، والبانرات التي لها تاريخ بدء أو انتهاء.',
    truncated: 'توجد أحداث كثيرة جدًا هذا الشهر؛ تُعرض أول 1000 منها.',
    events: {
      publish_planned: 'سيُنشر',
      publish_done: 'نُشر',
      update: 'تم التحديث (الإصدار {{version}})',
      start_planned: 'سيبدأ العرض',
      start_done: 'بدأ العرض',
      end_planned: 'سيُزال من النشر',
      end_done: 'أُزيل من النشر',
    },
    statesTitle: 'ملخص الحالة',
    postsTitle: 'مقالات المدونة',
    pagesTitle: 'الصفحات',
    bannersTitle: 'البانرات',
    pendingReview: 'بانتظار مراجعة المختص',
    categoriesTitle: 'المقالات المنشورة حسب الفئة',
    categoriesLead: 'تُحتسب حسب الفئة في الإصدار المنشور.',
    noCategories: 'لا توجد فئات مدونة أو مقالات منشورة بعد.',
    livePosts: 'المقالات المنشورة',
    monthlyTitle: 'المقالات التي نُشرت في آخر 12 شهرًا',
    monthlyLead: 'حسب التاريخ المعروض في واجهة المتجر (بتوقيت تركيا)؛ تُحتسب المقالات المنشورة حاليًا.',
    month: 'الشهر',
    published: 'المقالات',
    bar: 'مقارنة مرئية',
    staleTitle: 'مقالات لم تُحدَّث',
    staleLead:
      'مقالات منشورة مضى على آخر إصدار منشور منها أكثر من {{days}} يومًا. راجع المعلومات وأعد نشرها.',
    staleNone: 'لا يوجد مقال مضى عليه أكثر من عام دون تحديث.',
    staleMore: 'و{{count}} أخرى',
    lastPublished: 'آخر نشر: {{date}}',
    scTitle: 'Search Console: المقالات، آخر 28 يومًا',
    scUnavailable: 'لا يمكن عرض بيانات Search Console لهذه اللغة.',
    scOtherLocale: 'تُعرض نقرات Search Console فقط للمقالات المكتوبة بلغة واجهة المتجر (اللغة الافتراضية).',
    setupRequired: 'يتطلب الإعداد',
    scNotLinked: 'لا توجد خاصية Search Console مرتبطة بهذا المتجر. اربط خاصية من صفحة اتصالات Google.',
    scNoData: 'لا توجد بيانات Search Console بعد؛ ستظهر هنا بعد أول مزامنة.',
    scRange: 'نطاق البيانات: {{from}} – {{to}}',
    scNoClicks: 'لا توجد نقرات بحث أو مرات ظهور لمقالات المدونة في هذه الفترة.',
    scWithoutClicks: 'المقالات المنشورة التي لم تحصل على نقرات في هذه الفترة: {{count}}',
    post: 'المقال',
  },
  forms: {
    form: 'النموذج',
    kinds: {
      contact: 'نموذج التواصل',
      dealer_application: 'طلب الانضمام كموزّع (حقول إضافية)',
    },
    settingsTitle: 'النشر والإشعارات',
    noticeMissing: 'إشعار الخصوصية (KVKK) غير منشور',
    noticeMissingLead: 'انشر إشعار الخصوصية أولًا لعرض النموذج في واجهة المتجر.',
    enabled: 'عرض النموذج في صفحة التواصل',
    notifyStaff: 'إشعار بالبريد الإلكتروني عند وصول رسائل جديدة',
    newMessages: 'رسائل جديدة: {{count}}',
    dealerLead:
      'حقول اسم الشركة والبيانات الضريبية والهاتف والعنوان والمحافظة/المنطقة ونوع النشاط والملاحظة والمستندات ثابتة. تظهر الحقول التي تضيفها هنا في نهاية نموذج الطلب وتُحفظ مع الطلب.',
    fieldsTitle: 'حقول النموذج',
    extraFieldsTitle: 'حقول إضافية',
    fieldsLead:
      'تظهر الحقول في واجهة المتجر بهذا الترتيب. تُنشر التغييرات فورًا عند الضغط على «حفظ النموذج».',
    noFields: 'لا توجد حقول إضافية بعد.',
    addField: 'إضافة حقل',
    save: 'حفظ النموذج',
    saved: 'تم حفظ النموذج',
    untitled: 'حقل بلا اسم',
    fieldN: 'الحقل {{n}}: {{name}}',
    requiredBadge: 'إلزامي',
    label: 'التسمية',
    type: 'نوع الحقل',
    help: 'نص المساعدة',
    options: 'الخيارات (خيار في كل سطر)',
    required: 'حقل إلزامي',
    moveUp: 'نقل {{name}} إلى الأعلى',
    moveDown: 'نقل {{name}} إلى الأسفل',
    remove: 'إزالة {{name}}',
    types: {
      text: 'نص قصير',
      textarea: 'نص طويل',
      email: 'البريد الإلكتروني',
      tel: 'الهاتف',
      number: 'رقم',
      select: 'قائمة اختيار',
      checkbox: 'مربع اختيار',
      date: 'التاريخ',
    },
    presets: {
      name: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      message: 'الرسالة',
    },
  },
  messages: {
    filter: 'عرض',
    convert: 'تحويل إلى طلب دعم',
    filters: {
      new: 'الرسائل الجديدة',
      handled: 'المعالَجة',
      all: 'جميع الرسائل',
    },
    newCount: 'رسائل جديدة: {{count}}',
    listTitle: 'الرسائل',
    empty: 'لا توجد رسائل',
    emptyLead: 'تظهر هنا الرسائل المرسلة من واجهة المتجر أثناء تفعيل نموذج التواصل (واجهة المتجر ← النماذج).',
    statuses: {
      new: 'جديدة',
      handled: 'تمت المعالجة',
    },
    reply: 'الرد بالبريد الإلكتروني',
    markHandled: 'تعليم كمعالَجة',
    markNew: 'تعليم كجديدة',
    deleteConfirm: 'هل تريد حذف هذه الرسالة نهائيًا؟ لا يمكن التراجع عن هذا الإجراء.',
    deleted: 'تم حذف الرسالة',
    pageOf: 'الصفحة {{page}} من {{pages}}',
  },
  topbar: {
    store: 'المتجر الحالي',
    jobsRunning: 'مهام قيد التشغيل: {{count}}',
    jobsDone: 'اكتملت المهام ({{count}})',
    jobsTitle: 'مهام الخلفية',
    jobsLead: 'المهام الجارية والمهام التي انتهت في آخر 10 دقائق.',
    progress: '{{processed}} / {{total}}',
    statuses: {
      queued: 'في قائمة الانتظار',
      running: 'قيد التشغيل',
      done: 'مكتملة',
      failed: 'فشلت',
    },
    kinds: {
      import: 'استيراد',
      product_bulk: 'إجراء جماعي على المنتجات',
      seo_crawl: 'فحص الموقع',
      web_vitals: 'قياس سرعة الصفحة',
    },
    imports: {
      products: 'استيراد المنتجات',
      shopify_products: 'استيراد منتجات Shopify',
      categories: 'استيراد الفئات',
      dealers: 'استيراد قائمة الموزّعين',
      migration: 'حزمة الترحيل',
    },
  },
  audience: {
    subscribersTitle: 'مشتركو النشرة البريدية',
    subscribersLead:
      'الأشخاص الذين اشتركوا عبر نموذج النشرة البريدية في واجهة المتجر. يبدأ الاشتراك عبر رابط التأكيد في البريد الإلكتروني (تأكيد مزدوج)؛ وتظهر موافقات الأعضاء في بطاقة العميل.',
    status: 'الحالة',
    statuses: {
      subscribed: 'مشترك',
      pending: 'بانتظار التأكيد',
      unsubscribed: 'ألغى الاشتراك',
      all: 'الكل',
    },
    sources: {
      storefront_form: 'نموذج واجهة المتجر',
      admin_import: 'استيراد',
    },
    search: 'البحث بالبريد الإلكتروني',
    member: 'عضو',
    colEmail: 'البريد الإلكتروني',
    colStatus: 'الحالة',
    colConsent: 'تاريخ الموافقة ونصها',
    noSubscribers: 'لا يوجد مشتركون بهذه الحالة',
    noSubscribersLead:
      'يظهر نموذج النشرة البريدية في تذييل واجهة المتجر عند إعداد إرسال البريد الإلكتروني ونشر إشعار الخصوصية (KVKK).',
    unsubscribe: 'إنهاء الاشتراك',
    unsubscribeConfirm:
      'لن تُرسل أي رسائل تسويقية إلى هذا العنوان بعد الآن (يُضاف إلى قائمة الحظر)، ويُبلَّغ İYS بالرفض. هل تريد المتابعة؟',
    unsubscribedDone: 'تم إنهاء الاشتراك.',
    deleteConfirm:
      'يُحذف سجل المشترك (الخصوصية، KVKK). تُحفظ سجلات إلغاء الاشتراك وسجلات İYS كإثبات. لا يمكن التراجع عن هذا الإجراء. هل تريد المتابعة؟',
    deletedDone: 'تم حذف المشترك.',
    suppressionsTitle: 'قائمة الحظر',
    suppressionsLead:
      'لا تُرسل أي رسالة تسويقية إلى هذه العناوين حتى مع وجود موافقة: العناوين التي ألغت الاشتراك أو ارتدّت رسائلها أو قدّمت شكوى، والعناوين المضافة يدويًا. لا تتأثر إشعارات الطلبات والشحن.',
    channel: 'القناة',
    channels: {
      email: 'البريد الإلكتروني',
      sms: 'SMS',
      whatsapp: 'WhatsApp',
    },
    channelFilter: 'تصفية القائمة حسب القناة',
    allChannels: 'جميع القنوات',
    address: 'العنوان',
    note: 'ملاحظة (اختياري)',
    suppress: 'حظر',
    suppressedDone: 'تمت إضافة العنوان إلى قائمة الحظر.',
    colReason: 'السبب',
    colDate: 'التاريخ',
    reasons: {
      unsubscribe: 'ألغى الاشتراك',
      bounce: 'ارتدّت الرسالة',
      complaint: 'شكوى',
      manual: 'أُضيف يدويًا',
      iys_ret: 'مرفوض في İYS',
    },
    noSuppressions: 'قائمة الحظر فارغة',
    noSuppressionsLead: 'يظهر هنا من يستخدمون رابط إلغاء الاشتراك والعناوين التي تحظرها يدويًا.',
    unsuppress: 'إزالة',
    unsuppressConfirm:
      'سيُرفع الحظر، لكن الموافقة لا تعود تلقائيًا، ويجب على الشخص أن يمنح موافقته من جديد. هل تريد المتابعة؟',
    unsuppressedDone: 'تم رفع الحظر.',
    iysTitle: 'سجلات İYS',
    iysLead:
      'يجب إبلاغ نظام إدارة الرسائل التركي İleti Yönetim Sistemi بالموافقات وحالات الرفض خلال ثلاثة أيام عمل؛ ولا تُرسل أي رسالة تسويقية بناءً على موافقة لم يُبلَّغ عنها.',
    iysConnected: 'İYS متصل',
    iysSetup: 'يتطلب الإعداد',
    iysSetupLink: 'التكاملات ← İYS',
    iysPending: 'قيد الانتظار: {{count}}',
    iysOverdue: 'متأخرة: {{count}}',
    iysFailed: 'مرفوضة: {{count}}',
    iysFilter: 'عرض',
    iysFilters: {
      open: 'بانتظار الإبلاغ',
      sent: 'أُرسلت إلى İYS',
      reported: 'أُبلغ عنها يدويًا',
      failed: 'مرفوضة',
      all: 'الكل',
    },
    iysDownload: 'تنزيل الملف (CSV)',
    iysMark: 'تعليم المحدد كمُبلَّغ عنه ({{count}})',
    iysMarked: 'تم تعليم السجلات كمُبلَّغ عنها.',
    iysEmpty: 'لا توجد سجلات للإبلاغ',
    iysEmptyLead: 'تظهر هنا الموافقات وحالات الرفض الجديدة.',
    select: 'تحديد',
    selectRecord: 'تحديد السجل {{address}}',
    colIys: 'الموافقة',
    colDue: 'آخر موعد للإبلاغ',
    colState: 'الحالة',
    overdue: 'متأخر',
    recipientTypes: {
      BIREYSEL: 'فرد',
      TACIR: 'تاجر (موزّع)',
    },
    iysTypes: {
      EPOSTA: 'البريد الإلكتروني',
      MESAJ: 'رسالة',
      ARAMA: 'مكالمة',
    },
    iysStatuses: {
      ONAY: 'موافقة',
      RET: 'رفض',
    },
    eligibility: {
      invalid_address: 'عنوان غير صالح',
      suppressed: 'في قائمة الحظر',
      no_consent: 'لا توجد موافقة تسويقية',
      iys_not_registered: 'لم تُسجَّل الموافقة في İYS بعد',
      iys_refused: 'يوجد سجل رفض في İYS',
    },
    iysStates: {
      pending: 'قيد الانتظار',
      sent: 'أُرسل إلى İYS',
      reported: 'أُبلغ عنه يدويًا',
      failed: 'مرفوض',
    },
  },
  segments: {
    rfmTitle: 'مجموعات RFM',
    rfmLead:
      'يُقيَّم العملاء من 1 إلى 5 بحسب حداثة آخر شراء (R) وعدد الطلبات (F) وصافي الإنفاق (M)، ثم يُقسَّمون إلى مجموعات. يُعاد الحساب تلقائيًا كل ليلة.',
    computedAt: 'آخر حساب: {{date}}',
    neverComputed: 'لم يُحسب بعد. استخدم «إعادة الحساب الآن»؛ كما يُحسب تلقائيًا كل ليلة.',
    recompute: 'إعادة الحساب الآن',
    recomputed: 'تم تحديث مجموعات RFM وأعداد الشرائح.',
    thresholds:
      'R: شراء خلال {{r5}} يومًا = 5، {{r4}} يومًا = 4، {{r3}} يومًا = 3، {{r2}} يومًا = 2، أقدم من ذلك = 1. F: {{f5}} طلبات على الأقل = 5، {{f4}} = 4، {{f3}} = 3، {{f2}} = 2، طلب واحد = 1. M: الخُمسيات بين العملاء (أعلى 20% إنفاقًا = 5).',
    groupCount: '{{count}} عميل',
    groupShare: '{{pct}}% من العملاء',
    groupSpent: 'صافي الإنفاق {{amount}}',
    noOrdersCount: '{{count}} عضو',
    saveAsSegment: 'حفظ كشريحة',
    saveAsSegmentLabel: 'حفظ مجموعة {{group}} كشريحة',
    savedAsSegment: 'تم إنشاء الشريحة.',
    groups: {
      champions: 'الأبطال',
      loyal: 'العملاء الأوفياء',
      new: 'العملاء الجدد',
      potential: 'عملاء أوفياء محتملون',
      need_attention: 'بحاجة إلى اهتمام',
      cant_lose: 'لا يمكن خسارتهم',
      at_risk: 'معرّضون للخطر',
      hibernating: 'خاملون',
      lost: 'مفقودون',
      none: 'أعضاء بلا طلبات',
    },
    groupHints: {
      champions: 'اشتروا خلال {{r4}} يومًا، ولديهم {{f4}} طلبات على الأقل، وضمن أعلى 40% إنفاقًا.',
      loyal: 'اشتروا خلال {{r3}} يومًا ولديهم {{f3}} طلبات على الأقل.',
      new: 'قدّموا طلبهم الوحيد خلال {{r4}} يومًا.',
      potential: 'قدّموا طلبهم الثاني خلال {{r4}} يومًا.',
      need_attention: 'آخر شراء قبل {{r4}}–{{r3}} يومًا، وطلبان على الأكثر.',
      cant_lose: '{{f4}} طلبات على الأقل، لكن دون شراء منذ أكثر من {{r3}} يومًا.',
      at_risk: '2–3 طلبات، دون شراء منذ أكثر من {{r3}} يومًا.',
      hibernating: 'الطلب الوحيد قبل {{r3}}–{{r2}} يومًا.',
      lost: 'الطلب الوحيد قبل أكثر من {{r2}} يومًا.',
      none: 'مسجّلون لكن دون طلب صالح.',
    },
    listTitle: 'الشرائح',
    listLead:
      'مجموعات عملاء تُعرَّف بقواعد، وتُستخدم كجماهير مستهدفة في الحملات والأتمتة. يُعاد حساب الأعضاء من القواعد في كل مرة.',
    add: 'شريحة جديدة',
    emptyTitle: 'لا توجد شرائح بعد',
    emptyLead: 'احفظ إحدى مجموعات RFM أعلاه أو أنشئ شريحة بقواعدك الخاصة.',
    colName: 'الشريحة',
    colMembers: 'العملاء',
    colCounted: 'آخر إحصاء',
    backToList: 'جميع الشرائح',
    basics: 'بيانات الشريحة',
    name: 'الاسم',
    description: 'الوصف',
    rulesTitle: 'القواعد',
    rulesLead:
      'العملاء الذين تنطبق عليهم القواعد ينتمون إلى الشريحة. تُقيَّم شروط الطلبات لحظيًا، ومجموعة RFM وفق آخر حساب؛ ولا يُدرج أبدًا العملاء المحذوفون بموجب KVKK.',
    match: 'المطابقة',
    matchAll: 'جميع الشروط',
    matchAny: 'أي شرط',
    conditions: 'الشروط',
    field: 'الحقل',
    op: 'المقارنة',
    value: 'القيمة',
    choose: 'اختر',
    addCondition: 'إضافة شرط',
    removeCondition: 'إزالة الشرط',
    fields: {
      order_count: 'عدد الطلبات',
      total_spent: 'صافي الإنفاق',
      last_order_days: 'الأيام منذ آخر طلب',
      registered_days: 'الأيام منذ التسجيل',
      species: 'نوع الحيوان للمنتج المشترى',
      tag: 'الوسم',
      city: 'المدينة',
      kind: 'نوع العميل',
      consent: 'القناة التي توجد لها موافقة تسويقية',
      consent_source: 'مصدر الموافقة على البريد الإلكتروني',
      rfm: 'مجموعة RFM',
    },
    ops: {
      is: 'يساوي',
      is_not: 'لا يساوي',
      gte: 'على الأقل',
      lte: 'على الأكثر',
    },
    kinds: {
      dealer: 'موزّع (عضو شركة معتمد)',
      retail: 'عميل تجزئة',
    },
    amountIn: 'المبلغ ({{currency}})',
    days: 'الأيام',
    preview: 'معاينة',
    previewTitle: 'العملاء المطابقون: {{count}}',
    previewLead: 'معاينة قبل الحفظ؛ يُعرض أول 10 عملاء.',
    noMatches: 'لا يوجد عملاء تنطبق عليهم القواعد.',
    saved: 'تم حفظ الشريحة.',
    deleted: 'تم حذف الشريحة.',
    deleteConfirm: 'هل تريد حذف الشريحة «{{name}}»؟ لن يتأثر العملاء.',
    membersTitle: 'العملاء في هذه الشريحة: {{count}}',
    membersEmpty: 'لا يوجد عملاء في هذه الشريحة حاليًا.',
    colCustomer: 'العميل',
    colRfm: 'مجموعة RFM',
    colOrders: 'الطلبات',
    colSpent: 'صافي الإنفاق',
    colLastOrder: 'آخر طلب',
  },
  emailRouting: {
    title: 'إرسال البريد الإلكتروني',
    lead: 'يمكن إرسال رسائل الطلبات وكلمات المرور والدعوات (رسائل المعاملات) ورسائل النشرة البريدية والحملات (الرسائل التسويقية) عبر مزوّدين مختلفين. لا تظهر في القائمة إلا المزوّدات التي نجح اختبار الاتصال بها.',
    transactional: 'رسائل المعاملات',
    marketing: 'الرسائل التسويقية',
    smtpDefault: 'SMTP (الخاص بالنشاط التجاري أو بالمنصة)',
    sameAsTransactional: 'مثل رسائل المعاملات',
    noProviders:
      'لم يُربط أي مزوّد بريد إلكتروني (Amazon SES أو SendGrid أو Postmark) بعد؛ تُرسل الرسائل عبر SMTP.',
    save: 'حفظ خيار الإرسال',
    saved: 'تم حفظ خيار الإرسال.',
    webhooksLead:
      'أدخل هذه العناوين في لوحة تحكم المزوّد لإشعارات الارتداد والشكاوى وإلغاء الاشتراك؛ فهي تحدّث قائمة الحظر. تحتوي على مفتاح سري، فلا تشاركها.',
    webhookFor: 'رابط إشعارات {{provider}}',
    rotate: 'إعادة إنشاء الروابط',
    rotateConfirm:
      'سيُنشأ مفتاح سري جديد وستتوقف الروابط القديمة عن العمل فورًا. حدّثها في لوحات تحكم المزوّدين. هل تريد المتابعة؟',
    rotated: 'تمت إعادة إنشاء روابط الإشعارات.',
  },
  emailTemplates: {
    create: 'قالب جديد',
    lead: 'قوالب لرسائل النشرة البريدية والحملات. أنشئ المحتوى من كتل؛ تأتي الألوان والشعار من سمة المتجر المنشورة، والبيانات القانونية في التذييل من إعدادات النشاط التجاري. يتم الإرسال من شاشة الحملات.',
    emptyTitle: 'لا توجد قوالب بعد',
    emptyLead: 'ابدأ بـ«قالب جديد»: أضف كتل العنوان والنص والصورة والزر والمنتجات ورتّبها.',
    listLabel: 'قوالب البريد الإلكتروني',
    colName: 'القالب',
    colReview: 'مراجعة المختص',
    colUpdated: 'آخر تعديل',
    noReview: 'غير مطلوبة',
    saved: 'تم حفظ القالب.',
    deleted: 'تم حذف القالب.',
    save: 'حفظ',
    createConfirm: 'إنشاء القالب',
    back: 'جميع القوالب',
    unsaved: 'توجد تغييرات غير محفوظة',
    completeFirst: 'للحفظ، أكمل الاسم والموضوع والكتل المعلَّمة بأنها غير مكتملة.',
    editor: 'محرر القوالب',
    basics: 'بيانات القالب',
    name: 'اسم القالب',
    nameLead: 'يظهر في لوحة التحكم فقط (مثل «نشرة أكتوبر»).',
    subject: 'الموضوع',
    preheader: 'النص التمهيدي',
    preheaderLead: 'نص قصير يظهر بجانب الموضوع في صندوق الوارد، ولا يظهر داخل الرسالة.',
    mergeTitle: 'حقول التخصيص',
    mergeFields: {
      firstName: 'الاسم الأول للمستلم',
      name: 'الاسم الكامل للمستلم',
      email: 'عنوان البريد الإلكتروني للمستلم',
      storeName: 'اسم المتجر',
    },
    mergeFallback: 'لكتابة نص بديل عند عدم وجود قيمة، اكتبه بعد خط عمودي:',
    blocks: 'كتل المحتوى',
    blocksLead:
      'تظهر الكتل من الأعلى إلى الأسفل بهذا الترتيب. اسحبها من المقبض أو استخدم أزرار الأسهم لإعادة ترتيبها. تُضاف البيانات القانونية ورابط إلغاء الاشتراك إلى أسفل كل رسالة تلقائيًا.',
    noBlocks: 'لا توجد كتل بعد. أضف كتلة أدناه.',
    moved: 'نُقلت الكتلة إلى الموضع {{position}}.',
    removed: 'تمت إزالة الكتلة {{n}}.',
    added: 'تمت إضافة كتلة {{type}} في الموضع {{n}}.',
    dragHint: 'اسحب لإعادة الترتيب',
    blockTitle: '{{n}}. {{type}}',
    blockTypes: {
      heading: 'عنوان',
      text: 'نص',
      image: 'صورة',
      button: 'زر',
      products: 'بطاقات المنتجات',
      divider: 'خط فاصل',
      spacer: 'مسافة فارغة',
      cart: 'سلة التسوق',
      order: 'الطلب',
      quote: 'عرض السعر',
    },
    missing: {
      text: 'اكتب النص',
      image: 'ارفع صورة',
      label: 'أدخل نص الزر',
      link: 'أدخل الرابط',
      products: 'اختر منتجًا واحدًا على الأقل',
      collection: 'اختر مجموعة',
      category: 'اختر فئة',
    },
    moveUp: 'نقل الكتلة {{n}} إلى الأعلى',
    moveDown: 'نقل الكتلة {{n}} إلى الأسفل',
    removeBlock: 'إزالة الكتلة {{n}}',
    addBlock: 'إضافة كتلة',
    blockLimit: 'يمكن أن يحتوي القالب على {{max}} كتلة كحد أقصى.',
    dangerZone: 'حذف القالب',
    deleteConfirm: 'سيُحذف القالب «{{name}}». تبقى إصداراته بلغات أخرى. هل تريد المتابعة؟',
    updated: 'آخر تعديل: {{date}}',
    align: 'المحاذاة',
    aligns: {
      left: 'يسار',
      center: 'وسط',
    },
    headingText: 'العنوان',
    level: 'الحجم',
    levels: {
      '1': 'عنوان كبير',
      '2': 'عنوان فرعي',
    },
    text: 'النص',
    textLead: 'يبدأ السطر الفارغ فقرة جديدة. يظهر النص الموجود بين **نجمتين** بخط عريض.',
    replaceImage: 'استبدال الصورة',
    uploadImage: 'رفع صورة',
    imageAlt: 'وصف الصورة',
    imageAltLead: 'يظهر إذا لم تُحمَّل الصورة وتقرؤه برامج قراءة الشاشة. إلزامي للصور المرتبطة برابط.',
    imageLink: 'رابط الصورة',
    width: 'العرض',
    widths: {
      full: 'عرض كامل',
      half: 'نصف العرض (في الوسط)',
    },
    buttonLabel: 'نص الزر',
    buttonLink: 'رابط الزر',
    source: 'مصدر المنتجات',
    sources: {
      newest: 'أحدث المنتجات',
      collection: 'مجموعة',
      category: 'فئة',
      manual: 'منتجات مختارة يدويًا',
    },
    columns: 'الأعمدة',
    columnCount: '{{count}} أعمدة',
    limit: 'عدد المنتجات',
    collection: 'المجموعة',
    category: 'الفئة',
    choose: 'اختر',
    pickProducts: 'المنتجات',
    showPrice: 'إظهار السعر',
    productsLead:
      'تُعرض فقط المنتجات المنشورة في هذا المتجر والنشطة وذات المحتوى المعتمد، وتُستبعد المنتجات التي تتضمن ادعاءات صحية بانتظار الاعتماد. السعر هو أدنى سعر متغير شامل الضريبة في السوق الافتراضي، ويُعاد حسابه عند الإرسال.',
    spacerSize: 'ارتفاع المسافة',
    sizes: {
      sm: 'صغير',
      md: 'متوسط',
      lg: 'كبير',
    },
    cartLead:
      'في أتمتة سلة التسوق المتروكة، تُدرج هنا منتجات سلة العميل وإجماليها. وفي رسائل الحملات يظهر وصف بدلًا من ذلك.',
    orderLead:
      'في عمليات الأتمتة بعد الشراء، تُدرج هنا منتجات الطلب وإجماليه. وفي رسائل الحملات يظهر وصف بدلًا من ذلك.',
    quoteLead:
      'في أتمتة متابعة عروض أسعار الموزّعين تُدرَج هنا منتجات العرض وإجماليه وتاريخ صلاحيته. وفي رسالة الحملة يظهر نص توضيحي بدلًا منها.',
    dividerLead: 'خط رفيع بين الكتل.',
    preview: 'معاينة',
    previewUpdating: 'جارٍ التحديث…',
    device: 'الشاشة',
    devices: {
      desktop: 'سطح المكتب',
      phone: 'الهاتف',
    },
    format: 'التنسيق',
    formats: {
      html: 'البريد الإلكتروني',
      text: 'نص عادي',
    },
    previewFieldErrors: 'تعذّر إنشاء المعاينة؛ صحّح الحقول المعلَّمة.',
    previewWaiting: 'تظهر المعاينة هنا بمجرد كتابة الموضوع.',
    previewFrame: 'معاينة البريد الإلكتروني',
    findingsTitle:
      'توجد {{count}} من العبارات التي قد تكون ادعاءات صحية. بعد الحفظ يلزم اعتماد المراجع البيطري المختص، ولا يمكن استخدام القالب في الحملات بدونه.',
    emptyProducts:
      'لا توجد منتجات لعرضها في كتلة المنتجات (الكتلة: {{blocks}}). لا يحتوي المصدر على منتجات منشورة ومعتمدة، لذا تُستبعد الكتلة من الرسالة.',
    test: 'إرسال تجريبي',
    testLead:
      'تُرسل النسخة المحفوظة مع «[Test]» قبل الموضوع. تُرسل فقط إلى مستخدمي لوحة التحكم في نشاطك التجاري، ولا تُرسل أبدًا إلى العملاء.',
    testSend: 'إرسال',
    testQueued: 'أُضيفت الرسالة التجريبية إلى قائمة الإرسال (عدد المستلمين: {{count}}).',
    testSaveFirst: 'توجد تغييرات غير محفوظة. يرسل الاختبار النسخة المحفوظة؛ احفظ أولًا.',
    testTo: 'المستلمون',
    testToLead:
      'عناوين البريد الإلكتروني لمستخدمي لوحة التحكم، مفصولة بفواصل، بحد أقصى 5. اتركه فارغًا للإرسال إليك فقط.',
  },
  campaigns: {
    create: 'حملة جديدة',
    lead: 'ترسل الحملة قالب بريد إلكتروني إلى الجمهور المختار. يُتحقق من كل مستلم مجددًا وقت الإرسال: لا تصل الرسالة إلى من هم في قائمة الحظر أو من ليست لديهم موافقة أو من لم يُبلَّغ İYS بموافقتهم. يجري الإرسال في الخلفية بحد أقصى لكل دقيقة.',
    emptyTitle: 'لا توجد حملات بعد',
    emptyLead: 'جهّز قالب بريد إلكتروني أولًا، ثم اختر الجمهور عبر «حملة جديدة».',
    listLabel: 'حملات البريد الإلكتروني',
    colName: 'الحملة',
    colStatus: 'الحالة',
    colSent: 'المُرسل / المستلمون',
    colClicked: 'نقروا',
    colWhen: 'التاريخ',
    statuses: {
      draft: 'مسودة',
      scheduled: 'مجدولة',
      sending: 'جارٍ الإرسال',
      testing: 'اختبار A/B جارٍ',
      sent: 'أُرسلت',
      paused: 'متوقفة مؤقتًا',
      cancelled: 'أُوقفت',
    },
    saved: 'تم حفظ الحملة.',
    deleted: 'تم حذف الحملة.',
    cancelled: 'تم إيقاف الإرسال.',
    resumed: 'تم استئناف الإرسال.',
    save: 'حفظ',
    createConfirm: 'إنشاء مسودة',
    back: 'جميع الحملات',
    unsaved: 'توجد تغييرات غير محفوظة',
    editor: 'إعدادات الحملة',
    content: 'المحتوى',
    name: 'اسم الحملة',
    nameLead: 'يظهر في لوحة التحكم والتقارير، ويُنشأ منه رمز الحملة المضاف إلى الروابط.',
    template: 'قالب البريد الإلكتروني',
    chooseTemplate: 'اختر قالبًا',
    openTemplate: 'فتح القالب',
    noTemplates: 'لا توجد قوالب بريد إلكتروني في هذا المتجر بعد.',
    subject: 'الموضوع',
    subjectLead:
      'إذا تُرك فارغًا يُستخدم موضوع القالب: «{{subject}}». ويتلقى المستلمون بلغات أخرى موضوع القالب بلغتهم.',
    preheader: 'النص التمهيدي',
    preheaderLead: 'إذا تُرك فارغًا يُستخدم النص التمهيدي للقالب.',
    audience: 'الجمهور',
    audienceLead:
      'العملاء في الشرائح، واختياريًا مشتركو النشرة البريدية في المتجر. يُحتسب كل عنوان مرة واحدة.',
    segments: 'الشرائح',
    noSegments: 'لا توجد شرائح محفوظة (التسويق ← الشرائح).',
    segmentCount: '(آخر إحصاء: {{count}} عميل)',
    subscribers: 'مشتركو النشرة البريدية في المتجر',
    estimate: 'حساب المستلمين',
    estimateResult: 'يمكن الإرسال إلى {{eligible}} شخصًا (من أصل {{total}}).',
    estimateNote: 'تعكس الأعداد الوضع الحالي، ويُتحقق من كل مستلم مجددًا عند الإرسال.',
    skipReasons: {
      suppressed: 'في قائمة الحظر: {{count}}',
      no_consent: 'لا توجد موافقة تسويقية: {{count}}',
      iys_not_registered: 'لم يُبلَّغ İYS بالموافقة: {{count}}',
      iys_refused: 'مرفوض في İYS: {{count}}',
      invalid_address: 'عنوان غير صالح: {{count}}',
      staging_allowlist: 'غير مدرج في قائمة السماح لبيئة Staging (لم يُرسل): {{count}}',
    },
    abTitle: 'اختبار A/B (الموضوع)',
    abLead:
      'يتلقى جزء من المستلمين موضوعين مختلفين. بعد انتهاء مدة الانتظار، يُرسل الموضوع صاحب نسبة النقر الأعلى إلى بقية المستلمين.',
    abEnable: 'إجراء اختبار A/B على الموضوع',
    subjectB: 'الموضوع B',
    abPercent: 'مجموعة الاختبار',
    percentOption: '{{pct}}% من المستلمين',
    abWait: 'مدة الانتظار قبل اختيار الفائز',
    hoursOption: '{{count}} ساعة',
    delivery: 'سرعة الإرسال',
    deliveryLead: 'اضبطها وفق حدود المزوّد وسمعة نطاقك. ابدأ بسرعة منخفضة عند استخدام نطاق جديد.',
    rate: 'عدد الرسائل في الدقيقة (الحد الأقصى)',
    dangerZone: 'حذف الحملة',
    deleteConfirm: 'ستُحذف الحملة «{{name}}». هل تريد المتابعة؟',
    updated: 'آخر تعديل: {{date}}',
    send: 'إرسال…',
    templateNotApproved: 'القالب بانتظار اعتماد المختص، ولا يمكن إرساله قبل الاعتماد.',
    sendTitle: 'إرسال الحملة',
    sendLead:
      'تُرسل الرسائل إلى أشخاص حقيقيين ولا يمكن استرجاعها. يمكنك إيقاف الإرسال بعد بدئه، لكن الرسائل المُرسلة لا تُسترجع.',
    scheduleConfirm: 'جدولة',
    sendConfirm: 'إرسال إلى {{count}} شخص',
    when: 'التوقيت',
    now: 'الآن',
    later: 'في وقت لاحق',
    scheduledAt: 'وقت الإرسال',
    scheduledToast: 'تمت جدولة الحملة.',
    queuedToast: 'يبدأ الإرسال الآن؛ تابع التقدّم على هذه الشاشة.',
    statusTitle: 'حالة الإرسال',
    statusLabel: 'الحالة',
    startedAt: 'بدأ',
    abDecideAt: 'موعد اختيار الفائز',
    winner: 'الموضوع الفائز',
    variantLabel: 'الموضوع {{v}}',
    finishedAt: 'انتهى',
    progressLabel: 'تقدّم الإرسال',
    progress: 'تمت معالجة {{done}} / {{total}} من المستلمين: أُرسل إلى {{sent}}، وتم تخطي {{skipped}}.',
    abSkipped:
      'لم يُجرَ اختبار A/B: لم يكن عدد المستلمين كافيًا (100 على الأقل). أُرسل الموضوع A إلى الجميع.',
    pauseReasons: {
      email_not_configured:
        'إرسال البريد الإلكتروني غير مُعدّ (يتطلب الإعداد). اربط SMTP أو مزوّدًا من شاشة «الاتصالات»، ثم اضغط «استئناف».',
      provider_auth_failed:
        'رفض مزوّد البريد الإلكتروني المفتاح. أصلح الاتصال واضغط «استئناف»؛ المستلمون الذين لم يُرسل إليهم بالانتظار.',
      template_review_required: 'القالب بانتظار اعتماد المختص. اضغط «استئناف» بعد الاعتماد.',
      campaign_template_invalid: 'لم يُعثر على القالب (ربما حُذف). أوقف هذه الحملة وأنشئ حملة جديدة.',
    },
    resume: 'استئناف',
    cancel: 'إيقاف الإرسال',
    cancelConfirm:
      'لن تصل الرسالة إلى المستلمين الذين لم يُرسل إليهم بعد، ولا يمكن استرجاع الرسائل المُرسلة. هل تريد المتابعة؟',
    reportTitle: 'التقرير',
    reportLead:
      'لا تُقاس مرات الفتح (لأسباب تتعلق بالخصوصية والموثوقية). لا يُملأ حقل «تم التسليم» إلا مع SES أو SendGrid أو Postmark عند إدخال عنوان الإشعارات الخاص بها.',
    purged: 'حُذفت سجلات المستلمين بعد انتهاء مدة الاحتفاظ (180 يومًا)، مع الاحتفاظ بالإجماليات.',
    stats: {
      recipients: 'المستلمون',
      sent: 'أُرسلت',
      skipped: 'تم تخطيها',
      delivered: 'تم التسليم',
      bounced: 'ارتدّت',
      clicked: 'نقروا',
      clicks: 'النقرات',
      unsubscribed: 'ألغوا الاشتراك',
      complained: 'الشكاوى',
      failed: 'فشل الإرسال',
    },
    skippedTitle: 'تم تخطيها',
    colVariant: 'الموضوع',
    winnerBadge: 'الفائز',
    linksTitle: 'الرابط',
    ordersTitle: 'الطلبات الواردة من الحملة',
    noOrders: 'لا توجد طلبات من روابط الحملة بعد.',
    ordersLine: 'الطلبات: {{orders}}، المدفوعة: {{paid}} · الإيرادات: {{revenue}}',
    ordersNote:
      'يُحتسب الطلب إذا كان رابط البريد الإلكتروني آخر نقطة تواصل للزائر ووافق على ملفات تعريف الارتباط (القاعدة نفسها المتبعة في تقرير «الحملات والمصادر»).',
  },
  automations: {
    lead: 'الأتمتة ترسل بريدًا إلكترونيًا إلى الشخص تلقائيًا عند وقوع حدث ما (تسجيل جديد، سلة متروكة، طلب تم تسليمه…). تكون التدفقات متوقفة افتراضيًا، ولا تدخلها إلا الأحداث التي تقع بعد تشغيلها. قبل كل رسالة يُتحقق من قائمة الحظر والموافقة التسويقية و İYS وحد التكرار وساعات الهدوء.',
    listLabel: 'عمليات الأتمتة التسويقية',
    colFlow: 'التدفق',
    colStatus: 'الحالة',
    colEnrolled: 'الداخلون',
    colSent: 'المُرسلة',
    on: 'مُفعّل',
    off: 'متوقف',
    activeCount: '{{count}} قيد التنفيذ',
    last30Note: 'تغطي الأعداد آخر 30 يومًا.',
    kinds: {
      welcome: 'الترحيب',
      cart_abandon: 'سلة متروكة',
      checkout_abandon: 'دفع غير مكتمل',
      post_purchase: 'بعد الشراء',
      repurchase: 'تذكير بإعادة الشراء',
      winback: 'استعادة العملاء',
      vip: 'عملاء VIP',
      birthday: 'عيد الميلاد',
      dealer_welcome: 'الترحيب بالموزّعين',
      quote_followup: 'متابعة عروض أسعار الموزّعين',
    },
    summaries: {
      welcome: 'أول رسالة إلى عضو جديد أو مشترك في النشرة البريدية.',
      cart_abandon: 'تذكير لعضو ترك منتجات في سلة التسوق، مع رسالة ثانية اختيارية.',
      checkout_abandon: 'تذكير بطلب لم يكتمل دفعه.',
      post_purchase: 'دعوة إلى التقييم بعد التسليم.',
      repurchase: 'تذكير بعد عدد من الأيام من آخر طلب.',
      winback: 'استعادة العملاء الذين لم يطلبوا منذ مدة طويلة.',
      vip: 'شكر سنوي لمجموعة «الأبطال».',
      birthday: 'تهنئة للعملاء الذين أدخلوا تاريخ ميلادهم.',
      dealer_welcome: 'ترحيب بمستخدمي شركة موزّع معتمدة.',
      quote_followup: 'تذكير للموزّع بعرض سعر مُرسَل لم يتحوّل إلى طلب.',
    },
    settingsTitle: 'قواعد الإرسال',
    settingsLead: 'تسري على جميع التدفقات. تُحتسب رسائل الحملات ضمن حد التكرار.',
    frequencyCap: 'حد التكرار',
    frequencyCapLead:
      'يُتخطّى كل من تلقى رسالة حملة أو رسالة من تدفق آخر خلال هذه المدة. وتحدد خطوة الانتظار الفاصل الزمني داخل التدفق.',
    capNone: 'بلا حد',
    capHours: 'رسالة واحدة كحد أقصى كل {{count}} ساعة',
    quietHours: 'ساعات الهدوء',
    quietStart: 'البدء',
    quietEnd: 'الانتهاء',
    quietLead: 'لا تُرسل رسائل بين {{start}} و{{end}} (بتوقيت تركيا)، وتُرسل هذه الرسائل عند {{end}}.',
    quietOff: 'لا توجد ساعات هدوء: قد تُرسل الرسائل في أي وقت.',
    saveSettings: 'حفظ القواعد',
    settingsSaved: 'تم حفظ قواعد الإرسال.',
    unknownTitle: 'التدفق غير موجود',
    unknownLead: 'قد يكون العنوان خاطئًا. اختر تدفقًا من قائمة عمليات الأتمتة.',
    back: 'جميع عمليات الأتمتة',
    unsaved: 'توجد تغييرات غير محفوظة',
    editor: 'إعدادات التدفق',
    save: 'حفظ',
    saveAndEnable: 'حفظ وتشغيل',
    enableConfirm:
      'بعد التشغيل تُرسل الرسائل تلقائيًا إلى الأشخاص الذين يستوفون الشروط (ويجتازون التحقق من الموافقة وقائمة الحظر و İYS). لا يمكن استرجاع الرسائل المُرسلة. هل تريد التشغيل؟',
    saved: 'تم حفظ التدفق.',
    enabledToast: 'تم تشغيل التدفق؛ ستدخله الأحداث الجديدة.',
    disabledToast: 'تم إيقاف التدفق وإخراج الأشخاص الموجودين فيه.',
    statusTitle: 'الحالة',
    enabledLabel: 'التدفق مُفعّل',
    enabledSince: 'تاريخ التشغيل: {{date}}. تدخل التدفقَ الأحداثُ التي تقع بعد هذا التاريخ.',
    enableLead:
      'لتشغيل التدفق، اختر قالبًا لكل خطوة بريد إلكتروني. يجب إعداد إرسال البريد الإلكتروني، وتحتاج القوالب التي تتضمن ادعاءات صحية إلى اعتماد المختص.',
    disableWarning: 'عند الحفظ يتوقف التدفق ويُخرَج منه الأشخاص الموجودون فيه حاليًا.',
    stepsChangedWarning: 'لقد غيّرت الخطوات: عند الحفظ يُخرَج من التدفق الأشخاص الموجودون فيه حاليًا.',
    triggerTitle: 'المُشغِّل',
    triggers: {
      welcome: 'عند إنشاء حساب أو تأكيد الاشتراك في النشرة البريدية. مرة واحدة لكل عنوان.',
      cart_abandon: 'بعد {{hours}} ساعة من آخر تغيير في سلة تسوق العضو.',
      checkout_abandon: 'بعد {{hours}} ساعة من إنشاء الطلب إذا كان الدفع لا يزال معلّقًا.',
      post_purchase: 'بعد {{days}} يومًا من تسليم الطلب.',
      repurchase: 'بعد {{days}} يومًا من آخر طلب في هذا المتجر (إذا لم يوجد طلب أحدث).',
      winback: 'بعد {{days}} يومًا من آخر طلب في هذا المتجر (إذا لم يوجد طلب أحدث).',
      vip: 'عندما يكون العميل ضمن مجموعة «الأبطال» في RFM؛ يُتحقق يوميًا، ومرة واحدة سنويًا كحد أقصى لكل عميل.',
      birthday: 'في تاريخ الميلاد الذي أدخله العميل (في بداية اليوم، أو صباحًا إذا صادف ساعات الهدوء).',
      dealer_welcome: 'فور اعتماد شركة الموزّع.',
      quote_followup:
        'بعد {{days}} يوم من إرسال عرض السعر (آخر إصدار منه) إلى الموزّع، إذا كان العرض لا يزال مفتوحًا. يُرسَل إلى المسؤولين في الشركة وإلى المستخدم الذي طلب العرض؛ ويبدأ من جديد عند إرسال إصدار جديد.',
    },
    afterHours: 'بعد كم من الوقت',
    hoursOption: '{{count}} ساعة',
    daysLabel: {
      post_purchase: 'عدد الأيام بعد التسليم',
      repurchase: 'عدد الأيام بعد آخر طلب',
      winback: 'عدد الأيام بعد آخر طلب',
      quote_followup: 'عدد الأيام بعد إرسال العرض',
    },
    storeScoped: 'لا يُشغَّل هذا التدفق إلا بسلال التسوق والطلبات وعروض الأسعار في المتجر المختار.',
    stepsTitle: 'الخطوات',
    stepsLead:
      'تُنفَّذ الخطوات بالترتيب. يؤخر الانتظار الخطوة التالية؛ وإذا لم يتحقق الشرط يخرج الشخص من التدفق؛ وترسل خطوة البريد الإلكتروني القالب المختار.',
    stepTitle: 'الخطوة {{n}}: {{type}}',
    stepNumber: 'الخطوة {{n}}',
    stepTypes: {
      wait: 'انتظار',
      condition: 'شرط',
      email: 'بريد إلكتروني',
    },
    waitHours: 'ساعات الانتظار',
    condition: 'المتابعة إذا',
    conditionLead: 'إذا لم يتحقق الشرط يخرج الشخص من التدفق.',
    conditions: {
      cart_not_converted: 'لا تزال السلة تحتوي على منتجات ولم يُقدَّم طلب',
      order_not_paid: 'لا يزال دفع الطلب معلّقًا',
      not_reviewed: 'لم تُقيَّم منتجات الطلب بعد',
      no_order_since_enrollment: 'لا يوجد طلب منذ الدخول في التدفق',
      quote_open: 'العرض لا يزال مفتوحًا (الإصدار نفسه، لم تنتهِ صلاحيته، لم يتحوّل إلى طلب)',
    },
    template: 'قالب البريد الإلكتروني',
    chooseTemplate: 'اختر قالبًا',
    openTemplate: 'فتح القالب',
    noTemplates: 'لا توجد قوالب بريد إلكتروني في هذا المتجر بعد.',
    templateHints: {
      welcome: 'استخدم {{firstName}} لاسم الشخص.',
      cart_abandon: 'أضف كتلة «سلة التسوق» لعرض المنتجات وأسعارها الحالية.',
      checkout_abandon: 'أضف كتلة «الطلب» لعرض الطلب المعلّق ورابطه.',
      post_purchase: 'أضف كتلة «الطلب» لعرض الطلب الذي تم تسليمه.',
      repurchase: 'أضف كتلة «الطلب» لعرض آخر طلب.',
      winback: 'أضف كتلة «الطلب» لعرض آخر طلب.',
      vip: 'استخدم {{firstName}} لاسم الشخص.',
      birthday: 'استخدم {{firstName}} لاسم الشخص.',
      dealer_welcome: 'تظهر أسعار الموزّعين بعد تسجيل الدخول؛ أضف رابطًا لتسجيل الدخول.',
      quote_followup:
        'أضف كتلة «عرض السعر» إلى القالب لعرض منتجات العرض وإجماليه وتاريخ صلاحيته وزرًا يؤدي إلى العرض.',
    },
    moveUp: 'نقل الخطوة {{n}} إلى الأعلى',
    moveDown: 'نقل الخطوة {{n}} إلى الأسفل',
    removeStep: 'حذف الخطوة {{n}}',
    moved: 'نُقلت الخطوة إلى الموضع {{n}}.',
    added: 'تمت إضافة الخطوة {{n}}.',
    removed: 'تم حذف الخطوة {{n}}.',
    addStep: 'إضافة خطوة',
    resetDefaults: 'العودة إلى الخطوات الافتراضية',
    reportTitle: 'التقرير',
    reportLead:
      'الداخلون وأسباب الخروج والرسائل المُرسلة. تُحذف السجلات بعد 180 يومًا من انتهاء التدفق. لا تُقاس مرات الفتح.',
    stats: {
      enrolled: 'الداخلون',
      active: 'قيد التنفيذ',
      completed: 'أكملوا',
      exited: 'خرجوا',
      sent: 'أُرسلت',
      skipped: 'تم تخطيها',
      failed: 'فشل الإرسال',
    },
    exitsTitle: 'أسباب الخروج',
    exitReasons: {
      cart_not_converted: 'تحوّلت السلة إلى طلب أو أُفرغت: {{count}}',
      order_not_paid: 'تم الدفع أو أُلغي الطلب: {{count}}',
      not_reviewed: 'كتب تقييمًا: {{count}}',
      no_order_since_enrollment: 'قدّم طلبًا: {{count}}',
      superseded: 'تغيّرت السلة وفُتح سجل جديد: {{count}}',
      expired: 'تعذّر إرسال الرسالة خلال 72 ساعة: {{count}}',
      flow_changed: 'تغيّرت خطوات التدفق: {{count}}',
      disabled: 'أُوقف التدفق: {{count}}',
      quote_open: 'تحوّل العرض إلى طلب أو رُفض أو أُلغي أو انتهت صلاحيته أو أُرسل إصدار جديد: {{count}}',
    },
    skipsTitle: 'الرسائل غير المُرسلة',
    skipReasons: {
      suppressed: 'في قائمة الحظر: {{count}}',
      no_consent: 'لا توجد موافقة تسويقية: {{count}}',
      iys_not_registered: 'لم يُبلَّغ İYS بالموافقة: {{count}}',
      iys_refused: 'مرفوض في İYS: {{count}}',
      invalid_address: 'عنوان غير صالح: {{count}}',
      frequency_cap: 'حد التكرار: {{count}}',
      template_unavailable: 'القالب غير متاح: {{count}}',
      staging_allowlist: 'غير مدرج في قائمة السماح لبيئة Staging: {{count}}',
      rejected: 'رفضه المزوّد: {{count}}',
      error: 'خطأ في الإرسال: {{count}}',
    },
    skipOther: 'أخرى: {{count}}',
    byStepTitle: 'الرسائل المُرسلة لكل خطوة',
    colStep: 'الخطوة',
    ordersTitle: 'الطلبات الواردة من هذا التدفق',
    noOrders: 'لا توجد طلبات من روابط رسائل هذا التدفق بعد.',
    ordersNote:
      'يُضاف إلى روابط المتجر رمز حملة خاص بالتدفق؛ ويُحتسب الطلب إذا كان هذا الرابط آخر نقطة تواصل (مع الموافقة على ملفات تعريف الارتباط).',
    updated: 'آخر تعديل: {{date}}',
  },
  productAlerts: {
    lead: 'يمكن للمتسوقين ترك بريدهم الإلكتروني عبر «أعلمني عند التوفر» للمنتجات غير المتوفرة، وتلقي إشعار واحد عند عودة المخزون. وعندما ينخفض سعر منتج في المفضلة بقدر كافٍ، يمكن إرسال بريد إلكتروني إلى العملاء الذين لديهم موافقة تسويقية. كلاهما متوقف افتراضيًا.',
    settingsTitle: 'الإعدادات',
    settingsLead:
      'يجب إعداد إرسال البريد الإلكتروني. لا يظهر النموذج في واجهة المتجر ما لم يُنشر إشعار الخصوصية.',
    stockToggle: '«أعلمني عند التوفر» في واجهة المتجر',
    stockToggleLead:
      'يُبلَّغ المنتظرون بترتيب طلباتهم عند عودة المخزون (3 أضعاف كمية المخزون، و5 أشخاص على الأقل في كل جولة، كل 5 دقائق). إشعار لمرة واحدة بناءً على طلب الشخص، ولا تلزم موافقة تسويقية.',
    priceDropToggle: 'إشعارات انخفاض السعر للمفضلة',
    priceDropLead:
      'يُتحقق يوميًا في الساعة 10:05. يُرسل عندما يقل السعر عن أدنى سعر منذ الإضافة إلى المفضلة بالنسبة المختارة. هذه رسالة تسويقية: تسري الموافقة وقائمة الحظر و İYS وحد التكرار.',
    store: 'المتجر',
    chooseStore: 'اختر متجرًا',
    minPercent: 'الحد الأدنى للانخفاض',
    percentOption: '{{pct}}%',
    save: 'حفظ',
    saved: 'تم حفظ الإعدادات.',
    enableConfirm:
      'بعد التشغيل تُرسل الرسائل تلقائيًا إلى الأشخاص الذين يستوفون الشروط، ولا يمكن استرجاع الرسائل المُرسلة. هل تريد التشغيل؟',
    requestsTitle: 'طلبات «أعلمني عند التوفر»',
    requestsLead:
      'طلبات الإشعار المنتظرة والمُبلَّغ عنها لكل متغير. تبقى الطلبات صالحة 6 أشهر، وتُحذف السجلات المغلقة بعد 180 يومًا.',
    emptyTitle: 'لا توجد طلبات إشعار بعد',
    emptyLead:
      'تظهر هنا عناوين البريد الإلكتروني المتروكة على المنتجات غير المتوفرة طالما كانت ميزة «أعلمني عند التوفر» مفعّلة.',
    colProduct: 'المنتج',
    colWaiting: 'بالانتظار',
    colNotified: 'تم إبلاغهم',
    colStock: 'المخزون',
    colOldest: 'أقدم طلب إشعار',
    colActions: 'الإجراءات',
    inStock: 'متوفر ({{count}})',
    outOfStock: 'غير متوفر',
    view: 'طلبات الإشعار',
    viewFor: 'طلبات الإشعار لـ {{product}}',
    priceDropLast30: 'رسائل انخفاض السعر في آخر 30 يومًا: أُرسلت {{sent}}، ولم تُرسل {{skipped}}.',
    statusFilter: 'الحالة',
    statuses: {
      waiting: 'بالانتظار',
      notified: 'تم الإبلاغ',
      cancelled: 'مغلق',
    },
    noRequests: 'لا توجد طلبات إشعار بهذه الحالة.',
    member: 'عضو',
    requestedAt: 'تاريخ الطلب: {{date}}',
    notifiedAt: 'تاريخ الإبلاغ: {{date}}',
    reasons: {
      panel: 'أُلغي من لوحة التحكم',
      expired: 'انتهت الصلاحية (6 أشهر)',
      suppressed: 'العنوان في قائمة الحظر',
      staging_allowlist: 'غير مدرج في قائمة السماح لبيئة Staging',
      rejected: 'رفضه المزوّد',
    },
    cancel: 'إلغاء',
    cancelConfirm: 'سيُغلق طلب الإشعار ولن يُرسل أي إشعار. هل تريد المتابعة؟',
    cancelled: 'تم إلغاء طلب الإشعار.',
  },
  messaging: {
    create: 'حملة SMS/WhatsApp جديدة',
    lead: 'أرسل رسالة SMS أو قالب WhatsApp معتمدًا من Meta إلى العملاء في الشرائح. يُعاد التحقق من كل مستلم وقت الإرسال من حيث الموافقة وقائمة الحظر و İYS، ويُطبَّق حد التكرار وساعات الهدوء. الإرسال حقيقي ومدفوع: تحقّق أولًا من الجمهور والتكلفة التقديرية.',
    emptyTitle: 'لا توجد حملات SMS/WhatsApp لهذا المتجر',
    emptyLead: 'جهّز قالب SMS أولًا، ثم أنشئ مسودة عبر «حملة SMS/WhatsApp جديدة».',
    listLabel: 'حملات SMS و WhatsApp',
    colName: 'الحملة',
    colChannel: 'القناة',
    colStatus: 'الحالة',
    colSent: 'المُرسلة',
    colDelivered: 'المُسلَّمة',
    colWhen: 'التاريخ',
    channels: {
      sms: 'SMS',
      whatsapp: 'WhatsApp',
    },
    statuses: {
      draft: 'مسودة',
      scheduled: 'مجدولة',
      sending: 'جارٍ الإرسال',
      sent: 'أُرسلت',
      paused: 'متوقفة مؤقتًا',
      cancelled: 'أُوقفت',
    },
    recipientStatuses: {
      pending: 'في قائمة الانتظار',
      sending: 'جارٍ الإرسال',
      sent: 'أُرسلت',
      delivered: 'سُلِّمت',
      failed: 'فشلت',
      skipped: 'تم تخطيها',
      cancelled: 'أُلغيت',
    },
    setupTitle: 'حالة الإعداد',
    setupLead:
      'تتطلب رسائل SMS التجارية مزوّد SMS مرتبطًا ورقم MERSİS ونص إلغاء الاشتراك، ويتطلب WhatsApp اتصالًا بـ WhatsApp Business. القناة التي ينقصها شيء تظهر بحالة «يتطلب الإعداد» ولا يمكنها الإرسال.',
    connectedVia: '{{provider}} متصل',
    connected: 'متصل',
    webhookUrl: 'عنوان Webhook الخاص بـ Meta:',
    smsSetupLink: 'اربط Netgsm أو İleti Merkezi أو Verimor من التكاملات، ثم اختره أدناه',
    whatsappSetupLink: 'اربط WhatsApp Business من التكاملات',
    mersis: 'رقم MERSİS',
    missing: 'ناقص',
    mersisLink: 'أدخله في بيانات النشاط التجاري',
    optOut: 'نص إلغاء الاشتراك',
    settingsTitle: 'الإعدادات',
    settingsLead:
      'مزوّد SMS، ونص إلغاء الاشتراك في الرسائل التجارية، وتكاليف الوحدة التقديرية، وحد التكرار، وأرقام الاختبار لبيئة Staging. ساعات الهدوء مشتركة مع عمليات الأتمتة.',
    smsProvider: 'مزوّد SMS',
    smsProviderLead: 'لا يمكن اختيار إلا المزوّدين المرتبطين والمختبَرين في التكاملات.',
    noProvider: 'لم يُختر',
    providerNotConnected: '{{provider}} (يتطلب الإعداد)',
    optOutLead:
      'يُضاف مع رقم MERSİS إلى نهاية رسائل SMS التجارية (80 حرفًا كحد أقصى). تجنّب الأحرف التركية يجعل الرسالة أقصر.',
    smsUnitCost: 'تكلفة كل مقطع SMS (TRY)',
    whatsappUnitCost: 'تكلفة كل رسالة WhatsApp (TRY)',
    costInvalid: 'تعذّرت قراءة المبلغ؛ مثال: 0,25',
    frequencyCap: 'حدّ التكرار',
    frequencyCapLead: 'يتلقى رقم الهاتف رسالة حملة واحدة على الأكثر عبر SMS/WhatsApp خلال هذه المدة.',
    capNone: 'بلا حدّ',
    capHours: 'رسالة واحدة على الأكثر كل {{count}} ساعة',
    stagingPhones: 'أرقام اختبار Staging',
    stagingPhonesLead:
      'على خادم Staging تُرسل الرسائل إلى هذه الأرقام فقط (رقم في كل سطر، 10 كحد أقصى). لا تُستخدم في الوضع المباشر.',
    saveSettings: 'حفظ الإعدادات',
    settingsSaved: 'تم حفظ الإعدادات.',
    saved: 'تم حفظ الحملة.',
    deleted: 'تم حذف الحملة.',
    cancelled: 'تم إيقاف الإرسال.',
    resumed: 'تم استئناف الإرسال.',
    save: 'حفظ',
    createConfirm: 'إنشاء المسودة',
    back: 'حملات SMS وWhatsApp',
    unsaved: 'تغييرات غير محفوظة',
    channelSetup: '{{channel}}: يتطلب الإعداد',
    editor: 'محرر الحملة',
    content: 'المحتوى',
    channel: 'القناة',
    name: 'اسم الحملة',
    nameLead: 'يظهر في لوحة التحكم فقط.',
    smsTemplate: 'قالب SMS',
    chooseTemplate: 'اختر قالبًا',
    openTemplate: 'فتح القالب',
    noTemplates: 'لا توجد قوالب SMS بعد.',
    audience: 'الجمهور',
    audienceLead:
      'العملاء في الشرائح المختارة؛ يتلقى كل رقم هاتف رسالة واحدة. يحتاج الأفراد إلى موافقة وتأكيد في İYS؛ أما التجار (أعضاء شركة موزّع) فيكفي لإرسال SMS ألا يوجد رفض مسجّل في İYS. يتطلب WhatsApp موافقة صريحة من الجميع.',
    estimate: 'احتساب المستلمين والتكلفة',
    dangerZone: 'الحذف',
    deleteConfirm: 'هل تريد حذف الحملة «{{name}}»؟',
    updated: 'آخر تغيير: {{date}}',
    whatsappNotConnected:
      'WhatsApp Business غير متصل (يتطلب الإعداد): قائمة القوالب المعتمدة غير متاحة. يمكنك إعداد مسودة بكتابة اسم القالب ولغته كما في Meta؛ ويتطلب الإرسال وجود الاتصال.',
    whatsappTemplate: 'قالب WhatsApp',
    whatsappOption: '{{name}} ({{language}}) · {{status}}',
    waStatuses: {
      APPROVED: 'معتمد',
      PENDING: 'قيد مراجعة Meta',
      REJECTED: 'مرفوض',
      PAUSED: 'متوقف مؤقتًا',
      DISABLED: 'معطّل',
      OTHER: 'غير متاح',
    },
    whatsappName: 'اسم القالب',
    whatsappNameLead: 'اسم القالب في Meta (مثل campaign_announcement).',
    whatsappLanguage: 'رمز اللغة',
    whatsappParams: 'متغيرات القالب',
    noParams: 'لا يحتوي هذا القالب على متغيرات.',
    paramLabel: 'المتغير {{n}}',
    addParam: 'إضافة متغير',
    paramsLead:
      'تحلّ بالترتيب محلّ {{1}} و{{2}}… في القالب. لقيمة شخصية اكتب {{firstName}} أو {{name}} أو {{storeName}}.',
    estimateResult: 'يمكن الإرسال إلى {{eligible}} من أصل {{total}} شخصًا.',
    skipReasons: {
      no_phone: 'لا يوجد رقم هاتف: {{count}}',
      not_mobile: 'ليس رقم جوال تركيًا: {{count}}',
      suppressed: 'في قائمة الحظر: {{count}}',
      no_consent: 'لا توجد موافقة لهذه القناة: {{count}}',
      iys_not_registered: 'الموافقة غير مُبلَّغ عنها في İYS: {{count}}',
      iys_refused: 'مرفوض في İYS: {{count}}',
      duplicate_phone: 'الرقم نفسه لدى عدة عملاء (يُرسل مرة واحدة): {{count}}',
      frequency_cap: 'حدّ التكرار (تلقى رسالة أخرى مؤخرًا): {{count}}',
      staging_allowlist: 'ليس رقم اختبار Staging (لم يُرسل): {{count}}',
      invalid_address: 'رقم غير صالح: {{count}}',
    },
    partsPerMessage: '{{count}} مقطع SMS لكل شخص',
    costEstimate: 'التكلفة التقديرية: {{cost}}',
    costUnknown: 'أدخل تكلفة الوحدة في الإعدادات للحصول على تقدير للتكلفة.',
    estimateNote:
      'هذا تقدير: يُعاد التحقق من الموافقة وقائمة الحظر عند الإرسال؛ وقد يختلف طول الرسالة حسب الاسم.',
    send: 'إرسال…',
    templateNotApproved: 'القالب بانتظار موافقة المختص؛ ولا يمكن إرساله قبل الموافقة.',
    sendTitle: 'إرسال حملة {{channel}}',
    sendLead:
      'تُرسل رسائل مدفوعة إلى أشخاص حقيقيين ولا يمكن التراجع عنها. تحقّق من عدد المستلمين والتكلفة التقديرية؛ ويتطلب الإرسال التحقق بخطوتين.',
    scheduleConfirm: 'جدولة',
    sendConfirm: 'إرسال إلى {{count}} شخصًا',
    sendSetupWarning: 'هذه القناة غير مُعدّة (يتطلب الإعداد)؛ سيُرفض الإرسال.',
    scheduledToast: 'تمت جدولة الحملة.',
    queuedToast: 'أُضيفت الحملة إلى قائمة انتظار الإرسال.',
    statusTitle: 'حالة الإرسال',
    statusLabel: 'الحالة',
    progressLabel: 'تقدّم الإرسال',
    progress:
      'تمت معالجة {{done}} / {{total}}: أُرسل {{sent}}، وسُلّم {{delivered}}، وتم تخطي {{skipped}}، وفشل {{failed}}.',
    pauseReasons: {
      sms_template_required: 'متوقفة مؤقتًا: حُذف قالب SMS. أوقف الحملة وأعدّ حملة جديدة.',
      template_review_required: 'متوقفة مؤقتًا: تغيّر القالب وهو بانتظار موافقة المختص. استأنف بعد الموافقة.',
      sms_footer_missing: 'متوقفة مؤقتًا: رقم MERSİS أو نص إلغاء الاشتراك مفقود. أكمِله ثم استأنف.',
      sms_not_configured: 'متوقفة مؤقتًا: لا يوجد مزوّد SMS متصل أو محدد. اربطه من التكاملات ثم استأنف.',
      whatsapp_not_configured:
        'متوقفة مؤقتًا: لا يوجد اتصال WhatsApp Business. اربطه من التكاملات ثم استأنف.',
      provider_invalid_settings: 'متوقفة مؤقتًا: إعدادات المزوّد ناقصة أو خاطئة.',
      provider_auth_failed: 'متوقفة مؤقتًا: رفض المزوّد بيانات الاعتماد. جدّدها من التكاملات.',
      provider_sender_invalid: 'متوقفة مؤقتًا: عنوان الرسالة (اسم المرسل) غير معتمد لدى المزوّد.',
      provider_iys_not_configured: 'متوقفة مؤقتًا: لم يُحدَّد رمز العلامة التجارية في İYS على حساب المزوّد.',
      provider_insufficient_balance: 'متوقفة مؤقتًا: الرصيد غير كافٍ في حساب المزوّد. اشحن الرصيد ثم استأنف.',
      provider_template_invalid: 'متوقفة مؤقتًا: قالب WhatsApp غير صالح في Meta أو معاملاته غير متطابقة.',
    },
    pauseReasonOther: 'متوقفة مؤقتًا ({{code}}).',
    resume: 'استئناف',
    cancelConfirm: 'هل تريد إيقاف الإرسال؟ لن يتلقى المستلمون الذين لم يُرسل إليهم بعد أي رسالة.',
    cancel: 'إيقاف',
    reportTitle: 'التقرير',
    reportLead: 'تُجلب حالة تسليم SMS من المزوّد كل 10 دقائق؛ وتصل حالة تسليم WhatsApp عبر إشعارات Meta.',
    purged: 'حُذفت سجلات المستلمين بعد انتهاء مدة الاحتفاظ (180 يومًا)؛ ويُحتفظ بالإجماليات.',
    stats: {
      recipients: 'المستلمون',
      sent: 'المُرسلة',
      delivered: 'المُسلَّمة',
      failed: 'الفاشلة',
      skipped: 'المتخطّاة',
      parts: 'مقاطع SMS',
      cost: 'التكلفة التقديرية',
    },
    skippedTitle: 'المتخطّاة',
    errorsTitle: 'الفاشلة',
    sendErrors: {
      whatsapp_opted_out: 'أوقف الشخص رسائل WhatsApp التسويقية: {{count}}',
      interrupted: 'انقطع الإرسال (لن يُعاد الإرسال): {{count}}',
      undelivered: 'تعذّر على المشغّل التسليم: {{count}}',
      whatsapp_failed: 'تعذّر على WhatsApp التسليم: {{count}}',
      error: 'خطأ في الإرسال: {{count}}',
    },
    providerError: 'رمز خطأ المزوّد {{code}}: {{count}}',
    reportNote: 'التكلفة تقدير محسوب من تكلفة الوحدة في الإعدادات؛ والمبلغ الدقيق مذكور في فاتورة المزوّد.',
  },
  smsTemplates: {
    create: 'قالب SMS جديد',
    lead: 'نصوص SMS المستخدمة في الحملات. يُضاف رقم MERSİS ونص إلغاء الاشتراك عند الإرسال، ويُحتسب الطول معهما. لا يُرسل النص الذي يتضمن ادعاءات صحية دون موافقة المراجع البيطري المختص.',
    emptyTitle: 'لا توجد قوالب SMS بعد',
    emptyLead: 'ابدأ بنص قصير وواضح؛ ويمكن إضافة حقول شخصية.',
    listLabel: 'قوالب SMS',
    colName: 'القالب',
    colReview: 'موافقة المختص',
    colUpdated: 'آخر تغيير',
    noReview: 'غير مطلوبة',
    saved: 'تم حفظ القالب.',
    deleted: 'تم حذف القالب.',
    save: 'حفظ',
    createConfirm: 'إنشاء القالب',
    back: 'قوالب SMS',
    unsaved: 'تغييرات غير محفوظة',
    editor: 'محرر قالب SMS',
    name: 'اسم القالب',
    nameLead: 'يظهر في لوحة التحكم فقط.',
    body: 'النص',
    bodyLead: '900 حرف كحد أقصى. يُضاف رقم MERSİS ونص إلغاء الاشتراك تلقائيًا؛ لا تكتبهما هنا.',
    insertField: 'إدراج حقل:',
    fields: {
      firstName: 'الاسم الأول',
      name: 'الاسم الكامل',
      storeName: 'اسم المتجر',
    },
    preview: 'معاينة',
    previewEmpty: 'أثناء الكتابة يظهر هنا النص الذي سيُرسل.',
    encoding: 'مجموعة الأحرف',
    encodings: {
      gsm7: 'قياسي (دون أحرف تركية)',
      turkish: 'مع أحرف تركية',
      unicode: 'Unicode (رموز تعبيرية أو أحرف خاصة)',
    },
    length: 'الأحرف',
    parts: 'المقاطع',
    multiPart: 'يشغل النص {{count}} مقاطع SMS؛ ويُحتسب كل مقطع على حدة.',
    unicodeWarning:
      'رموز تعبيرية أو أحرف خاصة: ينخفض مقطع SMS الواحد إلى 65 حرفًا وترتفع التكلفة. أزِلها إن أمكن.',
    tooLong: 'يتجاوز النص 7 مقاطع SMS؛ ولا يستطيع المزوّدون إرساله. اختصره.',
    footerMissing: 'تذييل رسائل SMS التجارية غير مكتمل؛ لا يمكن إرسال الحملات:',
    footerParts: {
      mersis: 'رقم MERSİS (بيانات المنشأة)',
      optOut: 'نص إلغاء الاشتراك (إعدادات SMS وWhatsApp)',
    },
    findingsNote:
      'يتضمن النص {{count}} ادعاءً صحيًا محتملًا: تلزم موافقة المختص بعد الحفظ. لا تُستخدم ادعاءات الوقاية من الأمراض أو علاجها.',
    previewNote: 'شخص نموذجي: Ayşe Yılmaz. الطول تقديري؛ ويضيف المزوّد رمز المشغّل.',
    dangerZone: 'الحذف',
    deleteConfirm: 'هل تريد حذف القالب «{{name}}»؟',
    updated: 'آخر تغيير: {{date}}',
  },
  push: {
    create: 'حملة إشعارات جديدة',
    lead: 'أرسل إشعارًا قصيرًا إلى متصفحات الزوار الذين سمحوا بالإشعارات في واجهة المتجر. لا يشترك الزائر إلا إذا ضغط الزر بنفسه ومنح إذن المتصفح، ويمكنه إيقافها في أي وقت. يصل الإرسال إلى أشخاص حقيقيين؛ تحقّق من الجمهور أولًا.',
    emptyTitle: 'لا توجد حملات إشعارات لهذا المتجر',
    emptyLead: 'أكمِل الإعداد، ثم أنشئ مسودة عبر «حملة إشعارات جديدة».',
    listLabel: 'حملات الإشعارات',
    colName: 'الحملة',
    colStatus: 'الحالة',
    colSent: 'المُرسلة',
    colWhen: 'التاريخ',
    subscriberCount: '{{count}} متصفحًا فعّلت الإشعارات لهذا المتجر.',
    statuses: {
      draft: 'مسودة',
      scheduled: 'مجدولة',
      sending: 'جارٍ الإرسال',
      sent: 'أُرسلت',
      paused: 'متوقفة مؤقتًا',
      cancelled: 'أُوقفت',
    },
    setupTitle: 'الإعداد',
    setupLead:
      'يحتاج زر واجهة المتجر إلى مفتاح وعنوان اتصال وإشعار خصوصية KVKK منشور. وتحتاج إشعارات تطبيق الإدارة على Android إلى اتصال Firebase.',
    vapidKey: 'مفتاح الإشعارات (VAPID)',
    keyReady: 'جاهز ({{date}})',
    createKey: 'إنشاء مفتاح',
    replaceKey: 'استبدال المفتاح',
    replaceConfirm:
      'استبدال المفتاح يُبطل جميع اشتراكات المتصفحات؛ وسيتعيّن على الزوار تفعيل الإشعارات من جديد. هل تريد المتابعة؟',
    keyCreated: 'تم إنشاء المفتاح.',
    privacyNotice: 'إشعار الخصوصية وفق KVKK',
    published: 'منشور',
    missing: 'مفقود',
    privacyLink: 'انشره من النصوص القانونية',
    android: 'تطبيق Android (Firebase)',
    connected: 'متصل',
    firebaseLink: 'اربط Firebase من التكاملات',
    settingsTitle: 'إعدادات واجهة المتجر',
    contact: 'عنوان الاتصال',
    contactLead:
      'تستخدم خدمات الإشعارات الفورية (Google وMozilla وApple) هذا العنوان عند حدوث مشكلة. اكتب mailto: مع بريد إلكتروني أو https: مع عنوان موقع.',
    enabled: 'إظهار زر «تفعيل الإشعارات» في واجهة المتجر',
    saveSettings: 'حفظ',
    settingsSaved: 'تم حفظ الإعدادات.',
    saved: 'تم حفظ الحملة.',
    deleted: 'تم حذف الحملة.',
    cancelled: 'تم إيقاف الإرسال.',
    resumed: 'تم استئناف الإرسال.',
    save: 'حفظ',
    createConfirm: 'إنشاء المسودة',
    back: 'الإشعارات الفورية',
    unsaved: 'تغييرات غير محفوظة',
    notReady: 'يتطلب الإعداد: إشعارات واجهة المتجر معطّلة أو لا يوجد مفتاح',
    editor: 'محرر الإشعار',
    name: 'اسم الحملة',
    nameLead: 'يظهر في لوحة التحكم فقط.',
    title: 'العنوان',
    body: 'النص',
    counter: '{{n}} / {{max}} حرفًا',
    url: 'الصفحة التي ستُفتح',
    urlLead:
      'مسار داخل المتجر (مثل /kategori/kedi). يُفتح عند النقر على الإشعار؛ وتُضاف معاملات UTM لتقرير المصادر.',
    audience: 'الجمهور',
    audienceLead:
      'دون اختيار شرائح يُرسل إلى جميع مشتركي المتجر. ومع اختيار شرائح يُرسل فقط إلى متصفحات الأعضاء في تلك الشرائح (الذين سجّلوا الدخول عند الاشتراك).',
    estimate: 'احتساب عدد المتصفحات',
    estimateResult: 'سيصل إلى {{eligible}} من أصل {{total}} اشتراكًا.',
    anonymousExcluded: '{{count}} متصفحًا اشتركت دون تسجيل الدخول لا تدخل ضمن جمهور الشرائح.',
    estimateNote: 'هذا تقدير: تُستبعد الاشتراكات المنتهية عند الإرسال.',
    preview: 'معاينة',
    previewTitle: 'العنوان',
    previewBody: 'نص الإشعار',
    previewNote: 'يختلف المظهر حسب المتصفح ونظام التشغيل؛ وقد يُختصر النص الطويل.',
    findingsNote:
      'يتضمن النص {{count}} ادعاءً صحيًا محتملًا: تلزم موافقة المختص بعد الحفظ. لا تُستخدم ادعاءات الوقاية من الأمراض أو علاجها.',
    send: 'إرسال…',
    reviewRequired: 'النص بانتظار موافقة المختص؛ ولا يمكن إرساله قبل الموافقة.',
    sendTitle: 'إرسال حملة الإشعارات',
    sendLead: 'يصل الإشعار إلى متصفحات أشخاص حقيقيين ولا يمكن التراجع عنه. يتطلب الإرسال التحقق بخطوتين.',
    sendConfirm: 'إرسال إلى {{count}} متصفحًا',
    scheduleConfirm: 'جدولة',
    sendSetupWarning: 'إشعارات واجهة المتجر غير مُعدّة (يتطلب الإعداد)؛ سيُرفض الإرسال.',
    scheduledToast: 'تمت جدولة الحملة.',
    queuedToast: 'أُضيفت الحملة إلى قائمة انتظار الإرسال.',
    statusTitle: 'حالة الإرسال',
    statusLabel: 'الحالة',
    progressLabel: 'تقدّم الإرسال',
    progress:
      'تمت معالجة {{done}} / {{total}}: أُرسل {{sent}}، وانتهى {{expired}} اشتراكًا، وفشل {{failed}}.',
    pauseReasons: {
      template_review_required: 'متوقفة مؤقتًا: النص بانتظار موافقة المختص.',
      web_push_not_configured: 'متوقفة مؤقتًا: عُطّلت إشعارات واجهة المتجر أو حُذف المفتاح.',
      push_auth_failed:
        'متوقفة مؤقتًا: رفضت خدمة الإشعارات المفتاح. تحقّق من عنوان الاتصال؛ وقد يلزم استبدال المفتاح.',
    },
    pauseReasonOther: 'متوقفة مؤقتًا ({{code}}).',
    resume: 'استئناف',
    cancelConfirm: 'هل تريد إيقاف الإرسال؟ لن تتلقى المتصفحات التي لم يُرسل إليها بعد أي إشعار.',
    cancel: 'إيقاف',
    reportTitle: 'التقرير',
    reportLead: 'لا يُقاس ما إذا كان الإشعار قد ظهر؛ تُحتسب فقط عمليات الإرسال التي قبلتها الخدمة.',
    purged: 'حُذفت سجلات المستلمين بعد انتهاء مدة الاحتفاظ (180 يومًا)؛ ويُحتفظ بالإجماليات.',
    stats: {
      recipients: 'المستلمون',
      sent: 'المُرسلة',
      expired: 'الاشتراكات المنتهية',
      failed: 'الفاشلة',
      skipped: 'المتخطّاة',
    },
    errorsTitle: 'الأسباب',
    sendErrors: {
      push_404: 'الاشتراك غير موجود (أُزيل): {{count}}',
      push_410: 'انتهى الاشتراك (أُزيل): {{count}}',
      push_403: 'اشتراك أُنشئ بمفتاح آخر (أُزيل): {{count}}',
      push_too_large: 'الإشعار كبير جدًا: {{count}}',
      push_unavailable: 'تعذّر الوصول إلى خدمة الإشعارات بعد عدة محاولات: {{count}}',
      interrupted: 'انقطع الإرسال (لن يُعاد الإرسال): {{count}}',
    },
    serviceError: 'استجابة خدمة الإشعارات {{code}}: {{count}}',
    ordersNote:
      'طلبات الزوار الذين وصلوا عبر رابط الإشعار ووافقوا على ملفات تعريف الارتباط (آخر نقطة تفاعل).',
    dangerZone: 'الحذف',
    deleteConfirm: 'هل تريد حذف الحملة «{{name}}»؟',
    updated: 'آخر تغيير: {{date}}',
  },
  notifications: {
    title: 'إشعارات الجوال (Android)',
    lead: 'إشعارات في تطبيق الإدارة على Android لأحداث مثل الطلبات الجديدة وطلبات الإرجاع. تصلك فقط الأحداث التي لديك صلاحية عليها؛ ولا تتضمن الإشعارات بيانات شخصية.',
    firebaseMissing:
      'Firebase غير متصل لدى المنشأة؛ لن تُرسل أي إشعارات حتى يتم ربطه (التكاملات ← Firebase).',
    devices: 'أجهزتي',
    noDevices:
      'لا توجد أجهزة مسجّلة لهذا الحساب. يظهر الجهاز هنا بعد تفعيل الإشعارات في تطبيق الإدارة على Android.',
    unnamed: 'جهاز بلا اسم',
    deviceLine: 'إصدار التطبيق {{version}} · آخر ظهور {{seen}}',
    remove: 'إزالة',
    removeConfirm: 'هل تريد إزالة هذا الجهاز؟ يمكنه التسجيل مجددًا عند فتح التطبيق.',
    removed: 'تمت إزالة الجهاز.',
    events: 'الأحداث التي تصلني إشعارات بها',
    eventNames: {
      order_created: 'طلب جديد',
      payment_review_required: 'الدفع يحتاج إلى مراجعة',
      return_requested: 'طلب إرجاع جديد',
      dealer_applied: 'طلب انضمام موزّع جديد',
      form_submitted: 'رسالة تواصل جديدة',
      dealer_balance_paid: 'تم استلام دفعة موزّع',
    },
    noPermission: '(لا توجد صلاحية)',
    quietHours: 'ساعات الهدوء (لا إشعارات خلال هذه الفترة)',
    save: 'حفظ التفضيلات',
    saved: 'تم حفظ تفضيلات الإشعارات.',
    test: 'إرسال إشعار تجريبي',
    testSent: 'أُرسل إشعار تجريبي إلى {{count}} جهازًا.',
  },
  promotions: {
    create: 'عرض جديد',
    lead: 'خصومات دون رمز خصم: خصم على منتج/فئة/علامة تجارية، أو شرائح حسب قيمة السلة أو عدد القطع، أو اشترِ X وادفع Y، أو شحن مجاني. يُطبَّق الخصم في سلة التسوق؛ ولا يُعرض سعر مشطوب على المنتجات. لا يحصل على الخصم المنتج الذي رُفع سعره خلال الأيام العشرة السابقة للعرض.',
    emptyTitle: 'لا توجد عروض تلقائية بعد',
    emptyLead: 'أنشئ مسودة عبر «عرض جديد»؛ لن يرى العملاء شيئًا حتى تنشره.',
    listLabel: 'العروض التلقائية',
    colName: 'العرض',
    colKind: 'النوع',
    colStatus: 'الحالة',
    colUsage: 'الاستخدام',
    colDates: 'التواريخ',
    kinds: {
      item_discount: 'خصم على المنتج (نسبة مئوية)',
      cart_tiers: 'شرائح السلة',
      buy_x_pay_y: 'اشترِ X وادفع Y',
      free_shipping: 'شحن مجاني',
    },
    kindLeads: {
      item_discount:
        'خصم بنسبة مئوية على المنتجات المختارة (أو جميعها) في السلة. يُطبَّق خصم منتج واحد على الأكثر على كل منتج.',
      cart_tiers:
        'خصم عند تجاوز قيمة السلة أو عدد القطع حدًّا معينًا؛ وتُطبَّق أعلى شريحة مستحقة. يُحتسب على المبلغ المتبقي بعد خصومات المنتجات.',
      buy_x_pay_y: 'مع كل X قطعة تكون (X − Y) الأقل سعرًا مجانية. يمكن الجمع بين المنتجات المختارة.',
      free_shipping:
        'لا رسوم شحن فوق الحد (تظل رسوم الدفع عند الاستلام مطبّقة). يُحتسب على المبلغ بعد الخصم.',
    },
    phases: {
      draft: 'مسودة',
      scheduled: 'بانتظار البدء',
      running: 'منشور',
      paused: 'متوقف مؤقتًا',
      ended: 'انتهى',
    },
    usageShort: '{{orders}} طلبًا · {{discount}}',
    noDates: 'بلا نهاية',
    saved: 'تم حفظ العرض.',
    activated: 'تم نشر العرض.',
    paused: 'تم إيقاف العرض مؤقتًا.',
    deleted: 'تم حذف المسودة.',
    save: 'حفظ',
    createConfirm: 'إنشاء المسودة',
    activate: 'نشر',
    pause: 'إيقاف مؤقت',
    back: 'العودة إلى العروض التلقائية',
    unsaved: 'تغييرات غير محفوظة',
    liveLocked: 'لا يمكن تعديل عرض منشور؛ أوقفه مؤقتًا أولًا.',
    reviewRequired: 'قد يتضمن اسم العرض ادعاءً صحيًا: لا يمكن نشره دون موافقة المراجع البيطري المختص.',
    editor: 'إعدادات العرض',
    name: 'اسم العرض',
    nameLead: 'يظهر في لوحة التحكم فقط.',
    label: 'الاسم الظاهر للعملاء',
    labelLead: 'يظهر في سلة التسوق وعند إتمام الطلب وفي صفحات المنتجات ({{n}}/{{max}}).',
    kind: 'نوع العرض',
    percent: 'نسبة الخصم',
    buy: 'اشترِ (قطع)',
    pay: 'ادفع (قطع)',
    minSubtotal: 'الحد الأدنى لقيمة السلة',
    minSubtotalLead: 'اتركه فارغًا ليكون الشحن مجانيًا في كل طلب.',
    basis: 'نوع الحد',
    bases: {
      subtotal: 'قيمة السلة',
      quantity: 'عدد القطع',
    },
    tierType: 'نوع الخصم',
    tiers: 'الشرائح',
    tierMinAmount: 'الحد الأدنى للمبلغ',
    tierMinQty: 'الحد الأدنى للقطع',
    removeTier: 'إزالة الشريحة {{n}}',
    addTier: 'إضافة شريحة',
    currency: 'العملة',
    targets: 'المنتجات المستهدفة',
    targetsLead:
      'إذا لم يُحدَّد شيء فتشمل جميع المنتجات. يُدرج المنتج الذي يطابق أيًّا من الاختيارات؛ وتُشمل الفئات الفرعية.',
    categories: 'الفئات',
    brands: 'العلامات التجارية',
    collections: 'المجموعات',
    noCollections: 'لا توجد مجموعات.',
    products: 'المنتجات',
    audienceTitle: 'الجمهور',
    audience: 'لمن',
    audiences: {
      all: 'الجميع',
      retail: 'عملاء التجزئة فقط',
      dealers: 'الموزّعون فقط',
    },
    groups: 'مجموعات العملاء (اختياري)',
    segments: 'الشرائح (اختياري؛ للأعضاء المسجّلين دخولهم فقط)',
    noSegments: 'لا توجد شرائح.',
    rulesTitle: 'الأولوية والدمج والتواريخ',
    priority: 'الأولوية',
    stacking: 'الدمج',
    stackings: {
      combinable: 'يمكن دمجه مع عروض أخرى',
      exclusive: 'حصري (لا يُطبَّق أي عرض آخر)',
    },
    allowCoupon: 'يمكن استخدامه مع رمز خصم',
    startsAt: 'البداية',
    endsAt: 'النهاية',
    preview: 'ما يراه العملاء',
    previewLabel: 'الاسم الظاهر للعملاء',
    previewNote: 'تعرض صفحات المنتجات الاسم والشرط وتاريخ الانتهاء؛ ولا يُعرض سعر مشطوب.',
    excludedTitle: 'منتجات بلا خصم (زيادة في السعر)',
    excludedLead:
      'المنتجات التي رُفع سعرها خلال {{days}} يومًا قبل بدء العرض أو أثناءه لا تحصل على خصم من هذا العرض ولا يظهر العرض في صفحتها (قاعدة البيع بالتخفيض). في المسودة يُحتسب ذلك كما لو نُشر العرض الآن.',
    excludedNone: 'لا توجد زيادات في الأسعار؛ جميع المنتجات المستهدفة مشمولة.',
    excludedCount: '{{count}} من خيارات المنتجات مستبعدة من العرض.',
    colProduct: 'المنتج',
    colPriceList: 'قائمة الأسعار',
    colCurrent: 'السعر الحالي',
    colLowest: 'أدنى سعر خلال الفترة',
    usageTitle: 'الاستخدام',
    usageNone: 'لا توجد طلبات بهذا العرض بعد.',
    usageLine: '{{orders}} طلبًا · إجمالي الخصم {{discount}} · إجمالي الطلبات {{revenue}}',
    dangerZone: 'حذف المسودة',
    deleteConfirm: 'هل تريد حذف المسودة «{{name}}»؟',
    updated: 'آخر تغيير: {{date}}',
  },
  giftCards: {
    lead: 'بطاقة الهدية دفعة مسبقة تُنفق بإدخال رمزها عند إتمام الطلب. يُعرض الرمز مرة واحدة فقط عند الإنشاء؛ ولا يُحفظ منه إلا آخر أربعة أحرف. يبقى الرصيد المتبقي في البطاقة المستخدمة جزئيًا لاستخدامه لاحقًا.',
    create: 'إنشاء بطاقة هدية',
    search: 'آخر أربعة أحرف',
    searchPlaceholder: 'مثال: 7KQ2',
    searchInvalid: 'أدخل حتى أربعة أحرف أو أرقام.',
    stateFilter: 'الحالة',
    states: {
      active: 'قابلة للاستخدام',
      disabled: 'معطّلة',
      expired: 'منتهية الصلاحية',
      empty: 'لا رصيد',
    },
    emptyTitle: 'لا توجد بطاقات هدايا بعد',
    emptyLead:
      'استخدم «إنشاء بطاقة هدية» لاختيار مبلغ وتاريخ انتهاء اختياري؛ وتتولى أنت إيصال الرمز إلى العميل.',
    noMatch: 'لا توجد بطاقات تطابق عوامل التصفية هذه',
    listLabel: 'بطاقات الهدايا',
    colCard: 'البطاقة',
    colState: 'الحالة',
    colBalance: 'الرصيد',
    colExpires: 'تنتهي في',
    colCreated: 'تاريخ الإنشاء',
    cardTitle: 'البطاقة ···· {{last4}}',
    ofInitial: 'المبلغ الأولي {{amount}}',
    noExpiry: 'بلا انتهاء',
    createTitle: 'إنشاء بطاقة هدية',
    createLead: 'يُعرض الرمز مرة واحدة فقط. تتولى أنت إيصاله إلى العميل؛ ولا يُرسل أي بريد إلكتروني.',
    createForCustomer: 'تُسجَّل البطاقة باسم {{name}}. يُعرض الرمز مرة واحدة فقط؛ وتتولى أنت إيصاله.',
    createButton: 'إنشاء',
    amount: 'المبلغ',
    amountInvalid: 'أدخل المبلغ بصيغة مثل 250 أو 250.50.',
    currency: 'العملة',
    expiresAt: 'تاريخ الانتهاء',
    expiresHint: 'صالحة حتى نهاية اليوم المختار. اتركه فارغًا لتكون بلا انتهاء.',
    note: 'ملاحظة داخلية',
    noteHint: 'تظهر في لوحة التحكم فقط (مثل «هدية عيد ميلاد»).',
    createdTitle: 'تم إنشاء بطاقة الهدية',
    createdLead: 'رمز البطاقة بقيمة {{amount}} أدناه.',
    code: 'الرمز',
    copy: 'نسخ الرمز',
    copied: 'تم نسخ الرمز',
    copyFailed: 'تعذّر النسخ؛ حدّد الرمز وانسخه يدويًا.',
    codeOnce:
      'لن يُعرض هذا الرمز مرة أخرى. انسخه قبل الإغلاق وأوصله إلى العميل بأمان. إذا فُقد الرمز فعطّل البطاقة وأنشئ بطاقة جديدة.',
    openCard: 'فتح البطاقة',
    savedCode: 'لقد حفظت الرمز',
    backToList: 'بطاقات الهدايا',
    summary: 'البطاقة',
    balance: 'الرصيد',
    initial: 'المبلغ الأولي',
    customer: 'العميل',
    created: 'تاريخ الإنشاء',
    adjust: 'تعديل الرصيد',
    disable: 'تعطيل البطاقة',
    enable: 'إعادة تفعيل البطاقة',
    disableConfirm:
      'ستُعطَّل البطاقة ولن يمكن إنفاق رصيدها. لا تتأثر المبالغ المستخدمة في الطلبات السابقة. هل تريد المتابعة؟',
    enableConfirm: 'ستصبح البطاقة قابلة للاستخدام مجددًا. هل تريد المتابعة؟',
    settings: 'تاريخ الانتهاء والملاحظة',
    history: 'الحركات',
    noHistory: 'لا توجد حركات.',
    colDate: 'التاريخ',
    colKind: 'النوع',
    colAmount: 'المبلغ',
    colAfter: 'الرصيد بعدها',
    kinds: {
      issue: 'أُنشئت',
      redeem: 'استُخدمت في طلب',
      release: 'أُلغي الطلب، واستُعيد الرصيد',
      refund: 'استرداد، واستُعيد الرصيد',
      adjust: 'تعديل يدوي',
    },
    adjustTitle: 'تعديل رصيد البطاقة ···· {{last4}}',
    adjustLead: 'الرصيد الحالي {{balance}}. يُسجَّل التعديل وسببه في الحركات وفي سجل التدقيق.',
    direction: 'الإجراء',
    directionAdd: 'إضافة رصيد',
    directionSubtract: 'خصم من الرصيد',
    adjustAmount: 'المبلغ ({{currency}})',
    adjustNote: 'السبب',
    adjustNoteHint: '3 أحرف على الأقل، مثل «تصحيح شحن رصيد خاطئ».',
    adjustAdd: 'إضافة',
    adjustSubtract: 'خصم',
    adjusted: 'تم تحديث الرصيد',
  },
  storeCredit: {
    title: 'رصيد المتجر',
    lead: 'يُنفق الرصيد الموجود في حساب العميل عند إتمام الطلب عبر «استخدام رصيد المتجر». ويأتي من استرداد المبالغ (بموافقة العميل) أو يُضاف يدويًا.',
    adjust: 'إضافة / خصم رصيد',
    issueGiftCard: 'إصدار بطاقة هدية',
    none: 'لا يوجد رصيد.',
    history: 'حركات الرصيد',
    giftCards: 'بطاقات الهدايا الصادرة لهذا العميل',
    kinds: {
      grant: 'أُضيف',
      refund: 'استرداد المبلغ',
      redeem: 'استُخدم في طلب',
      release: 'أُلغي الطلب، واستُعيد الرصيد',
      adjust: 'خُصم',
    },
    adjustTitle: 'إضافة / خصم رصيد المتجر',
    adjustLead: 'يُسجَّل السبب في الحركات وفي سجل التدقيق؛ ولا يرى العميل في حسابه سوى المبلغ ونوع العملية.',
  },
  loyalty: {
    lead: 'يكسب الأعضاء نقاطًا من الطلبات المُسلَّمة ويدفعون بالنقاط عند إتمام الطلب؛ ويحصلون على مستوى VIP بحسب مشترياتهم في آخر 12 شهرًا (خصم المستوى وشحن مجاني). عندما يكون البرنامج معطّلًا لا يُطبَّق شيء على العملاء؛ وتبقى النقاط محفوظة.',
    summary: 'ملخص البرنامج',
    on: 'مفعّل',
    off: 'معطّل',
    members: 'أعضاء لديهم نقاط',
    outstanding: 'النقاط غير المستخدمة (قيمتها)',
    earned30: 'المكتسبة، آخر 30 يومًا',
    redeemed30: 'المستخدمة، آخر 30 يومًا',
    expired30: 'المنتهية، آخر 30 يومًا',
    tierCounts: 'الأعضاء حسب المستوى: {{list}}',
    settings: 'إعدادات البرنامج',
    settingsLead: 'تسري التغييرات على سلال التسوق وإتمام الطلب فور حفظها. ولا تتغير الطلبات القائمة.',
    enabled: 'برنامج الولاء مفعّل',
    currency: 'العملة',
    earn: 'النقاط المكتسبة لكل وحدة واحدة',
    value: 'النقاط اللازمة لخصم وحدة واحدة',
    preview:
      'يكسب العملاء {{earn}} نقطة مقابل كل {{one}}؛ و{{value}} نقطة = {{one}}. نسبة الاسترجاع: {{percent}}.',
    previewNoEarn: 'كسب النقاط معطّل: تُطبَّق المستويات فقط.',
    minRedeem: 'الحد الأدنى من النقاط للاستخدام',
    holdDays: 'مدة الانتظار بعد التسليم (أيام)',
    expiryMonths: 'صلاحية النقاط (أشهر)',
    expiryHint: '0 = لا تنتهي صلاحية النقاط أبدًا.',
    tiers: 'مستويات VIP',
    tiersLead:
      'يُعاد احتساب المستوى مع كل طلب بناءً على صافي مشتريات العميل في آخر 12 شهرًا (بعد خصم المبالغ المستردة). حتى 5 مستويات.',
    tierName: 'اسم المستوى',
    tierSpend: 'آخر 12 شهرًا على الأقل ({{currency}})',
    tierDiscount: 'الخصم (%)',
    tierShipping: 'شحن مجاني',
    tierAdd: 'إضافة مستوى',
    tierRemove: 'إزالة المستوى {{name}}',
    fixErrors: 'لم يتم الحفظ: صحّح الحقول المُعلَّمة.',
    save: 'حفظ',
    saved: 'تم حفظ برنامج الولاء',
    enableConfirm:
      'عند تفعيل البرنامج تُطبَّق خصومات المستويات فورًا على سلال الأعضاء، وتبدأ الطلبات المُسلَّمة في كسب النقاط. لا تُرسل أي رسائل إلى العملاء. هل تريد المتابعة؟',
    customerTitle: 'الولاء',
    adjust: 'إضافة / خصم نقاط',
    points: '{{points}} نقطة',
    expiringSoon: 'تنتهي صلاحية {{points}} نقطة خلال 30 يومًا.',
    customerTier: 'المستوى: {{tier}}',
    customerNoTier: 'بلا مستوى',
    spend12: 'آخر 12 شهرًا {{amount}}',
    nextTier: 'يتبقى {{amount}} للوصول إلى {{tier}}',
    history: 'سجل النقاط',
    colDate: 'التاريخ',
    colKind: 'النوع',
    colPoints: 'النقاط',
    colExpires: 'تنتهي في',
    kinds: {
      earn: 'مكتسبة',
      redeem: 'استُخدمت في طلب',
      release: 'استُعيدت',
      reverse: 'سُحبت (استرداد)',
      expire: 'انتهت صلاحيتها',
      adjust: 'تعديل يدوي',
    },
    adjustTitle: 'إضافة / خصم نقاط',
    adjustLead: 'الرصيد الحالي {{points}} نقطة. يُسجَّل السبب في السجل وفي سجل التدقيق؛ ولا يراه العميل.',
    direction: 'الإجراء',
    directionAdd: 'إضافة نقاط',
    directionSubtract: 'خصم نقاط',
    pointsField: 'النقاط',
    pointsInvalid: 'أدخل عددًا صحيحًا موجبًا.',
    adjustAdd: 'إضافة',
    adjustSubtract: 'خصم',
    adjusted: 'تم تحديث النقاط',
  },
  referrals: {
    lead: 'يحصل العضو على رمز الدعوة من صفحة حسابي ويشاركه مع أصدقائه. يحصل الصديق على خصم في طلبه الأول؛ وبعد تسليم الطلب وانقضاء فترة الانتظار يحصل المُحيل على رمز خصم مكافأة يُستخدم مرة واحدة. لا يراسل المتجر أحدًا. عندما يكون البرنامج معطّلًا لا تعمل رموز الدعوة.',
    summary: 'ملخص البرنامج',
    on: 'مفعّل',
    off: 'معطّل',
    codes: 'أعضاء لديهم رمز دعوة',
    pending: 'دعوات معلّقة',
    rewarded: 'دعوات مُنحت عنها مكافأة',
    cancelled: 'أُغلقت دون مكافأة',
    rewardCoupons: 'رموز خصم المكافأة (الصادرة / المستخدمة)',
    rewardCouponsValue: '{{issued}} / {{used}}',
    settings: 'إعدادات البرنامج',
    settingsLead:
      'عند الحفظ تُحدَّث جميع رموز الدعوة بالخصم الجديد. ولا تتغير رموز خصم المكافأة الصادرة سابقًا.',
    enabled: 'برنامج الإحالة مفعّل',
    currency: 'العملة',
    friend: 'خصم الصديق (الطلب الأول)',
    referrer: 'مكافأة المُحيل (رمز خصم)',
    rewardType: 'نوع الخصم',
    typePercent: 'نسبة مئوية',
    typeFixed: 'مبلغ ثابت ({{currency}})',
    valuePercent: 'الخصم (%)',
    valueFixed: 'مبلغ الخصم ({{currency}})',
    minSubtotal: 'الحد الأدنى لإجمالي السلة ({{currency}})',
    minSubtotalHint: 'اتركه فارغًا لعدم وجود حد أدنى.',
    holdDays: 'مدة الانتظار بعد التسليم (أيام)',
    rewardValidDays: 'صلاحية رمز خصم المكافأة (أيام)',
    maxRewards: 'الحد الأقصى للمكافآت لكل عضو',
    fixErrors: 'لم يتم الحفظ: صحّح الحقول المُعلَّمة.',
    save: 'حفظ',
    saved: 'تم حفظ برنامج الإحالة',
    enableConfirm:
      'بعد التفعيل يمكن للأعضاء الحصول على رمز دعوة من صفحة حسابي، وتعمل رموز الدعوة كخصم في سلة التسوق. لا تُرسل أي إشعارات إلى العملاء. هل تريد المتابعة؟',
    recent: 'أحدث الدعوات',
    recentLead:
      'الطلبات التي تمت برمز دعوة. تُمنح المكافآت عبر المهمة التي تعمل كل ساعة بعد انقضاء فترة الانتظار.',
    emptyTitle: 'لا توجد طلبات من دعوات بعد',
    emptyLead: 'عندما يقدّم صديق طلبه الأول برمز دعوة يظهر هنا.',
    colDate: 'التاريخ',
    colReferrer: 'المُحيل',
    colOrder: 'الطلب',
    colStatus: 'الحالة',
    colReward: 'رمز خصم المكافأة',
    statuses: {
      pending: 'بانتظار التسليم',
      rewarded: 'مُنحت المكافأة',
      cancelled: 'أُلغي / أُرجع',
      limit: 'بلغ حدّ المكافآت',
    },
  },
  affiliates: {
    lead: 'تُطابَق طلبات الشركاء التسويقيين والمؤثّرين برمز الخصم أو بقيمة utm_source في الرابط. لا تعمل المطابقة عبر الرابط إلا إذا سمح الزائر بملفات تعريف الارتباط الخاصة بالقياس. تُحتسب العمولة على مبلغ المنتجات دون ضريبة القيمة المضافة والشحن، وتُعتمد بعد 14 يومًا من التسليم. أنت من يدفع: نزّل ملف CSV وادفع، ثم ضع علامة «مدفوع».',
    create: 'إضافة شريك تسويقي',
    emptyTitle: 'لا يوجد شركاء تسويقيون بعد',
    emptyLead: 'أضف شريكًا تسويقيًا لتخصيص رمز خصم أو مصدر رابط خاص به.',
    listLabel: 'الشركاء التسويقيون',
    colName: 'الشريك التسويقي',
    colMatch: 'المطابقة',
    colRate: 'النسبة',
    colPending: 'المعلّقة',
    colApproved: 'المعتمدة',
    colPaid: 'المدفوعة',
    colActions: 'الإجراءات',
    kinds: {
      affiliate: 'شريك تسويقي',
      influencer: 'مؤثّر',
    },
    paused: 'متوقف مؤقتًا',
    coupon: 'رمز الخصم: {{code}}',
    edit: 'تعديل',
    editNamed: 'تعديل {{name}}',
    createTitle: 'إضافة شريك تسويقي',
    editTitle: 'تعديل الشريك التسويقي',
    dialogLead: 'تُطبَّق تغييرات النسبة والحالة على الطلبات المستقبلية فقط؛ ولا تتغير العمولات المسجّلة.',
    name: 'الاسم',
    kind: 'النوع',
    email: 'البريد الإلكتروني',
    emailMasked: 'البريد الإلكتروني مخفي. اكتب بريدًا جديدًا لتغييره.',
    source: 'مصدر الرابط (utm_source)',
    sourceHint: 'أضِف إلى نهاية الرابط: ?utm_source={{source}}',
    rate: 'نسبة العمولة (%)',
    discount: 'رمز الخصم',
    noDiscount: 'بلا رمز خصم (الرابط فقط)',
    status: 'الحالة',
    statuses: {
      active: 'نشط',
      paused: 'متوقف مؤقتًا',
    },
    note: 'ملاحظة داخلية',
    save: 'حفظ',
    created: 'تمت إضافة الشريك التسويقي',
    updated: 'تم تحديث الشريك التسويقي',
    commissions: 'العمولات',
    commissionsLead:
      'تُعتمد العمولة المعلّقة بعد 14 يومًا من التسليم؛ وتُلغى عند الإلغاء أو الاسترداد الكامل، ويُخفَّض أساس الاحتساب عند الاسترداد الجزئي.',
    filterAffiliate: 'الشريك التسويقي',
    filterStatus: 'الحالة',
    export: 'تنزيل CSV',
    markPaid: 'وضع علامة «مدفوع» ({{count}})',
    selectAll: 'تحديد جميع العمولات المعتمدة',
    selectOne: 'تحديد عمولة {{order}}',
    noCommissions: 'لا توجد عمولات',
    noCommissionsLead: 'تظهر الطلبات المطابقة هنا.',
    colOrder: 'الطلب',
    colAffiliate: 'الشريك التسويقي',
    colBase: 'أساس الاحتساب',
    colCommission: 'العمولة',
    colStatus: 'الحالة',
    sources: {
      coupon: 'عبر رمز الخصم',
      link: 'عبر الرابط',
    },
    commissionStatuses: {
      pending: 'معلّقة',
      approved: 'معتمدة',
      paid: 'مدفوعة',
      cancelled: 'ملغاة',
    },
    markPaidTitle: 'وضع علامة «مدفوع» على العمولات',
    markPaidLead:
      '{{count}} عمولة، بإجمالي {{total}}. ضع العلامة فقط إذا كنت قد دفعت خارج النظام؛ لا يمكن التراجع عن ذلك ويُسجَّل في سجل التدقيق.',
    paidNote: 'ملاحظة الدفع',
    paidNoteHint: 'مثل رقم الإيصال وتاريخ الدفع.',
    markPaidConfirm: 'وضع علامة «مدفوع»',
    markedPaid: 'وُضعت علامة «مدفوع» على {{count}} عمولة',
  },
  support: {
    lead: 'يفتح العملاء التذاكر من صفحة حسابي؛ ويمكن أيضًا تحويل رسائل نموذج التواصل إلى تذاكر. يُرسل ردّك على العميل بالبريد الإلكتروني أيضًا؛ ولا يرى الملاحظات الداخلية إلا الفريق. يمكن للعملاء تقييم التذاكر المحلولة من 1 إلى 5.',
    countsLabel: 'أعداد التذاكر',
    countOpen: 'بانتظار الرد: {{count}}',
    countWaiting: 'بانتظار العميل: {{count}}',
    countUnassigned: 'غير مُسندة: {{count}}',
    listTitle: 'التذاكر',
    filterStatus: 'الحالة',
    filterActive: 'مفتوحة وبالانتظار',
    filterAssigned: 'المُسند إليه',
    assignedMe: 'المُسندة إليّ',
    unassigned: 'غير مُسندة',
    filterPriority: 'الأولوية',
    search: 'بحث',
    searchPlaceholder: 'رقم التذكرة أو البريد الإلكتروني أو الموضوع',
    emptyTitle: 'لا توجد تذاكر',
    emptyLead: 'تظهر هنا التذاكر التي يفتحها العملاء من حسابي ← تذاكر الدعم.',
    colTicket: 'التذكرة',
    colCustomer: 'العميل',
    colStatus: 'الحالة',
    colAssignee: 'المُسند إليه',
    colLast: 'آخر نشاط',
    pageOf: 'الصفحة {{page}} من {{pages}}',
    statuses: {
      open: 'بانتظار الرد',
      waiting: 'بانتظار العميل',
      resolved: 'تم الحل',
      closed: 'مغلقة',
    },
    priorities: {
      low: 'منخفضة',
      normal: 'عادية',
      high: 'مرتفعة',
      urgent: 'عاجلة',
    },
    categories: {
      order: 'الطلب',
      shipping: 'الشحن والتسليم',
      return: 'الإرجاع والاستبدال',
      payment: 'الدفع والفاتورة',
      product: 'معلومات المنتج',
      account: 'الحساب',
      other: 'أخرى',
    },
    channels: {
      account: 'حسابي',
      contact_form: 'نموذج التواصل',
      panel: 'لوحة التحكم',
      chat: 'الدردشة المباشرة',
    },
    kinds: {
      customer: 'العميل',
      staff: 'رد',
      note: 'ملاحظة داخلية',
    },
    durationDays: '{{d}} يوم {{h}} ساعة',
    durationHours: '{{h}} ساعة {{m}} دقيقة',
    durationMinutes: '{{m}} دقيقة',
    report: 'تقرير الدعم والرضا',
    reportLead:
      'التذاكر المفتوحة والمحلولة خلال الفترة، ومدة الرد الأول (الوسيط)، ودرجات الرضا والمواضيع. تظهر أسباب الإرجاع إذا كانت لديك صلاحية عرض الطلبات.',
    period: 'الفترة',
    lastDays: 'آخر {{days}} يومًا',
    statCreated: 'المفتوحة',
    statResolved: 'المحلولة',
    statOpen: 'مفتوحة الآن',
    statFirstResponse: 'الرد الأول (الوسيط)',
    statSatisfaction: 'الرضا',
    satisfactionValue: '{{avg}} / 5 ({{count}} تقييمًا)',
    distribution: 'توزيع الدرجات',
    score: '{{score}} درجات',
    byCategory: 'التذاكر حسب الموضوع',
    noData: 'لا توجد سجلات في هذه الفترة.',
    returnReasons: 'أسباب الإرجاع',
    returnTotal: '{{count}} طلب إرجاع',
    colReason: 'السبب',
    colRequests: 'الطلبات',
    colApproved: 'المعتمدة',
    topReturned: 'المنتجات الأكثر إرجاعًا',
    units: '{{count}} قطعة',
    macros: 'الردود الجاهزة',
    macrosLead: 'احفظ الردود المتكررة؛ ويمكنك اختيارها وتعديلها أثناء الرد. يُستبدل {{name}} باسم العميل.',
    macrosEmpty: 'لا توجد ردود جاهزة',
    macrosEmptyLead: 'أضف مثلًا ردًا بشأن تأخر الشحن أو إجراءات الإرجاع.',
    macroAdd: 'إضافة رد جاهز',
    macroEdit: 'تعديل الرد الجاهز',
    macroEditNamed: 'تعديل الرد الجاهز {{name}}',
    macroDeleteNamed: 'حذف الرد الجاهز {{name}}',
    macroDeleteConfirm: 'هل تريد حذف الرد الجاهز «{{name}}»؟',
    macroDeleted: 'تم حذف الرد الجاهز',
    macroSaved: 'تم حفظ الرد الجاهز',
    macroDialogLead: 'يُستبدل {{name}} في النص باسم العميل عند الإدراج.',
    macroTitle: 'الاسم',
    macroBody: 'نص الرد',
    macroBodyHint: 'لا تكتب بيانات شخصية (الطلب، العنوان)؛ أضِفها في كل رد على حدة.',
    ticketTitle: 'التذكرة #{{number}}: {{subject}}',
    backToList: 'العودة إلى التذاكر',
    details: 'تفاصيل التذكرة',
    customer: 'العميل',
    guest: 'زائر',
    order: 'الطلب',
    channel: 'المصدر',
    opened: 'تاريخ الفتح',
    firstResponse: 'مدة الرد الأول',
    noResponseYet: 'لم يُرد بعد',
    satisfaction: 'الرضا',
    ratingValue: '{{rating}} / 5',
    status: 'الحالة',
    priority: 'الأولوية',
    category: 'الموضوع',
    assignee: 'الموظف المُسند إليه',
    notifyResolved: 'إرسال بريد إلكتروني إلى العميل بأن التذكرة قد حُلّت (مع رابط التقييم)',
    saveDetails: 'حفظ التغييرات',
    savedEmailed: 'تم الحفظ؛ وأُرسل بريد إلكتروني إلى العميل',
    savedNotEmailed: 'تم الحفظ؛ ولم يُرسل بريد إلكتروني لأن البريد الإلكتروني غير مُعدّ (يتطلب الإعداد)',
    conversation: 'المراسلات',
    emailed: 'أُرسل بالبريد الإلكتروني',
    notEmailed: 'لم يُرسل بالبريد الإلكتروني',
    closedHint:
      'التذكرة مغلقة: لا يمكنك الرد على العميل، بل إضافة ملاحظات داخلية فقط. غيّر الحالة للرد مجددًا.',
    insertMacro: 'إدراج رد جاهز',
    chooseMacro: 'اختر…',
    replyLabel: 'رد أو ملاحظة داخلية',
    noteLabel: 'ملاحظة داخلية',
    replyHint:
      'يظهر الرد في صفحة تذكرة العميل ويُرسل بالبريد الإلكتروني أيضًا. وتبقى الملاحظات الداخلية ضمن الفريق.',
    sendReply: 'إرسال الرد',
    sendAndResolve: 'إرسال ووضع علامة «تم الحل»',
    addNote: 'إضافة ملاحظة داخلية',
    noteSaved: 'تمت إضافة الملاحظة الداخلية',
    replySent: 'تم إرسال الرد؛ وأُرسل بريد إلكتروني إلى العميل',
    replySavedNotEmailed:
      'تم حفظ الرد؛ وسيراه العميل في صفحة التذكرة. لم يُرسل بريد إلكتروني لأن البريد الإلكتروني غير مُعدّ (يتطلب الإعداد).',
    convertTitle: 'تحويل إلى تذكرة دعم',
    convertLead:
      'تصبح الرسالة أول رسالة من العميل في التذكرة، وتُعلَّم بأنها «عولجت». ويُرسل رابط التذكرة إلى العميل بالبريد الإلكتروني مع ردّك الأول.',
    subject: 'موضوع التذكرة',
    convert: 'تحويل إلى تذكرة',
    converted: 'تم إنشاء التذكرة #{{number}}',
  },
  chat: {
    lead: 'المحادثات الواردة من نافذة «الدعم المباشر» في واجهة المتجر. لا يستطيع الزائر بدء محادثة إلا إذا كان موظف واحد على الأقل «متاحًا للمحادثة»؛ وإلا تتحول النافذة إلى نموذج رسالة (تذكرة دعم). تُحدَّث الشاشة كل 5 ثوانٍ.',
    disabledNotice: 'الدردشة المباشرة معطّلة: لا تظهر النافذة في واجهة المتجر. فعّلها من الإعدادات أدناه.',
    workspace: 'المحادثات',
    available: 'متاح للمحادثة',
    onlineAgents: 'الموظفون المتاحون الآن: {{count}}',
    waiting: 'بالانتظار',
    active: 'جارية',
    closedRecent: 'أُغلقت خلال آخر 24 ساعة',
    noWaiting: 'لا توجد محادثات بالانتظار.',
    noActive: 'لا توجد محادثات جارية.',
    noClosed: 'لا توجد محادثات مغلقة.',
    anonymous: 'زائر مجهول',
    visitor: 'الزائر',
    with: 'مع {{name}}',
    pickTitle: 'اختر محادثة',
    pickLead: 'اختر محادثة من القائمة؛ ويمكنك تولّي محادثة بالانتظار والرد عليها.',
    statuses: {
      waiting: 'بالانتظار',
      active: 'جارية',
      closed: 'مغلقة',
    },
    noEmail: 'لم يُذكر بريد إلكتروني',
    customerCard: 'بطاقة العميل',
    messages: 'رسائل المحادثة',
    events: {
      joined: 'انضم موظف إلى المحادثة',
      closed_visitor: 'أنهى الزائر المحادثة',
      closed_staff: 'أغلق الموظف المحادثة',
      closed_idle: 'أُغلقت بسبب عدم النشاط',
      ticket: 'حُوّلت إلى تذكرة دعم',
    },
    openTicket: 'فتح تذكرة الدعم',
    claim: 'تولّي المحادثة',
    reply: 'ردّك',
    replyHint: 'Enter للإرسال، وShift+Enter لسطر جديد. يرى الزائر «فريق الدعم» وليس اسمك.',
    send: 'إرسال',
    close: 'إغلاق المحادثة',
    closeConfirm: 'هل تريد إغلاق المحادثة؟ يمكن للزائر بدء محادثة جديدة.',
    closedToast: 'تم إغلاق المحادثة',
    convert: 'تحويل إلى تذكرة',
    convertNeedsEmail: 'تعذّر التحويل: لم يذكر الزائر بريدًا إلكترونيًا.',
    convertTitle: 'تحويل المحادثة إلى تذكرة دعم',
    convertLead:
      'تصبح رسائل الزائر رسائل العميل، ورسائل الفريق ردودًا؛ وتُغلق المحادثة. تُرسل الردود التي تكتبها في التذكرة إلى العميل بالبريد الإلكتروني.',
    settings: 'إعدادات المحادثة',
    settingsLead: 'المحادثة معطّلة افتراضيًا. لتفعيلها يجب أن يكون إشعار الخصوصية منشورًا.',
    enabled: 'نافذة الدعم المباشر في واجهة المتجر',
    needsNotice: 'لا يمكن تفعيل المحادثة قبل نشر إشعار الخصوصية (النصوص القانونية).',
    retentionDays: 'مدة الاحتفاظ بالمحادثات المغلقة (أيام)',
    idleMinutes: 'إغلاق المحادثة غير النشطة بعد (دقائق)',
    saveSettings: 'حفظ الإعدادات',
    settingsSaved: 'تم حفظ إعدادات المحادثة',
  },
  ads: {
    sourcesTitle: 'الحسابات الإعلانية والبيانات',
    sourcesLead:
      'تُقرأ بيانات الإنفاق كل صباح من اتصالات Meta وTikTok، أو ترفع التقرير (CSV/XLSX) الذي نزّلته من المنصة. وتُحتسب الإيرادات دائمًا من الطلبات الفعلية للمتجر.',
    connections: 'اتصالات الإعلانات',
    connected: 'متصل',
    connectionError: 'خطأ في الاتصال',
    setupRequired: 'يتطلب الإعداد',
    manageConnections: 'إدارة الاتصالات',
    googleNote:
      'لجلب إنفاق Google Ads عبر API كل صباح، اربط حساب Google بصلاحية «Google Ads» في صفحة اتصالات Google، واختر حساب العميل الخاص بالمتجر (لا يلزم رمز مطوّر). وحتى ذلك الحين يمكنك رفع تقرير Google Ads كملف.',
    googleNoteLink: 'اتصالات Google',
    syncNow: 'مزامنة الآن',
    synced: 'تمت المزامنة: قُرئ {{rows}} صفًا.',
    syncFailed: 'تعذّر إكمال المزامنة: {{error}}',
    addAccount: 'إضافة حساب',
    addAccountLead: 'حساب إعلاني ترفع بياناته كملف. تُضاف حسابات Meta وTikTok تلقائيًا بعد الربط.',
    editAccount: 'تعديل الحساب',
    editAccountFor: 'تعديل الحساب {{name}}',
    accountSaved: 'تم حفظ الحساب.',
    noAccounts: 'لا توجد حسابات إعلانية بعد',
    noAccountsLead: 'اربط Meta أو TikTok، أو أضف حسابًا لرفع تقارير Google Ads والمنصات الأخرى.',
    accountsTable: 'الحسابات الإعلانية',
    account: 'الحساب',
    accountName: 'اسم الحساب',
    platform: 'المنصة',
    externalId: 'معرّف الحساب على المنصة',
    currency: 'العملة',
    utmSources: 'المصادر المطابقة (utm_source)',
    utmDefault: 'إذا تُرك فارغًا تُستخدم القيم المعتادة للمنصة (مثل facebook وinstagram لـ Meta).',
    noUtm: 'لا توجد مصادر محددة',
    accountStatus: 'الحالة',
    active: 'نشط',
    archived: 'مؤرشف',
    source: 'مصدر البيانات',
    sources: {
      api: 'مزامنة API',
      file: 'ملف',
    },
    lastData: 'آخر مزامنة',
    automatic: 'تلقائي',
    platforms: {
      google_ads: 'Google Ads',
      meta: 'Meta',
      tiktok: 'TikTok',
      other: 'أخرى',
    },
    uploadReport: 'رفع تقرير',
    uploadTitle: '{{name}} — رفع تقرير',
    uploadLead:
      'ارفع تقرير المنصة المفصّل يوميًا (التاريخ، الحملة، الإنفاق؛ واختياريًا المجموعة الإعلانية، الإعلان، مرات الظهور، النقرات). يجب أن تكون المبالغ بعملة {{currency}}.',
    chooseFile: 'اختيار ملف',
    applyImport: 'حفظ البيانات',
    imported: 'تم الحفظ: {{inserted}} صفًا جديدًا، و{{updated}} صفًا محدّثًا.',
    previewFile: 'الملف',
    previewRows: 'الصفوف',
    previewRowsValue: '{{valid}} صفًا صالحًا من أصل {{rows}}، وتم تخطي {{skipped}}',
    previewPeriod: 'الفترة',
    previewSpend: 'إجمالي الإنفاق',
    previewCampaigns: 'الحملات',
    previewErrors: 'الصفوف المتخطّاة (أول 20)',
    rowError: 'الصف {{row}}: {{error}}',
    rowErrors: {
      ads_import_date: 'التاريخ غير مقروء أو في المستقبل',
      ads_import_campaign: 'لا يوجد اسم حملة أو صف إجماليات',
      ads_import_currency: 'العملة تختلف عن عملة الحساب',
      ads_import_amount: 'المبلغ أو الرقم غير مقروء',
    },
    reportTitle: 'أداء الحملات',
    reportLead:
      'بيانات المنصة مع طلبات المتجر معًا. تأتي الإيرادات من الطلبات المدفوعة التي يكون مصدر آخر زيارة فيها أحد مصادر الحساب وتتطابق حملتها (utm_campaign).',
    period: 'الفترة',
    lastDays: 'آخر {{n}} يومًا',
    allPlatforms: 'جميع المنصات',
    noData: 'لا توجد بيانات إعلانية في هذه الفترة',
    noDataLead: 'انتظر مزامنة الاتصالات أو ارفع تقريرًا لأحد الحسابات.',
    totalsLabel: 'الإجماليات ({{currency}})',
    campaignsTable: 'الحملات',
    campaign: 'الحملة',
    unmatchedCampaign: 'طلبات بلا حملة مطابقة',
    spend: 'الإنفاق',
    impressions: 'مرات الظهور',
    clicks: 'النقرات',
    ctr: 'نسبة النقر (CTR)',
    cpc: 'تكلفة النقرة (CPC)',
    cpm: 'تكلفة الألف ظهور (CPM)',
    platformConversions: 'تحويلات المنصة',
    orders: 'الطلبات',
    revenue: 'الإيرادات',
    cpa: 'التكلفة لكل طلب',
    newCustomers: 'العملاء الجدد',
    cac: 'تكلفة كل عميل جديد (CAC)',
    roas: 'ROAS',
    profit: 'الربح بعد الإعلانات',
    revenueNote:
      'الإيرادات هي مبلغ المنتجات دون ضريبة القيمة المضافة والشحن، بعد خصم المبالغ المستردة والإلغاءات. تحويلات المنصة للمقارنة فقط.',
    profitNote:
      'الربح = الإيرادات − تكلفة المنتجات − الإنفاق الإعلاني. إذا لم تُدخَل تكلفة أي منتج في الطلب فلا يُعرض الربح (—).',
    profitHidden: 'يتطلب عرض الربح بعد الإعلانات صلاحية عرض التكاليف.',
    currencyMismatch: 'استُبعد {{n}} طلبًا لأن عملته تختلف عن عملة الحساب الإعلاني.',
    compare: 'مقارنة',
    compareThis: 'إضافة الحملة {{name}} إلى المقارنة',
    compareHint: 'اختر حتى {{n}} حملات للمقارنة.',
    compareTitle: 'مقارنة الحملات',
    metric: 'المقياس',
    anomaliesTitle: 'التنبيهات',
    noAnomalies: 'لا يوجد ما هو غير معتاد في أحدث البيانات.',
    anomalyKinds: {
      spend_spike: 'قفزة في الإنفاق',
      ctr_drop: 'انخفاض نسبة النقر',
      no_clicks: 'إنفاق دون نقرات',
      sync_failed: 'خطأ في المزامنة',
      sync_stale: 'بيانات قديمة',
    },
    anomalyText: {
      spend_spike:
        '{{account}} · {{campaign}}: بلغ الإنفاق في {{date}} {{value}}، ومتوسط الأيام السبعة السابقة {{baseline}}.',
      ctr_drop: '{{account}} · {{campaign}}: نسبة النقر في {{date}} أقل من نصف نسبة الأيام السبعة السابقة.',
      no_clicks: '{{account}} · {{campaign}}: أُنفق {{value}} في {{date}} دون أي نقرات.',
      sync_failed: '{{account}}: فشلت آخر مزامنة. تحقّق من رمز الاتصال.',
      sync_stale: '{{account}}: لا توجد بيانات جديدة منذ أكثر من يومين.',
    },
    productsTitle: 'أداء المنتجات (الطلبات الواردة من الإعلانات)',
    product: 'المنتج',
    quantity: 'الكمية',
    productRevenue: 'صافي المبيعات',
    productAdsTitle: 'منتجات إعلانات التسوق (Google Ads)',
    productAdsNote:
      'الإنفاق والنقرات من تقرير المنتجات في Google؛ وصافي المبيعات هو مبلغ هذا المنتج في الطلبات المدفوعة من الحساب نفسه (المطابقة برمز SKU).',
    requestChange: 'طلب تغيير',
    changeTitle: 'طلب تغيير الميزانية أو حالة العرض',
    changeLead: '{{account}} · {{campaign}}. بعد الموافقة تطبّق التغيير بنفسك على المنصة الإعلانية.',
    changeKind: 'التغيير',
    kinds: {
      budget: 'تغيير الميزانية اليومية',
      status: 'تغيير حالة العرض',
    },
    dailyBudget: 'الميزانية اليومية الجديدة ({{currency}})',
    budgetInvalid: 'أدخل مبلغًا صالحًا (مثل 750 أو 750.50).',
    targetStatus: 'الحالة الجديدة',
    targets: {
      paused: 'إيقاف عرض الإعلان',
      active: 'استئناف عرض الإعلان',
    },
    changeNote: 'السبب',
    changeManualNote:
      'لا يُجري النظام أي تغيير على المنصة الإعلانية من تلقاء نفسه؛ بعد الموافقة طبّقه على المنصة وضع علامة «تم التطبيق».',
    sendRequest: 'إرسال للموافقة',
    changeRequested: 'أُرسل الطلب للموافقة.',
    changeUpdated: 'تم تحديث الطلب.',
    historyTitle: 'سجل التغييرات',
    historyLead: 'طلبات الميزانية وحالة العرض، والموافقات، وعمليات رفع البيانات.',
    changesTable: 'طلبات التغيير',
    noChanges: 'لا توجد طلبات تغيير بعد.',
    when: 'التاريخ',
    request: 'الطلب',
    status: 'الحالة',
    budgetTo: 'الميزانية اليومية: {{amount}}',
    requestedBy: 'مقدّم الطلب: {{name}}',
    decidedBy: '{{name}}، {{at}}',
    appliedAt: 'تم التطبيق: {{at}}',
    changeStatuses: {
      pending: 'بانتظار الموافقة',
      approved: 'تمت الموافقة — بانتظار التطبيق',
      rejected: 'مرفوض',
      applied: 'تم التطبيق',
      cancelled: 'ملغى',
    },
    decide: 'اتخاذ قرار',
    decideTitle: 'طلب التغيير',
    decideLead: '{{campaign}}: {{change}}',
    decisionNote: 'ملاحظة القرار',
    approve: 'موافقة',
    reject: 'رفض',
    markApplied: 'تم التطبيق',
    markAppliedConfirm: 'هل طبّقت التغيير على المنصة الإعلانية؟ ستوضع عليه علامة «تم التطبيق».',
    cancelRequest: 'إلغاء',
    cancelConfirm: 'هل تريد إلغاء الطلب المعلّق؟',
    runsTitle: 'عمليات رفع البيانات والمزامنة',
    noRuns: 'لم تُرفع أي بيانات بعد.',
    runRows: 'الصفوف',
    runRowsValue: '{{inserted}} جديد · {{updated}} محدّث · {{skipped}} متخطّى',
    gcTitle: 'رفع التحويلات إلى Google Ads',
    gcLead:
      'يُبلغ Google Ads بالطلبات المدفوعة الواردة من الإعلانات بوصفها تحويلات، لتتعلم استراتيجيات عروض الأسعار من المبيعات الفعلية. معطّل افتراضيًا.',
    gcPrivacy:
      'عند التفعيل، يُرسَل إلى Google (خارج البلاد) معرّف النقرة (gclid) ورقم الطلب والمبلغ والوقت للطلبات الواردة من الزوار الذين وافقوا على ملفات تعريف الارتباط التسويقية. تأكد مع محاميك قبل التفعيل من أن إشعار الخصوصية يغطي ذلك. لا يُرسَل الاسم أو البريد الإلكتروني أو الهاتف.',
    gcEnabled: 'رفع الطلبات المدفوعة إلى Google Ads كتحويلات',
    gcEnabledHint: 'كل صباح بعد المزامنة؛ آخر 60 يومًا، مرة واحدة لكل طلب.',
    gcAction: 'إجراء التحويل',
    gcActionHint:
      'إجراء تحويل من نوع «استيراد النقرات» في Google Ads ← الأهداف ← التحويلات؛ اسم المورد customers/…/conversionActions/….',
    gcSaved: 'تم حفظ إعداد رفع التحويلات.',
    gcNoUploads: 'لم يتم رفع أي تحويلات بعد.',
    gcUploaded: 'تم رفع {{count}} من الطلبات ({{value}})',
    gcFailed: 'رفضت Google {{count}} من الطلبات',
    runStatuses: {
      ok: 'ناجح',
      partial: 'جزئي',
      failed: 'فشل',
    },
  },
  googleReports: {
    ga4Title: 'تقرير Analytics (GA4)',
    ga4Lead:
      'الخاصية المرتبطة: {{property}}. حتى يوم أمس ضمنًا؛ تأتي بيانات Google Analytics من الزوار الذين وافقوا على القياس.',
    ga4LeadEmpty: 'تقرير القنوات والأيام لخاصية GA4 المرتبطة بالمتجر.',
    period: 'الفترة',
    lastDays: 'آخر {{n}} يوم',
    totals: 'إجماليات الفترة',
    sessions: 'الجلسات',
    users: 'المستخدمون',
    keyEvents: 'الأحداث الرئيسية',
    revenue: 'إيرادات الشراء',
    byChannel: 'حسب القناة',
    byDay: 'حسب اليوم',
    channel: 'القناة',
    day: 'اليوم',
    noData: 'لا توجد بيانات GA4 في هذه الفترة.',
    ga4Note:
      'تشمل إيرادات GA4 الزوار الذين وافقوا على القياس فقط، ولا تتضمن المبالغ المستردة أو الإلغاءات؛ وللاطلاع على المبيعات الدقيقة راجع تقريرَي «المبيعات» و«الحملات والمصادر». لا يُجمع عدد المستخدمين عبر الصفوف (فقد يصل الشخص نفسه عبر عدة قنوات).',
    gbpTitle: 'Google Business Profile',
    gbpLead: 'بيانات الموقع وآخر 50 مراجعة على Google (للقراءة فقط). يتم الرد على المراجعات في Google.',
    location: 'الموقع',
    address: 'العنوان',
    phone: 'الهاتف',
    website: 'الموقع الإلكتروني',
    rating: 'متوسط التقييم',
    ratingValue: '{{avg}} / 5 ({{count}} مراجعة)',
    replyOnGoogle: 'الفتح في خرائط Google والرد على المراجعات',
    reviews: 'مراجعات Google',
    noReviews: 'لا توجد مراجعات بعد.',
    anonymous: 'مستخدم Google',
    stars: '{{n}} نجوم',
    replied: 'ردّك: {{reply}}',
    noReply: 'لم يتم الرد بعد.',
    problem_google_not_linked: 'لا يوجد مورد Google مرتبط بهذا المتجر',
    problem_google_scope_missing: 'لم يمنح حساب Google الإذن لهذه الخدمة',
    problem_google_not_connected: 'لا يوجد حساب Google متصل',
    problemLead: 'في صفحة اتصالات Google، اربط الحساب بالإذن اللازم واختر خاصية أو موقعًا للمتجر.',
    openConnections: 'الانتقال إلى اتصالات Google',
  },
  trackingEvents: {
    title: 'مدير الأحداث',
    lead: 'أيّ أحداث التجارة الإلكترونية في واجهة المتجر تُرسَل إلى أي خدمة قياس، والأحداث المخصصة التي تحددها.',
    standardTitle: 'الأحداث القياسية',
    event: 'الحدث',
    sendTo: '{{event}}: إرسال إلى {{provider}}',
    notApplicable: 'لا يوجد مقابل في هذه الخدمة',
    events: {
      view_item_list: 'عرض قائمة المنتجات',
      select_item: 'اختيار منتج من القائمة',
      view_item: 'عرض المنتج',
      add_to_cart: 'الإضافة إلى سلة التسوق',
      remove_from_cart: 'الإزالة من سلة التسوق',
      view_cart: 'عرض سلة التسوق',
      begin_checkout: 'بدء إتمام الطلب',
      add_shipping_info: 'معلومات الشحن',
      add_payment_info: 'معلومات الدفع',
      purchase: 'الشراء',
      search: 'البحث',
      sign_up: 'التسجيل',
      login: 'تسجيل الدخول',
      generate_lead: 'إرسال نموذج (موزّع، تواصل)',
      quiz_start: 'بدء دليل الاحتياجات',
      quiz_step: 'خطوة في دليل الاحتياجات',
      quiz_complete: 'نتيجة دليل الاحتياجات',
    },
    customTitle: 'الأحداث المخصصة',
    customLead:
      'قِس مشاهدات صفحة معينة أو النقرات على روابط الهاتف والبريد الإلكتروني وWhatsApp والروابط الخارجية. لا تُرسَل أي بيانات شخصية؛ وفي الروابط الخارجية يُرسَل اسم النطاق فقط.',
    noCustom: 'لا توجد أحداث مخصصة.',
    name: 'اسم الحدث',
    nameHint: 'أحرف لاتينية صغيرة وأرقام وشرطة سفلية؛ مثل campaign_viewed',
    trigger: 'متى',
    triggers: {
      page_view: 'عند عرض الصفحة',
      click_phone: 'عند النقر على رابط هاتف',
      click_email: 'عند النقر على رابط بريد إلكتروني',
      click_whatsapp: 'عند النقر على رابط WhatsApp',
      click_outbound: 'عند النقر على رابط إلى موقع آخر',
    },
    path: 'مسار الصفحة',
    pathHint: 'مسار مطابق تمامًا (/campaign/october) أو أضف * في النهاية لمطابقة البداية (/campaign/*)',
    destinations: 'الإرسال إلى',
    addTitle: 'إضافة حدث مخصص',
    add: 'إضافة إلى القائمة',
    remove: 'إزالة {{name}}',
    consentNote:
      'لا تُرسَل الأحداث إلا عندما تكون سياسة ملفات تعريف الارتباط منشورة ويكون الزائر قد وافق على نوع ملفات تعريف الارتباط المعني (GA4: التحليلات؛ Meta وTikTok: التسويق). يُدار تحويل الشراء في Google Ads من إعدادات العلامة.',
    save: 'حفظ إعدادات الأحداث',
    saved: 'تم حفظ إعدادات الأحداث. ستُطبَّق على واجهة المتجر خلال بضع دقائق.',
  },
  credit: {
    available: 'الرصيد الائتماني المتبقي: {{amount}}',
    overdue: 'دين متأخر السداد: {{amount}}',
    overrideLead:
      'لديك صلاحية إدارة حسابات الموزّعين: أدخل سببًا واحفظ مجددًا لإنشاء الطلب متجاوزًا الحد (التحقق بخطوتين؛ يُسجَّل في سجل التدقيق).',
    overrideReason: 'سبب تجاوز الحد',
    summary: 'حد الائتمان {{limit}} · المتبقي {{available}}',
    blocked: {
      overdue: 'تم إيقاف الحساب الآجل بسبب دين متأخر السداد.',
      currency: 'الحد بعملة أخرى: الحساب الآجل مغلق بهذه العملة.',
    },
    limit: 'حد الائتمان',
    limitHint: 'اتركه فارغًا لعدم وضع حد.',
    currency: 'عملة الحد',
    blockWhenOverdue: 'إيقاف الحساب الآجل عند وجود دين متأخر',
    limitColumn: 'الحد / المتبقي',
  },
  compliance: {
    title: 'الأهلية حسب البلد',
    lead: 'ما إذا كان يجوز بيع المنتج في كل بلد، ورقم تسجيله/ترخيصه وحالة التحقق. يُسمح بالبيع في البلدان التي ليس لها سجل.',
    add: 'إضافة بلد',
    editTitle: 'تعديل سجل البلد',
    dialogLead:
      'لا يُعرض المنتج المحظور في سوق ذلك البلد، ولا يظهر في البحث أو في الـ Feed، ولا يمكن إضافته إلى سلة التسوق. لا يُعرض السبب والملاحظة للزوار.',
    empty: 'لا توجد سجلات بلدان',
    emptyLead: 'يمكن بيع المنتج في جميع البلدان. أضف بلدًا إذا كان لا يمكن بيعه فيه أو لإدخال رقم تسجيل.',
    country: 'البلد',
    saleStatus: 'حالة البيع',
    status: {
      allowed: 'متاح للبيع',
      blocked: 'غير متاح للبيع',
    },
    allowedLead: 'متاح للبيع',
    reason: 'السبب',
    reasons: {
      registration_missing: 'التسجيل/الترخيص غير موجود أو قيد الانتظار',
      legal_restriction: 'قيد قانوني',
      shipping_restriction: 'قيد على الشحن/الجمارك',
      business_decision: 'قرار تجاري',
      other: 'أخرى',
    },
    registrationNo: 'رقم التسجيل / الترخيص',
    registrationHint:
      'مثل رقم التسجيل لدى الوزارة أو موافقة الاتحاد الأوروبي على إضافة علفية. لا تظهر في المتجر إلا الأرقام التي تم التحقق منها.',
    registrationShort: 'رقم التسجيل {{no}}',
    verificationLabel: 'التحقق',
    verification: {
      unverified: 'لم يتم التحقق',
      verified: 'تم التحقق',
      not_required: 'غير مطلوب',
    },
    verifiedAt: 'تم التحقق: {{date}}',
    note: 'ملاحظة داخلية',
    confirmDelete: 'هل تريد حذف سجل {{country}}؟ سيصبح المنتج متاحًا للبيع هناك مجددًا.',
  },
  fx: {
    statusTitle: 'مصدر سعر الصرف',
    sourceLead:
      'ينشر البنك المركزي التركي (TCMB) نشرة أسعار الصرف في أيام العمل نحو الساعة 15:30، وتُجلب الأسعار تلقائيًا بعد الساعة 15:40. لا تُختلق الأسعار أبدًا: إذا تعذّر الجلب، يُستخدم آخر سعر صالح وتاريخه.',
    source: 'المصدر',
    sourceName: 'أسعار الصرف الاسترشادية من TCMB',
    bulletinLabel: 'أحدث نشرة',
    bulletin: 'نشرة {{date}}',
    bulletinNo: 'رقم {{no}}',
    noBulletin: 'لم تُجلب أي أسعار بعد',
    lastSuccess: 'آخر جلب ناجح',
    nextAttempt: 'المحاولة التالية',
    nextAttemptNone: 'غير مجدول (يبدأ عند استخدام عملة أجنبية)',
    lastError: 'آخر خطأ',
    refresh: 'تحديث الأسعار الآن',
    refreshResult: {
      updated: 'تم جلب نشرة جديدة ({{date}})؛ وأُعيد حساب {{count}} من القوائم.',
      unchanged: 'الأسعار محدّثة (نشرة {{date}}).',
      throttled: 'تمت المحاولة للتو؛ حاول مجددًا بعد دقيقة.',
      not_needed: 'لا يستخدم أي سوق أو قائمة أسعار عملة غير TRY؛ لم تُجلب أي أسعار.',
      not_due: 'لم يحن الموعد بعد.',
      failed: 'تعذّر الوصول إلى TCMB: {{error}}',
    },
    stale: {
      no_data: 'لا توجد أسعار صرف بعد؛ لا يمكن حساب القوائم المشتقة من سعر الصرف.',
      old_bulletin: 'أسعار الصرف قديمة: أحدث نشرة بتاريخ {{date}}. وتستمر الأسعار والطلبات في استخدامها.',
      fetch_failing: 'تعذّر جلب أسعار الصرف (فشلت {{count}} محاولات). يُستخدم آخر سعر صالح ({{date}}).',
    },
    ratesTitle: 'أسعار الصرف',
    ratesLead: 'القيمة بـ TRY؛ إذا لم تكن الوحدة 1 (مثل JPY 100) فهي قيمة هذا العدد من الوحدات.',
    currency: 'العملة',
    unit: 'الوحدة',
    rateTypes: {
      forex_buying: 'شراء العملات',
      forex_selling: 'بيع العملات',
      banknote_buying: 'شراء الأوراق النقدية',
      banknote_selling: 'بيع الأوراق النقدية',
    },
    notPublished: 'غير منشور',
    inUse: 'قيد الاستخدام',
    noRates: 'لا توجد أسعار صرف بعد',
    noRatesLead:
      'تُجلب الأسعار بمجرد أن يستخدم سوق أو قائمة أسعار عملة غير TRY؛ استخدم «تحديث الأسعار الآن» لجلبها فورًا.',
    derivedTitle: 'قوائم الأسعار المشتقة من سعر الصرف',
    derivedLead: 'تُحسب الأسعار من القائمة الأساسية بسعر الصرف المحدد، ولا يمكن إدخالها يدويًا.',
    toPricing: 'الانتقال إلى قوائم الأسعار',
    noDerived: 'لا توجد قوائم مشتقة من سعر الصرف',
    noDerivedLead: 'استخدم «الاشتقاق من سعر الصرف» على إحدى القوائم في صفحة التسعير.',
    derivedFrom: 'من {{base}} ({{currency}})',
    rule: '{{rateType}} · الهامش {{markup}} · نهاية السعر {{ending}}',
    auto: 'يتحدّث تلقائيًا',
    manualOnly: 'يُعاد حسابه يدويًا',
    applied: 'نشرة {{date}}: {{pair}} · {{count}} سعر',
    notApplied: 'لم يُحسب بعد (لا يوجد سعر صرف)',
    behind: 'لم يُحسب بأحدث نشرة',
    recompute: 'إعادة الحساب الآن',
    recomputed: 'أُعيد حساب القائمة بأحدث سعر صرف؛ وتغيّر {{count}} من الأسعار.',
    pair: '{{unit}} {{currency}} = {{rate}} TRY',
    deriveButton: 'الاشتقاق من سعر الصرف',
    deriveTitle: '{{name}} — الاشتقاق من سعر الصرف',
    deriveLead:
      'تُحسب أسعار هذه القائمة ({{currency}}) من القائمة الأساسية بسعر صرف TCMB. تحلّ الأسعار المحسوبة محل الأسعار الحالية (وتُسجَّل في سجل الأسعار)، ولا يمكن إدخال أسعار يدوية.',
    lastApplied: 'آخر حساب: نشرة {{date}}، {{pair}} ({{rateType}}).',
    baseList: 'القائمة الأساسية',
    baseListHint: 'قائمة مسعّرة يدويًا بعملة أخرى. تُحوَّل الأسعار المتدرجة أيضًا.',
    rateType: 'نوع سعر الصرف',
    markup: 'الهامش (%)',
    markupHint: 'يُطبَّق بعد التحويل؛ استخدم علامة السالب للتخفيض (مثل -5).',
    markupInvalid: 'أدخل النسبة بصيغة 5 أو -2.5.',
    autoLabel: 'التحديث تلقائيًا عند صدور نشرة جديدة وعند تغيّر الأسعار الأساسية',
    saved: 'تم حفظ إعدادات سعر الصرف؛ وتم تحديث {{count}} من الأسعار.',
    savedNoRate: 'تم حفظ إعدادات سعر الصرف لكن تعذّر حساب القائمة: {{reason}}',
    clear: 'التحويل إلى أسعار يدوية',
    confirmClear:
      'ستصبح القائمة مسعّرة يدويًا؛ تبقى الأسعار الحالية ولن تُحدَّث بسعر الصرف بعد الآن. هل تريد المتابعة؟',
    cleared: 'أصبحت القائمة الآن مسعّرة يدويًا.',
    badge: 'سعر الصرف · {{base}}',
    noBaseOptions:
      'لا توجد قائمة مسعّرة يدويًا بعملة أخرى. أنشئ القائمة الأساسية أولًا (مثل قائمة التجزئة بـ TRY).',
    orderRate: 'سعر الصرف',
    orderRateLine: '{{pair}} · سعر شراء العملات من TCMB · نشرة {{date}} ({{no}})',
    orderRateNone: 'لم يكن سعر الصرف متاحًا عند تقديم الطلب (ولم يُختلق أي سعر).',
    orderTryEquivalent: 'المعادل بـ TRY (بسعر الصرف وقت الطلب، للعلم): {{amount}}',
    orderRateStale: 'كان سعر الصرف قديمًا عند تقديم الطلب.',
    orderListRate: 'أسعار {{name}}: {{pair}} ({{rateType}}، نشرة {{date}})',
  },
  internationalReport: {
    csv: 'تنزيل CSV',
    from: 'من',
    to: 'إلى',
    store: 'المتجر',
    allStores: 'جميع المتاجر',
    note: 'الدولة هي دولة عنوان الشحن. المبالغ بعملة الطلب، ولا تُجمع العملات المختلفة معًا. الإجمالي يشمل ضريبة القيمة المضافة بعد خصم المنتجات الملغاة؛ الصافي = الإجمالي − المبالغ المستردة. التصدير: الطلبات المعفاة من ضريبة القيمة المضافة (تصدير). يُحسب المعادل بالليرة التركية بسعر TCMB المسجّل في الطلب.',
    empty: 'لا توجد طلبات في هذه الفترة',
    emptyLead: 'لا تُحتسب المسودات والطلبات الملغاة. غيّر الفترة أو المتجر.',
    totalOrders: 'الطلبات',
    tryNet: 'الصافي (المعادل بالليرة التركية)',
    exportOrders: 'طلبات التصدير',
    exportTryNet: 'صافي التصدير (المعادل بالليرة التركية)',
    withoutRate:
      '{{count}} من طلبات العملات الأجنبية بلا سعر صرف مسجّل، ولم تُدرج في المعادل بالليرة التركية.',
    caption: 'المبيعات حسب الدولة والعملة',
    country: 'الدولة',
    currency: 'العملة',
    orders: 'الطلبات',
    gross: 'الإجمالي',
    tax: 'ضريبة القيمة المضافة',
    shipping: 'الشحن',
    refunded: 'المبالغ المستردة',
    net: 'الصافي',
    unknown: 'بلا عنوان',
    rowWithoutRate: '{{count}} بلا سعر صرف',
    currencyTotal: 'المجموع',
  },
  dealerReports: {
    csv: 'تنزيل CSV',
    report: 'التقرير',
    reports: {
      sales: 'المبيعات',
      products: 'المنتجات',
      categories: 'الفئات',
      aging: 'أعمار الديون',
      collections: 'التحصيلات',
    },
    from: 'من',
    to: 'إلى',
    groupBy: 'التجميع حسب',
    groups: {
      company: 'الموزّع',
      rep: 'مندوب المبيعات',
      region: 'المنطقة',
    },
    none: {
      company: 'بدون شركة',
      rep: 'بدون مندوب مبيعات',
      region: 'بدون منطقة',
    },
    rep: 'مندوب المبيعات',
    region: 'المنطقة',
    all: 'الكل',
    noRep: 'بدون مندوب مبيعات',
    noRegion: 'بدون منطقة',
    notes: {
      sales:
        'طلبات الموزّعين المقدَّمة خلال الفترة (باستثناء المسودات والإلغاءات). الإجمالي: مجموع الطلب − البنود الملغاة (شاملًا ضريبة القيمة المضافة). الصافي: الإجمالي − المبالغ المستردة. مبيعات المنتجات لا تشمل ضريبة القيمة المضافة والشحن. مندوب المبيعات هو المندوب المسجَّل في الطلب، والمنطقة هي المنطقة الحالية للموزّع.',
      products:
        'الكمية والمبيعات دون ضريبة القيمة المضافة لكل منتج في طلبات الموزّعين خلال الفترة (باستثناء الكميات الملغاة).',
      categories:
        'تُحتسب كل فئة ينتمي إليها المنتج: يظهر المنتج الموجود في عدة فئات في كل منها، والصف الأخير هو إجمالي مبيعات المنتجات.',
      aging:
        'البنود المفتوحة حتى اليوم حسب عدد أيام التأخر عن الاستحقاق (دفتر حسابات الموزّعين في هذا النظام؛ تُطبَّق الدفعات على أقدم دين مستحق). رصيد BizimHesap للعلم فقط. مندوب المبيعات والمنطقة هما التعيين الحالي للموزّع.',
      collections:
        'الدفعات المسجَّلة في حسابات الموزّعين خلال الفترة (باستثناء القيود المعكوسة)؛ وتُسجَّل «دفعة الطلب» عبر «تم استلام الدفعة» في الطلب.',
    },
    orders: 'الطلبات',
    dealers: 'الموزّعون',
    gross: 'الإجمالي (شامل ضريبة القيمة المضافة)',
    refunded: 'المبالغ المستردة',
    net: 'الصافي (شامل ضريبة القيمة المضافة)',
    netExTax: 'مبيعات المنتجات (دون ضريبة القيمة المضافة)',
    average: 'متوسط الطلب',
    lastOrder: 'آخر طلب',
    total: 'الإجمالي',
    product: 'المنتج',
    quantity: 'الكمية',
    category: 'الفئة',
    noCategory: 'بدون فئة',
    productTotal: 'إجمالي مبيعات المنتجات',
    balance: 'الرصيد',
    buckets: {
      notDue: 'غير مستحق بعد',
      d1_30: '1–30 يومًا',
      d31_60: '31–60 يومًا',
      d61_90: '61–90 يومًا',
      d90plus: 'أكثر من 90 يومًا',
    },
    bizimhesap: 'رصيد BizimHesap',
    oldest: 'أقدم تأخير',
    days: '{{days}} يوم',
    count: 'عدد الدفعات',
    collected: 'إجمالي التحصيل',
    methods: {
      bank_transfer: 'تحويل بنكي',
      cash: 'نقدًا',
      card: 'بطاقة',
      cheque: 'شيك',
      note: 'سند لأمر',
      other: 'أخرى',
      order: 'دفعة الطلب',
    },
    emptySales: 'لا توجد طلبات موزّعين في هذه الفترة.',
    emptyAging: 'لا يوجد موزّع لديه رصيد مفتوح.',
    emptyCollections: 'لا توجد دفعات في هذه الفترة.',
    emptyLead: 'غيّر التواريخ أو عوامل التصفية.',
  },
  dealerCampaigns: {
    companies: 'شركات الموزّعين',
    search: 'ابحث بالاسم أو رمز الموزّع أو الرقم الضريبي',
    companiesNote:
      'تم اختيار شركات: تُطبَّق الحملة على مستخدمي هؤلاء الموزّعين فقط (الجمهور: الموزّعون). ويُطبَّق اختيار المجموعة والشريحة أيضًا.',
    forCompanies: 'مخصص لـ {{count}} من الموزّعين',
    couponFor: 'فقط: {{names}}',
  },
  balancePayments: {
    recent: {
      title: 'أحدث مدفوعات الموزّعين',
      lead: 'الدفعات التي أجراها الموزّعون بالبطاقة من حسابي ← حسابي الجاري (آخر 30 يومًا). تُقيَّد كل دفعة في حساب الموزّع تلقائيًا، وتذهب الأموال إلى حسابك لدى مزوّد الدفع.',
      all: 'الحسابات الجارية',
      empty: 'لا توجد مدفوعات بطاقة من الموزّعين خلال آخر {{days}} يومًا.',
      email: 'بريد إلكتروني عند دفع الموزّع',
      emailOn: 'يتلقى مستلمو التنبيهات بريدًا إلكترونيًا عند دفع الموزّع.',
      emailOff: 'البريد الإلكتروني عند دفع الموزّع متوقف.',
    },
    title: 'دفعات الرصيد بالبطاقة',
    lead: 'الدفعات التي أجراها الموزّع بالبطاقة من حسابي ← حسابي الجاري. تُقيَّد الدفعات المستلمة تلقائيًا في الدفتر كتحصيلات بالبطاقة.',
    reference: 'مفتاح الدفع',
    status: 'الحالة',
    card: 'البطاقة',
    sandbox: 'تجريبي',
    installments: '{{count}} أقساط',
    modes: {
      balance: 'كامل الرصيد',
      items: 'البنود المحددة',
      custom: 'المبلغ',
    },
    providers: {
      iyzico: 'iyzico',
      paytr: 'PayTR',
    },
    statuses: {
      pending: 'قيد الانتظار',
      captured: 'تم الاستلام',
      failed: 'فشل',
      expired: 'منتهي الصلاحية',
      requires_action: 'قيد المراجعة',
    },
    reviewHint:
      '{{reason}} لم يُقيَّد في الدفتر: تحقّق من لوحة مزوّد الدفع؛ وإذا تم استلام المبلغ، فأدخل تحصيلًا بالبطاقة عبر «تسجيل دفعة».',
    reasons: {
      amount_mismatch: 'أبلغ مزوّد الدفع عن مبلغ مختلف.',
      amount_unverified: 'تعذّر التحقق من المبلغ.',
      currency_mismatch: 'عملة مختلفة.',
      provider_review: 'يراجع مزوّد الدفع العملية.',
      provider_review_stale: 'استغرقت مراجعة مزوّد الدفع وقتًا طويلًا.',
      provider_unreachable: 'تعذّر الوصول إلى مزوّد الدفع.',
      test_mode_payment: 'عملية تجريبية في البيئة المباشرة.',
      other: 'النتيجة غير نهائية.',
    },
  },
  bankImport: {
    open: 'رفع الحركات البنكية',
    back: 'العودة إلى حسابات الموزّعين',
    columns:
      'ارفع حركات حسابك البنكي بصيغة CSV أو Excel (XLSX). الأعمدة المطلوبة: التاريخ والمبلغ (أو دائن/مدين في عمودين منفصلين). تُستخدم أعمدة الوصف والمُرسِل والمرجع للمطابقة إن وُجدت. تُؤخذ الحركات الواردة فقط.',
    file: 'كشف الحساب البنكي',
    summary:
      'الحركات الواردة: {{incoming}}؛ طوبق منها مع موزّع: {{matched}}، متعددة المرشحين: {{ambiguous}}، غير مطابقة: {{unmatched}}، غير قابلة للقيد: {{blocked}}. تم تخطي {{outgoing}} من الحركات الصادرة.',
    validUntil: 'المعاينة صالحة حتى {{time}}.',
    tableCaption: 'الحركات البنكية والموزّعون المقترحون',
    pick: 'تحديد',
    pickRow: 'قيد السطر {{line}}',
    date: 'التاريخ',
    description: 'الوصف',
    amount: 'المبلغ',
    dealer: 'الموزّع',
    dealerFor: 'الموزّع للسطر {{line}}',
    matchColumn: 'المطابقة',
    reference: 'المرجع {{ref}}',
    line: 'سطر الملف {{line}}',
    chooseDealer: 'اختر موزّعًا',
    candidates: 'المرشحون',
    allDealers: 'جميع الموزّعين',
    match: {
      order: 'الطلب {{number}}',
      code: 'رمز الموزّع',
      bizimhesap: 'رمز BizimHesap',
      tax: 'الرقم الضريبي',
      name: 'اسم مشابه — يُرجى التحقق',
      ambiguous: 'عدة مرشحين',
      none: 'لا توجد مطابقة',
    },
    issues: {
      amount_invalid: 'مبلغ غير مقروء',
      date_invalid: 'تاريخ غير مقروء',
      date_in_future: 'تاريخ مستقبلي',
      duplicate: 'مقيَّد مسبقًا',
    },
    apply: 'قيد المحدد ({{count}} حركة · {{total}})',
    missingDealer: 'اختر موزّعًا لكل سطر محدد.',
    applied: 'تم قيد {{count}} من الدفعات في الدفتر.',
    appliedWithBh: 'تم قيد {{count}} من الدفعات، ودخل {{queued}} منها قائمة انتظار التحصيل في BizimHesap.',
    alreadyApplied: 'تم قيد هذا الكشف. ارفع الكشف مجددًا للحركات الجديدة.',
  },
  ledger: {
    import: 'استيراد الأرصدة الافتتاحية',
    importLead:
      'استورد أرصدة الموزّعين من نظامك المحاسبي السابق عبر ملف. تُعرض معاينة أولًا، ولا يتم القيد إلا بعد التأكيد.',
    importColumns:
      'الأعمدة: رمز الموزّع أو الرقم الضريبي، والمبلغ (المدين موجب والدائن سالب)، والعملة اختياريًا (TRY إذا تُركت فارغة)، والتاريخ، وتاريخ الاستحقاق، والوصف. بصيغة CSV (فاصلة منقوطة) أو Excel.',
    importFile: 'الملف',
    importSummary:
      'سيتم استيراد {{valid}} من الصفوف، و{{invalid}} من الصفوف بها أخطاء (سيتم تخطيها). الإجمالي: {{totals}}',
    importAlready:
      'لدى {{count}} من الموزّعين في هذا الملف رصيد افتتاحي بالفعل. تأكد من عدم الاستيراد مرتين.',
    importApply: 'قيد {{count}} من الصفوف',
    importApplied: 'تم قيد {{count}} من قيود الرصيد الافتتاحي.',
    importPreview: 'معاينة الأرصدة الافتتاحية',
    importLine: 'الصف',
    importStatus: 'الحالة',
    importOk: 'سيتم الاستيراد',
    importErrors: {
      dealer_key_required: 'لا يوجد رمز موزّع أو رقم ضريبي.',
      dealer_not_found: 'لم يتم العثور على الموزّع.',
      currency_invalid: 'عملة غير صالحة (مثل TRY، EUR).',
      amount_invalid: 'تعذّرت قراءة المبلغ.',
      amount_zero: 'المبلغ صفر.',
      date_invalid: 'تعذّرت قراءة التاريخ.',
      date_in_future: 'التاريخ في المستقبل.',
      due_date_invalid: 'تعذّرت قراءة تاريخ الاستحقاق.',
    },
    totals: 'الإجماليات',
    totalBalance: 'إجمالي الرصيد ({{currency}})',
    totalOverdue: 'متأخر السداد: {{amount}}',
    search: 'البحث عن موزّعين',
    onlyOverdue: 'المتأخرة فقط',
    empty: 'لا توجد حركات في حسابات الموزّعين',
    emptyLead: 'تُقيَّد طلبات الحساب الآجل تلقائيًا. استخدم «استيراد الأرصدة الافتتاحية» للأرصدة السابقة.',
    listCaption: 'حسابات الموزّعين',
    dealer: 'الموزّع',
    balance: 'الرصيد',
    overdue: 'متأخر السداد',
    notDue: 'غير مستحق بعد',
    oldestOverdue: 'أقدم تاريخ استحقاق',
    daysOverdue: '{{date}} (متأخر {{days}} يوم)',
    lastEntry: 'آخر حركة',
    companyTitle: '{{name}} — الحساب الجاري',
    toDealer: 'بطاقة الموزّع',
    term: 'مدة السداد: {{days}} يوم بعد الطلب. الرصيد الموجب يعني أن الموزّع مدين لك.',
    noEntries: 'لا توجد حركات في الحساب بعد',
    noEntriesLead: 'تظهر هنا طلبات الحساب الآجل والدفعات والأرصدة الافتتاحية.',
    statement: 'كشف الحساب',
    csv: 'تنزيل كشف الحساب (CSV)',
    print: 'طباعة',
    currency: 'العملة',
    from: 'من',
    to: 'إلى',
    date: 'التاريخ',
    kind: 'النوع',
    description: 'الوصف',
    dueDate: 'تاريخ الاستحقاق',
    debit: 'مدين',
    credit: 'دائن',
    actions: 'الإجراءات',
    broughtForward: 'رصيد مُرحَّل',
    periodTotal: 'إجمالي الفترة / الرصيد الختامي',
    reversedBadge: 'معكوس',
    kinds: {
      order: 'طلب',
      order_change: 'تعديل طلب',
      order_payment: 'دفعة الطلب',
      payment: 'دفعة',
      opening: 'رصيد افتتاحي',
      adjustment: 'تسوية',
      reversal: 'قيد عكسي',
    },
    reasons: {
      placed: 'تم تقديم الطلب',
      cancelled: 'ملغى',
      partial_cancel: 'إلغاء جزئي',
      edited: 'تم تعديل الطلب',
      refunded: 'استرداد المبلغ',
      paid: 'تم استلام الدفعة',
      refund_paid: 'تم صرف المبلغ المسترد',
      changed: 'تغيّر المبلغ',
      card_balance: 'دفع بالبطاقة من حسابي',
    },
    methods: {
      bank_transfer: 'تحويل بنكي',
      cash: 'نقدًا',
      cheque: 'شيك',
      note: 'سند لأمر',
      card: 'بطاقة',
      other: 'أخرى',
    },
    payment: 'تسجيل دفعة',
    paymentLead:
      'يُقيَّد المبلغ المستلم من الموزّع في الجانب الدائن ويُطبَّق على أقدم دين مستحق. إذا كان الموزّع مرتبطًا بـ BizimHesap، فإن التحصيلات بالتحويل البنكي والنقد والبطاقة تدخل أيضًا قائمة انتظار التحصيل في BizimHesap (وتُرسَل فورًا عند تفعيل الكتابة إلى BizimHesap).',
    paymentSaved: 'تم تسجيل الدفعة.',
    adjustment: 'تسجيل تسوية',
    adjustmentLead: 'قيد يدوي يزيد دين الموزّع أو ينقصه. الوصف مطلوب.',
    adjustmentSaved: 'تم تسجيل التسوية.',
    direction: 'الاتجاه',
    directions: {
      debit: 'مدين (يزيد دين الموزّع)',
      credit: 'دائن (ينقص دين الموزّع)',
    },
    amount: 'المبلغ',
    amountIn: 'المبلغ ({{currency}})',
    amountInvalid: 'تعذّرت قراءة المبلغ (مثل 1,250.50).',
    entryDate: 'تاريخ القيد',
    method: 'طريقة الدفع',
    reference: 'رقم المستند',
    reverse: 'عكس القيد',
    reverseTitle: 'عكس القيد',
    reverseLead: 'يُلغى قيد {{kind}} ({{amount}}) بقيد معاكس. لا يُحذف أي شيء.',
    reverseReason: 'السبب',
    reversed: 'تم عكس القيد.',
    openItems: 'البنود المفتوحة',
    openItemsLead: 'المبالغ غير المسددة، الأقدم استحقاقًا أولًا. تُطبَّق الدفعات على أقدم دين مستحق.',
    openItem: 'الطلب / القيد',
    original: 'المبلغ',
    open: 'المتبقي',
    reminders: {
      title: 'تذكيرات السداد',
      lead: 'بريد إلكتروني صباحي للموزّعين بشأن المبالغ التي يقترب استحقاقها أو المتأخرة. معطّل افتراضيًا.',
      noMail:
        'لم يتم إعداد إرسال البريد الإلكتروني (يتطلب الإعداد): لن تُرسَل أي رسائل حتى عند تفعيل التذكيرات. اربط مزوّد بريد إلكتروني (SMTP أو Amazon SES أو SendGrid أو Postmark) من صفحة التكاملات.',
      enabled: 'إرسال تذكيرات السداد إلى الموزّعين',
      daysBefore: 'عدد الأيام قبل تاريخ الاستحقاق',
      daysInvalid: 'أدخل عدد أيام بين 0 و30.',
      confirm:
        'أؤكد أن الموزّعين الذين لديهم بنود مفتوحة (البريد الإلكتروني للشركة والمسؤولون المفوّضون فيها) سيتلقّون رسائل بريد إلكتروني حقيقية كل صباح.',
      saved: 'تم حفظ إعداد تذكيرات السداد.',
    },
  },
  sales: {
    sectionTitle: 'مندوب المبيعات والمنطقة',
    sectionLead:
      'عند ضبط النطاق على «الموزّعون المعيَّنون فقط»، يرى مندوب المبيعات ومدير المنطقة هذا الموزّع ومستخدميه وطلباته وعروض أسعاره.',
    rep: 'مندوب المبيعات',
    region: 'منطقة المبيعات',
    noRep: 'بدون مندوب',
    noRegion: 'بدون منطقة',
    saveAssignment: 'حفظ التعيين',
    repLabel: 'المندوب: {{name}}',
    regionLabel: 'المنطقة: {{name}}',
    newRegion: 'إضافة منطقة',
    editRegion: 'تعديل منطقة {{name}}',
    saveRegion: 'حفظ المنطقة',
    regionSaved: 'تم حفظ المنطقة.',
    regionDeleted: 'تم حذف المنطقة.',
    emptyRegions: 'لا توجد مناطق مبيعات بعد',
    emptyRegionsLead: 'أنشئ مناطق من المحافظات/الأقضية، وعيّن مسؤولًا، وجمّع الموزّعين حسب الموقع.',
    regionsTable: 'مناطق المبيعات',
    regionName: 'اسم المنطقة',
    places: 'المحافظات والأقضية',
    manager: 'مدير المنطقة',
    noManager: 'بدون مدير',
    dealerCount: 'الموزّعون',
    morePlaces: 'و{{count}} أخرى',
    confirmDelete:
      'هل تريد حذف منطقة {{name}}؟ سيفقد {{count}} من الموزّعين منطقتهم، ولن يتأثر الموزّعون والطلبات.',
    city: 'المحافظة',
    district: 'القضاء',
    wholeCity: 'المحافظة بأكملها',
    addPlace: 'إضافة',
    chosenPlaces: 'المحافظات والأقضية في المنطقة',
    removePlace: 'إزالة {{place}} من المنطقة',
    noPlaces: 'لم تُضَف محافظات أو أقضية بعد.',
    autoAssign: 'التعيين حسب المحافظة/القضاء',
    autoAssignLead:
      'تُطابَق محافظة/قضاء الموزّعين مع المناطق: القضاء أولًا، وإلا فالمحافظة بأكملها. تُعرض معاينة أولًا، ولا يُحفظ أي شيء.',
    reassignAll: 'إعادة مطابقة الموزّعين الذين لديهم منطقة أيضًا',
    previewAssign: 'معاينة',
    previewSummary: 'سيتم تعيين {{assigned}} من الموزّعين، ولا يطابق {{unmatched}} من الموزّعين أي منطقة.',
    applyAssign: 'تعيين {{count}} من الموزّعين',
    autoAssigned: 'تم تعيين {{count}} من الموزّعين إلى المناطق.',
  },
  bizimhesap: {
    reversedFixAtBh: 'تم عكس القيد في الدفتر؛ صحّح التحصيل في BizimHesap يدويًا.',
    ledgerEntry: 'تحصيل BizimHesap {{number}}: {{status}}',
    statement: {
      title: 'كشف حساب BizimHesap',
      lead: 'يُعدّ BizimHesap السجل الرئيسي: الرصيد هو آخر رصيد جارٍ في كشف الحساب. يُتحقَّق من حد الائتمان مقابل هذا الرصيد مضافًا إليه طلبات الحساب الآجل التي لم تُنقل إلى BizimHesap بعد. يُجلب الكشف كل 30 دقيقة (وكل 6 ساعات للموزّعين غير النشطين).',
      notLinked: 'الموزّع غير مرتبط بحساب في BizimHesap. للربط:',
      balance: 'رصيد BizimHesap',
      pending: 'الطلبات التي لم تُنقل بعد',
      effective: 'المستخدم لحد الائتمان',
      fetchedAt: 'آخر تحديث {{date}}',
      neverFetched: 'لم يُجلب بعد',
      lastError: 'فشلت المحاولة الأخيرة: {{error}}',
      refreshOne: 'تحديث هذا الموزّع',
      refreshed: 'تم تحديث كشف الحساب من BizimHesap.',
      pendingOrders: 'طلبات الحساب الآجل التي لم تُنقل إلى BizimHesap بعد: {{orders}}',
      rows: 'سطور كشف حساب BizimHesap',
      date: 'التاريخ',
      type: 'النوع',
      note: 'الوصف',
      debit: 'مدين',
      credit: 'دائن',
      running: 'الرصيد',
      sources: {
        field: 'قُرئ الرصيد من رأس الكشف (لا يوجد رصيد جارٍ في السطور)',
        sums: 'حُسب الرصيد من مجموع المدين − الدائن',
        rows: 'حُسب الرصيد من السطور',
      },
      creditSource: 'يُتحقَّق من حد الائتمان مقابل رصيد BizimHesap مضافًا إليه الطلبات التي لم تُنقل بعد.',
    },
    diff: {
      title: 'أرصدة BizimHesap وتقرير الفروق',
      lead: 'لكل موزّع مرتبط بـ BizimHesap: رصيد BizimHesap، وطلبات الحساب الآجل التي لم تُنقل بعد، ورصيد الدفتر في هذا النظام. الفرق = BizimHesap + غير المنقول − الدفتر (الأكبر أولًا).',
      refreshAll: 'التحديث الآن',
      queued: 'تمت جدولة كشوف حسابات {{count}} من الموزّعين، وستُحدَّث خلال بضع دقائق.',
      bizimhesap: 'BizimHesap',
      pending: 'غير منقول',
      ledger: 'الدفتر',
      diff: 'الفرق',
      updated: 'آخر تحديث',
    },
    dealerTitle: 'حساب BizimHesap',
    dealerLead:
      'تُقيَّد فواتير هذا الموزّع وتحصيلاته على رمز الحساب هذا في BizimHesap، ويُعدّ BizimHesap السجل الرئيسي. يُتحقَّق من الرمز مقابل قائمة الحسابات في BizimHesap.',
    notLinked: 'غير مرتبط — لا تُرسَل الفواتير',
    linkedAt: 'تاريخ الربط',
    link: 'ربط',
    unlink: 'إلغاء الربط',
    notConnected:
      'BizimHesap غير متصل أو لم يُختبر (يتطلب الإعداد). أدخل معرّف الشركة ثم شغّل «اختبار الاتصال»:',
    cashTitle: 'حسابات الصندوق',
    cashLead:
      'تُرسَل فاتورة الطلب المدفوع مع حساب الصندوق الخاص بطريقة الدفع، ويسجّل BizimHesap التحصيل فيه. لا تُرسِل طلبات الحساب الآجل أي حساب صندوق وتبقى ذممًا مدينة.',
    cashiersRefreshed: 'تم تحديث قائمة حسابات الصندوق.',
    cashiersAt: '{{count}} من حسابات الصندوق من BizimHesap · {{date}}',
    cashiersNever: 'لم تُجلب قائمة حسابات الصندوق بعد.',
    refreshCashiers: 'جلب حسابات الصندوق',
    cashKeys: {
      card: 'الدفع بالبطاقة',
      bank_transfer: 'تحويل بنكي',
      cash_on_delivery: 'الدفع عند الاستلام',
      manual: 'دفع يدوي (لوحة التحكم)',
      cash: 'تحصيل نقدي (الحساب الجاري)',
    },
    noCash: 'لا يوجد حساب صندوق',
    cashRule:
      'لا تُرسَل فواتير الطلبات المدفوعة بطريقة ليس لها حساب صندوق (فبدونه لا يُظهر BizimHesap أي تحصيل).',
    saveCash: 'حفظ حسابات الصندوق',
    linksTitle: 'الموزّع ↔ حساب BizimHesap',
    linksLead:
      'تُقيَّد فواتير الموزّعين وتحصيلاتهم على رمز حساب الموزّع في BizimHesap. تتم المطابقة عبر قائمة الحسابات: أولًا رمز الموزّع = رمز الحساب، ثم الرقم الضريبي. لا تُرسَل فواتير الموزّعين غير المرتبطين.',
    dealers: 'الموزّعون',
    linked: 'مرتبط بـ BizimHesap',
    customersCheck: 'الفحص الليلي لقائمة الحسابات',
    customersCheckResult: 'الموزّعون الذين لا يوجد رمزهم المرتبط في القائمة: {{missing}}',
    importCustomers: 'استيراد الحسابات',
    linkedDone: 'تم ربط {{count}} من الموزّعين بحسابات BizimHesap.',
    previewSummary:
      'مطابَق {{matched}} · ملتبس {{ambiguous}} · غير موجود في BizimHesap {{unmatched}} · مرتبط مسبقًا {{linked}}. تبقى {{other}} من حسابات BizimHesap التي لا تطابق أي موزّع (قد تكون للتجزئة) دون تغيير.',
    applyLinks: 'حفظ {{count}} من المطابقات',
    groupMatched: 'المطابَقة (محددة للحفظ)',
    byCode: 'رمز الموزّع',
    byTax: 'الرقم الضريبي',
    groupAmbiguous: 'ملتبسة: عدة مرشحين',
    leaveUnlinked: 'عدم الربط',
    groupUnmatched: 'غير موجودة في BizimHesap',
    unmatchedLead:
      'يحتاج هؤلاء الموزّعون إلى حساب في BizimHesap. إضافة الحسابات (AddCustomer) تكتب في BizimHesap وهي معطّلة افتراضيًا؛ وإلى حين تفعيلها، افتح الحساب في BizimHesap ثم استورد القائمة مجددًا.',
    linkMissing: 'الرمز المرتبط ({{code}}) غير موجود في القائمة',
    alreadyLinked: '{{count}} من الموزّعين مرتبطون مسبقًا.',
    writesTitle: 'الكتابة إلى BizimHesap',
    writesLead:
      'تكتب هذه الخطوات سجلات في حسابك الحقيقي على BizimHesap وهي معطّلة افتراضيًا. أثناء تعطيلها تنتظر السجلات هنا، وبعد التفعيل تُرسَل يدويًا.',
    writeKeys: {
      collections: 'إرسال التحصيلات (AddCollection)',
      customers: 'إضافة حسابات (AddCustomer)',
      cancel: 'إلغاء الفواتير (CancelInvoice)',
    },
    writesConfirm: 'أؤكد أن الخطوات التي أفعّلها ستكتب سجلات في حسابي الحقيقي على BizimHesap.',
    saveWrites: 'حفظ إعدادات الكتابة',
    writesOwnerOnly: 'يغيّر هذا الإعداد المالك أو المسؤول.',
    correctionsTitle: 'طلبات مدفوعة أُرسلت دون حساب صندوق',
    correctionsLead:
      'طلبات مدفوعة صدرت فواتيرها سابقًا دون حساب صندوق: لا يُظهر BizimHesap أي تحصيل لها. حدّدها لفتح سجلات تحصيل؛ ويتوقف الإرسال على إعداد الكتابة الذي يُفعَّل بموافقة المالك.',
    queued: 'تم فتح {{count}} من سجلات التحصيل.',
    noCorrections: 'لا توجد فواتير تحتاج إلى تصحيح.',
    method: 'طريقة الدفع',
    customerCode: 'رمز الحساب',
    sentAt: 'إرسال الفاتورة',
    amount: 'المبلغ',
    collection: 'التحصيل',
    pickCorrection: 'تحديد الطلب {{number}}',
    cashMissing: 'لا يوجد حساب صندوق',
    statuses: {
      pending: 'قيد الانتظار',
      sending: 'جارٍ الإرسال',
      sent: 'تم الإرسال',
      failed: 'فشل',
      uncertain: 'غير مؤكد',
      cancelled: 'ملغى',
    },
    queueCorrections: 'فتح سجلات تحصيل للمحدد ({{count}})',
    writesOffNote: 'كتابة التحصيلات إلى BizimHesap معطّلة: تنتظر السجلات دون إرسال.',
    collectionsTitle: 'قائمة انتظار التحصيل',
    collectionsLead:
      'التحصيلات المقرر إرسالها إلى BizimHesap والمرسلة إليه. يُكتب رقم التحصيل (ZT-TAH-…) في حقل الملاحظة في BizimHesap؛ وإذا لم يصل رد تصبح الحالة «غير مؤكد» ويُتحقَّق منها بالبحث عن هذا الرقم في كشف الحساب — دون إعادة محاولة عشوائية.',
    sent: 'تم إرسال التحصيل إلى BizimHesap.',
    sendResult: {
      uncertain: 'لم يستجب BizimHesap: ربما أُنشئ التحصيل. تحقّق من كشف الحساب.',
      failed: 'رفض BizimHesap التحصيل؛ الخطأ موضّح في السطر.',
    },
    checkFound: 'تم العثور على رقم التحصيل في كشف الحساب: وُسم كمُرسَل.',
    checkNotFound: 'لم يُعثر عليه في كشف الحساب: يمكنك إرساله مجددًا.',
    noCollections: 'لا توجد سجلات تحصيل.',
    collectionNumber: 'رقم التحصيل',
    account: 'الحساب',
    paymentType: 'النوع',
    status: 'الحالة',
    sources: {
      order_correction: 'تصحيح فاتورة',
      ledger_payment: 'تحصيل من لوحة التحكم',
      balance_payment: 'دفع الرصيد بالبطاقة',
    },
    paymentTypes: {
      '1': 'نقدًا',
      '2': 'بطاقة ائتمان',
      '3': 'تحويل بنكي',
    },
    send: 'إرسال',
    cancelCollection: 'إلغاء السجل',
    checkStatement: 'التحقق من كشف الحساب',
    collectionActionsNote: 'تُسجَّل عمليات «إرسال» و«التحقق من كشف الحساب» و«إلغاء السجل» في سجل التدقيق.',
    cancelled: 'تم إلغاء سجل التحصيل.',
    cancelTitle: 'إلغاء السجل {{number}}',
    cancelLead: 'لن يُرسَل السجل إلى BizimHesap. دوّن ذلك إذا كنت قد أدخلت التحصيل في BizimHesap يدويًا.',
    cancelNote: 'السبب',
    sampleReset: 'تم حذف العينة، وسيُحفظ الرد الحقيقي التالي مجددًا.',
    samplesTitle: 'عينات ردود BizimHesap',
    samplesLead:
      'لا تصف وثائق BizimHesap حقول ردود قائمة الحسابات وكشف الحساب وحسابات الصندوق. يُحفظ هنا أول رد حقيقي مع إخفاء البيانات الشخصية، ويُتحقَّق من مطابقة الحقول بناءً عليه.',
    endpoints: {
      customers: 'قائمة الحسابات (customers)',
      abstract: 'كشف الحساب (abstract)',
      cashiers: 'حسابات الصندوق (cashiers)',
    },
    sampleAt: 'التُقطت في {{date}}',
    sampleNone: 'لا توجد بعد',
    copySample: 'نسخ',
    copied: 'تم النسخ.',
    resetSample: 'حذف العينة',
  },
  commissions: {
    rules: 'قواعد العمولة',
    rulesLead:
      'تُطبَّق النسبة على صافي مبلغ الطلب دون ضريبة القيمة المضافة والشحن. يُطبَّق على كل سطر القاعدة الأكثر تحديدًا: الخاصة بالمندوب قبل العامة، والمنتج قبل الفئة، والفئة قبل جميع المنتجات.',
    newRule: 'إضافة قاعدة',
    editRule: 'تعديل القاعدة {{name}}',
    saveRule: 'حفظ القاعدة',
    ruleSaved: 'تم حفظ قاعدة العمولة.',
    ruleDeleted: 'تم حذف قاعدة العمولة.',
    confirmDeleteRule:
      'هل تريد حذف القاعدة {{name}}؟ لن تتغير النسب المحسوبة مسبقًا للطلبات، ولن تُطبَّق على الطلبات الجديدة.',
    noRules: 'لا توجد قواعد عمولة بعد',
    noRulesLead: 'ابدأ بنسبة عامة لجميع المندوبين، وأضف عند الحاجة قواعد خاصة بمندوب أو منتج.',
    ruleName: 'اسم القاعدة',
    rep: 'المندوب',
    allReps: 'جميع المندوبين',
    scope: 'النطاق',
    allProducts: 'جميع المنتجات',
    categoryCount: '{{count}} فئات',
    productCount: '{{count}} منتجات',
    rate: 'النسبة',
    rateHint: 'كنسبة مئوية، مثل 5 أو 2.5. بحد أقصى 50%.',
    rateInvalid: 'أدخل نسبة مئوية بين 0 و50 (مثل 2.5).',
    validity: 'الصلاحية',
    always: 'دون تاريخ انتهاء',
    validFrom: 'اليوم الأول',
    validTo: 'اليوم الأخير',
    categories: 'الفئات',
    products: 'المنتجات',
    activeLabel: 'القاعدة مفعّلة',
    inactive: 'معطّلة',
    statements: 'الكشوف الشهرية',
    statementsLead:
      'عند حساب فترة ما يُنشأ كشف مسودة لكل مندوب. تتبع العمولة المبلغ المحصَّل، وتظهر المبالغ المستردة والإلغاءات والدفعات المتأخرة كتسويات في الأشهر اللاحقة.',
    period: 'الفترة (الشهر)',
    calculate: 'حساب الفترة',
    calculated: 'تم إعداد كشوف لـ {{count}} من المندوبين، وتم الإبقاء على {{locked}} من الكشوف المعتمدة.',
    downloadCsv: 'تنزيل CSV',
    noStatements: 'لا توجد كشوف لهذه الفترة. احسب الفترة.',
    orders: 'الطلبات',
    base: 'الأساس (دون ضريبة القيمة المضافة)',
    commission: 'العمولة',
    status: 'الحالة',
    statuses: {
      draft: 'مسودة',
      approved: 'معتمد',
      paid: 'مدفوع',
    },
    details: 'التفاصيل',
    approve: 'اعتماد',
    approved: 'تم اعتماد الكشف.',
    markPaid: 'وسم كمدفوع',
    markPaidTitle: '{{name}} — وسم كمدفوع',
    markPaidLead:
      'يتم الدفع خارج النظام (تحويل، كشف رواتب)، ويُحتفظ هنا بالسجل فقط. لا يمكن تعديل الكشف المدفوع.',
    paidNote: 'ملاحظة الدفع',
    paidDone: 'تم وسم الكشف كمدفوع.',
    detailTitle: '{{name}} — {{period}}',
    calculatedAt: 'تاريخ الحساب: {{date}}',
    entries: 'سطور الكشف',
    kind: 'النوع',
    kinds: {
      accrual: 'استحقاق',
      adjustment: 'تسوية',
    },
    collected: 'المحصَّل',
    ownOnly: 'ترى كشوفك الخاصة فقط.',
  },
  quotes: {
    new: 'عرض سعر جديد',
    newLead: 'اختر الموزّع. يُفتح عرض السعر في المتجر الذي تعمل عليه، وتُحدَّد الأسعار حسب مجموعة الموزّع.',
    create: 'إنشاء عرض سعر',
    changeDealer: 'تغيير الموزّع',
    status: 'الحالة',
    search: 'رقم العرض أو الموزّع',
    empty: 'لا توجد عروض أسعار',
    emptyLead: 'يمكن للموزّعين طلب عرض سعر من سلة التسوق، ويمكنك أيضًا إعداد عرض عبر «عرض سعر جديد».',
    listCaption: 'عروض الأسعار',
    number: 'رقم العرض',
    dealer: 'الموزّع',
    total: 'الإجمالي',
    validUntil: 'صالح حتى',
    validUntilShort: 'حتى {{date}}',
    createdAt: 'تاريخ الإنشاء',
    expired: 'منتهي الصلاحية',
    statuses: {
      requested: 'مطلوب',
      draft: 'مسودة',
      sent: 'مُرسَل',
      ordered: 'تحوّل إلى طلب',
      rejected: 'مرفوض',
      cancelled: 'ملغى',
    },
    title: 'عرض السعر {{number}}',
    backToList: 'قائمة عروض الأسعار',
    print: 'طباعة',
    send: 'إرسال',
    resend: 'إرسال الإصدار الجديد',
    cancel: 'إلغاء عرض السعر',
    saved: 'تم حفظ عرض السعر.',
    sentEmailed: 'تم إرسال عرض السعر، وأُرسل بريد إلكتروني إلى الموزّع.',
    sentNoEmail:
      'تم إرسال عرض السعر، ويمكن للموزّع رؤيته في حسابي. لم يُرسَل بريد إلكتروني لأن إرسال البريد غير مُعدّ (يتطلب الإعداد).',
    summary: 'الملخص',
    requester: 'مقدّم الطلب',
    requestNote: 'ملاحظة الموزّع',
    version: 'الإصدار المُرسَل',
    versionValue: 'الإصدار {{version}}',
    rejectReason: 'سبب الرفض',
    cancelReason: 'سبب الإلغاء',
    order: 'الطلب',
    openOrder: 'فتح الطلب',
    editResetsLead:
      'عند حفظ تغييرات على عرض سعر مُرسَل يعود إلى مسودة، ولا يمكن للموزّع قبوله حتى ترسل الإصدار الجديد.',
    lines: 'المنتجات',
    linesLead:
      'أدخل أسعار الوحدة كما في قائمة أسعار الموزّع (شاملة/غير شاملة ضريبة القيمة المضافة)؛ وإذا تُركت فارغة يُستخدم سعر القائمة الخاص بالموزّع.',
    product: 'المنتج',
    qty: 'الكمية',
    listPrice: 'سعر القائمة',
    unitPrice: 'سعر العرض',
    lineTotal: 'المبلغ (شامل ضريبة القيمة المضافة)',
    taxIncluded: 'ضريبة القيمة المضافة: {{tax}}',
    saving: 'الخصم مقارنة بسعر القائمة: {{amount}}',
    saveToRecalc: 'يُعاد حساب مبالغ السطور المعدّلة عند الحفظ.',
    terms: 'الشروط',
    note: 'ملاحظة للموزّع',
    noteHint: 'تظهر في عرض السعر',
    internalNote: 'ملاحظة داخلية',
    internalNoteHint: 'في لوحة التحكم فقط',
    versions: 'الإصدارات المُرسَلة',
    cancelTitle: 'إلغاء عرض السعر',
    cancelLead: 'لا يمكن قبول عرض سعر ملغى. يبقى السبب في لوحة التحكم.',
    cancelled: 'تم إلغاء عرض السعر.',
  },
  locations: {
    title: 'المواقع',
    lead: 'عناوين الفروع والتسليم والفوترة الخاصة بالموزّع. يختار مستخدمو الموزّع أحدها عند إتمام الطلب، ويمكن للمسؤول المفوّض في الشركة إضافتها أيضًا من واجهة المتجر.',
    add: 'إضافة موقع',
    edit: 'تعديل الموقع',
    empty: 'لا توجد مواقع',
    emptyLead: 'أضف مواقع للموزّعين الذين لديهم فروع أو عناوين تسليم/فوترة منفصلة.',
    label: 'اسم الموقع',
    contact: 'المستلم',
    postalCode: 'الرمز البريدي',
    defaultShipping: 'التسليم الافتراضي',
    defaultBilling: 'الفوترة الافتراضية',
    makeDefaultShipping: 'تعيين كعنوان التسليم الافتراضي',
    makeDefaultBilling: 'تعيين كعنوان الفوترة الافتراضي',
    saved: 'تم حفظ الموقع.',
    deleted: 'تم حذف الموقع.',
    confirmDelete: 'هل تريد حذف الموقع «{{name}}»؟ لن تتغير العناوين في الطلبات السابقة.',
    fill: 'التعبئة من موقع الشركة',
    choose: 'اختر موقعًا',
  },
  retention: {
    rulesTitle: 'قواعد الإتلاف التلقائي',
    rulesLead:
      'تعمل القواعد المفعّلة كل ليلة في الساعة 03:40 وتحذف نهائيًا السجلات التي انتهت مدة الاحتفاظ بها. جميعها معطّلة افتراضيًا. المدد مقترحة؛ تأكد منها مع محاميك.',
    colData: 'البيانات',
    colDays: 'مدة الاحتفاظ (بالأيام)',
    colDue: 'مستحق اليوم',
    colEnabled: 'الإتلاف التلقائي',
    daysLabel: '{{name}}: مدة الاحتفاظ (بالأيام)',
    daysRange: '{{min}}–{{max}} يومًا؛ المقترح {{def}}',
    dueValue: '{{n}} سجل',
    enabledLabel: '{{name}}: الإتلاف التلقائي',
    on: 'مفعّل',
    off: 'معطّل',
    saved: 'تم حفظ قواعد الاحتفاظ.',
    lastRun: 'آخر إتلاف: {{day}}',
    noRunYet: 'لم يتم أي إتلاف بعد.',
    confirmTitle: 'تفعيل الإتلاف التلقائي',
    confirmLead:
      'تعمل القواعد المفعّلة كل ليلة. تُحذف السجلات التي انتهت مدة الاحتفاظ بها نهائيًا وتُدوَّن في سجل الإتلاف.',
    confirmRow: '{{days}} يومًا: سيُحذف {{n}} سجل في التشغيل الأول',
    confirmRowUnknown: '{{days}} يومًا: تعذّر حساب عدد السجلات التي ستُحذف',
    confirmAck: 'أدرك أن السجلات المنتهية ستُحذف نهائيًا كل ليلة.',
    confirmButton: 'تفعيل وحفظ',
    fixedTitle: 'مدد احتفاظ ثابتة',
    fixedLead:
      'تُحذف هذه السجلات عند انتهاء المدة الخاصة بالميزة المعنية وتُدوَّن في سجل الإتلاف. تُغيَّر مدة الدردشة المباشرة من إعدادات الدردشة المباشرة.',
    colRetention: 'مدة الاحتفاظ',
    days: '{{n}} يوم',
    logTitle: 'سجل الإتلاف',
    logLead:
      'البيانات الشخصية المحذوفة أو المجهّلة: اليوم ونوع البيانات والطريقة وعدد السجلات. لا يحتوي السجل على بيانات شخصية ولا يُحذف أبدًا.',
    period: 'الفترة',
    lastDays: 'آخر {{n}} يوم',
    colDay: 'اليوم',
    colRule: 'نوع البيانات',
    colMethod: 'الطريقة',
    colCount: 'السجلات',
    methods: {
      delete: 'الحذف',
      anonymize: 'إخفاء الهوية',
    },
    byRequest: 'بناءً على طلب',
    logEmpty: 'لم يتم أي إتلاف في هذه الفترة',
    logEmptyLead: 'يظهر هنا عند حذف السجلات المنتهية أو إخفاء هوية البيانات بناءً على طلب.',
    rules: {
      carts: 'سلال التسوق',
      pending_subscribers: 'اشتراكات النشرة البريدية غير المؤكدة',
      unsubscribed_subscribers: 'اشتراكات النشرة البريدية المنتهية',
      integration_logs: 'سجلات التكامل',
      support_tickets: 'تذاكر الدعم المحلولة',
      form_submissions: 'رسائل نموذج التواصل',
      chat_conversations: 'محادثات الدردشة المباشرة المغلقة',
      email_campaign_recipients: 'سجلات مستلمي حملات البريد الإلكتروني',
      automation_runs: 'سجلات الأتمتة المنتهية',
      stock_alerts: 'طلبات «أعلمني عند التوفر» المغلقة',
      price_drop_notices: 'إشعارات انخفاض السعر',
      message_recipients: 'سجلات مستلمي حملات SMS/WhatsApp',
      push_deliveries: 'سجلات إرسال إشعارات المتصفح',
      push_subscriptions: 'اشتراكات إشعارات المتصفح المنتهية',
      staff_notifications: 'إشعارات الموظفين',
      staff_devices: 'أجهزة الموظفين غير المستخدمة',
      server_events: 'أحداث القياس من جانب الخادم',
      privacy_request: 'طلب KVKK (بيانات الشخص المعني)',
    },
    ruleLeads: {
      carts: 'سلال التسوق التي تحوّلت إلى طلبات أو تُركت؛ تُحتسب المدة من آخر تغيير.',
      pending_subscribers:
        'الاشتراكات التي لم يُفتح رابط تأكيدها (لا توجد موافقة)؛ تُحتسب المدة من تاريخ الاشتراك.',
      unsubscribed_subscribers:
        'سجلات الأشخاص الذين ألغوا الاشتراك في النشرة البريدية؛ تُحتسب المدة من تاريخ الإلغاء. يُحتفظ بسجلات الموافقة 3 سنوات بعد انتهاء الموافقة، ويبقى العنوان في قائمة الحظر.',
      integration_logs: 'سجلات الاتصال بالخدمات الخارجية (ملخص مُقنَّع).',
    },
  },
  questions: {
    filter: 'الحالة',
    statuses: {
      pending: 'بانتظار الرد',
      published: 'منشور',
      rejected: 'مرفوض',
    },
    empty: {
      pending: 'لا توجد أسئلة بانتظار الرد',
      published: 'لا توجد أسئلة منشورة',
      rejected: 'لا توجد أسئلة مرفوضة',
    },
    answered: 'تمت كتابة الرد',
    unanswered: 'لا يوجد رد',
    detailTitle: 'سؤال عن المنتج',
    back: 'جميع الأسئلة',
    question: 'السؤال',
    meta: '{{author}} · {{date}}',
    answer: 'الرد',
    answerLead: 'يظهر الرد في صفحة المنتج باسم المتجر.',
    answerLabel: 'ردّك',
    answeredBy: 'آخر رد بواسطة {{name}}، {{date}}',
    save: 'حفظ الرد',
    saved: 'تم حفظ الرد',
    saveFirst: 'احفظ الرد قبل النشر.',
    publish: 'نشر',
    publishedToast: 'تم نشر السؤال',
    notified: 'تم إرسال بريد الرد إلى العميل: {{date}}',
    rejectTitle: 'رفض',
    rejectLead: 'لن يظهر السؤال في واجهة المتجر، ولن يتلقى العميل إشعارًا.',
    rejectNote: 'السبب (في لوحة التحكم فقط)',
    reject: 'رفض',
    unpublish: 'إلغاء النشر',
    rejectConfirm: 'لن يظهر السؤال في واجهة المتجر. هل تريد المتابعة؟',
    rejectedToast: 'تم رفض السؤال',
    rejectedNote: 'سبب الرفض: {{note}}',
  },
  productTools: {
    copy: 'نسخ',
    copyConfirm:
      'ستُنشأ نسخة مسودة تشمل: المحتوى، والمتغيرات (SKU جديد، دون باركود)، والفئات، والخصائص، والصور، والأسعار. لا يُنسخ النشر في المتجر ولا المخزون. هل تريد المتابعة؟',
    copied: 'تم إنشاء نسخة مسودة. SKU الجديد: {{skus}}',
    saveTemplate: 'حفظ كقالب',
    saveTemplateLead:
      'تُحفظ العلامة التجارية والفئات والأنواع والخيارات والخصائص والوسوم ونصوص الوصف. ولا يُحفظ الاسم وSKU والسعر والصور.',
    templateName: 'اسم القالب',
    templateSaved: 'تم حفظ القالب',
    startFrom: 'البدء من قالب',
    startFromLead: 'طبّق قالبًا محفوظًا لتعبئة النموذج، ثم عدّله.',
    template: 'القالب',
    chooseTemplate: 'اختر قالبًا',
    applyTemplate: 'تطبيق القالب',
    templateApplied: 'تم تطبيق القالب «{{name}}»',
    noTemplates: 'لا توجد قوالب محفوظة. استخدم «حفظ كقالب» في أحد المنتجات لإنشاء قالب.',
    deleteTemplate: 'حذف القالب',
    deleteTemplateConfirm: 'هل تريد حذف القالب «{{name}}»؟ لن تتأثر المنتجات التي أُنشئت منه.',
    templateDeleted: 'تم حذف القالب',
    suggestSkus: 'اقتراح رموز SKU',
    skusSuggested: 'تمت تعبئة حقول SKU الفارغة (النمط: {{pattern}}). لا تنسَ الحفظ.',
    skuPattern: 'نمط SKU',
    skuPatternLead: 'تتبع اقتراحات SKU هذا النمط وتكون دائمًا فريدة داخل النشاط التجاري.',
    skuPatternLabel: 'النمط',
    skuPatternHint:
      'الرموز: {marka} (العلامة التجارية)، {kategori} (الفئة)، {urun} (أول ثلاث كلمات من الاسم)، {secenek} (قيم الخيارات)، {sira} (الرقم التسلسلي). الفواصل: - _ . /',
    skuPatternSaved: 'تم حفظ نمط SKU',
    schedule: 'جدولة النشر',
    scheduleLead:
      'يُنشر المنتج في هذا المتجر في الوقت المحدد. يُعاد التحقق من شروط النشر حينها؛ وإذا لم تتحقق لا يُنشر ويظهر السبب هنا.',
    publishAt: 'وقت النشر',
    publishAtHint: 'حسب توقيت متصفحك؛ بعد دقيقة واحدة على الأقل وخلال سنة واحدة.',
    scheduleSave: 'جدولة',
    scheduled: 'تمت جدولة النشر',
    scheduledFor: 'مجدول: {{date}}',
    unschedule: 'إلغاء الجدولة',
    unscheduled: 'تم إلغاء الجدولة',
    scheduleFailed: 'فشل النشر المجدول:',
  },
  productBulk: {
    selectAllPage: 'تحديد جميع المنتجات في هذه الصفحة',
    selectRow: 'تحديد {{title}}',
    selected: 'تم تحديد {{count}} من المنتجات',
    allMatching: 'تم تحديد جميع المنتجات المطابقة لعامل التصفية',
    selectAllMatching: 'تحديد جميع المنتجات المطابقة لعامل التصفية',
    clear: 'مسح التحديد',
    open: 'إجراء جماعي',
    history: 'سجل الإجراءات الجماعية',
    lead: 'اختر إجراءً واعرض معاينته. لا يتغير شيء في المعاينة؛ يُنفَّذ التغيير عبر «تطبيق»، ويمكن التراجع عنه من سجل الإجراءات الجماعية.',
    kind: 'الإجراء',
    kinds: {
      status: 'تغيير الحالة',
      categories_add: 'إضافة إلى فئة',
      categories_remove: 'إزالة من فئة',
      tags_add: 'إضافة وسوم',
      tags_remove: 'إزالة وسوم',
      collection_add: 'إضافة إلى مجموعة',
      collection_remove: 'إزالة من مجموعة',
      stock_set: 'ضبط المخزون على كمية الجرد',
      stock_adjust: 'إضافة مخزون أو خصمه',
      seo: 'عنوان SEO ووصفه',
      merchant: 'Google Shopping',
      cells: 'التعديل في الجدول',
      store_publish: 'النشر في المتجر',
      store_unpublish: 'إلغاء النشر من المتجر',
    },
    newStatus: 'الحالة الجديدة',
    categories: 'الفئات',
    tags: 'الوسوم',
    tagsHint: 'مفصولة بفاصلة (,) مثل: قطط صغيرة, خالٍ من الحبوب.',
    collection: 'المجموعة',
    chooseCollection: 'اختر مجموعة',
    noManualCollections:
      'لا توجد مجموعات مختارة يدويًا. تنضم المنتجات إلى المجموعات القائمة على القواعد تلقائيًا.',
    warehouse: 'المستودع',
    chooseWarehouse: 'اختر مستودعًا',
    quantitySet: 'المخزون الجديد (بالوحدات)',
    quantityAdjust: 'عدد الوحدات المراد إضافتها أو خصمها',
    stockHint:
      'يغيّر مخزون كل متغير نشط في هذا المستودع. استخدم علامة السالب للخصم (مثل -5). يُتخطّى المتغير إذا كان مخزونه سينخفض عن الكمية المحجوزة، وتُدخَل المتغيرات المتتبَّعة بالدفعة/تاريخ انتهاء الصلاحية من شاشة المخزون.',
    seoTitle: 'نمط عنوان SEO',
    seoDescription: 'نمط وصف SEO',
    seoHint:
      'الرموز: {urun}، {marka}، {kategori} (مثل {urun} | {marka}). تبقى الحقول الفارغة دون تغيير. يُقتطع العنوان عند 70 حرفًا والوصف عند 170 حرفًا.',
    onlyEmpty: 'تعبئة الحقول الفارغة فقط',
    merchantChoice: 'في خلاصة منتجات Google Shopping',
    store: 'المتجر',
    storeHint:
      'لا تُنشر المنتجات غير النشطة أو التي تنتظر الموافقة البيطرية أو التي ليس لها سعر في هذا المتجر، وتتخطاها المعاينة مع ذكر السبب.',
    merchantOptions: {
      include: 'تضمين',
      exclude: 'استبعاد',
    },
    preview: 'معاينة',
    back: 'رجوع',
    apply: 'تطبيق',
    summary: 'تم فحص {{products}} من المنتجات: {{total}} تغيير، و{{skipped}} متخطّى.',
    nothing: 'لن يتغير شيء. راجع أسباب الصفوف المتخطّاة.',
    expires: 'المعاينة صالحة حتى {{time}}.',
    item: 'المنتج',
    before: 'الآن',
    after: 'بعد',
    sampleNote: 'يتم عرض أول 200 تغيير.',
    skippedTitle: 'المتخطّاة ({{count}})',
    queued: 'جارٍ التطبيق في الخلفية: {{processed}} / {{total}}',
    queuedLead: 'يمكنك إغلاق هذه النافذة؛ يظهر التقدم في سجل الإجراءات الجماعية.',
    done: 'تم تطبيق الإجراء الجماعي: عدد التغييرات {{applied}}، وعدد الأسطر المتخطاة {{skipped}}.',
    notes: {
      unchanged: 'القيمة مطابقة بالفعل',
      product_requires_active_variant: 'لا يوجد متغيّر نشط',
      too_many_categories: 'تم تجاوز حد الفئات (20)',
      too_many_tags: 'تم تجاوز حد الوسوم (30)',
      lot_tracked: 'يُتتبَّع بالدفعة/تاريخ انتهاء الصلاحية؛ استخدم شاشة المخزون',
      insufficient_stock: 'سينخفض المخزون إلى ما دون الصفر أو دون الكمية المحجوزة',
      changed_since_preview: 'تغيّر بعد المعاينة؛ لم يُعدَّل',
      error: 'تعذّر التغيير ({{code}})',
    },
    values: {
      inCollection: 'ضمن المجموعة',
      notInCollection: 'ليس ضمن المجموعة',
      included: 'مُضمَّن',
      excluded: 'مُستبعَد',
      published: 'منشور',
      notPublished: 'غير منشور',
    },
    date: 'التاريخ',
    status: 'الحالة',
    rows: 'الأسطر',
    statuses: {
      preview: 'لم يُطبَّق',
      queued: 'في قائمة الانتظار',
      running: 'جارٍ التطبيق',
      applied: 'تم التطبيق',
      failed: 'فشل',
      reverted: 'تم التراجع',
      expired: 'انتهت الصلاحية',
    },
    states: {
      pending: 'قيد الانتظار',
      applied: 'تم التطبيق',
      skipped: 'تم التخطي',
      reverted: 'تم التراجع',
      revert_skipped: 'لم يتم التراجع (تغيّر لاحقًا)',
    },
    progress: '{{processed}} / {{total}}',
    skippedCount: 'المتخطاة: {{count}}',
    empty: 'لا توجد إجراءات جماعية بعد',
    emptyLead: 'حدّد المنتجات في شاشة المنتجات واختر «إجراء جماعي».',
    details: 'التفاصيل',
    revert: 'تراجع',
    revertConfirm:
      'ستعود القيم التي غيّرها هذا الإجراء إلى ما كانت عليه. لن تُمسّ الأسطر التي عُدِّلت يدويًا بعد ذلك، ويُصحَّح المخزون بحركة عكسية. هل تريد المتابعة؟',
    reverted: 'عدد الأسطر التي تم التراجع عنها: {{reverted}}. المتخطاة لأنها تغيّرت لاحقًا: {{skipped}}.',
    itemsNote: 'يتم عرض أول 200 سطر.',
    note: 'ملاحظة',
  },
  productGrid: {
    open: 'تعديل في الجدول',
    tableLabel: 'جدول المنتجات',
    priceList: 'قائمة الأسعار',
    noPriceList: 'إخفاء الأسعار',
    warehouse: 'المستودع',
    noWarehouse: 'إخفاء المخزون',
    lockedWhileDirty: 'احفظ تغييراتك أو تجاهلها قبل تبديل قائمة الأسعار أو المستودع.',
    keyboard:
      'استخدم مفاتيح الأسهم للتنقل بين الخلايا. للتعديل اضغط Enter أو انقر نقرًا مزدوجًا أو ابدأ الكتابة؛ يحفظ Enter وينتقل إلى الأسفل، وينتقل Tab إلى الخلية التالية، ويلغي Esc.',
    changesRegion: 'تغييرات غير محفوظة',
    cols: {
      product: 'المنتج',
      sku: 'SKU',
      barcode: 'الباركود',
      status: 'الحالة',
      price: 'السعر',
      priceIn: 'السعر ({{currency}})',
      onHand: 'المخزون',
    },
    statuses: {
      active: 'نشط',
      archived: 'مؤرشف',
    },
    changes: 'تغييرات غير محفوظة: {{count}}',
    noChanges: 'لا توجد تغييرات غير محفوظة',
    discard: 'تجاهل',
    discardConfirm: 'هل تريد تجاهل التغييرات غير المحفوظة ({{count}})؟',
    review: 'حفظ التغييرات',
    previously: 'سابقًا: {{value}}',
    edited: 'تم التغيير، لم يُحفظ',
    invalidPrice: 'أدخل المبلغ بصيغة 129.90.',
    invalidStock: 'أدخل صفرًا أو عددًا صحيحًا موجبًا.',
    lotTracked: 'يُتتبَّع بالدفعة/تاريخ انتهاء الصلاحية؛ استخدم شاشة المخزون',
    prevPage: 'الصفحة السابقة',
    nextPage: 'الصفحة التالية',
    empty: 'لا توجد منتجات مطابقة لهذا البحث',
    previewTitle: 'حفظ التغييرات',
    previewLead: 'تحقّق قبل الحفظ. لن تُحفظ الخلايا التي غيّرها شخص آخر أثناء تعديلك.',
    summary: 'عدد الأسطر التي ستُحفظ فيها التغييرات: {{total}}.',
    nothing: 'لا توجد تغييرات صالحة للحفظ.',
    field: 'الحقل',
    conflictsTitle: 'تغيّرت أثناء تعديلك ({{count}})',
    conflictsLead:
      'لن تُحفظ هذه الخلايا وستُزال من الجدول. بعد إعادة تحميل الجدول عدّلها مجددًا انطلاقًا من القيمة الحالية.',
    conflict: 'القيمة التي رأيتها {{yours}}، والحالية {{current}}',
    problemsTitle: 'خلايا لا يمكن حفظها ({{count}})',
    save: 'حفظ',
    saved: 'تم حفظ الأسطر: {{count}}.',
    queued: 'يتم حفظ التغييرات في الخلفية، ويظهر التقدّم في سجل الإجراءات الجماعية.',
  },
  priceTiers: {
    title: 'أسعار حسب الكمية',
    lead: 'سعر يسري ابتداءً من كمية معيّنة (مثل 6 قطع فأكثر). يُطبَّق في سلة التسوق أعلى مستوى مطابق للكمية.',
    row: '{{list}} · {{sku}} · {{qty}} فأكثر: {{price}}',
    empty: 'لا توجد أسعار حسب الكمية.',
    list: 'القائمة',
    variant: 'المتغيّر',
    minQuantity: 'الحد الأدنى للكمية',
    price: 'سعر الوحدة ({{currency}})',
    add: 'إضافة',
    remove: 'إزالة',
    removeConfirm: 'هل تريد إزالة سعر {{qty}} قطعة فأكثر؟',
  },
  reviews: {
    enabled: 'التقييمات معروضة في واجهة المتجر',
    filter: 'الحالة',
    statuses: {
      pending: 'بانتظار الموافقة',
      published: 'منشور',
      rejected: 'مرفوض',
    },
    empty: {
      pending: 'لا توجد تقييمات بانتظار الموافقة',
      published: 'لا توجد تقييمات منشورة',
      rejected: 'لا توجد تقييمات مرفوضة',
    },
    ratingFilter: 'النجوم',
    allRatings: 'كل النجوم',
    ratingN: '{{n}} نجوم',
    listLabel: 'التقييمات',
    itemLabel: '{{rating}}/5 — {{title}}',
    verified: 'شراء موثّق',
    replied: 'تم الرد',
    detailTitle: 'تقييم المنتج',
    back: 'جميع التقييمات',
    verifiedOrder: 'شراء موثّق: الطلب {{number}}',
    review: 'التقييم',
    ratingOutOf: '{{n}} من 5',
    meta: '{{author}} · {{date}}',
    reply: 'رد المتجر',
    replyLead: 'يظهر الرد أسفل التقييم في صفحة المنتج باسم المتجر.',
    replyLabel: 'ردّك',
    repliedBy: 'آخر رد بواسطة {{name}}، {{date}}',
    saveReply: 'حفظ الرد',
    replySaved: 'تم حفظ الرد',
    saveFirst: 'احفظ الرد قبل النشر.',
    publish: 'الموافقة والنشر',
    publishedToast: 'تم نشر التقييم',
    rejectTitle: 'رفض',
    rejectLead: 'يُخفى التقييم ولا يُحتسب في المتوسط، ولا يتم إشعار العميل.',
    rejectNote: 'السبب (يظهر في لوحة التحكم فقط)',
    reject: 'رفض',
    unpublish: 'إلغاء النشر',
    rejectConfirm: 'سيتم إخفاء التقييم من واجهة المتجر. هل تريد المتابعة؟',
    rejectedToast: 'تم رفض التقييم',
    rejectedNote: 'سبب الرفض: {{note}}',
  },
  translations: {
    locale: 'لغة المحتوى',
    current: 'اللغة: {{lang}}',
    others: 'لغات أخرى:',
    add: 'إضافة ترجمة',
    lead: 'يُنسخ المحتوى كمسودة باللغة المحددة. ترجم النصوص واحفظها؛ ولن يظهر في واجهة المتجر قبل نشره. يحتاج المحتوى الصحي في الترجمة إلى موافقة المراجع المختص مجددًا.',
    target: 'اللغة الهدف',
    create: 'إنشاء الترجمة',
    created: 'تم إنشاء مسودة الترجمة',
    categoryName: 'اسم الفئة ({{lang}})',
  },
  // F7-19: düzenli sipariş (abonelik)
  subscriptions: {
    lead: 'يبدأ العميل التوصيل المنتظم («كل N أسابيع») من صفحة المنتج. في كل فترة يُفتح طلب بالسعر الحالي مع خصم الاشتراك، ويُحجز المخزون ويُرسل رابط دفع بالبطاقة. لا تُحفظ البطاقة ولا يُخصم أي مبلغ تلقائيًا؛ الطلب غير المدفوع في موعده يُلغى ويعود المخزون.',
    store: 'المتجر',
    settingsTitle: 'الإعدادات',
    settingsLead: 'يُفعّل التوصيل المنتظم لكل متجر على حدة؛ وهو معطّل افتراضيًا.',
    readiness: 'الجاهزية',
    ok: 'جاهز',
    missing: 'ناقص',
    readyCard: 'مزوّد الدفع بالبطاقة متصل (لروابط الدفع)',
    readyLegal: 'نموذج المعلومات المسبقة وعقد البيع عن بُعد منشوران',
    readyEmail: 'إرسال البريد الإلكتروني مفعّل (إن كان معطّلًا يرى العميل رابط الدفع في «حسابي» فقط)',
    readyProducts: 'منتجات متاحة للتوصيل المنتظم: {{count}}',
    enabled: 'تفعيل التوصيل المنتظم',
    enabledLead:
      'عند التفعيل يظهر مربع «التوصيل المنتظم» في صفحات المنتجات المؤهلة. عند التعطيل لا تُفتح طلبات جديدة وتبقى الاشتراكات في الانتظار.',
    intervals: 'الفترات التي يمكن للعميل اختيارها',
    everyWeek: 'كل أسبوع',
    everyWeeks: 'كل {{n}} أسابيع',
    discount: 'خصم الاشتراك (%)',
    discountHint: 'من 0 إلى 30. النسبة عند بدء الاشتراك تبقى ثابتة له.',
    discountShort: 'خصم {{pct}}٪',
    linkHours: 'مدة صلاحية رابط الدفع',
    hoursOption: '{{n}} ساعة',
    save: 'حفظ الإعدادات',
    saved: 'تم حفظ إعدادات الطلبات المتكررة.',
    enableConfirm:
      'تفعيل التوصيل المنتظم؟ يظهر مربع «التوصيل المنتظم» في صفحات المنتجات المؤهلة ويمكن للعملاء بدء الاشتراك.',
    listTitle: 'الاشتراكات',
    listLead: 'العميل والمنتج والفترة ويوم الطلب التالي والطلب الذي ينتظر الدفع.',
    statusFilter: 'الحالة',
    all: 'الكل',
    statuses: {
      active: 'نشط',
      paused: 'متوقف مؤقتًا',
      cancelled: 'ملغى',
    },
    reasons: {
      customer: 'بطلب من العميل',
      unpaid: 'لم يُدفع طلبان متتاليان',
      unavailable: 'المنتج أو العميل لم يعد مؤهلًا',
      panel: 'أُلغي من اللوحة',
      payment_unavailable: 'تعذّر إنشاء رابط الدفع (هل الدفع بالبطاقة متصل؟)',
    },
    emptyTitle: 'لا توجد طلبات متكررة بعد',
    emptyLead:
      'فعّل الإعدادات وحدّد المنتجات المتاحة للتوصيل المنتظم؛ عندها يمكن للعملاء البدء من صفحة المنتج.',
    colCustomer: 'العميل',
    colProduct: 'المنتج',
    colQuantity: 'الكمية',
    colInterval: 'الفترة',
    colNext: 'الطلب التالي',
    colStatus: 'الحالة',
    colPending: 'بانتظار الدفع',
    colActions: 'الإجراءات',
    runs: 'الفترات',
    runsFor: 'سجلات الفترات لـ {{product}}',
    runsTitle: 'سجلات الفترات',
    noRuns: 'لا توجد سجلات بعد.',
    runStatuses: {
      order_created: 'فُتح الطلب (بانتظار الدفع)',
      paid: 'مدفوع',
      skipped: 'تم التخطي',
      out_of_stock: 'غير متوفر في المخزون',
      unpaid: 'لم يُدفع (أُلغي الطلب)',
      failed: 'تعذّر فتح الطلب',
    },
    cancel: 'إلغاء',
    cancelFor: 'إلغاء اشتراك {{product}}',
    cancelTitle: 'إلغاء الاشتراك',
    cancelLead:
      'لن تُفتح طلبات جديدة. الطلب الذي ينتظر الدفع يُلغى تلقائيًا عند انتهاء صلاحية رابطه. لا يتلقى العميل بريدًا؛ ويرى «ملغى» في «حسابي».',
    cancelReason: 'السبب (يُسجَّل في سجل التدقيق)',
    cancelSubmit: 'إلغاء الاشتراك',
    cancelled: 'تم إلغاء الاشتراك.',
  },
  gads: {
    textReviewStatus: {
      not_required: 'لا تلزم مراجعة خبير',
      pending:
        'يحتوي النص على {{count}} ادعاءات صحية: بانتظار موافقة المراجع البيطري؛ لا يمكن الموافقة على هذا الطلب قبل ذلك.',
      approved: 'وافق الخبير على النص (رُوجعت {{count}} ملاحظات).',
      rejected: 'رفض الخبير النص؛ عدّله واطلب مجددًا.',
    },
    keywordChanges: {
      added: 'للإضافة ({{count}})',
      removed: 'للحذف ({{count}})',
    },
    accessLevel: 'مستوى الوصول إلى Google Ads API',
    accessLevelHint:
      'المستوى الذي منحه Google لمشروع Cloud. اقتراحات الكلمات معطلة في Explorer؛ غيّره بعد الموافقة على Basic.',
    accessLevels: {
      explorer: 'Explorer (افتراضي)',
      basic: 'Basic',
      standard: 'Standard',
    },
    searchOnlyReady: 'يمكن إعداد حملة بحث فقط: ينقص Performance Max والتسوق ما يلي',
    search: {
      source: 'إنشاء المسودة من البيانات',
      sourceKinds: {
        product: 'منتج',
        category: 'فئة',
      },
      sourceCategory: 'الفئة',
      sourceSearch: 'ابحث عن منتجات',
      sourceProduct: 'المنتج',
      suggest: 'إنشاء مسودة',
      preview: 'معاينة الإعلان',
      previewCaption: 'عرض توضيحي: يختار Google ترتيب العناوين والأوصاف وتركيبها.',
      sponsored: 'إعلان مموَّل',
      previewEmpty: 'أدخل العناوين',
      findings: '{{count}} ملاحظات ادعاء صحي',
      findingsLead:
        'لا يمكن إرسال هذا النص إلى Google دون موافقة المراجع البيطري. لا تدّعِ الوقاية من الأمراض أو علاجها.',
      shortOf: 'لا يوجد نص كافٍ في البيانات: اكتب {{headlines}} عناوين و{{descriptions}} أوصاف إضافية.',
      finalUrl: 'عنوان URL النهائي',
      finalUrlHint: 'صفحة في متجرك (https://…). تُملأ بصفحة المنتج أو الفئة عند إنشاء المسودة.',
      path1: 'المسار المعروض 1',
      path2: 'المسار المعروض 2',
      headlines: 'العناوين (3–15، حتى 30 حرفًا)',
      headlinesHint: 'اكتب عناوين بمعانٍ مختلفة؛ ثبّت فقط عند الحاجة.',
      headlineN: 'العنوان {{n}}',
      pinN: 'تثبيت العنوان {{n}}',
      pinNone: 'دون تثبيت',
      pins: {
        h1: 'موضع العنوان 1',
        h2: 'موضع العنوان 2',
        h3: 'موضع العنوان 3',
        d1: 'موضع الوصف 1',
        d2: 'موضع الوصف 2',
      },
      removeHeadline: 'حذف العنوان {{n}}',
      addHeadline: 'إضافة عنوان',
      descriptions: 'الأوصاف (2–4، حتى 90 حرفًا)',
      descriptionN: 'الوصف {{n}}',
      pinDescN: 'تثبيت الوصف {{n}}',
      removeDescription: 'حذف الوصف {{n}}',
      addDescription: 'إضافة وصف',
      keywordN: '{{label}} {{n}}',
      matchTypeN: 'نوع مطابقة {{label}} {{n}}',
      matchTypes: {
        broad: 'مطابقة واسعة',
        phrase: 'مطابقة العبارة',
        exact: 'مطابقة تامة',
      },
      removeKeyword: 'حذف «{{text}}»',
      addKeywords: 'إضافة {{label}}',
      addKeywordsHint: 'واحدة في كل سطر (أو افصل بـ ;). تُضاف بمطابقة العبارة.',
      add: 'إضافة',
      keywordCount: '{{count}} / {{max}}',
      ideas: 'اقتراح كلمات مفتاحية',
      basicRequired: 'يلزم وصول Basic',
      basicRequiredLead:
        'يعطّل Google خدمات التخطيط (اقتراحات الكلمات) مع وصول Explorer. بعد الموافقة على Basic غيّر مستوى الوصول من سقف الميزانية والإعدادات.',
      noIdeas: 'لم يُرجع Google اقتراحات لهذه الكلمات.',
      monthlySearches: '≈ {{n}} عملية بحث شهريًا',
      competition: {
        LOW: 'منافسة منخفضة',
        MEDIUM: 'منافسة متوسطة',
        HIGH: 'منافسة مرتفعة',
        UNSPECIFIED: 'المنافسة غير معروفة',
        UNKNOWN: 'المنافسة غير معروفة',
      },
      addIdea: 'إضافة «{{text}}»',
      approvalStatuses: {
        APPROVED: 'معتمد',
        APPROVED_LIMITED: 'معتمد (محدود)',
        AREA_OF_INTEREST_ONLY: 'منطقة الاهتمام فقط',
        DISAPPROVED: 'مرفوض',
        UNKNOWN: 'غير معروف',
      },
      googleReviewStatuses: {
        REVIEW_IN_PROGRESS: 'قيد المراجعة',
        REVIEWED: 'تمت المراجعة',
        UNDER_APPEAL: 'قيد الطعن',
        ELIGIBLE_MAY_SERVE: 'مؤهل وقد يُعرض',
      },
      adStrengths: {
        EXCELLENT: 'ممتاز',
        GOOD: 'جيد',
        AVERAGE: 'متوسط',
        POOR: 'ضعيف',
        PENDING: 'قيد الحساب',
        NO_ADS: 'لا توجد إعلانات',
      },
      notSent: 'لم يُرسل إلى Google',
      reviewSaved: 'حُفظ قرار المراجعة.',
      reviewTitle: 'مراجعة الخبير',
      reviewStatuses: {
        not_required: 'غير مطلوبة',
        pending: 'قيد الانتظار',
        approved: 'معتمد',
        rejected: 'مرفوض',
      },
      reviewedBy: 'القرار: {{name}}',
      reviewNote: 'ملاحظة المراجعة',
      reviewNoteHint: 'السبب مطلوب عند الرفض.',
      reviewApprove: 'اعتماد النص',
      reviewReject: 'رفض النص',
      reviewWaiting: 'بانتظار قرار المراجع البيطري.',
      adTitle: 'نص الإعلان',
      adLead: 'إعلان بحث متجاوب: يجمع Google بين العناوين والأوصاف.',
      requestedDiffers: 'النص الجديد المطلوب ليس في Google بعد (بانتظار الموافقة أو التطبيق).',
      googleState: 'الحالة في Google',
      approvalStatus: 'موافقة السياسة',
      googleReview: 'مراجعة Google',
      adStrength: 'قوة الإعلان',
      keywords: 'الكلمات المفتاحية',
      keywordsLead: 'عمليات البحث التي قد يظهر فيها الإعلان. تتطلب الإضافة موافقة؛ الحذف فقط لا يتطلب.',
      negatives: 'الكلمات المفتاحية السلبية',
      negativesLead: 'عمليات البحث التي لن يظهر فيها الإعلان. لا تتطلب الإضافة موافقة؛ يتطلب الحذف موافقة.',
      noKeywords: 'لا توجد كلمات مفتاحية.',
      noNegatives: 'لا توجد كلمات مفتاحية سلبية.',
      edit: {
        ad: 'تعديل نص الإعلان',
        keywords: 'تعديل الكلمات المفتاحية',
        negatives: 'تعديل الكلمات السلبية',
      },
      draftSaved: 'حُفظت المسودة.',
      draftEditLead: 'الحملة مسودة: تُحفظ التغييرات دون إرسالها إلى Google.',
      adChangeLead:
        'يُرسل النص الجديد للموافقة؛ وبعدها يُحدَّث الإعلان في Google. تحتاج الادعاءات الصحية موافقة الخبير أولًا.',
      changeSummary: '{{added}} للإضافة، {{removed}} للحذف.',
      summaryAd: 'الإعلان',
      summaryAdValue:
        '{{headlines}} عناوين، {{descriptions}} أوصاف، {{keywords}} كلمات مفتاحية، {{negatives}} سلبية',
      summaryReviewNote: 'إذا احتوى النص على ادعاءات صحية فلا يمكن إنشاء الحملة دون موافقة المراجع البيطري.',
    },
    backToAds: 'مركز الإعلانات',
    backToList: 'الحملات',
    settings: 'سقف الميزانية والإعدادات',
    newCampaign: 'حملة جديدة',
    stopAll: 'إيقاف كل حملات Google',
    stopConfirm:
      'سيتم إيقاف كل حملات Google Ads المنشورة مؤقتًا وإلغاء طلبات الإنفاق المعلّقة. هل تريد المتابعة؟',
    stopDone: 'يجري إيقاف {{pausing}} حملة؛ أُلغي {{cancelled}} طلب.',
    monthTitle: 'هذا الشهر',
    monthSpent: 'المنفَق هذا الشهر',
    monthlyCap: 'السقف الشهري لميزانية الإعلانات',
    capMissing: 'غير محدّد',
    capExceeded: 'يتجاوز السقف ({{cap}})',
    projected: 'الحد الأعلى الشهري المقدّر',
    projectedAll: 'الحد الأعلى الشهري مع كل الحملات المنشورة',
    projectedNote:
      'الحد الأعلى الشهري المقدّر هو مجموع الميزانيات اليومية للحملات المنشورة × 30.4. قد ينفق Google في يوم واحد حتى ضعفي الميزانية اليومية؛ ولا يتجاوز مجموع الشهر الميزانية اليومية × 30.4.',
    apiUsage: 'عمليات Google Ads API اليوم',
    apiUsageValue: '{{used}} / {{limit}}',
    campaignsTitle: 'الحملات',
    empty: 'لا توجد حملات Google Ads بعد',
    emptyLead:
      'استخدم «حملة جديدة» لإعداد حملة Performance Max أو تسوّق من منتجاتك. تُنشأ الحملة في Google متوقفة مؤقتًا؛ ويحتاج النشر إلى موافقة منفصلة.',
    campaign: 'الحملة',
    status: 'الحالة',
    dailyBudget: 'الميزانية اليومية',
    dailyMax: 'الحد الأعلى في يوم واحد',
    monthlyMax: 'الحد الأعلى الشهري',
    productsCount: 'المنتجات',
    notes: 'ملاحظات',
    driftBadge: 'تغيّرت في Google Ads',
    pendingBadge: '{{count}} بانتظار الموافقة',
    kinds: {
      search: 'البحث',
      pmax: 'Performance Max',
      shopping: 'التسوّق',
    },
    kindHints: {
      search:
        'إعلانات نصية في نتائج بحث Google (إعلان بحث متجاوب) بالعناوين والأوصاف والكلمات المفتاحية. لا يلزم Merchant Center. عروض الأسعار: قيمة التحويل أو التحويلات أو النقرات.',
      pmax: 'إعلانات تلقائية من خلاصة المنتجات عبر كل قنوات Google (البحث، التسوّق، YouTube، الشبكة الإعلانية، Gmail). العروض: قيمة التحويل أو التحويلات.',
      shopping: 'إعلانات المنتجات في نتائج Google Shopping فقط. العروض: قيمة التحويل أو النقرات.',
    },
    statuses: {
      draft: 'مسودة',
      paused: 'متوقفة مؤقتًا',
      enabled: 'منشورة',
      removed: 'مُزالة',
    },
    biddings: {
      max_conv_value: 'زيادة قيمة التحويل إلى أقصى حد',
      max_conversions: 'زيادة التحويلات إلى أقصى حد',
      max_clicks: 'زيادة النقرات إلى أقصى حد',
    },
    alerts: {
      month_80: 'أُنفق {{spent}} هذا الشهر: بلغ الإنفاق 80% من السقف الشهري ({{cap}}).',
      month_cap_reached: 'أُنفق {{spent}} هذا الشهر: بلغ الإنفاق السقف الشهري ({{cap}}).',
      daily_overspend: 'تجاوز إنفاق اليوم الأخير ({{spent}}) مرة ونصف الميزانية اليومية ({{budget}}).',
      no_conversions_2d: 'أُنفق {{spent}} في آخر يومين ولم يبلّغ Google عن أي تحويل.',
    },
    approvalsTitle: 'بانتظار الموافقة',
    approvalsLead:
      'لا تُرسل التغييرات التي قد تسبب إنفاقًا إلى Google قبل الموافقة. تتطلب الموافقة التحقق بخطوتين؛ ولا يوافق على طلبه الخاص إلا مالك النشاط.',
    noApprovals: 'لا يوجد شيء بانتظار الموافقة.',
    requestedBy: 'مقدّم الطلب: {{name}}',
    system: 'النظام',
    approve: 'موافقة',
    reject: 'رفض',
    approveTitle: 'الموافقة على التغيير',
    rejectTitle: 'رفض التغيير',
    approveSubmit: 'وافق وأرسل إلى Google',
    rejectSubmit: 'رفض',
    approved: 'تمت الموافقة؛ أُضيف التغيير إلى قائمة الانتظار.',
    rejected: 'تم الرفض.',
    approveStepUp: 'تتطلب الموافقة التحقق بخطوتين؛ قد يُطلب منك رمز.',
    decisionNote: 'ملاحظة',
    moneyLine: 'الميزانية اليومية: {{daily}}.',
    moneyRule:
      'قد ينفق Google حتى الضعف في يوم واحد ({{dailyMax}})؛ الحد الأعلى الشهري ≈ اليومية × 30.4 ({{monthlyMax}}).',
    moneyProjected: 'مع هذه الموافقة يصبح الحد الأعلى الشهري المقدّر لكل الحملات المنشورة: {{value}}.',
    loosensWarning: 'هذا التغيير يخفّف هدف العروض أو يغيّر الاستراتيجية: قد يزداد الإنفاق.',
    removeWarning: 'لا يمكن التراجع عن الإزالة: تُزال الحملة في Google Ads ولا يمكن إعادة فتحها.',
    settingsTitle: 'سقف الميزانية والإعدادات',
    settingsLead:
      'يُتحقق من السقف الشهري عند الموافقة على التغييرات التي تسبب إنفاقًا. يتطلب تغييره صلاحية الموافقة والتحقق بخطوتين.',
    monthlyCapLabel: 'السقف الشهري لميزانية الإعلانات ({{currency}})',
    monthlyCapHint: 'إذا تُرك فارغًا فلا يمكن الموافقة على النشر أو زيادة الميزانية.',
    autoStop: 'الإيقاف التلقائي عند بلوغ السقف',
    autoStopHint:
      'معطّل افتراضيًا. عند تفعيله تُوقف الحملات المنشورة دون موافقة حين يبلغ إنفاق Google Ads الشهري السقف.',
    dailyLimitHint:
      'الحد اليومي لعمليات Google Ads API: {{limit}}. عند بلوغه تُطبَّق التغييرات صباح اليوم التالي.',
    settingsReadOnly: 'لا يغيّر هذه الإعدادات إلا من لديه صلاحية الموافقة.',
    settingsSaved: 'حُفظت الإعدادات.',
    wizardTitle: 'حملة Google Ads جديدة',
    wizardStep: 'الخطوة {{n}} من {{total}}: {{name}}',
    stepsLabel: 'خطوات المعالج',
    steps: {
      ad: 'الإعلان والكلمات المفتاحية',
      store: 'المتجر',
      campaign: 'النوع والاسم',
      products: 'المنتجات',
      budget: 'الميزانية والعروض',
      targeting: 'المناطق واللغات والتواريخ',
      summary: 'الملخص',
    },
    back: 'رجوع',
    next: 'التالي',
    store: 'المتجر',
    checking: 'جارٍ التحقق من اتصالات Google…',
    ready: 'جاهز',
    readyLead: 'حساب Google Ads {{customer}}، Merchant Center {{merchant}}؛ تحويل الشراء: {{conversion}}.',
    locked: 'قبل إعداد حملة، أكمل ما يلي:',
    kind: 'نوع الحملة',
    name: 'اسم الحملة',
    productSearch: 'ابحث عن منتجات',
    productsHint:
      'تدخل المنتجات المختارة في مرشّح منتجات الحملة. المنتجات التي لا يمكنها دخول خلاصة Google (مثل غياب موافقة الطبيب البيطري أو وجود ادعاء صحي) لا تُضاف وتُعرض الأسباب.',
    selectedCount: 'اختير {{count}} منتج',
    dailyBudgetLabel: 'الميزانية اليومية ({{currency}})',
    budgetInvalid: 'أدخل مبلغًا صالحًا.',
    bidding: 'استراتيجية العروض',
    targetRoas: 'العائد المستهدف على الإنفاق الإعلاني (%)',
    targetRoasHint: 'اختياري. مثال: 400 = استهداف 4 وحدات من قيمة التحويل لكل وحدة إنفاق.',
    targetCpa: 'التكلفة المستهدفة لكل تحويل ({{currency}})',
    targetCpaHint: 'اختياري. إذا تُرك فارغًا يبحث Google عن أكبر عدد من التحويلات ضمن الميزانية.',
    roasValue: 'عائد {{value}}%',
    noTarget: 'دون هدف',
    countries: 'الدول',
    languagesLabel: 'اللغات',
    languages: {
      tr: 'التركية',
      en: 'الإنجليزية',
      de: 'الألمانية',
      ar: 'العربية',
    },
    countryNames: {
      TR: 'تركيا',
      DE: 'ألمانيا',
      GB: 'المملكة المتحدة',
      AE: 'الإمارات',
      US: 'الولايات المتحدة',
      NL: 'هولندا',
      FR: 'فرنسا',
      AT: 'النمسا',
      BE: 'بلجيكا',
      CH: 'سويسرا',
      AZ: 'أذربيجان',
      SA: 'السعودية',
      QA: 'قطر',
      KW: 'الكويت',
      BG: 'بلغاريا',
      GR: 'اليونان',
      IT: 'إيطاليا',
      ES: 'إسبانيا',
      SE: 'السويد',
      DK: 'الدنمارك',
    },
    startDate: 'تاريخ البدء',
    endDate: 'تاريخ الانتهاء',
    startHint: 'إذا تُرك فارغًا تبدأ بعد الموافقة والنشر.',
    endHint: 'إذا تُرك فارغًا فهي دون نهاية.',
    dates: 'التواريخ',
    startNow: 'عند النشر',
    noEnd: 'دون نهاية',
    assetsNote:
      'العناصر: يُنشئ Google نصوص الإعلانات والصور من خلاصة المنتجات وموقعك (لا يضيف هذا الإصدار عناوين أو صورًا؛ ويذكر Google أن الوصول قد يكون محدودًا).',
    pausedNote:
      'تُنشأ الحملة في Google Ads متوقفة مؤقتًا، وتعتمد العروض على تحويل «الشراء» فقط. يحتاج النشر إلى موافقة منفصلة.',
    requestNote: 'ملاحظة (لمن سيوافق)',
    saveDraft: 'حفظ المسودة',
    submitForApproval: 'إرسال للموافقة',
    wizardSaved: 'حُفظت المسودة',
    wizardSavedLead: 'لم تُرسل المسودة إلى Google. يمكنك تعديلها من صفحة الحملة وإرسالها للموافقة.',
    wizardSubmitted: 'أُرسلت للموافقة',
    wizardSubmittedLead: 'بعد الموافقة تُنشأ الحملة في Google Ads متوقفة مؤقتًا.',
    openCampaign: 'فتح الحملة',
    rejectedTitle: 'منتجات لم تُضف',
    reasons: {
      product_not_active: 'المنتج غير منشور.',
      product_not_found: 'المنتج غير موجود.',
      in_other_campaign: 'المنتج في حملة أخرى (يمكن أن يكون المنتج في حملة واحدة فقط).',
      feed_not_listed:
        'المنتج ليس في خلاصة Google لهذا المتجر (هل هو منشور في المتجر ومتاح للبيع بالتجزئة؟).',
      feed_excluded_by_user: 'المنتج مستبعد من خلاصة Google.',
      feed_health_not_approved: 'المحتوى الصحي بانتظار موافقة الطبيب البيطري.',
      feed_health_claim: 'يحتوي النص على ادعاء بعلاج مرض (سياسة Google الصحية واللوائح).',
      feed_image_missing: 'لا توجد صورة.',
      feed_image_too_small: 'الصورة أصغر من الحد الأدنى لدى Google.',
      feed_image_too_large: 'الصورة كبيرة جدًا.',
      feed_price_missing: 'لا يوجد سعر.',
      feed_price_not_tax_inclusive: 'السعر لا يشمل ضريبة القيمة المضافة.',
      feed_no_variants: 'لا توجد خيارات نشطة.',
      feed_country_blocked: 'لا يُسمح ببيع المنتج في هذه الدولة.',
      feed_translation_missing: 'لا توجد ترجمة بلغة السوق.',
      feed_tax_rate_missing: 'لم يُحدَّد معدل ضريبة القيمة المضافة.',
      out_of_stock: 'غير متوفر: لا يعرض Google المنتجات غير المتوفرة.',
    },
    productStates: {
      queued: 'في قائمة الانتظار',
      sent: 'أُرسل إلى Google — قيد المعالجة',
      eligible: 'مؤهل',
      limited: 'محدود',
      not_eligible: 'غير مؤهل',
    },
    googleId: 'معرّف Google {{id}}',
    labelValue: 'تسمية المنتج {{label}}',
    primaryStatus: 'الحالة في Google: {{status}}',
    primaryStatuses: {
      ELIGIBLE: 'مؤهلة',
      PAUSED: 'متوقفة مؤقتًا',
      REMOVED: 'مُزالة',
      ENDED: 'انتهت',
      PENDING: 'بانتظار البدء',
      MISCONFIGURED: 'إعداد خاطئ',
      LIMITED: 'محدودة',
      LEARNING: 'قيد التعلّم',
      NOT_ELIGIBLE: 'غير مؤهلة',
    },
    readAt: 'قُرئت {{at}}',
    driftTitle: 'تغيّرت في Google Ads',
    driftLead:
      'تختلف القيم في Google Ads عن النظام. لا يكتب النظام فوق قيم Google من تلقاء نفسه: اقبل قيم Google أو افتح طلبًا جديدًا.',
    driftFields: {
      ad_text: 'نص الإعلان (العنوان الأول)',
      keywords: 'عدد الكلمات المفتاحية',
      negatives: 'عدد الكلمات المفتاحية السلبية',
      status: 'الحالة',
      name: 'الاسم',
      budget: 'الميزانية اليومية (مايكرو)',
      bidding: 'استراتيجية العروض',
      target_roas: 'العائد المستهدف (%)',
      target_cpa: 'التكلفة المستهدفة (مايكرو)',
      end_date: 'تاريخ الانتهاء',
    },
    driftValues: 'في النظام {{expected}}، وفي Google {{google}}',
    acceptGoogle: 'قبول قيم Google',
    driftAccepted: 'أصبح سجل النظام مطابقًا لـ Google Ads.',
    goal: 'هدف التحويل',
    goalApplied: 'الشراء فقط',
    goalPending: 'قيد التطبيق',
    accounts: 'Google Ads / Merchant',
    actions: 'إجراءات الحملة',
    ops: {
      adTextText: 'العنوان الأول: {{headline}}',
      keywordsText: '{{add}} للإضافة، {{remove}} للحذف',
      actions: {
        ad_text: 'نص الإعلان',
        keywords: 'الكلمات المفتاحية',
        negatives: 'الكلمات المفتاحية السلبية',
        create: 'إرسال للموافقة (إنشاء)',
        enable: 'نشر',
        pause: 'إيقاف مؤقت',
        budget: 'تغيير الميزانية',
        bidding: 'استراتيجية العروض',
        targeting: 'المناطق واللغات والتواريخ',
        rename: 'إعادة التسمية',
        remove: 'إزالة',
        apply_recommendation: 'توصية Google',
        conversion_goal: 'هدف التحويل',
      },
      kinds: {
        ad_text: 'نص الإعلان',
        keywords: 'الكلمات المفتاحية',
        negatives: 'الكلمات المفتاحية السلبية',
        create: 'الإنشاء',
        enable: 'النشر',
        pause: 'الإيقاف المؤقت',
        budget: 'الميزانية',
        bidding: 'العروض',
        targeting: 'الاستهداف',
        rename: 'الاسم',
        remove: 'الإزالة',
        apply_recommendation: 'توصية Google',
        conversion_goal: 'هدف الشراء',
      },
      budgetText: 'الميزانية اليومية {{from}} ← {{to}}',
      biddingText: '{{bidding}} ({{target}})',
      targetingText: '{{countries}} · {{languages}} · {{start}} — {{end}}',
      renameText: 'الاسم الجديد: {{name}}',
      recommendationText: 'التوصية: {{type}}',
    },
    opStatuses: {
      pending_approval: 'بانتظار الموافقة',
      queued: 'في قائمة الانتظار',
      applying: 'قيد التطبيق',
      applied: 'طُبِّق',
      failed: 'فشل',
      rejected: 'مرفوض',
      cancelled: 'ملغى',
    },
    origins: {
      user: 'المستخدم',
      system: 'النظام',
      emergency: 'إيقاف طارئ',
      auto_stop: 'إيقاف تلقائي (السقف)',
    },
    deleteDraft: 'حذف المسودة',
    deleteDraftConfirm: 'ستُحذف المسودة. لا يتغير شيء في Google Ads لأنها لم تُرسل.',
    draftDeleted: 'حُذفت المسودة.',
    openNote: 'يوجد تغيير معلّق؛ لا يمكن طلب تغيير جديد سوى الإيقاف المؤقت.',
    productsTitle: 'المنتجات',
    productsLead:
      'تُرسل المنتجات إلى Merchant Center مع تسمية الحملة (custom_label_0) ونطاق الهامش (custom_label_1)؛ وبعد معالجة Google تظهر حالة كل منتج في الحملة.',
    addProducts: 'إضافة منتجات',
    addProductsLead: 'لا تُضاف إلا المنتجات التي تدخل خلاصة Google وليست في حملة أخرى.',
    addSelected: 'إضافة {{count}} منتج',
    noProducts: 'لا توجد منتجات في الحملة.',
    removeProduct: 'إزالة',
    productRemoved: 'أُزيل المنتج من الحملة.',
    productsAdded: 'أُضيف {{count}} منتج.',
    productsRemoved: 'أُزيل {{count}} منتج.',
    operationsTitle: 'التغييرات',
    noOperations: 'لا توجد تغييرات بعد.',
    operation: 'التغيير',
    who: 'مقدّم الطلب ← صاحب القرار',
    when: 'الوقت',
    cancel: 'إلغاء',
    cancelled: 'أُلغي التغيير.',
    nextAttempt: 'المحاولة التالية: {{at}}',
    recommendationsTitle: 'توصيات Google',
    recommendationsLead: 'تُقرأ من Google عند الطلب. يتطلب تطبيق أي توصية موافقة دائمًا.',
    loadRecommendations: 'جلب التوصيات',
    noRecommendations: 'لا توجد توصيات من Google لهذه الحملة.',
    recommendationTypes: {
      CAMPAIGN_BUDGET: 'توصية الميزانية',
      TARGET_ROAS_OPT_IN: 'توصية العائد المستهدف',
      MAXIMIZE_CONVERSION_VALUE_OPT_IN: 'توصية العروض حسب قيمة التحويل',
    },
    recommendedBudget: 'الميزانية اليومية الموصى بها {{daily}} (الحد الأعلى الشهري {{monthly}})',
    requestRecommendation: 'طلب التطبيق',
    recommendationRequested: 'أُرسلت التوصية للموافقة.',
    historyTitle: 'سجل تغييرات Google Ads',
    historyLead: 'آخر 14 يومًا؛ يُقرأ من Google عند الطلب ولا يُخزَّن.',
    loadHistory: 'جلب السجل',
    noHistory: 'لا توجد تغييرات في هذه الفترة.',
    historyBy: 'المصدر: {{client}} · {{user}}',
    historyNote: 'وقت القراءة: {{at}}',
    noApprovalLead:
      'لا يحتاج هذا التغيير إلى موافقة؛ بعد تحديد المربع يُضاف إلى قائمة الانتظار ويُطبَّق على Google.',
    approvalLead: 'قد يزيد هذا التغيير الإنفاق: لا يُرسل إلى Google قبل الموافقة.',
    applyNow: 'تطبيق على Google Ads',
    sendForApproval: 'إرسال للموافقة',
    queued: 'أُضيف التغيير إلى قائمة الانتظار.',
    sentForApproval: 'أُرسل للموافقة.',
    enableLead: 'يبدأ الإنفاق عند نشر الحملة: {{daily}} يوميًا، وبحد أقصى {{monthly}} شهريًا.',
    confirmApply: 'أؤكد تطبيق هذا التغيير على Google Ads.',
    productBox: 'إعلانات Google',
    productBoxTitle: 'إعلانات Google',
    inCampaign: 'الحملة:',
    notInCampaign: 'هذا المنتج ليس في أي حملة Google Ads.',
    checkedAt: 'قُرئ من Google: {{at}}',
    labelsNote:
      'لهذا المنتج يُرسل إلى Merchant custom_label_0 = {{label}} وcustom_label_1 = نطاق الهامش (بدلًا من التسميتين الأولى والثانية الخاصتين بالمنتج).',
    removeFromCampaign: 'إزالة من الحملة',
    notEligible: 'لا يمكن إضافة هذا المنتج إلى حملة حاليًا:',
    chooseCampaign: 'الحملة',
    chooseCampaignPlaceholder: 'اختر حملة',
    addToCampaign: 'إضافة إلى الحملة',
    productAdded: 'أُضيف المنتج إلى الحملة.',
    productNotAdded: 'تعذّرت إضافة المنتج؛ الأسباب أدناه.',
    noCampaignsYet: 'لا توجد حملات بعد. أنشئ واحدة من التسويق ← حملات Google Ads.',
    bulkCampaign: 'حملة Google Ads',
    bulkAdd: 'إضافة {{count}} منتج محدد',
    bulkRemove: 'إزالة المحدد من الحملة',
    filterLabel: 'إعلانات Google',
    filterAny: 'في حملة',
    filterNone: 'ليس في حملة',
    filterNotEligible: 'غير مؤهل حسب Google',
  },
};
